export const linksTransparencia = [
  ["Categoria", "Trimestre", "Creado por", "Solicitado el dia", "Link"],
  [
    "Compras",
    "2do Trimestre",
    "Ines Flores Perez",
    "19-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/Pedido 025-2023.pdf",
    },
  ],
  [
    "Ingresos",
    "2do Trimestre",
    "Maribel Butron Rosales",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir5/ingresos/MESES SIN INTERESES.pdf",
    },
  ],
  [
    "Compras",
    "2do Trimestre",
    "Ines Flores Perez",
    "21-06-2023",
    {
      text: "DOCX",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/TÍTULO CUARTO.docx",
    },
  ],
  [
    "Juridico",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-125-2023.pdf",
    },
  ],
  [
    "Juridico",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-126-2023.pdf",
    },
  ],
  [
    "Servicios Generales",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/ServiciosGenerales/OS 20230612001.PDF",
    },
  ],
  [
    "Servicios Generales",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/ServiciosGenerales/OS 20230418008.PDF",
    },
  ],
  [
    "Servicios Generales",
    "2do Trimestre",
    "Amparo Flores",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/ServiciosGenerales/Circ.DAF-SPF-78-23.pdf",
    },
  ],
  [
    "PADA",
    "2022",
    "Guille Trejo",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/PADA/2022/Informe PADA 2022.pdf",
    },
  ],
  [
    "PADA",
    "2023",
    "Guille Trejo",
    "21-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/PADA/2023/Informe PADA 2023.pdf",
    },
  ],
  [
    "Juridico",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "22-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-127-2023.pdf",
    },
  ],
  [
    "Compras",
    "2do Trimestre",
    "Ines Flores Perez",
    "22-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/TÍTULO CUARTO.pdf",
    },
  ],
  [
    "Planeacion",
    "2do Trimestre",
    "Marleen Barrera Osorio",
    "26-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Planeacion/Circular DAF-SPF-077-2023.pdf",
    },
  ],
  [
    "Planeacion",
    "2do Trimestre",
    "Marleen Barrera Osorio",
    "26-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Planeacion/Oficio DAF-SPF-2456-2023.pdf",
    },
  ],
  [
    "Planeacion",
    "2do Trimestre",
    "Marleen Barrera Osorio",
    "26-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Planeacion/Oficio DAF-SPF-2457-2023.pdf",
    },
  ],
  [
    "Compras",
    "2do Trimestre",
    "Ines Flores Perez",
    "26-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/Pedido 006-2023.pdf",
    },
  ],
  [
    "Compras",
    "2do Trimestre",
    "Ines Flores Perez",
    "26-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/Pedido 018-2023.pdf",
    },
  ],
  [
    "Planeacion",
    "2do Trimestre",
    "Marleen Barrera Osorio",
    "27-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Planeacion/CIRCULAR52.pdf",
    },
  ],
  [
    "Planeacion",
    "2do Trimestre",
    "Marleen Barrera Osorio",
    "27-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Planeacion/CIRCULAR53.pdf",
    },
  ],
  [
    "Compras",
    "2do Trimestre",
    "Yadira Alarcon",
    "27-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/123002.pdf",
    },
  ],
  [
    "Compras",
    "2do Trimestre",
    "Yadira Alarcon",
    "27-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-69-2023.pdf",
    },
  ],
  // 1
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-01-2023.pdf",
    },
  ],
  // 2
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-02-2023.pdf",
    },
  ],
  // 3
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-03-2023.pdf",
    },
  ],
  // 4
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-04-2023.pdf",
    },
  ],
  // 5
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-05-2023.pdf",
    },
  ],
  // 6
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-06-2023.pdf",
    },
  ],
  // 7
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-07-2023.pdf",
    },
  ],
  // 8
  [
    "Licitaciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-08-2023.pdf",
    },
  ],
  [
    "Juridico",
    "2do Trimestre",
    "Jorge Daniel",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/CAASIM-DAJ-003-2023.pdf",
    },
  ],
  [
    "Juridico",
    "2do Trimestre",
    "Jorge Daniel",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Convenio CAASIM-DAJ-010-2023.pdf",
    },
  ],
  // 1
  [
    "Construccion",
    "2do Trimestre",
    "Construccion",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Construccion/111.2023.pdf",
    },
  ],
  // 2
  [
    "Construccion",
    "2do Trimestre",
    "Construccion",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Construccion/112.2023.pdf",
    },
  ],
  // 3
  [
    "Construccion",
    "2do Trimestre",
    "Construccion",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Construccion/115.2023.pdf",
    },
  ],
  // 4
  [
    "Construccion",
    "2do Trimestre",
    "Construccion",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Construccion/CAASIM-DAJ-132-2023 CERCADOS.pdf",
    },
  ],
  // 5
  [
    "Construccion",
    "2do Trimestre",
    "Construccion",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Construccion/CAASIM-DAJ-133-2023 CERCADOS NO.pdf",
    },
  ],
  // 1
  [
    "Compras",
    "2do Trimestre",
    "Beatriz Martinez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-67.pdf",
    },
  ],
  // 2
  [
    "Compras",
    "2do Trimestre",
    "Beatriz Martinez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-73.pdf",
    },
  ],
  // 3
  [
    "Compras",
    "2do Trimestre",
    "Beatriz Martinez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-86.pdf",
    },
  ],
  // 1
  [
    "Licitaciones FALLOS",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/FALLO CAASIM-HGO-L.O.P-14-2023.pdf",
    },
  ],
  // 2
  [
    "Licitaciones FALLOS",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/FALLO CAASIM-HGO-L.O.P-15-2023.pdf",
    },
  ],
  // 3
  [
    "Licitaciones FALLOS",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/FALLO CAASIM-HGO-L.O.P-17-2023.pdf",
    },
  ],
  //4
  [
    "Licitaciones FALLOS",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/FALLO CAASIM-HGO-L.O.P-19-2023.pdf",
    },
  ],
  // 5
  [
    "Licitaciones FALLOS",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/FALLO CAASIM-HGO-L.O.P-21-2023.pdf",
    },
  ],
  // 1
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2023.pdf",
    },
  ],
  // 2
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2023.pdf",
    },
  ],
  // 3
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2023.pdf",
    },
  ],
  // 4
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2023.pdf",
    },
  ],
  // 5
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-2023.pdf",
    },
  ],
  // 6
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-06-2023.pdf",
    },
  ],
  // 7
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-07-2023.pdf",
    },
  ],
  // 8
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-08-2023.pdf",
    },
  ],
  // 9
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-09-2023.pdf",
    },
  ],
  // 10
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-10-2023.pdf",
    },
  ],
  // 11
  [
    "Licitaciones Juntas de Aclaraciones",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.OP.-11-2023.pdf",
    },
  ],
  // 1
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-12-2023.pdf",
    },
  ],
  // 2
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-13-2023.pdf",
    },
  ],
  // 3
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-14-2023.pdf",
    },
  ],
  // 4
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-15-2023.pdf",
    },
  ],
  // 5
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-16-2023.pdf",
    },
  ],
  // 6
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-17-2023.pdf",
    },
  ],
  // 7
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-18-2023.pdf",
    },
  ],
  // 8
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-19-2023.pdf",
    },
  ],
  // 9
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-20-2023.pdf",
    },
  ],
  // 10
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-21-2023.pdf",
    },
  ],
  // 11
  [
    "Aperturas Economicas",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TÉCNICA Y ECONÓMICA CAASIM-HGO-L.O.P.-22-2023.pdf",
    },
  ],
  // 1
  [
    "Construccion Avance Fisico y Financiero",
    "2do Trimestre",
    "Construccion",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Construccion/AVANCE FISICO Y FINANCIERO DE OBRA.pdf",
    },
  ],
  // 1
  [
    "Juridico Contratos",
    "2do Trimestre",
    "Jorge Daniel Hernandez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-121-2023.pdf",
    },
  ],
  // 2
  [
    "Juridico Contratos",
    "2do Trimestre",
    "Jorge Daniel Hernandez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-036-2023.pdf",
    },
  ],
  // 3
  [
    "Juridico Contratos",
    "2do Trimestre",
    "Jorge Daniel Hernandez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-056-2023.pdf",
    },
  ],
  // 4
  [
    "Juridico Contratos",
    "2do Trimestre",
    "Jorge Daniel Hernandez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-055-2023.pdf",
    },
  ],
  // 5
  [
    "Juridico Contratos",
    "2do Trimestre",
    "Jorge Daniel Hernandez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-051-2023.pdf",
    },
  ],
  // 6
  [
    "Juridico Contratos",
    "2do Trimestre",
    "Jorge Daniel Hernandez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-105-2023.pdf",
    },
  ],
  // 7
  [
    "Juridico Contratos",
    "2do Trimestre",
    "Jorge Daniel Hernandez",
    "29-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-120-2023.pdf",
    },
  ],
  // 1
  [
    "Licitaciones Junta de Aclaracion 12",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-12-2023 ZONA 1.pdf",
    },
  ],
  // 2
  [
    "Licitaciones Junta de Aclaracion 13",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-13-2023 ZONA 2.pdf",
    },
  ],
  // 3
  [
    "Licitaciones Junta de Aclaracion 14",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-14-2023 ZONA 3.pdf",
    },
  ],
  // 4
  [
    "Licitaciones Junta de Aclaracion 15",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-15-2023 ZONA 4.pdf",
    },
  ],
  // 5
  [
    "Licitaciones Junta de Aclaracion 16",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-16-2023.pdf",
    },
  ],
  // 6
  [
    "Licitaciones Junta de Aclaracion 17",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-17-2023.pdf",
    },
  ],
  // 7
  [
    "Licitaciones Junta de Aclaracion 18",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-18-2023.pdf",
    },
  ],
  // 8
  [
    "Licitaciones Junta de Aclaracion 19",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-19-2023.pdf",
    },
  ],
  // 9
  [
    "Licitaciones Junta de Aclaracion 20",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-20-2023.pdf",
    },
  ],
  // 10
  [
    "Licitaciones Junta de Aclaracion 21",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-21-2023.pdf",
    },
  ],
  // 11
  [
    "Licitaciones Junta de Aclaracion 22",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P-22-2023.pdf",
    },
  ],
  // 1
  [
    "Comunicacion Factura 908",
    "2do Trimestre",
    "Comunicacion",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Comunicacion/factura907.pdf",
    },
  ],
  // 2
  [
    "Comunicacion Factura 907",
    "2do Trimestre",
    "Comunicacion",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Comunicacion/factura908.pdf",
    },
  ],
  // 3
  [
    "Comunicacion Pedido 7002",
    "2do Trimestre",
    "Comunicacion",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Comunicacion/pedido7002.pdf",
    },
  ],
  // 4
  [
    "Comunicacion Pedido 7004",
    "2do Trimestre",
    "Comunicacion",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Comunicacion/pedido7004.pdf",
    },
  ],
  // 1
  [
    "Comercial Segundo Trimestre Articulo 48",
    "2do Trimestre",
    "Miguel Vivar Morales",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Comercial/SEGUNDO TRIMESTRE ARTICULO 69 FRACCIÓN  48 PROACTIVA.pdf",
    },
  ],
  // 1
  [
    "Licitaciones Junta de Aclaracion 16",
    "2do Trimestre",
    "Beatriz Martinez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/JUNTA DE ACLARACIONES EA-913005999-N16-2023 MUEBLES DE OFICINA, ESTANTERIA Y EQUIPO DE ADMINISTRACION.pdf",
    },
  ],
  // 1
  [
    "Apertura 3",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-03-2023.pdf",
    },
  ],
  // 2
  [
    "Apertura 9",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-09-2023.pdf",
    },
  ],
  // 3
  [
    "Apertura 10",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-10-2023.pdf",
    },
  ],
  // 4
  [
    "Apertura 11",
    "2do Trimestre",
    "Karla Eloisa Mora Abonce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/APERTURA TECNICA Y ECONOMICA CAASIM-HGO-L.O.P.-11-2023.pdf",
    },
  ],
  // 1
  [
    "Contrato DAJ-058-2023",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/1er Trimestre/Juridico/Contrato DAJ-058-2023.pdf",
    },
  ],
  // 2
  [
    "Contrato DAJ-059-2023",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/1er Trimestre/Juridico/Contrato DAJ-059-2023.pdf",
    },
  ],
  // 3
  [
    "Contrato DAJ-060-2023",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/1er Trimestre/Juridico/Contrato DAJ-060-2023.pdf",
    },
  ],
  // 4
  [
    "Contrato DAJ-073-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-073-2023.pdf",
    },
  ],
  // 5
  [
    "Contrato DAJ-123-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-123-2023.pdf",
    },
  ],
  // 6
  [
    "Contrato DAJ-128-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-128-2023.pdf",
    },
  ],
  // 7
  [
    "Contrato DAJ-129-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-129-2023.pdf",
    },
  ],
  // 8
  [
    "Contrato DAJ-130-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-130-2023.pdf",
    },
  ],
  // 9
  [
    "Contrato DAJ-132-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-132-2023.pdf",
    },
  ],
  // 10
  [
    "Contrato DAJ-133-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-133-2023.pdf",
    },
  ],
  // 1
  [
    "Licitaciones Autorizacion SPF-125-2023",
    "2do Trimestre",
    "Dulce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/AUTORIZACIÓN SPF-125-2023.pdf",
    },
  ],
  // 1
  [
    "Licitaciones PS 20230629001.pdf",
    "2do Trimestre",
    "Dulce",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/PS 20230629001.pdf",
    },
  ],
  // 1
  [
    "Compras SPF-70",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-70.pdf",
    },
  ],
  // 2
  [
    "Compras SPF-91",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-91.pdf",
    },
  ],
  // 3
  [
    "Compras SPF-92",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-92.pdf",
    },
  ],
  // 4
  [
    "Compras SPF-94",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-94.pdf",
    },
  ],
  // 5
  [
    "Compras SPF-95",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-95.pdf",
    },
  ],
  // 6
  [
    "Compras SPF-96",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-96.pdf",
    },
  ],
  // 7
  [
    "Compras SPF-98",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-98.pdf",
    },
  ],
  // 8
  [
    "Compras SPF-102",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-102.pdf",
    },
  ],
  // 9
  [
    "Compras SPF-103",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-103.pdf",
    },
  ],
  // 10
  [
    "Compras SPF-109",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-109.pdf",
    },
  ],
  // 11
  [
    "Compras SPF-113",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-113.pdf",
    },
  ],
  // 12
  [
    "Compras SPF-115",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-115.pdf",
    },
  ],
  // 13
  [
    "Compras OS-20230418008",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OS-20230418008.pdf",
    },
  ],
  // 14
  [
    "Compras OS-20230612001",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OS-20230612001.pdf",
    },
  ],
  // 15
  [
    "Compras SPF-14",
    "2do Trimestre",
    "Ines Flores Perez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/SPF-115.pdf",
    },
  ],
  // 1
  [
    "ST Avance Abril-Junio",
    "2do Trimestre",
    "Itzel Ortiz Vazquez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Secretaria Tecnica/AVANCE ABRIL-JUNIO.pdf",
    },
  ],
  // 1
  [
    "Compras Mantenimiento SPF-121",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/Mantenimiento-SPF-121-2023.pdf",
    },
  ],
  // 2
  [
    "Compras - Oficio de autorizacion 01 Al 06",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION CAASIM-AD-OP-01AL06-2023001.pdf",
    },
  ],
  // 3
  [
    "Compra - Oficio de autorizacion 7",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION CAASIM-AD-OP-07-2023001.pdf",
    },
  ],
  // 4
  [
    "Compras - Oficio de autorizacion 8",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION CAASIM-AD-OP-08-2023001.pdf",
    },
  ],
  // 5
  [
    "Compras - Oficio de autorizacion 9",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION CAASIM-AD-OP-09-2023001.pdf",
    },
  ],
  // 6
  [
    "Compras - Oficio de autorizacion 10",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION CAASIM-AD-OP-10-2023001.pdf",
    },
  ],
  // 7
  [
    "Compras - Oficio de autorizacion 11",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION CAASIM-AD-OP-11-2023001.pdf",
    },
  ],
  // 8
  [
    "Compras - Oficio de autorizacion N3-2023-001",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION EA-913005999-N3-2023001.pdf",
    },
  ],
  // 9
  [
    "Compras - Oficio de autorizacion N4-2023-001",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/OFICIO DE AUTORIZACION EA-913005999-N4-2023001.pdf",
    },
  ],
  // 10
  [
    "Compras - Servicios Integrales SPF-117-2023",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/Serv. Integrales-SPF-117-2023.pdf",
    },
  ],
  // 11
  [
    "Compras - Sust. Quim.-SPF-085-2023",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/Sust. Quim.-SPF-085-2023.pdf",
    },
  ],
  // 12
  [
    "Compras - Vactor-SPF-107-2023",
    "2do Trimestre",
    "Fernanda Garcia",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Compras/Vactor-SPF-107-2023.pdf",
    },
  ],
  // 1
  [
    "Compras - Dictamen Tecnico para autorizar",
    "2do Trimestre",
    "Miguel Vivar Morales",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Comercial/dictamen técnico para autorizar derivación de toma.pdf",
    },
  ],
  // 2
  [
    "Compras - Solicitud de servicio",
    "2do Trimestre",
    "Miguel Vivar Morales",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Comercial/solicitud de servicio.pdf",
    },
  ],
  // 1
  [
    "A y F - 2293",
    "2do Trimestre",
    "Mónica Yezmín Hernández Ávila",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Administracion y Finanzas/2293.pdf",
    },
  ],
  // 2
  [
    "A y F - 2294",
    "2do Trimestre",
    "Mónica Yezmín Hernández Ávila",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Administracion y Finanzas/2294.pdf",
    },
  ],
  // 3
  [
    "A y F - 2311",
    "2do Trimestre",
    "Mónica Yezmín Hernández Ávila",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Administracion y Finanzas/2311.pdf",
    },
  ],
  // 4
  [
    "A y F - 2375",
    "2do Trimestre",
    "Mónica Yezmín Hernández Ávila",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Administracion y Finanzas/2375.pdf",
    },
  ],
  // 1
  [
    "Juridico - Convenio DAJ-014-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Convenio DAJ-014-2023.pdf",
    },
  ],
  // 2
  [
    "Juridico - Convenio DAJ-015-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Convenio DAJ-015-2023.pdf",
    },
  ],
  // 3
  [
    "Juridico - Convenio DAJ-016-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Convenio DAJ-016-2023.pdf",
    },
  ],
  // 4
  [
    "Juridico - Convenio DAJ-017-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Convenio DAJ-017-2023.pdf",
    },
  ],
  // 5
  [
    "Juridico - Convenio DAJ-018-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Convenio DAJ-018-2023.pdf",
    },
  ],
  // 1
  [
    "Juridico - Padrón de Subsidios Abr-Jun 2023.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Padrón de Subsidios Abr-Jun 2023.pdf",
    },
  ],
  // 2
  [
    "Juridico - Contrato CAASIM-DAJ-024-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "4-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/1er Trimestre/Juridico/Contrato CAASIM-DAJ-024-2023.pdf",
    },
  ],
  // 1
  [
    "ST - Anexo a69_f41CAASIMf",
    "2do Trimestre",
    "Flor Natalia Sánchez Nochebuena",
    "05-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Secretaria Tecnica/Anexo a69_f41CAASIM ST 2o Trim.pdf",
    },
  ],
  // 1
  [
    "Faltantes - Ley Art 33.pdf",
    "Desconocido",
    "Anonimo",
    "Desconocido",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/rubros/rubro 28/ley art 33.pdf",
    },
  ],
  // 2
  [
    "Faltantes - Contrato 140",
    "Desconocido",
    "Anonimo",
    "Desconocido",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/rubros/rubro 27/contrato 140.pdf",
    },
  ],
  // 1
  [
    "DAB - A.69 f.30 Actividades P.13",
    "2do Trimestre",
    "Martin Velazquez Ortega",
    "06-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Abasto/A.69 f.30 Actividades P.13.pdf",
    },
  ],
  // 2
  [
    "DAB - A.69 f.30 Actividades P.22",
    "2do Trimestre",
    "Martin Velazquez Ortega",
    "06-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Abasto/A.69 f.30 Actividades P.22.pdf",
    },
  ],
  // 3
  [
    "DAB - A.69 f.30 INDICADORES Proy. 13",
    "2do Trimestre",
    "Martin Velazquez Ortega",
    "06-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Abasto/A.69 f.30 INDICADORES Proy. 13.pdf",
    },
  ],
  // 4
  [
    "DAB - A.69 f.30 INDICADORES Proyecto 22",
    "2do Trimestre",
    "Martin Velazquez Ortega",
    "06-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Abasto/A.69 f.30 INDICADORES Proyecto 22.pdf",
    },
  ],
  // 5
  [
    "DAB - GRAFICA PROY. 13  A.69 f.30",
    "2do Trimestre",
    "Martin Velazquez Ortega",
    "06-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Abasto/GRAFICA PROY. 13  A.69 f.30.pdf",
    },
  ],
  // 6
  [
    "DAB - GRAFICA PROY. 22  A.69 f.30.pdf",
    "2do Trimestre",
    "Martin Velazquez Ortega",
    "06-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Abasto/GRAFICA PROY. 22  A.69 f.30.pdf",
    },
  ],
  // 1
  [
    "ST - doc00903120230706104541.pdf",
    "2do Trimestre",
    "Itzel Ortiz Vazquez",
    "30-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Secretaria Tecnica/doc00903120230706104541.pdf",
    },
  ],
  // 1
  [
    "Licitaciones - AUTORIZACIÓN 122-027",
    "2do Trimestre",
    "Karla Mora Abonce",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/AUTORIZACIÓN 122-027.pdf",
    },
  ],
  // 2
  [
    "Licitaciones - AUTORIZACIÓN SPF-76-2023",
    "2do Trimestre",
    "Karla Mora Abonce",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/AUTORIZACIÓN SPF-76-2023  14.pdf",
    },
  ],
  // 3
  [
    "Licitaciones - AUTORIZACIÓN SPF-82-2023  19",
    "2do Trimestre",
    "Karla Mora Abonce",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/AUTORIZACIÓN SPF-82-2023  19.pdf",
    },
  ],
  // 4
  [
    "Licitaciones - AUTORIZACIÓN SPF-99-2023 ADPE023",
    "2do Trimestre",
    "Karla Mora Abonce",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/AUTORIZACIÓN SPF-99-2023 ADPE023.pdf",
    },
  ],
  // 5
  [
    "Licitaciones - AUTORIZACIÓN SPF-119-2023 ADPE026",
    "2do Trimestre",
    "Karla Mora Abonce",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/AUTORIZACIÓN SPF-119-2023 ADPE026.pdf",
    },
  ],
  // 1
  [
    "Juridico - Contrato DAJ-143-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-143-2023.pdf",
    },
  ],
  // 2
  [
    "Juridico - Contrato DAJ-144-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-144-2023.pdf",
    },
  ],
  // 3
  [
    "Juridico - Contrato DAJ-145-2023.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "11-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Juridico/Contrato DAJ-145-2023.pdf",
    },
  ],
  // 1
  [
    "Licitaciones - Contrato DAJ-145-2023",
    "2do Trimestre",
    "Fernanda Garcia",
    "18-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/PEDIDO-CONTRATO 028-2023001.pdf",
    },
  ],
  // 2
  [
    "Licitaciones - Contrato DAJ-145-2023",
    "3er Trimestre",
    "Fernanda Garcia",
    "18-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DCONS/PEDIDO-CONTRATO 028-2023001.pdf",
    },
  ],
  // 1
  [
    "Licitaciones - EA-913005999-N22-2023 DAF-29702023",
    "3er Trimestre",
    "Fernanda Garcia",
    "18-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/dir1/2023/2do Trimestre/Licitaciones/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N22-2023 DAF-29702023 ESTUDIO DE EFICIENCIA.pdf",
    },
  ],
  // 1
  [
    "Compras - P 040-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "26-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/P 040-2023.pdf",
    },
  ],
  // 2
  [
    "Compras - P 032-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "26-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/P 032-2023.pdf",
    },
  ],
  // 1
  [
    "DAJ - Convenio CAASIM-DAJ-021-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/2do Trimestre/DAJ/Convenio CAASIM-DAJ-021-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Convenio Convenio CAASIM-DAJ-026-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/2do Trimestre/DAJ/Convenio CAASIM-DAJ-026-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Convenio Contrato CAASIM-DAJ-134-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/2do Trimestre/DAJ/Contrato CAASIM-DAJ-134-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Convenio Contrato CAASIM-DAJ-135-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/2do Trimestre/DAJ/Contrato CAASIM-DAJ-135-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-147-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-147-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato CAASIM-DAJ-148-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-148-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Convenio Contrato CAASIM-DAJ-149-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-149-2023.pdf",
    },
  ],
  // 9
  [
    "DAJ - Contrato CAASIM-DAJ-150-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-150-2023.pdf",
    },
  ],
  // 10
  [
    "DAJ - Contrato CAASIM-DAJ-151-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-151-2023.pdf",
    },
  ],
  // 11
  [
    "DAJ - Contrato CAASIM-DAJ-152-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-152-2023.pdf",
    },
  ],
  // 12
  [
    "DAJ - Contrato CAASIM-DAJ-155-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-155-2023.pdf",
    },
  ],
  // 13
  [
    "DAJ - Contrato CAASIM-DAJ-156-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-156-2023.pdf",
    },
  ],
  // 14
  [
    "DAJ - Contrato CAASIM-DAJ-157-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-157-2023.pdf",
    },
  ],
  // 15
  [
    "DAJ - Contrato CAASIM-DAJ-158-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-158-2023.pdf",
    },
  ],
  // 16
  [
    "DAJ - Contrato CAASIM-DAJ-159-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-159-2023.pdf",
    },
  ],
  // 17
  [
    "DAJ - Contrato CAASIM-DAJ-160-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-160-2023.pdf",
    },
  ],
  // 17
  [
    "DAJ - LA LEY ESTATAL DEL AGUA",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-07-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Ley Estatal de Agua y Alcantarillado para el Estado de Hidalgo.pdf",
    },
  ],
  [
    "RH - 2290Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2290Y.pdf",
    },
  ],
  [
    "RH - 2291y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2291y.pdf",
    },
  ],
  [
    "RH - 2292y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2292y.pdf",
    },
  ],
  [
    "RH - 2293y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2293y.pdf",
    },
  ],
  [
    "RH - 2294y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2294y.pdf",
    },
  ],
  [
    "RH - 2295y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2295y.pdf",
    },
  ],
  [
    "RH - 2296Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2296Y.pdf",
    },
  ],
  [
    "RH - 2297Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2297Y.pdf",
    },
  ],
  [
    "RH - 2300Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2300Y.pdf",
    },
  ],
  [
    "RH - 2301Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2301Y.pdf",
    },
  ],
  [
    "RH - 2302Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2302Y.pdf",
    },
  ],
  [
    "RH - 2303Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2303Y.pdf",
    },
  ],
  [
    "RH - 2305Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2305Y.pdf",
    },
  ],
  [
    "RH - 2306Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2306Y.pdf",
    },
  ],
  [
    "RH - 2308Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2308Y.pdf",
    },
  ],
  [
    "RH - 2309Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2309Y.pdf",
    },
  ],
  [
    "RH - 2310Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2310Y.pdf",
    },
  ],
  [
    "RH - 2311Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2311Y.pdf",
    },
  ],
  [
    "RH - 2312Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2312Y.pdf",
    },
  ],
  [
    "RH - 2314Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2314Y.pdf",
    },
  ],
  [
    "RH - 2315Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2315Y.pdf",
    },
  ],
  [
    "RH - 2316Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2316Y.pdf",
    },
  ],
  [
    "RH - 2317Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2317Y.pdf",
    },
  ],
  [
    "RH - 2318Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2318Y.pdf",
    },
  ],
  [
    "RH - 2325Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2325Y.pdf",
    },
  ],
  [
    "RH - 2326Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2326Y.pdf",
    },
  ],
  [
    "RH - 2329Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2329Y.pdf",
    },
  ],
  [
    "RH - 2331Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2331Y.pdf",
    },
  ],
  [
    "RH - 2333Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2333Y.pdf",
    },
  ],
  [
    "RH - 2335Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2335Y.pdf",
    },
  ],
  [
    "RH - 2337Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2337Y.pdf",
    },
  ],
  [
    "RH - 2338Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2338Y.pdf",
    },
  ],
  [
    "RH - 2339Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2339Y.pdf",
    },
  ],
  [
    "RH - 2340Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2340Y.pdf",
    },
  ],
  [
    "RH - 2341Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2341Y.pdf",
    },
  ],
  [
    "RH - 2342Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2342Y.pdf",
    },
  ],
  [
    "RH - 2343Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2343Y.pdf",
    },
  ],
  [
    "RH - 2344Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2344Y.pdf",
    },
  ],
  [
    "RH - 2345Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2345Y.pdf",
    },
  ],
  [
    "RH - 2346Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2346Y.pdf",
    },
  ],
  [
    "RH - 2347Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2347Y.pdf",
    },
  ],
  [
    "RH - 2348Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2348Y.pdf",
    },
  ],
  [
    "RH - 2349Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2349Y.pdf",
    },
  ],
  [
    "RH - 2350Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2350Y.pdf",
    },
  ],
  [
    "RH - 2354Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2354Y.pdf",
    },
  ],
  [
    "RH - 2355Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2355Y.pdf",
    },
  ],
  [
    "RH - 2356Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2356Y.pdf",
    },
  ],
  [
    "RH - 2357Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2357Y.pdf",
    },
  ],
  [
    "RH - 2358Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2358Y.pdf",
    },
  ],
  [
    "RH - 2360Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2360Y.pdf",
    },
  ],
  [
    "RH - 2361Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2361Y.pdf",
    },
  ],
  [
    "RH - 2362Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2362Y.pdf",
    },
  ],
  [
    "RH - 2364Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2364Y.pdf",
    },
  ],
  [
    "RH - 2366Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2366Y.pdf",
    },
  ],
  [
    "RH - 2367Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2367Y.pdf",
    },
  ],
  [
    "RH - 2368Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2368Y.pdf",
    },
  ],
  [
    "RH - 2370Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2370Y.pdf",
    },
  ],
  [
    "RH - 2372Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2372Y.pdf",
    },
  ],
  [
    "RH - 2374Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2374Y.pdf",
    },
  ],
  [
    "RH - 2375Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2375Y.pdf",
    },
  ],
  [
    "RH - 2376Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2376Y.pdf",
    },
  ],
  [
    "RH - 2401Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2401Y.pdf",
    },
  ],
  [
    "RH - 2402Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2402Y.pdf",
    },
  ],
  [
    "RH - 2403Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2403Y.pdf",
    },
  ],
  [
    "RH - 2404Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2404Y.pdf",
    },
  ],
  [
    "RH - 2405Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2405Y.pdf",
    },
  ],
  [
    "RH - 2406Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2406Y.pdf",
    },
  ],
  [
    "RH - 2407Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2407Y.pdf",
    },
  ],
  [
    "RH - 2408Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2408Y.pdf",
    },
  ],
  [
    "RH - 2409Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2409Y.pdf",
    },
  ],
  [
    "RH - 2411Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2411Y.pdf",
    },
  ],
  [
    "RH - 2414Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2414Y.pdf",
    },
  ],
  [
    "RH - 2415Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2415Y.pdf",
    },
  ],
  [
    "RH - 2424Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2424Y.pdf",
    },
  ],
  [
    "RH - 2426Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2426Y.pdf",
    },
  ],
  [
    "RH - 2427Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2427Y.pdf",
    },
  ],
  [
    "RH - 2429Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2429Y.pdf",
    },
  ],
  [
    "RH - 2430Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2430Y.pdf",
    },
  ],
  [
    "RH - 2432Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2432Y.pdf",
    },
  ],
  [
    "RH - 2433Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2433Y.pdf",
    },
  ],
  [
    "RH - 2434Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2434Y.pdf",
    },
  ],
  [
    "RH - 2435Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2435Y.pdf",
    },
  ],
  [
    "RH - 2436Y.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/2436Y.pdf",
    },
  ],
  // 1
  [
    "DAJ - Contrato DAJ-131-2023.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "02-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/2do Trimestre/DAJ/Contrato DAJ-131-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-164-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-164-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-166-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-166-2023.pdf",
    },
  ],
  // 1
  [
    "DAJ - Contrato DAJ-146-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-146-2023.pdf",
    },
  ],
  // 1
  [
    "DAJ - Contrato DAJ-154-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "10-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-154-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-165-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "10-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-165-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-168-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "10-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-168-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-169-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "10-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-169-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-170-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "10-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-170-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-171-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "10-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-171-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-179-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "23-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-179-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-153-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "23-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-153-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - P.C. 046-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "28-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/P.C. 046-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - P.C. 059-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "28-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/P.C. 059-2023.pdf",
    },
  ],
  // 1
  [
    "DAJ - Contrato DAJ-161-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-161-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-162-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-162-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-172-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-172-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-163-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-163-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-173-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-173-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-174-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-174-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato DAJ-175-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-175-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Contrato DAJ-177-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "30-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-177-2023.pdf",
    },
  ],
  // 1
  [
    "DAF-S-RM - PEDIDO CONTRATO 058-2023.pdf",
    "3er Trimestre",
    "Maria Fernanda Garcia",
    "04-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PEDIDO CONTRATO 058-2023.pdf",
    },
  ],
  // 1
  [
    "DAF-S-RM - PEDIDO 048-2023 CODES.pdf",
    "3er Trimestre",
    "Dulce",
    "04-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PEDIDO 048-2023 CODES.pdf",
    },
  ],
  // 1
  [
    "DAJ - Contrato DAJ-182-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "06-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-182-2023.pdf",
    },
  ],
  // 1
  [
    "DAJ - Contrato DAJ-176-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-176-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-180-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-180-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-183-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-183-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-184-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-184-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-185-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-185-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-186-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-186-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato DAJ-187-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-187-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Contrato DAJ-188-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-188-2023.pdf",
    },
  ],
  // 9
  [
    "DAJ - Contrato DAJ-190-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-190-2023.pdf",
    },
  ],
  // 10
  [
    "DAJ - Contrato DAJ-194-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-194-2023.pdf",
    },
  ],
  // 1
  [
    "DAJ - Contrato DAJ-189-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-189-2023.pdf",
    },
  ],

  // 1
  [
    "DAJ - Contrato DAJ-124-2023",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/2do Trimestre/DAJ/Contrato DAJ-124-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-167-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-167-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-195-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-195-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-196-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "08-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-196-2023.pdf",
    },
  ],

  // 1
  [
    "DAJ - Contrato DAJ-178-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "09-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-178-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-197-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "09-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-197-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-204-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "09-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-204-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-205-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "09-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-205-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-206-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "09-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-206-2023.pdf",
    },
  ],
  // Links for DAF-S-PCF
  // 1
  [
    "DAJ-S-PCF - OFICIO DAF-2372-2023 R-364",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OFICIO DAF-2372-2023 R-364.pdf",
    },
  ],
  // 2
  [
    "DAJ-S-PCF - OFICIO DAF-2966-2023 R-220",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OFICIO DAF-2966-2023 R-220.pdf",
    },
  ],
  // 3
  [
    "DAJ-S-PCF - OFICIO DAF-2966-2023 R-276",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OFICIO DAF-2966-2023 R-276.pdf",
    },
  ],
  // 4
  [
    "DAJ-S-PCF - OFICIO DAF-2966-2023 R-291",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OFICIO DAF-2966-2023 R-291.pdf",
    },
  ],
  // 5
  [
    "DAJ-S-PCF - OFICIO DAF-3280-2023 ALFER",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OFICIO DAF-3280-2023 ALFER.pdf",
    },
  ],
  // 6
  [
    "DAJ-S-PCF - OS 20230612001",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OS 20230612001.pdf",
    },
  ],
  // 7
  [
    "DAJ-S-PCF - OS 20230718004._",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OS 20230718004._.pdf",
    },
  ],
  // 8
  [
    "DAJ-S-PCF - OS 20230718004",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OS 20230718004.pdf",
    },
  ],
  // 9
  [
    "DAJ-S-PCF - OS 20230718004_",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/OS 20230718004_.pdf",
    },
  ],
  // 10
  [
    "DAJ-S-PCF - PS 20230803001",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/PS 20230803001.pdf",
    },
  ],
  // Link for Archivo
  [
    "Archivo - CUADRO GENERAL DE CLASIFICACION ARCHIVISTICA 2022.pdf",
    "No especificado",
    "Guille Trejo",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2022/Archivo/CUADRO GENERAL DE CLASIFICACION ARCHIVISTICA 2022.pdf",
    },
  ],
  // Link for Alexia Monterrubio
  [
    "DAF-S-PF - CAASIM (3).pdf",
    "3er Trimestre",
    "Alexia Monterrubio",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/CAASIM (3).pdf",
    },
  ],
  // Link for Ines Flores
  // 1
  [
    "DAF-S-RM - SPF-130-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-130-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - SPF-131-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-131-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - SPF-132-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-132-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - SPF-133-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-133-2023.pdf",
    },
  ],
  // 5
  [
    "DAF-S-RM - SPF-148-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-148-2023.pdf",
    },
  ],
  // 6
  [
    "DAF-S-RM - SPF-150-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-150-2023.pdf",
    },
  ],
  // 7
  [
    "DAF-S-RM -SPF-155-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-155-2023.pdf",
    },
  ],
  // 8
  [
    "DAF-S-RM - SPF-163-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-163-2023.pdf",
    },
  ],
  // 9
  [
    "DAF-S-RM - SPF-170-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-170-2023.pdf",
    },
  ],
  // 10
  [
    "DAF-S-RM - SPF-171-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-171-2023.pdf",
    },
  ],
  // 11
  [
    "DAF-S-RM - SPF-179-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-179-2023.pdf",
    },
  ],
  // 12
  [
    "DAF-S-RM - SPF-182-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-182-2023.pdf",
    },
  ],
  // 13
  [
    "DAF-S-RM - SPF-189-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-189-2023.pdf",
    },
  ],
  // 14
  [
    "DAF-S-RM - SPF-197-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "21-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-197-2023.pdf",
    },
  ],
  // Links for DAF-S-PCF
  // 1
  [
    "DAJ-S-PCF - PS 20230804001",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/PS 20230804001.pdf",
    },
  ],
  // 2
  [
    "DAJ-S-PCF - PS 20230816001",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/PS 20230816001.pdf",
    },
  ],
  // 3
  [
    "DAJ-S-PCF - PS 20230904001",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/PS 20230904001.pdf",
    },
  ],
  // 4
  [
    "DAJ-S-PCF - PS 20230904002",
    "3er Trimestre",
    "Cristina Mejia",
    "20-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/PS 20230904002.pdf",
    },
  ],
  // Links para Cristina Mejia
  // 1
  [
    "DAJ-S-PCF - SPF-153-2023",
    "3er Trimestre",
    "Cristina Mejia",
    "22-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/SPF-153-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ-S-PCF - SPF-188-2023",
    "3er Trimestre",
    "Cristina Mejia",
    "22-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/SPF-188-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ-S-PCF - SPF-200-2023",
    "3er Trimestre",
    "Cristina Mejia",
    "22-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/SPF-200-2023.pdf",
    },
  ],
  // Links for Jorge Daniel Olguin
  // 1
  [
    "DAJ - Contrato DAJ-207-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "22-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-207-2023.pdf",
    },
  ],
  // 2
  // 1
  [
    "DAJ - Contrato DAJ-208-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "22-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-208-2023.pdf",
    },
  ],
  // Amparo Flores
  // 1
  [
    "DAF-S-PCF - 3er-2023transp",
    "3er Trimestre",
    "Amparo Flores",
    "25-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/3er-2023transp.pdf",
    },
  ],
  // Yair Arturo Diaz Perez
  // 1
  [
    "DAF-S-PCF - SPF-156-2023",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "25-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/SPF-156-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-PCF - SPF-157-2023",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "25-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/SPF-157-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-PCF - SPF-164-2023",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "25-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/SPF-164-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-PCF - SPF-191-2023",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "25-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/SPF-191-2023.pdf",
    },
  ],
  // Link Licitaciones
  // 1
  [
    "DAF-S-RM - Aut. SPF-046-2023",
    "3er Trimestre",
    "Desconocido",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Aut. SPF-046-2023.pdf",
    },
  ],
  // Link Licitaciones Karla
  // 1
  [
    "DAF-S-RM - APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2023",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/APERTURA TECNICA Y ECONOMICA EA-913005999-N30-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - FALLO EA-913005999-N23-2023 HERRAMIENTA MENOR",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/FALLO EA-913005999-N23-2023 HERRAMIENTA MENOR.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - FALLO EA-913005999-N30-2023",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/FALLO EA-913005999-N30-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - FALLO EA-913005999-N33-2023 HERRAMIENTAS MENORES (SEGUNDO PROCEDIMIENTO)",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/FALLO EA-913005999-N33-2023 HERRAMIENTAS MENORES (SEGUNDO PROCEDIMIENTO).pdf",
    },
  ],
  // 5
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N23-2023",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/JUNTA DE ACLARACIONES EA-913005999-N23-2023.pdf",
    },
  ],
  // 6
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N30-2023",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/JUNTA DE ACLARACIONES EA-913005999-N30-2023.pdf",
    },
  ],
  // 7
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N33-2023 HERRAMIENTA MENOR",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/JUNTA DE ACLARACIONES EA-913005999-N33-2023 HERRAMIENTA MENOR.pdf",
    },
  ],
  // 8
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N23-2023 HERRAMIENTAS MENORES",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N23-2023 HERRAMIENTAS MENORES.pdf",
    },
  ],
  // 9
  [
    "DAF-S-RM - PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2023",
    "3er Trimestre",
    "Karla Licitaciones",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2023.pdf",
    },
  ],
  // Link Fernanda trans
  // 1
  [
    "DAF-S-RM - CAASIM-HGO-INV3-OP-01-2023",
    "3er Trimestre",
    "Fernanda Amezcua",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/CAASIM-HGO-INV3-OP-01-2023.pdf",
    },
  ],
  // Convenios Links Transparencia
  // 1
  [
    "DAF-S-RM - Conv 01-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 01-23.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - Conv 02-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 02-23.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - Conv 03-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 03-23.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - Conv 04-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 04-23.pdf",
    },
  ],
  // 5
  [
    "DAF-S-RM - Conv 05-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 05-23.pdf",
    },
  ],
  // 6
  [
    "DAF-S-RM - Conv 06-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 06-23.pdf",
    },
  ],
  // 7
  [
    "DAF-S-RM - Conv 07-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 07-23.pdf",
    },
  ],
  // 8
  [
    "DAF-S-RM - Conv 08-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 08-23.pdf",
    },
  ],
  // 9
  [
    "DAF-S-RM - Conv 09-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 09-23.pdf",
    },
  ],
  // 10
  [
    "DAF-S-RM - Conv 10-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 10-23.pdf",
    },
  ],
  // 11
  [
    "DAF-S-RM - Conv 11-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 11-23.pdf",
    },
  ],
  // 12
  [
    "DAF-S-RM - Conv 12-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 12-23.pdf",
    },
  ],
  // 13
  [
    "DAF-S-RM - Conv 13-23",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Conv 13-23.pdf",
    },
  ],
  // Other Licitaciones Link
  // 1
  [
    "DAF-S-RM - autorización spf-165-2023",
    "3er Trimestre",
    "Anonimo",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/autorización spf-165-2023.pdf",
    },
  ],
  // Direccion Comercial
  // 1
  [
    "DCOME - LINEAMIENTOS GENERALES PARA LA ATENCIÓN DE AJUSTES A LA FACTURACIÓN,CONSUMOS Y REGULARIZACIÓN DE USUARIOS DE LA CAASIM_",
    "3er Trimestre",
    "Miguel Vivar",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DCOME/LINEAMIENTOS GENERALES PARA LA ATENCIÓN DE AJUSTES A LA FACTURACIÓN,CONSUMOS Y REGULARIZACIÓN DE USUARIOS DE LA CAASIM_.pdf",
    },
  ],
  // Ines Flores Links
  // 1
  [
    "DAF-S-RM - PC-71-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PC-71-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - SPF-207-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-207-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - SPF-208-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-208-2023.pdf",
    },
  ],
  // Link for Karla
  // 1
  [
    "DAF-S-RM - FALLO EA-913005999-N33-2023 HERRAMIENTA MENOR (SEGUNDO PROCEDIMI",
    "3er Trimestre",
    "Karla Mora",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/FALLO EA-913005999-N33-2023 HERRAMIENTA MENOR (SEGUNDO PROCEDIMI.pdf",
    },
  ],
  // Link for Fernanda
  // 1
  [
    "DAF-S-RM - HACIENDA-A-FAFEF-GI-2023-4019-00160",
    "3er Trimestre",
    "Fernanda Amezcua",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/HACIENDA-A-FAFEF-GI-2023-4019-00160.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - HACIENDA-A-FAFEF-GI-2023-4019-00189",
    "3er Trimestre",
    "Fernanda Amezcua",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/HACIENDA-A-FAFEF-GI-2023-4019-00189.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - HACIENDA-A-FAFEF-GI-2023-4019-00221",
    "3er Trimestre",
    "Fernanda Amezcua",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/HACIENDA-A-FAFEF-GI-2023-4019-00221.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - SPF-193-2023",
    "3er Trimestre",
    "Fernanda Amezcua",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-193-2023.pdf",
    },
  ],
  // 5
  [
    "DAF-S-RM - SPF-194-2023",
    "3er Trimestre",
    "Fernanda Amezcua",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-194-2023.pdf",
    },
  ],
  // Otro de Ines
  [
    "DAF-S-RM - PC-72-2023",
    "3er Trimestre",
    "Ines Flores Perez",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PC-72-2023.pdf",
    },
  ],
  // Otro de Licitaciones
  [
    "DAF-S-RM - PEDIDO CON REVERSO YURIDIA",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PEDIDO CON REVERSO YURIDIA.pdf",
    },
  ],
  [
    "DAF-S-RM - AUT SPF-079-2023",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "26-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/AUT SPF-079-2023.pdf",
    },
  ],
  // Links for Contratos
  // 1
  [
    "DAJ - Contrato DAJ-210-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-210-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-213-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-213-2023.pdf",
    },
  ],
  // Link for Karla
  // 1
  [
    "DAF-S-RM - OFICIO SPF-83-2023 AUTORIZACION N15 DESIERTAS",
    "3er Trimestre",
    "Karla Mora",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/OFICIO SPF-83-2023 AUTORIZACION N15 DESIERTAS.pdf",
    },
  ],
  // 1
  [
    "DAF-S-RM - SPF-87-2023",
    "3er Trimestre",
    "Yadira Alarcon",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-87-2023.pdf",
    },
  ],
  // 1
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES  ITP-CAASIM-SRMYSG-DL-02-2023",
    "3er Trimestre",
    "Desconocido",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/JUNTA DE ACLARACIONES  ITP-CAASIM-SRMYSG-DL-02-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - AUT SPF-187-2023",
    "3er Trimestre",
    "Desconocido",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/AUT SPF-187-2023.pdf",
    },
  ],
  // New Links
  // 1
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO 2 LAS GARZAS.pdf",
    "3er Trimestre",
    "Javier Acoltzi Conde",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO 2 LAS GARZAS.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO 3 TELLEZ.pdf",
    "3er Trimestre",
    "Javier Acoltzi Conde",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO 3 TELLEZ.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO C. DORIA.pdf",
    "3er Trimestre",
    "Javier Acoltzi Conde",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO C. DORIA.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO COLOSIO.pdf",
    "3er Trimestre",
    "Javier Acoltzi Conde",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO COLOSIO.pdf",
    },
  ],
  // 5
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO PROVIDENCIA 4.pdf",
    "3er Trimestre",
    "Javier Acoltzi Conde",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO PROVIDENCIA 4.pdf",
    },
  ],
  // 6
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO PTAR. MATILDE.pdf",
    "3er Trimestre",
    "Javier Acoltzi Conde",
    "27-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/OFICIO AUTORIZACIÓN DE SUFICIENCIA POZO PTAR. MATILDE.pdf",
    },
  ],
  // Links for comunicacion social
  // 1
  [
    "DG-S-COMU - facturaagosto",
    "3er Trimestre",
    "Anonimo",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/facturaagosto.pdf",
    },
  ],
  // 2
  [
    "DG-S-COMU - facturajulio",
    "3er Trimestre",
    "Anonimo",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/facturajulio.pdf",
    },
  ],
  // 3
  [
    "DG-S-COMU - facturaseptiembre",
    "3er Trimestre",
    "Anonimo",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/facturaseptiembre.pdf",
    },
  ],
  // 4
  [
    "DG-S-COMU - pedidoagosto",
    "3er Trimestre",
    "Anonimo",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/pedidoagosto.pdf",
    },
  ],
  // 5
  [
    "DG-S-COMU - pedidojulio",
    "3er Trimestre",
    "Anonimo",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/pedidojulio.pdf",
    },
  ],
  // 1
  [
    "DG-S-COMU - pedidoseptiembre",
    "3er Trimestre",
    "Anonimo",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/pedidoseptiembre.pdf",
    },
  ],
  // Links for DAJ
  // 1
  [
    "DAJ - contrato DAJ-191-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/contrato DAJ-191-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - contrato DAJ-192-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/contrato DAJ-192-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - contrato DAJ-193-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/contrato DAJ-193-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - contrato DAJ-201-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/contrato DAJ-201-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - contrato DAJ-202-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/contrato DAJ-202-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - convenio DAJ-038-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "28-06-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/convenio DAJ-038-2023.pdf",
    },
  ],
  // Link for Planeacion Financiera
  // 1
  [
    "DAF-S-PF - Acta de la 12 SE 2023",
    "3er Trimestre",
    "Bibiana Limon Perez",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Acta de la 12 SE 2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-PF - Acta de la 13 SE 2023",
    "3er Trimestre",
    "Bibiana Limon Perez",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Acta de la 13 SE 2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-PF - Acta de la 14 SE 2023",
    "3er Trimestre",
    "Bibiana Limon Perez",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Acta de la 14 SE 2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-PF - Acta de la 2 SO 2023",
    "3er Trimestre",
    "Bibiana Limon Perez",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Acta de la 2 SO 2023.pdf",
    },
  ],
  // Link for Amparito
  [
    "DAF-S-PF - Cuotas y tarifas 2023",
    "3er Trimestre",
    "Amparo Flores",
    "28-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Cuotas y tarifas 2023.pdf",
    },
  ],
  // Links for DAF-S-RM
  [
    "DAF-S-RM - Junta de aclaraciones EA-913005999-N40-2023 Servicios de Consultoría y Asesoría",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "29-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Junta de aclaraciones EA-913005999-N40-2023 Servicios de Consultoría y Asesoría.pdf",
    },
  ],
  // Link for Planeacion Financiera
  // 1
  [
    "DAF-S-PF - Acta de la 15 SE 2023.pdf",
    "3er Trimestre",
    "Bibiana Limon Perez",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Acta de la 15 SE 2023.pdf",
    },
  ],
  // 1
  [
    "DAF-S-PF - Acta de la 16 SE 2023.pdf",
    "3er Trimestre",
    "Bibiana Limon Perez",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Acta de la 16 SE 2023.pdf",
    },
  ],
  // Links for Planeacion de Infraestructura Hidraulica
  // 1
  [
    "DOH-S-PIH - Avance Físico financiero ST 3er Trimestre.pdf",
    "3er Trimestre",
    "Flor Natalia Sanchez Nochebuena",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DOH-S-PIH/Avance Físico financiero ST 3er Trimestre.pdf",
    },
  ],
  // Direccion de Construccion
  [
    "DCONS - AVANCE FISICO FINANCIERO",
    "3er Trimestre",
    "Rosalba",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DCONS/AVANCE FISICO FINANCIERO.pdf",
    },
  ],
  // Link Licitaciones Karla
  // 1
  [
    "DAF-S-RM - PEDIDO 066-2023_ CEASKAAN N33",
    "3er Trimestre",
    "Karla Licitaciones",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PEDIDO 066-2023_ CEASKAAN N33.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - PEDIDO 067-2023_ CODES N33",
    "3er Trimestre",
    "Karla Licitaciones",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PEDIDO 067-2023_ CODES N33.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - PEDIDO 069-2023_ MTZ BARRANCO N33",
    "3er Trimestre",
    "Karla Licitaciones",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PEDIDO 069-2023_ MTZ BARRANCO N33.pdf",
    },
  ],
  // Link for Betty Maragui
  [
    "DAF-S-RM - PC 073-2023.pdf",
    "3er Trimestre",
    "Betty Maragui",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PC 073-2023.pdf",
    },
  ],
  // Links for DAJ
  // 1
  [
    "DAJ - Contrato DAJ-200-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-200-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-212-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-212-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-218-2023",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-218-2023.pdf",
    },
  ],
  // Links for Maffer Garcia
  // 1
  [
    "DAF-S-RM - oficio de autorizacion fibras.pdf",
    "3er Trimestre",
    "Maffer Garcia",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/oficio de autorizacion fibras.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - pedido-contrato-058-2023.pdf",
    "3er Trimestre",
    "Maffer Garcia",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/pedido-contrato-058-2023.pdf",
    },
  ],
  // Link for Direccion Comercial
  [
    "DCOME - LINEAMIENTOS CAASIM",
    "3er Trimestre",
    "Desconocido",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DCOME/LINEAMIENTOS CAASIM..pdf",
    },
  ],
  [
    "DCOME - Transparencia proactiva Unidad Movil.pdf",
    "3er Trimestre",
    "Miguel Vivar",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DCOME/Transparencia proactiva Unidad Movil.pdf",
    },
  ],
  // Links for Recursos Humanos
  // 1
  [
    "RH - CEPCI",
    "3er Trimestre",
    "Amparo Flores",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/CEPCI.pdf",
    },
  ],
  // 2
  [
    "RH - COCODI",
    "3er Trimestre",
    "Amparo Flores",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/COCODI.pdf",
    },
  ],
  // 3
  [
    "RH - CÓDIGO CONDUCTA",
    "3er Trimestre",
    "Amparo Flores",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/CÓDIGO CONDUCTA.pdf",
    },
  ],
  // Links for Joana Abasto
  // 1
  [
    "DAB - 3er. Trimestre AbastoGRAFICA 20PROY.pdf",
    "3er Trimestre",
    "Joana Paz",
    "04-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAB/3er. Trimestre AbastoGRAFICA 20PROY.pdf",
    },
  ],
  // 2
  [
    "DAB - 3er. TrimestreAbastoGRAFICA 20PROY_.pdf",
    "3er Trimestre",
    "Joana Paz",
    "04-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAB/3er. TrimestreAbastoGRAFICA 20PROY_.pdf",
    },
  ],
  // 3
  [
    "DAB - ACTIVIDADES 3ER. TRIMESTRE.pdf",
    "3er Trimestre",
    "Joana Paz",
    "04-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAB/ACTIVIDADES 3ER. TRIMESTRE.pdf",
    },
  ],
  // 4
  [
    "DAB - ACTIVIDADES 3er_trimes.pdf",
    "3er Trimestre",
    "Joana Paz",
    "04-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAB/ACTIVIDADES 3er_trimes.pdf",
    },
  ],
  // 5
  [
    "DAB - INDICADORES 3ER. TRIMESTRE.pdf",
    "3er Trimestre",
    "Joana Paz",
    "04-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAB/INDICADORES 3ER. TRIMESTRE.pdf",
    },
  ],
  // 6
  [
    "DAB - INDICADORES 3er_trimes.pdf",
    "3er Trimestre",
    "Joana Paz",
    "04-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAB/INDICADORES 3er_trimes.pdf",
    },
  ],
  // Link for DAJ
  [
    "DAJ - Contrato DAJ-203-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-203-2023.pdf",
    },
  ],
  [
    "RH - 1816.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/1816.pdf",
    },
  ],
  [
    "RH - 1853.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/1853.pdf",
    },
  ],
  [
    "RH - 1989.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/1989.pdf",
    },
  ],
  [
    "RH - 2297.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2297.pdf",
    },
  ],
  [
    "RH - 2106.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2106.pdf",
    },
  ],
  [
    "RH - 2261.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2261.pdf",
    },
  ],
  [
    "RH - 228.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/228.pdf",
    },
  ],
  [
    "RH - 2541.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2541.pdf",
    },
  ],
  [
    "RH - 2547.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2547.pdf",
    },
  ],
  [
    "RH - 2556.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2556.pdf",
    },
  ],
  [
    "RH - 256.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/256.pdf",
    },
  ],
  [
    "RH - 2560.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2560.pdf",
    },
  ],
  [
    "RH - 2566.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2566.pdf",
    },
  ],
  [
    "RH - 2567.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2567.pdf",
    },
  ],
  [
    "RH - 2581.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2581.pdf",
    },
  ],
  [
    "RH - 2655.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2655.pdf",
    },
  ],
  [
    "RH - 2677.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2677.pdf",
    },
  ],
  [
    "RH - 2734.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2734.pdf",
    },
  ],
  [
    "RH - 2771.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2771.pdf",
    },
  ],
  [
    "RH - 2786.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2786.pdf",
    },
  ],
  [
    "RH - 2804.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2804.pdf",
    },
  ],
  [
    "RH - 2885.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2885.pdf",
    },
  ],
  [
    "RH - 2957.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2957.pdf",
    },
  ],
  [
    "RH - 2971.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2971.pdf",
    },
  ],
  [
    "RH - 2980.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/2980.pdf",
    },
  ],
  [
    "RH - 3001.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3001.pdf",
    },
  ],
  [
    "RH - 301.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/301.pdf",
    },
  ],
  [
    "RH - 3027.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3027.pdf",
    },
  ],
  [
    "RH - 3032.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3032.pdf",
    },
  ],
  [
    "RH - 3070.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3070.pdf",
    },
  ],
  [
    "RH - 3110.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3110.pdf",
    },
  ],
  [
    "RH - 3166.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3166.pdf",
    },
  ],
  [
    "RH - 3321.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3321.pdf",
    },
  ],
  [
    "RH - 3406.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3406.pdf",
    },
  ],
  [
    "RH - 3475.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3475.pdf",
    },
  ],
  [
    "RH - 349.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/349.pdf",
    },
  ],
  [
    "RH - 366.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/366.pdf",
    },
  ],
  [
    "RH - 3726.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3726.pdf",
    },
  ],
  [
    "RH - 3733.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3733.pdf",
    },
  ],
  [
    "RH - 376.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/376.pdf",
    },
  ],
  [
    "RH - 3962.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3962.pdf",
    },
  ],
  [
    "RH - 3967.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3967.pdf",
    },
  ],
  [
    "RH - 3970.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3970.pdf",
    },
  ],
  [
    "RH - 3978.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/3978.pdf",
    },
  ],
  [
    "RH - 4010.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4010.pdf",
    },
  ],
  [
    "RH - 4033.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4033.pdf",
    },
  ],
  [
    "RH - 4149.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4149.pdf",
    },
  ],
  [
    "RH - 4154.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4154.pdf",
    },
  ],
  [
    "RH - 4155.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4155.pdf",
    },
  ],
  [
    "RH - 4156.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4156.pdf",
    },
  ],
  [
    "RH - 4159.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4159.pdf",
    },
  ],
  [
    "RH - 4160.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4160.pdf",
    },
  ],
  [
    "RH - 4161.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4161.pdf",
    },
  ],
  [
    "RH - 4162.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4162.pdf",
    },
  ],
  [
    "RH - 4163.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4163.pdf",
    },
  ],
  [
    "RH - 4164.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4164.pdf",
    },
  ],
  [
    "RH - 4165.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4165.pdf",
    },
  ],
  [
    "RH - 4166.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4166.pdf",
    },
  ],
  [
    "RH - 4167.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4167.pdf",
    },
  ],
  [
    "RH - 4170.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4170.pdf",
    },
  ],
  [
    "RH - 4171.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4171.pdf",
    },
  ],
  [
    "RH - 4173.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4173.pdf",
    },
  ],
  [
    "RH - 4174.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4174.pdf",
    },
  ],
  [
    "RH - 4176.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4176.pdf",
    },
  ],
  [
    "RH - 4177.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4177.pdf",
    },
  ],
  [
    "RH - 4178.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4178.pdf",
    },
  ],
  [
    "RH - 4181.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4181.pdf",
    },
  ],
  [
    "RH - 4183.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4183.pdf",
    },
  ],
  [
    "RH - 4184.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4184.pdf",
    },
  ],
  [
    "RH - 4185.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4185.pdf",
    },
  ],
  [
    "RH - 4186.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4186.pdf",
    },
  ],
  [
    "RH - 4189.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4189.pdf",
    },
  ],
  [
    "RH - 4190.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4190.pdf",
    },
  ],
  [
    "RH - 4191.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4191.pdf",
    },
  ],
  [
    "RH - 4206.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4206.pdf",
    },
  ],
  [
    "RH - 4212.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4212.pdf",
    },
  ],
  [
    "RH - 4215.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4215.pdf",
    },
  ],
  [
    "RH - 4219.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4219.pdf",
    },
  ],
  [
    "RH - 4230.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4230.pdf",
    },
  ],
  [
    "RH - 4238.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4238.pdf",
    },
  ],
  [
    "RH - 4240.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4240.pdf",
    },
  ],
  [
    "RH - 4246.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4246.pdf",
    },
  ],
  [
    "RH - 4256.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4256.pdf",
    },
  ],
  [
    "RH - 4263.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "01-08-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RH/Nuevos/4263.pdf",
    },
  ],
  // Links for Planeacion de Infraestructura Hidraulica
  // 1
  [
    "DOH-S-PIH - Entregables F41 Testado",
    "3er Trimestre",
    "Flor Natalia Sanchez Nochebuena",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DOH-S-PIH/Entregables F41 Testado.pdf",
    },
  ],
  // Link for DAJ
  [
    "DAJ - Subsidios Jul-Sep 2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "03-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Subsidios Jul-Sep 2023.pdf",
    },
  ],
  // Links for PF
  // 1
  [
    "DAF-S-PF - Circular DAF-SPF-081.pdf",
    "3er Trimestre",
    "Marleen Barrera",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Circular DAF-SPF-081.pdf",
    },
  ],
  // 2
  [
    "DAF-S-PF - Circular DAF-SPF-086.pdf",
    "3er Trimestre",
    "Marleen Barrera",
    "02-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Circular DAF-SPF-086.pdf",
    },
  ],
  // Link for DAJ
  [
    "DAJ - LEAAyEH 27.10.22.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/LEAAyEH 27.10.22.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-222-2023.pdf",
    "3er Trimestre",
    "Daniel Olguin",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato CAASIM-DAJ-222-2023.pdf",
    },
  ],
  // Links for Licitaciones
  // 1
  [
    "DAF-S-RM - SPF-76-2023.pdf",
    "3er Trimestre",
    "Fernanda Amezcua",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-76-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - SPF-82-2023.pdf",
    "3er Trimestre",
    "Fernanda Amezcua",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-82-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - SPF-99-2023.pdf",
    "3er Trimestre",
    "Fernanda Amezcua",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-99-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - SPF-122-2023.pdf",
    "3er Trimestre",
    "Fernanda Amezcua",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/SPF-122-2023.pdf",
    },
  ],
  // Links Planeacion Financiera
  // 1
  [
    "DAF-S-PF - CONAIP-SNT-ACUERDO-ORD01-31-03-2023-03.pdf",
    "3er Trimestre",
    "Angelica Mirella Barrera Lugo",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/CONAIP-SNT-ACUERDO-ORD01-31-03-2023-03.pdf",
    },
  ],
  // 2
  [
    "DAF-S-PF - Lineamientos2023 04.2023.pdf",
    "3er Trimestre",
    "Angelica Mirella Barrera Lugo",
    "06-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Lineamientos2023 04.2023.pdf",
    },
  ],
  // Contratos por DAJ
  // 1
  [
    "DAJ - Contrato DAJ-198-2023.pdf",
    "3er Trimestre",
    "Daniel Olguin",
    "09-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-198-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Convenio DAJ-037-2023.pdf",
    "3er Trimestre",
    "Daniel Olguin",
    "09-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-037-2023.pdf",
    },
  ],
  // Link for DAF-S-RM
  [
    "DAF-S-RM - PC 074.pdf",
    "3er Trimestre",
    "Desconocido",
    "12-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PC 074.pdf",
    },
  ],
  // Link for DAF-S-RM
  // 1
  [
    "DAF-S-RM - Pedido-Contrato 184-2022.pdf",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "24-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Pedido-Contrato 184-2022.pdf",
    },
  ],
  // 1
  [
    "DAF-S-RM - Solicitud y Respuesta para eximir fianza AD-059.pdf",
    "3er Trimestre",
    "Yair Arturo Diaz Perez",
    "24-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/Solicitud y Respuesta para eximir fianza AD-059.pdf",
    },
  ],
  // Links for DAJ
  // 1
  [
    "DAJ - Convenio DAJ-037-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-037-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Convenio DAJ-034-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-034-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Convenio DAJ-032-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-032-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Convenio DAJ-031-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-031-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Convenio DAJ-030-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-030-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-221-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-221-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato DAJ-220-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-220-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Contrato DAJ-217-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-217-2023.pdf",
    },
  ],
  // 9
  [
    "DAJ - Contrato DAJ-215-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-215-2023.pdf",
    },
  ],
  // 10
  [
    "DAJ - Contrato DAJ-214-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-214-2023.pdf",
    },
  ],
  // 11
  [
    "DAJ - Contrato DAJ-198-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "25-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-198-2023.pdf",
    },
  ],
  // Links for Licitaciones
  // 1
  [
    "DAF-S-RM - PS 20231004001.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "30-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PS 20231004001.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - PS 20231013001.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "30-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PS 20231013001.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - PS 20231024002.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "30-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/PS 20231024002.pdf",
    },
  ],
  // Link for Servicios Generales
  // 3
  [
    "DAF-S-PCF - PS 20231017001.pdf",
    "3er Trimestre",
    "Christina Mejia",
    "31-10-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/PS 20231017001.pdf",
    },
  ],
  // Links for Ines
  // 1
  [
    "DAF-S-RM - doc01014120231031130032.pdf",
    "3er Trimestre",
    "Ines Flores Perez",
    "31-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/doc01014120231031130032.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - doc01014220231031130051.pdf",
    "3er Trimestre",
    "Ines Flores Perez",
    "31-09-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/doc01014220231031130051.pdf",
    },
  ],
  // Links for DAJ
  // 1
  [
    "DAJ - Contrato DAJ-219-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-219-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-224-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-224-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-225-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-225-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-227-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-227-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-233-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-233-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-234-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-234-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato DAJ-237-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-237-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Contrato DAJ-240-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-240-2023.pdf",
    },
  ],
  // 9
  [
    "DAJ - Contrato DAJ-243-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-243-2023.pdf",
    },
  ],
  // 10
  [
    "DAJ - Contrato DAJ-245-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Contrato DAJ-245-2023.pdf",
    },
  ],
  // 11
  [
    "DAJ - Convenio DAJ-046-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-046-2023.pdf",
    },
  ],
  // DAF-S-PCF
  [
    "DAJ - b) 2. Clasificacion Economica y Obj. del Gto Sep.23.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "02-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PCF/b) 2. Clasificacion Economica y Obj. del Gto Sep.23.pdf",
    },
  ],
  // Links for Bibiana Limon
  // 1
  [
    "DAF-S-PF - Informe DG_ oct-dic.22.pdf",
    "3er Trimestre",
    "Bibiana Limon",
    "063-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Informe DG_ oct-dic.22.pdf",
    },
  ],
  // 2
  [
    "DAF-S-PF - Informe DG_abr-jun.23.pdf",
    "3er Trimestre",
    "Bibiana Limon",
    "063-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Informe DG_abr-jun.23.pdf",
    },
  ],
  // 3
  [
    "DAF-S-PF - Informe DG_ene-mar.23.pdf",
    "3er Trimestre",
    "Bibiana Limon",
    "063-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-PF/Informe DG_ene-mar.23.pdf",
    },
  ],
  // Links for Fernanda
  // 1
  [
    "DAF-S-RM - oficio AUTORIZACIÓN DE RECURSOS.pdf",
    "3er Trimestre",
    "Fernanda Amezcua",
    "06-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/oficio AUTORIZACIÓN DE RECURSOS.pdf",
    },
  ],
  // Links for Inesita
  // 1
  [
    "DAF-S-RM - 20230914001.pdf",
    "3er Trimestre",
    "Ines Flores",
    "07-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/20230914001.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - P.C. 071-2023.pdf",
    "3er Trimestre",
    "Ines Flores",
    "07-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/P.C. 071-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - P.C. 072-2023.pdf",
    "3er Trimestre",
    "Ines Flores",
    "07-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAF-S-RM/P.C. 072-2023.pdf",
    },
  ],
  // Links For Dirrecion de comunicacones
  // 1
  [
    "DG-S-COMU - CamScanner 16-11-2023 16.15.pdf",
    "3er Trimestre",
    "Desconocido",
    "16-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/CamScanner 16-11-2023 16.15.pdf",
    },
  ],
  // 2
  [
    "DG-S-COMU - CamScanner 16-11-2023 16.15(1).pdf",
    "3er Trimestre",
    "Desconocido",
    "16-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/CamScanner 16-11-2023 16.15(1).pdf",
    },
  ],
  // 3
  [
    "DG-S-COMU - CamScanner 16-11-2023 16.16.pdf",
    "3er Trimestre",
    "Desconocido",
    "16-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DG-S-COMU/CamScanner 16-11-2023 16.16.pdf",
    },
  ],
  // Links for DAJ
  // 1 - 2do Trimestre
  [
    "DAJ - Convenio DAJ-020-2023.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/2do Trimestre/DAJ/Convenio DAJ-020-2023.pdf",
    },
  ],
  // 2 - 3er Trimestre
  [
    "DAJ - Convenio DAJ-040-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-040-2023.pdf",
    },
  ],
  // 3 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-231-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-231-2023.pdf",
    },
  ],
  // 4 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-232-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-232-2023.pdf",
    },
  ],
  // 5 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-235-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-235-2023.pdf",
    },
  ],
  // 6 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-236-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-236-2023.pdf",
    },
  ],
  // 7 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-238-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-238-2023.pdf",
    },
  ],
  // 8 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-239-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-239-2023.pdf",
    },
  ],
  // 9 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-241-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-241-2023.pdf",
    },
  ],
  // 10 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-242-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-242-2023.pdf",
    },
  ],
  // 11 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-244-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-244-2023.pdf",
    },
  ],
  // 12 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-247-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-247-2023.pdf",
    },
  ],
  // 13 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-249-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-249-2023.pdf",
    },
  ],
  // 14 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-251-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-251-2023.pdf",
    },
  ],
  // 15 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-253-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-253-2023.pdf",
    },
  ],
  // 16 - 4to Trimestre
  [
    "DAJ - Contrato DAJ-254-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-254-2023.pdf",
    },
  ],
  // 17 - 4to Trimestre
  [
    "DAJ - Convenio DAJ-041-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-041-2023.pdf",
    },
  ],
  // 18 - 4to Trimestre
  [
    "DAJ - Convenio DAJ-043-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-043-2023.pdf",
    },
  ],
  // 19 - 4to Trimestre
  [
    "DAJ - Convenio DAJ-047-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "29-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-047-2023.pdf",
    },
  ],
  //
  [
    "DAJ-S-PCF - OS 20231115001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/OS 20231115001.pdf",
    },
  ],
  // Links for Ines 4to Trimestre
  // 1
  [
    "DAF-S-RM - AD-43-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "30-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/AD-43-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - AD-44-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "30-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/AD-44-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - AD-47-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "30-11-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/AD-47-2023.pdf",
    },
  ],
  // Link for Reglamento de Obra Publica
  // 3
  [
    "Obras Publicas - Reglamento de Obra Publica.pdf",
    "Historico",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/Otros/Obrasp/reg_ley_obras_pub_hidalgo.pdf",
    },
  ],
  // Link for DAJ rubro 03
  // 1
  [
    "Estatuto Organico - DG.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DG.pdf",
    },
  ],
  // 2
  [
    "Estatuto Organico - DAF.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DAF.pdf",
    },
  ],
  // 3
  [
    "Estatuto Organico - DAJ.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DAJ.pdf",
    },
  ],
  // 4
  [
    "Estatuto Organico - DC.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DC.pdf",
    },
  ],
  // 5
  [
    "Estatuto Organico - DCOM.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DCOM.pdf",
    },
  ],
  // 6
  [
    "Estatuto Organico - DA.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DA.pdf",
    },
  ],
  // 7
  [
    "Estatuto Organico - ST.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/ST.pdf",
    },
  ],
  // 2
  [
    "Estatuto Organico - DOH.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DOH.pdf",
    },
  ],
  // 2
  [
    "Estatuto Organico - DVGE.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/DVGE.pdf",
    },
  ],
  // 2
  [
    "Estatuto Organico - OIC.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/OIC.pdf",
    },
  ],
  // 2
  [
    "Estatuto Organico - TICS.pdf",
    "2018 -Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/1er Trimestre/DAJ/rubro 3/TICS.pdf",
    },
  ],
  // Link For DAJ Primer Trimestre
  // 1
  [
    "DAJ - Contrato CAASIM-DAJ-024-2023.pdf",
    "Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/1er Trimestre/DAJ/Contrato CAASIM-DAJ-024-2023.pdf",
    },
  ],
  // Link For Guia Documental 2018
  // 1
  [
    "SRMS.1er 2023 GGuia 2018.pdf",
    "Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/Otros/45 SRMS.1er 2023 GGuia 2018.pdf",
    },
  ],
  // Link For Inventario Documental 2018
  // 2
  [
    "SRMSG 1er 2023Inventario 2018.pdf",
    "Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/Otros/45 SRMSG 1er 2023Inventario 2018.pdf",
    },
  ],
  // 1
  [
    "DAJ - convenio 77.pdf",
    "Primer Trimestre",
    "Amparo Flores",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2020/4to Trimestre/DAJ/convenio 77.pdf",
    },
  ],
  // 1 - DAF-S-RM
  [
    "DAJ - pedido 102-2023.pdf",
    "4to Trimestre",
    "Recursos Materiales",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/pedido 102-2023.pdf",
    },
  ],
  // 1 - DAJ - Estatuso Historicos
  [
    "DAJ - Estatuto 2019.pdf",
    "4to Trimestre",
    "Estatutos Organicos",
    "04-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2018/4to Trimestre/DAJ/Estatuto 2019.pdf",
    },
  ],
  // Planeacion Financiera
  [
    "DAF-S-PF - Circ.144.23.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/Circ.144.23.pdf",
    },
  ],
  // Links for DAJ
  // 1
  [
    "DAJ - Contrato DAJ-223-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-223-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-248-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-248-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-250-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-250-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-252-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-252-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-256-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-256-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-259-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-259-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato DAJ-260-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-260-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Contrato DAJ-262-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-262-2023.pdf",
    },
  ],
  // 9
  [
    "DAJ - Contrato DAJ-263-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-263-2023.pdf",
    },
  ],
  // 10
  [
    "DAJ - Convenio DAJ-042-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-042-2023.pdf",
    },
  ],
  // 11
  [
    "DAJ - Convenio DAJ-049-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-049-2023.pdf",
    },
  ],
  // 12
  [
    "DAJ - Convenio DAJ-051-2022.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "05-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-051-2022.pdf",
    },
  ],
  // Links Transparencia RM
  // 12
  [
    "DAJ-S-RM - PEDIDO 101-2023 JOSE DAVID MENDOZA.pdf",
    "4to Trimestre",
    "Karla Mora",
    "06-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PEDIDO 101-2023 JOSE DAVID MENDOZA.pdf",
    },
  ],
  // LINKS for DAJ
  // 1
  [
    "DAJ - Contrato DAJ-223-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-223-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-248-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-248-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-250-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-250-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-256-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-256-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-252-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-252-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-259-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-259-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato DAJ-260-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-260-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Contrato DAJ-262-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-262-2023.pdf",
    },
  ],
  // 9
  [
    "DAJ - Contrato DAJ-263-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-263-2023.pdf",
    },
  ],
  // 10
  [
    "DAJ - Contrato DAJ-270-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-270-2023.pdf",
    },
  ],
  // 11
  [
    "DAJ - Convenio DAJ-042-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-042-2023.pdf",
    },
  ],
  // 12
  [
    "DAJ - Convenio DAJ-049-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-049-2023.pdf",
    },
  ],
  // 13
  [
    "DAJ - Convenio DAJ-051-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "14-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-051-2022.pdf",
    },
  ],
  // 14
  [
    "DAJ - Convenio DAJ-035-2023.pdf",
    "3er Trimestre",
    "Jorge Daniel Olguin",
    "15-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/3er Trimestre/DAJ/Convenio DAJ-035-2023.pdf",
    },
  ],
  // lINKS for DAJ
  // 1
  [
    "DAJ - Contrato DAJ-258-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-258-2023.pdf",
    },
  ],
  // 2
  [
    "DAJ - Contrato DAJ-261-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-261-2023.pdf",
    },
  ],
  // 3
  [
    "DAJ - Contrato DAJ-266-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-266-2023.pdf",
    },
  ],
  // 4
  [
    "DAJ - Contrato DAJ-273-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-273-2023.pdf",
    },
  ],
  // 5
  [
    "DAJ - Contrato DAJ-274-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-274-2023.pdf",
    },
  ],
  // 6
  [
    "DAJ - Contrato DAJ-276-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-276-2023.pdf",
    },
  ],
  // 7
  [
    "DAJ - Contrato DAJ-291-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-291-2023.pdf",
    },
  ],
  // 8
  [
    "DAJ - Contrato DAJ-292-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-292-2023.pdf",
    },
  ],
  // 9
  [
    "DAJ - Contrato DAJ-290-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-290-2023.pdf",
    },
  ],
  // DCONS
  // 1
  [
    "DCONS - DOC013_2.PDF",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/DOC013_2.PDF",
    },
  ],
  // 2
  [
    "DCONS - Acta Entrega Fisica Descargas.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/Acta Entrega Fisica Descargas.pdf",
    },
  ],
  // 3
  [
    "DCONS - Acta Entrega Fisica Redes.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/Acta Entrega Fisica Redes.pdf",
    },
  ],
  // 4
  [
    "DCONS - Finiquito De Obra Descargas.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/Finiquito De Obra Descargas.pdf",
    },
  ],
  // 5
  [
    "DCONS - Finiquito De Obra Redes.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/Finiquito De Obra Redes.pdf",
    },
  ],
  // 6
  [
    "DCONS - acta entrega fisica bacheo zona 3.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/acta entrega fisica bacheo zona 3.pdf",
    },
  ],
  // 7
  [
    "DCONS - acta entrega fisica zona 2.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/acta entrega fisica zona 2.pdf",
    },
  ],
  // 8
  [
    "DCONS - acta finiquito zona 2.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/acta finiquito zona 2.pdf",
    },
  ],
  // 9
  [
    "DCONS - acta finquito zona 3.pdf",
    "4to Trimestre",
    "Desconocido",
    "21-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DCONS/acta finquito zona 3.pdf",
    },
  ],
  // Links RH
  // 1
  [
    "DAF-S-RH - 3026.pdf",
    "4to Trimestre",
    "Yezmin Hernandez",
    "26-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3026.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RH - 4289.pdf",
    "4to Trimestre",
    "Yezmin Hernandez",
    "26-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4289.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RH - 4303.pdf",
    "4to Trimestre",
    "Yezmin Hernandez",
    "26-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4303.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RH - 4304.pdf",
    "4to Trimestre",
    "Yezmin Hernandez",
    "26-12-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4304.pdf",
    },
  ],
  // Cristina Mejia nuevos links
  // 1
  [
    "DAJ-S-PCF - OS 20231204001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "02-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/OS 20231204001.pdf",
    },
  ],
  // 2
  [
    "DAJ-S-PCF - OS 20231204002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "02-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/OS 20231204002.pdf",
    },
  ],
  // 3
  [
    "DAJ-S-PCF - OS 20231204003.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "02-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/OS 20231204003.pdf",
    },
  ],
  // 4
  [
    "DAJ-S-PCF - OS 20231204004.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "02-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/OS 20231204004.pdf",
    },
  ],
  // 5
  [
    "DAJ-S-PCF - OS 20231219002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "02-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/OS 20231219002.pdf",
    },
  ],
  // Links For Amparo
  // 1
  [
    "DAF-S-PF - 2023.12.29 CyT2024 10-52.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "02-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/2023.12.29 CyT2024 10-52.pdf",
    },
  ],
  // 2
  [
    "DAF-S-PF - Indicacion 4o 2023.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "02-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/Indicacion 4o 2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-PF - 2023.12.29 P.Egesos 2024 9_52.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/2023.12.29 P.Egesos 2024 9_52.pdf",
    },
  ],
  // 4
  [
    "DAF-S-PF - P ingresos 2024.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/P ingresos 2024.pdf",
    },
  ],
  // Links for DAJ
  // 1
  [
    "DAJ - Caducidad Juicio 089-2018.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Caducidad Juicio 089-2018.pdf",
    },
  ],
  // 2
  [
    "DAJ - Laudo Juicio 111-2020.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Laudo Juicio 111-2020.pdf",
    },
  ],
  // Link for Yadira Alarcon
  // 1
  [
    "DAF-S-RM - P 134-2023.pdf",
    "4to Trimestre",
    "Yadira Alarcon",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/P 134-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - SPF-247-2023.pdf",
    "4to Trimestre",
    "Yadira Alarcon",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-247-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - SPF-306-2023.pdf",
    "4to Trimestre",
    "Yadira Alarcon",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-306-2023.pdf",
    },
  ],
  // Links for RH
  [
    "RH - 1989.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/1989.pdf",
    },
  ],
  [
    "RH - 2541.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/2541.pdf",
    },
  ],
  [
    "RH - 2771.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/2771.pdf",
    },
  ],
  [
    "RH - 3026.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3026.pdf",
    },
  ],
  [
    "RH - 3032.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3032.pdf",
    },
  ],
  [
    "RH - 3110.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3110.pdf",
    },
  ],
  [
    "RH - 3321.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3321.pdf",
    },
  ],
  [
    "RH - 3406.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3406.pdf",
    },
  ],
  [
    "RH - 3726.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3726.pdf",
    },
  ],
  [
    "RH - 376.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/376.pdf",
    },
  ],
  [
    "RH - 3978.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/3978.pdf",
    },
  ],
  [
    "RH - 4033.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4033.pdf",
    },
  ],
  [
    "RH - 4149.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4149.pdf",
    },
  ],
  [
    "RH - 4156.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4156.pdf",
    },
  ],
  [
    "RH - 4163.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4163.pdf",
    },
  ],
  [
    "RH - 4164.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4164.pdf",
    },
  ],
  [
    "RH - 4165.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4165.pdf",
    },
  ],
  [
    "RH - 4166.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4166.pdf",
    },
  ],
  [
    "RH - 4171.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4171.pdf",
    },
  ],
  [
    "RH - 4174.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4174.pdf",
    },
  ],
  [
    "RH - 4178.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4178.pdf",
    },
  ],
  [
    "RH - 4186.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4186.pdf",
    },
  ],
  [
    "RH - 4190.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4190.pdf",
    },
  ],
  [
    "RH - 4191.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4191.pdf",
    },
  ],
  [
    "RH - 4212.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4212.pdf",
    },
  ],
  [
    "RH - 4215.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4215.pdf",
    },
  ],
  [
    "RH - 4219.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4219.pdf",
    },
  ],
  [
    "RH - 4230.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4230.pdf",
    },
  ],
  [
    "RH - 4263.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4263.pdf",
    },
  ],
  [
    "RH - 4289.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4289.pdf",
    },
  ],
  [
    "RH - 4303.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4303.pdf",
    },
  ],
  [
    "RH - 4304.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "03-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/4304.pdf",
    },
  ],
  // Links for Licitaciones correo
  // 1
  [
    "DAF-S-RM - HACIENDA-A-FAFEF-GI-2023-4019-00189 ADL-08-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/HACIENDA-A-FAFEF-GI-2023-4019-00189 ADL-08-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - SPF-324-2023 ADPE046-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-324-2023 ADPE046-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - SPF-342-2023 ADPE052-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-342-2023 ADPE052-2023.pdf",
    },
  ],
  // Links for Ines
  // 1
  [
    "DAF-S-RM - PC 118-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC 118-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - PC 128-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC 128-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - PC 130-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC 130-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - 131-B-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/131-B-2023.pdf",
    },
  ],
  // Links For Cristina Mejia
  // 1
  [
    "DAJ-S-PCF - PEDIDO JESUS BERNARDO.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "04-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PEDIDO JESUS BERNARDO.pdf",
    },
  ],
  // Links for DAB
  // 1
  [
    "DAB - 4to. TrimestreAbastoGRAFICA13PROY.pdf",
    "4to Trimestre",
    "Adrian Cabrera",
    "05-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAB/4to. TrimestreAbastoGRAFICA13PROY.pdf",
    },
  ],
  // 2
  [
    "DAB - 4to. TrimestreAbastoGRAFICA22PROY.pdf",
    "4to Trimestre",
    "Adrian Cabrera",
    "05-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAB/4to. TrimestreAbastoGRAFICA22PROY.pdf",
    },
  ],
  // 3
  [
    "DAB - Actividades 4to trimestre Alcantarillado.pdf",
    "4to Trimestre",
    "Adrian Cabrera",
    "05-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAB/Actividades 4to trimestre Alcantarillado.pdf",
    },
  ],
  // 4
  [
    "DAB - Actividades 4to trimestre Pipas.pdf",
    "4to Trimestre",
    "Adrian Cabrera",
    "05-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAB/Actividades 4to trimestre Pipas.pdf",
    },
  ],
  // 5
  [
    "DAB - Indicadores 4to trimestre Alcantarillado.pdf",
    "4to Trimestre",
    "Adrian Cabrera",
    "05-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAB/Indicadores 4to trimestre Alcantarillado.pdf",
    },
  ],
  // 6
  [
    "DAB - Indicadores 4to trimestre Pipas.pdf",
    "4to Trimestre",
    "Adrian Cabrera",
    "05-01-2023",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAB/Indicadores 4to trimestre Pipas.pdf",
    },
  ],
  // Links for DAF-S-RM
  // 1
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-037-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-037-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-038-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-038-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-039-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-039-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-040-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-040-2023.pdf",
    },
  ],
  // 5
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-041-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-041-2023.pdf",
    },
  ],
  // 6
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-042-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-042-2023.pdf",
    },
  ],
  // 7
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-043-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-043-2023.pdf",
    },
  ],
  // 8
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-044-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-044-2023.pdf",
    },
  ],
  // 9
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-048-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-048-2023.pdf",
    },
  ],
  // 10
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-050-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-050-2023.pdf",
    },
  ],
  // 11
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN ADPE-051-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN ADPE-051-2023.pdf",
    },
  ],
  // 12
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-18-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-18-2023.pdf",
    },
  ],
  // 13
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-19-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-19-2023.pdf",
    },
  ],
  // 14
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-20-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-20-2023.pdf",
    },
  ],
  // 15
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-21-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-21-2023.pdf",
    },
  ],
  // 16
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-22-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-22-2023.pdf",
    },
  ],
  // 17
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-23-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-23-2023.pdf",
    },
  ],
  // 18
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-24-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-24-2023.pdf",
    },
  ],
  // 19
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-25-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-25-2023.pdf",
    },
  ],
  // 20
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-26-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-26-2023.pdf",
    },
  ],
  // 21
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-27-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-27-2023.pdf",
    },
  ],
  // 22
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-28-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-28-2023.pdf",
    },
  ],
  // 23
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-29-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-29-2023.pdf",
    },
  ],
  // Links for Yahir Licitaciones
  // 1
  [
    "DAF-S-RM - HACIENDA-A-FOCOE-GI-2023-4019-01596.pdf",
    "4to Trimestre",
    "Yahir Arturo",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/HACIENDA-A-FOCOE-GI-2023-4019-01596.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - SPF-304-2023.pdf",
    "4to Trimestre",
    "Yahir Arturo",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-304-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - SPF-323-2023.pdf",
    "4to Trimestre",
    "Yahir Arturo",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-323-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - SPF-332-2023.pdf",
    "4to Trimestre",
    "Yahir Arturo",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-332-2023.pdf",
    },
  ],
  // Links for Licitaciones
  // 1
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-30-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-30-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-31-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-31-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-33-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN CAASIM-HGO-AD-OP-33-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN N-1-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN N-1-2023.pdf",
    },
  ],
  // 5
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN N-3-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN N-3-2023.pdf",
    },
  ],
  // 6
  [
    "DAF-S-RM - OFICIO DE AUTORIZCIÓN CAASIM-HGO-AD-OP-32-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZCIÓN CAASIM-HGO-AD-OP-32-2023.pdf",
    },
  ],
  // 7
  [
    "DAF-S-RM - SPF-110-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-110-2023.pdf",
    },
  ],
  // 8
  [
    "DAF-S-RM - SPF-195-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-195-2023.pdf",
    },
  ],
  // 9
  [
    "DAF-S-RM - SPF-293-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-293-2023.pdf",
    },
  ],
  // Links for Licitaciones
  [
    "DAF-S-RM - autorizacion de recursos i.d. 11289.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/autorizacion de recursos i.d. 11289.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS I.D. 11292.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/AUTORIZACION DE RECURSOS I.D. 11292.pdf",
    },
  ],
  [
    "DAF-S-RM - PC 131-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC 131-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - PC 133-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC 133-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - PC 139-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC 139-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 326-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 326-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 328-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 328-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 339-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 339-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 344 Y 345.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 344 Y 345.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 345-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 345-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 346-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 346-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 347-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 347-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-277-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-277-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-305-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-305-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-329-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-329-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-340-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-340-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-344-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-344-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-345-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF-345-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - Invitaciones ITP-CAASIM-SRMYSG-DL-08-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/Invitaciones ITP-CAASIM-SRMYSG-DL-08-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-L.O.P.-26-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE AUTORIZACION CAASIM-HGO-L.O.P.-26-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE RECURSOS ADL048.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE RECURSOS ADL048.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE RECURSOS ADL049.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO DE RECURSOS ADL049.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO 100-2023 CREACIONES INDUSTRIALES Y DEPORTIVAS.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PEDIDO 100-2023 CREACIONES INDUSTRIALES Y DEPORTIVAS.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO 101-2023 JOSE DAVID MENDOZA.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PEDIDO 101-2023 JOSE DAVID MENDOZA.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 197-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 197-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 207-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 207-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 208-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 208-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 227-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 227-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 233-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 233-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 237-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 237-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 238-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 238-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 260-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 260-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 349-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 349-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF 350-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 350-2023.pdf",
    },
  ],
  //  Planeacion Financiera
  // 1
  [
    "DAF-S-PF - Carta Descriptiva 2023 Componente 3 oct nov.pdf",
    "4to Trimestre",
    "Marleen Barrera",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/Carta Descriptiva 2023 Componente 3 oct nov.pdf",
    },
  ],
  // Links For Ines
  // 1
  [
    "DAF-S-RM - SPF 239-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 239-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - SPF 348 2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/SPF 348 2023.pdf",
    },
  ],
  // Links For Cristina Mejia
  [
    "DAF-S-PCF - OS 20231115001 (2).pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/OS 20231115001 (2).pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231009002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231009002.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231103001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231103001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231117001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231117001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231121001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231121001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231121002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231121002.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231122001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231122001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231122002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231122002.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231205001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231205001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231213001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231213001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231214001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231214001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231226001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231226001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231226002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231226002.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231226003.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231226003.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231226004.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231226004.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231227002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231227002.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231228002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231228002.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231228003.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231228003.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS 20231229010.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS 20231229010.pdf",
    },
  ],
  // Links for Cristina Mejia 2
  [
    "DAF-S-PCF - SPF-232-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-232-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-255-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-255-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-256-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-256-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-262-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-262-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-263-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-263-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-265-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-265-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-266-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-266-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-270-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-270-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-276-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-276-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-297-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-297-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-322-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-322-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-325-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-325-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-331-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-331-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-334-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-334-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-335-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-335-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - PEDIDO ARENS 130 BIS 2023.pdf",
    "4to Trimestre",
    "Cristina Mejia 2",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PEDIDO ARENS 130 BIS 2023.pdf",
    },
  ],
  // Links for Ines
  // 1
  [
    "DAF-S-RM - PC-071-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC-071-2023.pdf",
    },
  ],
  // 2
  [
    "DAF-S-RM - PC-141-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC-141-2023.pdf",
    },
  ],
  // 3
  [
    "DAF-S-RM - PC-143-2023.pdf",
    "4to Trimestre",
    "Ines Flores",
    "05-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PC-143-2023.pdf",
    },
  ],
  // 4
  [
    "DAF-S-RM - PS-20230914001.pdf",
    "4to Trimestre",
    "Ines Flores",
    "06-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PS-20230914001.pdf",
    },
  ],
  // Link for DAJ
  // 1
  [
    "DAJ - 2023_dic_29_alc8_52.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "03-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/2023_dic_29_alc8_52.pdf",
    },
  ],
  // Links for Cristina Mejia
  [
    "DAF-S-PCF - DAF-5198-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/DAF-5198-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - DAF-5199-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/DAF-5199-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - DAF-5200-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/DAF-5200-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - DAF-5201-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/DAF-5201-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - DAF-5558-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/DAF-5558-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN SPF-278-2023.pdf",
    "4to Trimestre",
    "Desconocido",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/AUTORIZACIÓN SPF-278-2023.pdf",
    },
  ],
  // Links for Erick
  [
    "DG-S-COMU - CamScanner 21-11-2023 10.27.pdf",
    "4to Trimestre",
    "Erick",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 21-11-2023 10.27.pdf",
    },
  ],
  [
    "DG-S-COMU - CamScanner 21-11-2023 10.28.pdf",
    "4to Trimestre",
    "Erick",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 21-11-2023 10.28.pdf",
    },
  ],
  [
    "DG-S-COMU - CamScanner 27-10-2023 10.17.pdf",
    "4to Trimestre",
    "Erick",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 27-10-2023 10.17.pdf",
    },
  ],
  [
    "DG-S-COMU - CamScanner 27-10-2023 10.24.pdf",
    "4to Trimestre",
    "Erick",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 27-10-2023 10.24.pdf",
    },
  ],
  // Links for Cristina Mejia
  [
    "DAF-S-PCF - SPF-353-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-353-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-354-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-354-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-355-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-355-2023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-356-2023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-356-2023.pdf",
    },
  ],
  // Links for PF Ale Monterrubio
  [
    "DAF-S-PF - PS. 20231229001.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229001.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229002.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229002.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229003.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229003.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229004.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229004.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229005.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229005.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229006.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229006.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229007.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229007.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229008.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229008.pdf",
    },
  ],
  [
    "DAF-S-PF - PS. 20231229009.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/PS. 20231229009.pdf",
    },
  ],
  // Links for Cristina Mejia
  [
    "DAF-S-PCF - PS20231201004.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS20231201004.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS20231206001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS20231206001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PS20231215001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/PS20231215001.pdf",
    },
  ],
  // Links for Ale Monterrubio
  [
    "DAF-S-PF - requi 1.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 1.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 2.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 2.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 3.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 3.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 4.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 4.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 5.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 5.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 6.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 6.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 7.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 7.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 8.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 8.pdf",
    },
  ],
  [
    "DAF-S-PF - requi 9.pdf",
    "4to Trimestre",
    "Ale Monterrubio",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PF/requi 9.pdf",
    },
  ],
  // Links for CRstina Mejia
  [
    "DAF-S-PCF - ID 11141.pdf",
    "4to Trimestre",
    "Crstina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/ID 11141.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11142.pdf",
    "4to Trimestre",
    "Crstina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/ID 11142.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11194.pdf",
    "4to Trimestre",
    "Crstina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/ID 11194.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11262.pdf",
    "4to Trimestre",
    "Crstina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/ID 11262.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11280.pdf",
    "4to Trimestre",
    "Crstina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/ID 11280.pdf",
    },
  ],
  // Links for CRstina Mejia
  [
    "DAF-S-PCF - SPF-3572023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-3572023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-3582023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-3582023.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-3592023.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/SPF-3592023.pdf",
    },
  ],
  // Links for Jorge Daniel
  [
    "DAJ - CUOTAS Y TARIFAS 2024.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/CUOTAS Y TARIFAS 2024.pdf",
    },
  ],
  [
    "DAJ - Presupuesto de Egresos del Edo de Hgo 2024.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Presupuesto de Egresos del Edo de Hgo 2024.pdf",
    },
  ],
  // Links for DAF-S-PCRF
  [
    "DAF-S-PCF - AUTORIZACION DE RECURSOS ARCODEN.pdf",
    "4to Trimestre",
    "Crsitina Mejia",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/AUTORIZACION DE RECURSOS ARCODEN.pdf",
    },
  ],
  [
    "DAF-S-PCF - AUTORIZACION DE RECURSOS BLANCA.pdf",
    "4to Trimestre",
    "Crsitina Mejia",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-PCF/AUTORIZACION DE RECURSOS BLANCA.pdf",
    },
  ],
  // Links for Maf Garcia
  [
    "DAF-S-RM - OFICIO AUTORIZACION ESCANER.pdf",
    "4to Trimestre",
    "Maff Garcia",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO AUTORIZACION ESCANER.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION ESTUDIO.pdf",
    "4to Trimestre",
    "Maff Garcia",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/OFICIO AUTORIZACION ESTUDIO.pdf",
    },
  ],
  // Links for Amparo
  [
    "DG-S-COMU - UCS.4oT2023 f.48A.pdf",
    "4to Trimestre",
    "Amparito",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/UCS.4oT2023 f.48A.pdf",
    },
  ],
  [
    "DAJ - DAJ-4o2023 f.1.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/DAJ-4o2023 f.1.pdf",
    },
  ],
  // Links for Micaela
  [
    "SETE - AVANCE FISICO FINANCIERO ESTUDIOS.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/SETE/AVANCE FISICO FINANCIERO ESTUDIOS.pdf",
    },
  ],
  [
    "SETE - AVANCE FISICO POZOS.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/SETE/AVANCE FISICO POZOS.pdf",
    },
  ],
  // Links for Jorge Daniel
  [
    "DAJ - Contrato DAJ-268-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-268-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-269-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-269-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-272-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-272-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-283-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-283-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-284-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-284-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-285-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-285-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-288-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-288-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-289-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-289-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-290-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-290-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-297-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-297-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-298-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-298-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-299-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-299-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-300-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-300-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-301-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-301-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-302-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-302-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-303-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-303-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-304-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-304-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-305-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-305-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-306-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-306-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-307-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-307-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-308-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-308-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-309-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-309-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-312-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-312-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-313-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-313-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-314-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-314-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-315-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-315-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-316-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-316-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-329-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-329-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-330-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-330-2023.pdf",
    },
  ],
  // Links for Micaela
  [
    "SETE - AVANCE FISICO FINANCIERO RECURSOS PROPIOS.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/SETE/AVANCE FISICO FINANCIERO RECURSOS PROPIOS.pdf",
    },
  ],
  [
    "SETE - AVANCES FISICO FINANCIEROS ESTATALES.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "09-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/SETE/AVANCES FISICO FINANCIEROS ESTATALES.pdf",
    },
  ],
  // lINK FOR CARLA
  [
    "DAF-S-RM - PEDIDO 067-2023_ CODES N33.pdf",
    "4to Trimestre",
    "Karla Mora",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PEDIDO 067-2023_ CODES N33.pdf",
    },
  ],
  // Links for Licitaciones
  [
    "DAF-S-RM - PEDIDO CON REVERSO CAMCOR.pdf",
    "4to Trimestre",
    "Licitaciones",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/PEDIDO CON REVERSO CAMCOR.pdf",
    },
  ],
  // Links for DAJ
  [
    "DAJ - Contrato DAJ-257-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-257-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-278-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-278-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-284-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-284-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-286-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-286-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-287-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-287-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-294-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-294-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-296-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-296-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-317-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-317-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-318-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-318-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-333-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-333-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-340-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-340-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-341-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-341-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-344-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-344-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-345-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-345-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-347-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-347-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-349-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-349-2023.pdf",
    },
  ],
  // Links for DAJ
  [
    "DAJ - Subsidios 4° Trimestre Oct-Dic 2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "11-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Subsidios 4° Trimestre Oct-Dic 2023.pdf",
    },
  ],
  // Erick Fotografia
  [
    "DG-S-COMU - 9011C541-441B-45A2-A2E5-CD2C99D637BB (1).pdf",
    "4to Trimestre",
    "Erick Fotografia",
    "11-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/9011C541-441B-45A2-A2E5-CD2C99D637BB (1).pdf",
    },
  ],
  [
    "DG-S-COMU - CamScanner 30-10-2023 10.03 (1).pdf",
    "4to Trimestre",
    "Erick Fotografia",
    "11-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 30-10-2023 10.03 (1).pdf",
    },
  ],
  [
    "DG-S-COMU - CamScanner 31-10-2023 11.52 (2).pdf",
    "4to Trimestre",
    "Erick Fotografia",
    "11-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 31-10-2023 11.52 (2).pdf",
    },
  ],
  [
    "DG-S-COMU - DCC13F8F-6203-443A-86AE-0681D36EBC94 (1).pdf",
    "4to Trimestre",
    "Erick Fotografia",
    "11-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/DCC13F8F-6203-443A-86AE-0681D36EBC94 (1).pdf",
    },
  ],
  [
    "DG-S-COMU - PEDIDO_DE_SERVICIO_20231107003.pdf",
    "4to Trimestre",
    "Erick Fotografia",
    "11-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/PEDIDO_DE_SERVICIO_20231107003.pdf",
    },
  ],
  [
    "DG-S-COMU - PEDIDO_DE_SERVICIO_20231107004.pdf",
    "4to Trimestre",
    "Erick Fotografia",
    "11-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/PEDIDO_DE_SERVICIO_20231107004.pdf",
    },
  ],
  // Link for Licitaciones CAASIM
  [
    "DAF-S-RM - EA-913005999-N46-2018-BIENES-INFORMATICOS.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "15-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RM/EA-913005999-N46-2018-BIENES-INFORMATICOS.pdf",
    },
  ],
  // Links for DAJ
  [
    "DAJ - Convenio DAJ-059-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-059-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-060-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-060-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-062-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-062-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-068-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-068-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-072-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-072-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-075-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-075-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-076-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-076-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-077-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Convenio DAJ-077-2023.pdf",
    },
  ],
  // Links segunda ronda
  [
    "DAJ - Contrato DAJ-279-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-279-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-280-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-280-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-323-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-323-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-324-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-324-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-326-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-326-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-346-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-346-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-353-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-353-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-355-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "19-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAJ/Contrato DAJ-355-2023.pdf",
    },
  ],
  // Link for Susana Martinez
  [
    "DAF-S-RH - Tabulador 2023.pdf",
    "4to Trimestre",
    "Susana Martinez",
    "23-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DAF-S-RH/Tabulador 2023.pdf",
    },
  ],
  // Link for Comunication
  [
    "DG-S-COMU - CamScanner 23-01-2024 14.17 (2).pdf",
    "4to Trimestre",
    "Erick Parra",
    "23-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 23-01-2024 14.17 (2).pdf",
    },
  ],
  // Link for Comunicacion
  [
    "DG-S-COMU - CamScanner 31-01-2024 13.28.pdf",
    "4to Trimestre",
    "Erick Parra",
    "31-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 31-01-2024 13.28.pdf",
    },
  ],
  [
    "DG-S-COMU - CamScanner 31-01-2024 13.29.pdf",
    "4to Trimestre",
    "Erick Parra",
    "31-01-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to Trimestre/DG-S-COMU/CamScanner 31-01-2024 13.29.pdf",
    },
  ],
  // Link For Transparencia
  [
    "DAF-S-PF - 5.-Dictamen 2021 HA.pdf",
    "4to Trimestre",
    "Magda Ensastiga Ramirez",
    "06-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2020/4to Trimestre/DAF-S-PF/5.-Dictamen 2021 HA.pdf",
    },
  ],
  [
    "DAF-S-PF - Dic.Edo.Fin.2021.spf.daf...pdf",
    "1er Trimestre",
    "Amparo Flores",
    "11-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2022/1er Trimestre/DAF-S-PF/Dic.Edo.Fin.2021.spf.daf...pdf",
    },
  ],
  // SECTION Primer Trimestre 2024
  [
    "DCONS - doc02085920240327102145.pdf",
    "1er Trimestre",
    "Maria del Coral Salas Sanchez",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/doc02085920240327102145.pdf",
    },
  ],
  [
    "DAF-S-PF - F-70 1erT. 24 Circ.33-24..pdf",
    "1er Trimestre",
    "Amparto Flores",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PF/F-70 1erT. 24 Circ.33-24..pdf",
    },
  ],
  // 15 de Construccion
  [
    "DCONS - ACATA ENTREGA FISICA ZONA2-2023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACATA ENTREGA FISICA ZONA2-2023.pdf",
    },
  ],
  [
    "DCONS - ACATA FINIQUITO ZONA2-2023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACATA FINIQUITO ZONA2-2023.pdf",
    },
  ],
  [
    "DCONS - Acta Entrega Fisica Descargas 2023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Acta Entrega Fisica Descargas 2023.pdf",
    },
  ],
  [
    "DCONS - Acta Entrega Fisica Redes.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Acta Entrega Fisica Redes.pdf",
    },
  ],
  [
    "DCONS - ACTA ENTREGA FISICA ZONA 3-2023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTA ENTREGA FISICA ZONA 3-2023.pdf",
    },
  ],
  [
    "DCONS - ACTA ENTREGA FISICA.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTA ENTREGA FISICA.pdf",
    },
  ],
  [
    "DCONS - Acta entrega-fisica 111.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Acta entrega-fisica 111.pdf",
    },
  ],
  [
    "DCONS - Acta entrega-fisica 112.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Acta entrega-fisica 112.pdf",
    },
  ],
  [
    "DCONS - Acta entrega-fisica 132.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Acta entrega-fisica 132.pdf",
    },
  ],
  [
    "DCONS - Acta entrega-fisica 133.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Acta entrega-fisica 133.pdf",
    },
  ],
  [
    "DCONS - ACTA FINIQUITO ZONA3-2023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTA FINIQUITO ZONA3-2023.pdf",
    },
  ],
  [
    "DCONS - ACTAFINIQAREQZA2023z1.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTAFINIQAREQZA2023z1.pdf",
    },
  ],
  [
    "DCONS - ACTAFINIQMIRNAz42023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTAFINIQMIRNAz42023.pdf",
    },
  ],
  [
    "DCONS - AEFz1AREQZA 2023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/AEFz1AREQZA 2023.pdf",
    },
  ],
  [
    "DCONS - AEFz4 MIRNA 2023.pdf",
    "1er Trimestre",
    "Desconocido",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/AEFz4 MIRNA 2023.pdf",
    },
  ],
  // Segundo correo de links
  [
    "DCONS - Finiquito 111.pdf",
    "1er Trimestre",
    "Desconocido 2",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Finiquito 111.pdf",
    },
  ],
  [
    "DCONS - Finiquito 112.pdf",
    "1er Trimestre",
    "Desconocido 2",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Finiquito 112.pdf",
    },
  ],
  [
    "DCONS - Finiquito 132.pdf",
    "1er Trimestre",
    "Desconocido 2",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Finiquito 132.pdf",
    },
  ],
  [
    "DCONS - Finiquito 133.pdf",
    "1er Trimestre",
    "Desconocido 2",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Finiquito 133.pdf",
    },
  ],
  [
    "DCONS - finiquito de obra BUENO.pdf",
    "1er Trimestre",
    "Desconocido 2",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/finiquito de obra BUENO.pdf",
    },
  ],
  [
    "DCONS - Finiquito De Obra Descargas.pdf",
    "1er Trimestre",
    "Desconocido 2",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Finiquito De Obra Descargas.pdf",
    },
  ],
  [
    "DCONS - Finiquito De Obra Redes.pdf",
    "1er Trimestre",
    "Desconocido 2",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Finiquito De Obra Redes.pdf",
    },
  ],
  [
    "DCONS - CAASIM (1).pdf",
    "1er Trimestre",
    "Desconocido3",
    "27-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/CAASIM (1).pdf",
    },
  ],
  // Links For Cristina Mejia
  [
    "DAF-S-PCF - PSN20240202001.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PSN20240202001.pdf",
    },
  ],
  [
    "DAF-S-PCF - PSN20240304001.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PSN20240304001.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-041-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SPF-041-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-042-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SPF-042-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-043-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SPF-043-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-055-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SPF-055-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-056-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SPF-056-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-057-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SPF-057-2024.pdf",
    },
  ],
  // Links for Construccion
  [
    "DCONS - ANTICIPO BACHEO ZONA 1.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO BACHEO ZONA 1.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO BACHEO ZONA 2.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO BACHEO ZONA 2.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO BACHEO ZONA 3.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO BACHEO ZONA 3.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO BACHEO ZONA 4.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO BACHEO ZONA 4.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO CAJAS.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO CAJAS.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO CERCADOS NO PROPIEDAD.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO CERCADOS NO PROPIEDAD.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO CERCADOS PROPIEDAD.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO CERCADOS PROPIEDAD.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO DESCARGAS DOMICILIARIAS.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO DESCARGAS DOMICILIARIAS.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO OBRA CIVIL NO PROPIEDAD.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO OBRA CIVIL NO PROPIEDAD.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO OBRA CIVIL PROPIEDAD.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO OBRA CIVIL PROPIEDAD.pdf",
    },
  ],
  [
    "DCONS - ANTICIPO REDES Y LINEAS.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ANTICIPO REDES Y LINEAS.pdf",
    },
  ],
  // Links for Cristina Mejia
  [
    "DAF-S-PCF - doc02014020240401150139.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014020240401150139.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014120240401150151.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014120240401150151.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014220240401150204.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014220240401150204.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014320240401150215.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014320240401150215.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014420240401150227.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014420240401150227.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014520240401150238.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014520240401150238.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014620240401150249.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014620240401150249.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014720240401150259.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014720240401150259.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014820240401150310.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014820240401150310.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02014920240401150320.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02014920240401150320.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02015020240401150331.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02015020240401150331.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02015120240401150342.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02015120240401150342.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02015220240401150352.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02015220240401150352.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02015320240401150407.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02015320240401150407.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02015420240401151026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02015420240401151026.pdf",
    },
  ],
  // Links for Fernanda Amezcua
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN SH-0077-2024.pdf",
    "1er Trimestre",
    "Fernanda Garcia Amezcua",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO AUTORIZACIÓN SH-0077-2024.pdf",
    },
  ],
  // Link for Rosalba DCONS
  [
    "DCONS - SPF-40 2023.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/SPF-40 2023.pdf",
    },
  ],
  [
    "DCONS - SPF-41 2023.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/SPF-41 2023.pdf",
    },
  ],
  [
    "DCONS - SPF-42 2023.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "01-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/SPF-42 2023.pdf",
    },
  ],
  // Links for Nancy Templos
  [
    "DAF-S-RH - f02b_Estructura 2024 CAASIM 1.pdf",
    "1er Trimestre",
    "Nancy Templods",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/f02b_Estructura 2024 CAASIM 1.pdf",
    },
  ],
  [
    "DAF-S-RH - f02_Catálogo Institucional de la CAASIM.pdf",
    "1er Trimestre",
    "Nancy Templods",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/f02_Catálogo Institucional de la CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - f03_DECRETO Autorizado 2019 1.pdf",
    "1er Trimestre",
    "Nancy Templods",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/f03_DECRETO Autorizado 2019 1.pdf",
    },
  ],
  [
    "DAF-S-RH - f08b_Decreto Ppto 2024 1.pdf",
    "1er Trimestre",
    "Nancy Templods",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/f08b_Decreto Ppto 2024 1.pdf",
    },
  ],
  [
    "DAF-S-RH - f16_Condiciones Generales de Trabajo 2022-2023 1.pdf",
    "1er Trimestre",
    "Nancy Templods",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/f16_Condiciones Generales de Trabajo 2022-2023 1.pdf",
    },
  ],
  // Joana Abasto
  [
    "DAB - ACTIVIDADES PIPAS 1ER TRIMESTRE.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAB/ACTIVIDADES PIPAS 1ER TRIMESTRE.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES_1ER TRIMESTRE ALCANTARILLADO.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAB/ACTIVIDADES_1ER TRIMESTRE ALCANTARILLADO.pdf",
    },
  ],
  [
    "DAB - GRAFICA_ ACT 1ER. TRIMESTRE Proy13.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAB/GRAFICA_ ACT 1ER. TRIMESTRE Proy13.pdf",
    },
  ],
  [
    "DAB - GRAFICA_1ER TRIMESTRE PROY 22.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAB/GRAFICA_1ER TRIMESTRE PROY 22.pdf",
    },
  ],
  [
    "DAB - INDICADORES PIPAS 1ER TRIMESTRE.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAB/INDICADORES PIPAS 1ER TRIMESTRE.pdf",
    },
  ],
  [
    "DAB - INDICADORES_1ER TRIMESTRE ALCANTARILLADO.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAB/INDICADORES_1ER TRIMESTRE ALCANTARILLADO.pdf",
    },
  ],
  // Links de Yezmin 1er Trimestre 2024
  [
    "DAF-S-RH - doc01092420240109161247.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01092420240109161247.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01092520240109161310.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01092520240109161310.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01092820240109161343.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01092820240109161343.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01092920240109161405.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01092920240109161405.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01093020240109161432.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01093020240109161432.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01210320240207132908.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01210320240207132908.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01210420240207132956.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01210420240207132956.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01229720240213144059.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01229720240213144059.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01229820240213150808.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01229820240213150808.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01236620240214155923.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01236620240214155923.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01236720240214160427.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01236720240214160427.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01236820240214160609.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01236820240214160609.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01236920240214160759.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01236920240214160759.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01237120240214160833.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01237120240214160833.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01237220240214160905.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01237220240214160905.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01237320240214160953.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01237320240214160953.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01237420240214161020.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01237420240214161020.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01237520240214161247.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01237520240214161247.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01237620240214161441.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01237620240214161441.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01237720240214161551.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01237720240214161551.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01240820240215090856.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01240820240215090856.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01240920240215091037.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01240920240215091037.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241020240215091104.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241020240215091104.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241120240215091306.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241120240215091306.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241220240215091358.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241220240215091358.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241320240215091445.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241320240215091445.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241420240215091536.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241420240215091536.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241520240215091612.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241520240215091612.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241620240215091647.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241620240215091647.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01241720240215091723.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01241720240215091723.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01242420240215093309.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01242420240215093309.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01242520240215093417.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01242520240215093417.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01242620240215093508.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01242620240215093508.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01242720240215093554.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01242720240215093554.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01242820240215093641.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01242820240215093641.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01242920240215093719.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01242920240215093719.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01243020240215093739.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01243020240215093739.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01248220240215143523.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01248220240215143523.pdf",
    },
  ],
  [
    "DAF-S-RH - doc01424820240320135919.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/doc01424820240320135919.pdf",
    },
  ],
  [
    "DAF-S-RH - Formato ARI 01. Mapa de riesgos 2024.xls",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/Formato ARI 01. Mapa de riesgos 2024.xls",
    },
  ],
  [
    "DAF-S-RH - NOM_CAASIM_04_2023.xlsx",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/NOM_CAASIM_04_2023.xlsx",
    },
  ],
  [
    "DAF-S-RH - Subdir. Rec. Hum. Estructura.pptx",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/Subdir. Rec. Hum. Estructura.pptx",
    },
  ],
  [
    "DAF-S-RH - Subdir. Recursos Humanos.pptx",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/Subdir. Recursos Humanos.pptx",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-1.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-1.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-10.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-10.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-11.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-11.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-12.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-12.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-13.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-13.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-14.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-14.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-15.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-15.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-16.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-16.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-17.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-17.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-18.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-18.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-19.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-19.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-2.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-2.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-20.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-20.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-21.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-21.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-22.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-22.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-23.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-23.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-24.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-24.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-25.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-25.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-26.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-26.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-27.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-27.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-28.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-28.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-29.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-29.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-3.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-3.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-30.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-30.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-31.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-31.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-32.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-32.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-33.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-33.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-34.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-34.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-35.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-35.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-36.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-36.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-37.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-37.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-38.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-38.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-39.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-39.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-4.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-4.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-40.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-40.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-41.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-41.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-42.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-42.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-43.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-43.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-44.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-44.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-45.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-45.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-46.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-46.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-47.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-47.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-48.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-48.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-49.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-49.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-5.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-5.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-50.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-50.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-51.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-51.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-52.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-52.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-53.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-53.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-54.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-54.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-55.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-55.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-56.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-56.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-57.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-57.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-58.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-58.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-59.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-59.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-6.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-6.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-60.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-60.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-61.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-61.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-62.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-62.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-63.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-63.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-64.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-64.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-65.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-65.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-66.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-66.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-67.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-67.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-68.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-68.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-69.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-69.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-7.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-7.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-70.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-70.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-71.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-71.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-72.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-72.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-73.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-73.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-74.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-74.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-75.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-75.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-76.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-76.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-77.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-77.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-78.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-78.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-79.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-79.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-8.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-8.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-80.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-80.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-81.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-81.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-82.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-82.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-83.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-83.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-84.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-84.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-85.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-85.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-86.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-86.pdf",
    },
  ],
  [
    "DAF-S-RH - TRANSPARENCIA 2024 BUENO-páginas-9.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RH/TRANSPARENCIA 2024 BUENO-páginas-9.pdf",
    },
  ],
  // Links for Cristina Mejia
  [
    "DAF-S-PCF - 0f08056_02_2024-2 (1).pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/0f08056_02_2024-2 (1).pdf",
    },
  ],
  [
    "DAF-S-PCF - 0f08056_03_2024-2 (1).pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/0f08056_03_2024-2 (1).pdf",
    },
  ],
  [
    "DAF-S-PCF - CAASIM-DAJ-031-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/CAASIM-DAJ-031-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - CAASIM-DAJ-047-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/CAASIM-DAJ-047-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - PIB120515NX2FE072704.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PIB120515NX2FE072704.pdf",
    },
  ],
  [
    "DAF-S-PCF - PIB120515NX2FE072707.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PIB120515NX2FE072707.pdf",
    },
  ],
  [
    "DAF-S-PCF - PIB120515NX2FE072802.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PIB120515NX2FE072802.pdf",
    },
  ],
  [
    "DAF-S-PCF - PIB120515NX2FE072812.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PIB120515NX2FE072812.pdf",
    },
  ],
  // Links for Karla Licitaciones
  [
    "DAF-S-RM - OFICIO AUTORIZACION N85.pdf",
    "1er Trimestre",
    "Karla Licitaciones",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO AUTORIZACION N85.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION N86.pdf",
    "1er Trimestre",
    "Karla Licitaciones",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO AUTORIZACION N86.pdf",
    },
  ],
  // Links Cristina Mejia
  [
    "DAF-S-PCF - PIBEH CUSTODIOS.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PIBEH CUSTODIOS.pdf",
    },
  ],
  [
    "DAF-S-PCF - PIBEH PATRULLAJE.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/PIBEH PATRULLAJE.pdf",
    },
  ],
  // Links for PV
  [
    "DAF - Adobe Scan 02 abr. 2024 (1).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (1).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024 (2).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (2).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024 (4).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (4).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024 (5).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (5).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024 (6).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (6).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024 (7).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (7).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024 (8).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (8).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024 (9).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (9).pdf",
    },
  ],
  [
    "DAF - Adobe Scan 02 abr. 2024.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024.pdf",
    },
  ],
  [
    "DAF - FACING_11384463_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384463_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384538_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384538_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384555_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384555_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384617_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384617_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384618_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384618_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384748_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384748_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384758_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384758_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384814_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384814_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384818_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384818_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384830_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384830_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384848_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384848_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384932_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384932_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11384950_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11384950_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385045_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385045_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385052_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385052_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385053_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385053_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385127_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385127_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385138_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385138_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385155_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385155_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385161_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385161_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385163_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385163_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385222_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385222_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385244_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385244_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385324_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385324_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385340_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385340_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385443_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385443_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385458_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385458_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385459_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385459_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385526_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385526_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385533_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385533_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385537_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385537_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385540_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385540_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385543_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385543_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385562_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385562_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385633_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385633_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385641_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385641_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385664_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385664_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385728_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385728_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385745_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385745_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385818_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385818_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385820_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385820_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385841_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385841_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385891_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385891_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385905_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385905_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385906_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385906_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11385978_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11385978_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386013_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386013_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386117_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386117_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386118_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386118_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386119_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386119_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386121_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386121_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386135_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386135_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386207_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386207_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386248_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386248_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386249_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386249_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386261_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386261_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386343_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386343_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386346_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386346_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386441_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386441_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386531_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386531_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386642_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386642_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386654_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386654_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386668_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386668_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386739_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386739_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386762_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386762_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386838_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386838_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386840_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386840_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11386924_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11386924_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387047_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387047_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387051_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387051_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387135_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387135_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387253_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387253_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387259_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387259_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387263_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387263_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387264_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387264_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387269_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387269_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387355_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387355_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387358_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387358_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387419_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387419_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387429_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387429_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387528_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387528_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387530_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387530_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387719_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387719_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387725_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387725_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387799_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387799_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387839_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387839_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387937_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387937_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387947_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387947_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11387977_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11387977_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388078_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388078_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388276_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388276_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388312_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388312_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388315_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388315_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388326_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388326_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388350_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388350_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388364_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388364_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388422_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388422_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388488_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388488_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388495_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388495_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388511_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388511_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388517_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388517_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388533_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388533_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388675_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388675_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388683_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388683_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388689_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388689_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388704_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388704_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388723_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388723_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388729_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388729_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388745_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388745_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388763_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388763_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388797_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388797_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388824_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388824_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388864_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388864_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388873_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388873_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388896_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388896_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388916_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388916_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388932_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388932_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11388993_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11388993_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389030_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389030_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389041_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389041_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389081_43153116807742788205 (1).pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389081_43153116807742788205 (1).pdf",
    },
  ],
  [
    "DAF - FACING_11389082_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389082_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389134_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389134_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389165_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389165_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389174_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389174_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389187_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389187_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389306_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389306_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389320_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389320_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389331_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389331_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389344_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389344_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389386_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389386_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389424_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389424_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389468_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389468_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389475_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389475_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389576_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389576_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389595_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389595_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389622_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389622_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389692_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389692_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389695_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389695_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389718_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389718_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389769_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389769_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389773_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389773_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389814_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389814_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389838_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389838_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389851_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389851_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389856_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389856_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389921_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389921_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389923_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389923_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389973_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389973_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389979_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389979_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11389984_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11389984_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390042_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390042_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390051_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390051_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390120_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390120_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390132_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390132_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390158_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390158_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390178_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390178_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390183_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390183_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390189_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390189_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390214_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390214_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390245_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390245_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390246_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390246_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390251_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390251_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390264_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390264_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390276_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390276_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390287_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390287_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390382_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390382_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390393_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390393_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390397_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390397_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390412_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390412_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390424_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390424_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390451_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390451_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390452_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390452_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390460_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390460_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390570_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390570_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390590_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390590_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390599_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390599_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390608_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390608_43153116807742788205.pdf",
    },
  ],
  [
    "DAF - FACING_11390737_43153116807742788205.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/FACING_11390737_43153116807742788205.pdf",
    },
  ],
  // Ultimo link
  [
    "DAF - Adobe Scan 02 abr. 2024 (3).pdf",
    "1er Trimestre",
    "PV",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF/Adobe Scan 02 abr. 2024 (3).pdf",
    },
  ],
  // Links for Cristina Mejia
  [
    "DAF-S-PCF - doc02032020240402142541.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032020240402142541.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032120240402142550.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032120240402142550.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032220240402142718.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032220240402142718.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032320240402142738.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032320240402142738.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032420240402142748.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032420240402142748.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032520240402143048.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032520240402143048.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032620240402143105.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032620240402143105.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032720240402143114.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032720240402143114.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032820240402143426.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032820240402143426.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02032920240402143437.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02032920240402143437.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02033120240402143819.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02033120240402143819.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02033220240402143829.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02033220240402143829.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02033320240402143840.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02033320240402143840.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02033520240402144137.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02033520240402144137.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02033620240402144147.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02033620240402144147.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02033720240402144203.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02033720240402144203.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02035520240402145133.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02035520240402145133.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02035620240402145143.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02035620240402145143.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02035720240402145153.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02035720240402145153.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02035820240402145308.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02035820240402145308.pdf",
    },
  ],
  [
    "DAF-S-PCF - doc02035920240402145320.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/doc02035920240402145320.pdf",
    },
  ],
  // Cristina Mejia
  [
    "DAF-S-PCF - ARCODEM.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-PCF - BLANCA CECILIA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/BLANCA CECILIA.pdf",
    },
  ],
  [
    "DAF-S-PCF - CARLOS IBARRA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/CARLOS IBARRA.pdf",
    },
  ],
  [
    "DAF-S-PCF - GRACIELA PAULIN.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/GRACIELA PAULIN.pdf",
    },
  ],
  [
    "DAF-S-PCF - MA. DEL CARMEN CORTEZ.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/MA. DEL CARMEN CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-PCF - MA. DEL CARMEN PARRA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/MA. DEL CARMEN PARRA.pdf",
    },
  ],
  [
    "DAF-S-PCF - ODILON.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ODILON.pdf",
    },
  ],
  [
    "DAF-S-PCF - SISTEMA CONTINUO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "02-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SISTEMA CONTINUO.pdf",
    },
  ],
  // Links for Licitaciones
  [
    "DAF-S-RM - DICTAMEN EA-913005999-N1-2023.pdf",
    "1er Trimestre",
    "Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN EA-913005999-N1-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913005999-N4-2023.pdf",
    "1er Trimestre",
    "Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN EA-913005999-N4-2023.pdf",
    },
  ],
  // Licitaciones 2
  [
    "DAF-S-RM - DICTAMEN ADL-02-2023.pdf",
    "1er Trimestre",
    "Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN ADL-02-2023.pdf",
    },
  ],
  // Link for PF
  [
    "DAF-S-PF - Cuota y Tarifas 2024.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PF/Cuota y Tarifas 2024.pdf",
    },
  ],
  // Links for Cristina Mejia
  [
    "DAF-S-PCF - ID 11327.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11327.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11328.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11328.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11330.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11330.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11332.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11332.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11333.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11333.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11334.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11334.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11335.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11335.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11336.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11336.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11337.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11337.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11338.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11338.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11339.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11339.pdf",
    },
  ],
  [
    "DAF-S-PCF - ID 11340.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/ID 11340.pdf",
    },
  ],
  [
    "DAF-S-PCF - SISTEMA CONTINO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/SISTEMA CONTINO.pdf",
    },
  ],
  [
    "DAF-S-PCF - \u206fID 11329.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/\u206fID 11329.pdf",
    },
  ],
  // Links for DAJ
  [
    "DAJ - Contrato DAJ-001-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-001-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-002-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-002-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-003-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-003-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-005-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-005-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-006-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-006-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-007-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-007-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-008-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-008-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-009-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-009-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-010-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-010-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-011-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-011-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-012-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-012-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-002-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-002-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-004-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-004-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-005-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-005-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-006-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-006-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-007-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-007-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-008-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-008-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-010-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-010-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-012-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-012-2024.pdf",
    },
  ],
  // Direccion de Construccion
  [
    "DCONS - ACTA ENTREGA FISICA CALZADA.pdf",
    "1er Trimestre",
    "Construccion",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTA ENTREGA FISICA CALZADA.pdf",
    },
  ],
  [
    "DCONS - ACTA FINIQUITO CALZADA.pdf",
    "1er Trimestre",
    "Construccion",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTA FINIQUITO CALZADA.pdf",
    },
  ],
  [
    "DCONS - AVANCE.pdf",
    "1er Trimestre",
    "Construccion",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/AVANCE.pdf",
    },
  ],
  [
    "DCONS - Factura682.pdf",
    "1er Trimestre",
    "Construccion",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Factura682.pdf",
    },
  ],
  [
    "DCONS - Factura708.pdf",
    "1er Trimestre",
    "Construccion",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/Factura708.pdf",
    },
  ],
  [
    "DCONS - OFICIO DE AUTORIZACIÓN (1) CALZADA.pdf",
    "1er Trimestre",
    "Construccion",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/OFICIO DE AUTORIZACIÓN (1) CALZADA.pdf",
    },
  ],
  [
    "DCONS - OFICO AUTORIZACION SAN GABRIEL.pdf",
    "1er Trimestre",
    "Construccion",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/OFICO AUTORIZACION SAN GABRIEL.pdf",
    },
  ],
  // Link for Yair Arturo
  [
    "DAF-S-RM - Dictamen EA-913005999-N6-2024.pdf",
    "1er Trimestre",
    "Yair Arturo",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/Dictamen EA-913005999-N6-2024.pdf",
    },
  ],
  // Links for Construccion
  [
    "DCONS - ACTA ENTREGA FISICA SAN GABRIEL.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTA ENTREGA FISICA SAN GABRIEL.pdf",
    },
  ],
  [
    "DCONS - ACTA FINIQUITO SAN GABRIEL.pdf",
    "1er Trimestre",
    "Rosalba DCONS",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DCONS/ACTA FINIQUITO SAN GABRIEL.pdf",
    },
  ],
  // Link for RM
  [
    "DAF-S-RM - HACIENDA-A-FOCOE-GI-2023-4019-01596.pdf",
    "1er Trimestre",
    "Yair Arturo",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/HACIENDA-A-FOCOE-GI-2023-4019-01596.pdf",
    },
  ],
  // Link for Freduy
  [
    "DAF-S-PCF - CALENDARIO ANUAL 2024.pdf",
    "1er Trimestre",
    "Freddy Pacheco",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PCF/CALENDARIO ANUAL 2024.pdf",
    },
  ],
  // Links for Betty Olvera
  [
    "DAF-S-RM - HACIENDA-A-PRISR-GI-2023-4019-01311N72.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/HACIENDA-A-PRISR-GI-2023-4019-01311N72.pdf",
    },
  ],
  [
    "DAF-S-RM - JGSE.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/JGSE.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio autorización N83.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/oficio autorización N83.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio autorización N84.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/oficio autorización N84.pdf",
    },
  ],
  [
    "DAF-S-RM - DAF-SPF-291-2023.pdf",
    "1er Trimestre",
    "Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DAF-SPF-291-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913005999-N88-2023.pdf",
    "1er Trimestre",
    "Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN EA-913005999-N88-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-PRISR-GI-2023-4019-01311N72.pdf",
    "1er Trimestre",
    "Karla Mora",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/HACIENDA-A-PRISR-GI-2023-4019-01311N72.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ADL08-2023.pdf",
    "1er Trimestre",
    "Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN ADL08-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N72.pdf",
    "1er Trimestre",
    "Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N72.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N83.pdf",
    "1er Trimestre",
    "Dulce Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N83.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N84.pdf",
    "1er Trimestre",
    "Dulce Licitaciones",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N84.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N85.pdf",
    "1er Trimestre",
    "Karla Mora",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N85.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N86.pdf",
    "1er Trimestre",
    "Karla Mora",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N86.pdf",
    },
  ],
  // Links for BEatriz Olvera
  [
    "DAF-S-RM - DICTAMEN N19.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N19.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N69.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N69.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N70.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N70.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N75.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N75.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N87.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N87.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION DE RECURSOS N19.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO AUTORIZACION DE RECURSOS N19.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION DE RECURSOS N69.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO DE AUTORIZACION DE RECURSOS N69.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION DE RECURSOS N70.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO DE AUTORIZACION DE RECURSOS N70.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION DE RECURSOS N75.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO DE AUTORIZACION DE RECURSOS N75.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION DE RECURSOS N87.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO DE AUTORIZACION DE RECURSOS N87.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN DE RECURSOS N80.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN DE RECURSOS N80.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN DE RECURSOS N82.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO DE AUTORIZACIÓN DE RECURSOS N82.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N80.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N80.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N82.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N82.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-014-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-014-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-016-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-016-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-017-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-017-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-018-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-018-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-020-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-020-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-021-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-021-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-023-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-023-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-025-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-025-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-026-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-026-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-027-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-027-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-028-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-028-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-029-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-029-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-030-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-030-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ADL-01-2024 - copia.pdf",
    "1er Trimestre",
    "Maff Garcia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN ADL-01-2024 - copia.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N73-2024 - copia.pdf",
    "1er Trimestre",
    "Maff Garcia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN N73-2024 - copia.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN SEGUROS - copia.pdf",
    "1er Trimestre",
    "Maff Garcia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/DICTAMEN SEGUROS - copia.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTO N73-2024 - copia.pdf",
    "1er Trimestre",
    "Maff Garcia",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-RM/OFICIO AUTO N73-2024 - copia.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-034-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-034-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-035-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-035-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-036-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-036-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-037-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-037-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-038-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-038-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-039-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-039-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-040-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-040-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-041-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-041-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-042-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-042-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-043-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-043-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-044-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-044-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-045-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-045-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-046-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-046-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-048-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-048-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-049-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-049-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-050-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-050-2024.pdf",
    },
  ],
  [
    "SETE - AVANCES FISICO FINANCIERO.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "03-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/AVANCES FISICO FINANCIERO.pdf",
    },
  ],
  // Links for Jorge
  [
    "DAJ - Contrato DAJ-343-2023.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-343-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-354-2023.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Contrato DAJ-354-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-082-2023.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-082-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-083-2023.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-083-2023.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-084-2023.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Convenio DAJ-084-2023.pdf",
    },
  ],
  // Links for DAJ
  [
    "DAJ - Informe de Subsidios Ene-Mar 2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAJ/Informe de Subsidios Ene-Mar 2024.pdf",
    },
  ],
  [
    "SETE - ADQ. VARIADORES.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/ADQ. VARIADORES.pdf",
    },
  ],
  [
    "SETE - FAC VIDEO VIGILANCIA.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/FAC VIDEO VIGILANCIA.pdf",
    },
  ],
  [
    "SETE - FAC. EQUIPAMIENTO TELEMETRIA.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/FAC. EQUIPAMIENTO TELEMETRIA.pdf",
    },
  ],
  [
    "SETE - FAC. TEL CONTROL Y COM.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/FAC. TEL CONTROL Y COM.pdf",
    },
  ],
  [
    "SETE - FACTURA SOLARES.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/FACTURA SOLARES.pdf",
    },
  ],
  [
    "SETE - FAC. BORDO.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/FAC. BORDO.pdf",
    },
  ],
  [
    "SETE - FAC. ESTUDIO.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/FAC. ESTUDIO.pdf",
    },
  ],
  [
    "DAF-S-PF - Carta Descriptiva Comp 1 Comercial 2024 MIR.pdf",
    "1er Trimestre",
    "Marleen Barrera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PF/Carta Descriptiva Comp 1 Comercial 2024 MIR.pdf",
    },
  ],
  [
    "DAF-S-PF - Carta Descriptiva Comp 2 ST 2024 MIR.pdf",
    "1er Trimestre",
    "Marleen Barrera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PF/Carta Descriptiva Comp 2 ST 2024 MIR.pdf",
    },
  ],
  [
    "DAF-S-PF - Carta Descriptiva Comp 3 ST 2024 MIR.pdf",
    "1er Trimestre",
    "Marleen Barrera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/DAF-S-PF/Carta Descriptiva Comp 3 ST 2024 MIR.pdf",
    },
  ],
  [
    "SETE - AVANCES.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/AVANCES.pdf",
    },
  ],
  [
    "SETE - FAC CORRALILLOS.pdf",
    "1er Trimestre",
    "Micaela Copca",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er Trimestre/SETE/FAC CORRALILLOS.pdf",
    },
  ],
  [
    "DAF-S-PF - doc02458420240404124039.pdf",
    "1er Trimestre",
    "Marleen Barrera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/doc02458420240404124039.pdf",
    },
  ],
  [
    "DAF-S-PF - doc02458520240404124050.pdf",
    "1er Trimestre",
    "Marleen Barrera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/doc02458520240404124050.pdf",
    },
  ],
  [
    "DAF-S-PF - Reporte MIR 2024.pdf",
    "1er Trimestre",
    "Marleen Osorio",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Reporte%20MIR%202024.pdf",
    },
  ],
  [
    "DAF-S-PF - Dictamen_23.pdf",
    "1er Trimestre",
    "Magda Ensastiga",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Dictamen_23.pdf",
    },
  ],
  [
    "DAF-S-PF - Estados Financieros.zip",
    "1er Trimestre",
    "Magda Ensastiga",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Estados%20Financieros.zip",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-17-2023.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-17-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-19-2023.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-19-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-21-2023.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-21-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-26-2023.pdf",
    "1er Trimestre",
    "Beatriz Olvera",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-26-2023.pdf",
    },
  ],
  [
    "DAJ - Juicio de Amparo 2137-2023-7.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAJ/Juicio%20de%20Amparo%202137-2023-7.pdf",
    },
  ],
  [
    "DAF-S-RH - Informa Anual del PAT de CEPCI 2023.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "04-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/Informa%20Anual%20del%20PAT%20de%20CEPCI%202023.pdf",
    },
  ],
  [
    "DAF-S-PF - Asignación Presupuesto recursos propios 2024.pdf",
    "1er Trimestre",
    "David",
    "05-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Asignación%20Presupuesto%20recursos%20propios%202024.pdf",
    },
  ],
  [
    "DAF-S-PF - Circular de lineamientos para ejecución del gasto 2024.pdf",
    "1er Trimestre",
    "David",
    "05-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Circular%20de%20lineamientos%20para%20ejecución%20del%20gasto%202024.pdf",
    },
  ],
  [
    "DAF-S-PF - f03DECRETO-2019 DIR.GEN.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "05-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/f03DECRETO-2019%20DIR.GEN.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe Director General julio-septiembre 2023.pdf",
    "1er Trimestre",
    "Bibiana Limon",
    "15-04-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Informe%20Director%20General%20julio-septiembre%202023.pdf",
    },
  ],
  // Link for Subdireccion de Ingresos
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS MODULOS DE COBRO.pdf",
    "1er Trimestre",
    "Butron",
    "02-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20MODULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-PF - 21b-1er2024 spf EAEPE.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "02-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/21b-1er2024%20spf%20EAEPE.pdf",
    },
  ],
  [
    "DAF-S-PF - Presupuesto asignado 2024 CAASIM.pdf",
    "1er Trimestre",
    "Marisol",
    "02-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Presupuesto%20asignado%202024%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-PF - Estados Financieros 23.pdf",
    "1er Trimestre",
    "Magda Esastiga",
    "02-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/Estados%20Financieros%2023.pdf",
    },
  ],
  // Link Nancy Templos
  [
    "DAF-S-RH - f02_Catalogo Institucional de la CAASIM.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "03-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/f02_Catalogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  // Links para Jorge Daniel
  [
    "daj - Contrato DAJ-004-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-004-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-019-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-019-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-021-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-021-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-023-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-023-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-024-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-024-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-025-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-025-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-027-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-027-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-052-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-052-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-053-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-053-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-057-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-057-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-059-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-059-2024.pdf",
    },
  ],
  [
    "daj - Contrato DAJ-063-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Contrato%20DAJ-063-2024.pdf",
    },
  ],
  [
    "daj - Convenio DAJ-011-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/daj/Convenio%20DAJ-011-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-060-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAJ/Contrato%20DAJ-060-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-064-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAJ/Contrato%20DAJ-064-2024.pdf",
    },
  ],
  [
    "DAF-S-PF - SRH_70G_1ER-2024_califi.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "08-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-PF/SRH_70G_1ER-2024_califi.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2029.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2239.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2457.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2769.pdf",
    },
  ],
  [
    "DAF-S-RH - 2804.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2804.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2919.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3213.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3366.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3390.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3583.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3609.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3725.pdf",
    },
  ],
  [
    "DAF-S-RH - 3735.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3735.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3750.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3769.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3816.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3878.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3893.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3918.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3979.pdf",
    },
  ],
  [
    "DAF-S-RH - 4147.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4147.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4157.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4271.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4296.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4299.pdf",
    },
  ],
  [
    "DAF-S-RH - 4308.pdf",
    "1er Trimestre",
    "Yezmin",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4308.pdf",
    },
  ],
  [
    "DAF-S-RH - DAF.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/DAF.pdf",
    },
  ],
  [
    "DAF-S-RH - DAJ.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/DAJ.pdf",
    },
  ],
  [
    "DAF-S-RH - DCOM.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/DCOM.pdf",
    },
  ],
  [
    "DAF-S-RH - f03DECRETO-2019 DIR.GEN.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/f03DECRETO-2019%20DIR.GEN.pdf",
    },
  ],
  [
    "DAF-S-RH - TICS.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "22-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/TICS.pdf",
    },
  ],
  [
    "DAF-S-RM - Facturas.pdf",
    "1er Trimestre",
    "Ines",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/Facturas.pdf",
    },
  ],
  [
    "DAF-S-RH - 1008.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/1008.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/1022.pdf",
    },
  ],
  [
    "DAF-S-RH - 1831.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/1831.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/1979.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/1992.pdf",
    },
  ],
  [
    "DAF-S-RH - 2391.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2391.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2420.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2456.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2465.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2483.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2489.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2579.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2603.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2631.pdf",
    },
  ],
  [
    "DAF-S-RH - 2706.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2706.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2855.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2886.pdf",
    },
  ],
  [
    "DAF-S-RH - 2903.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2903.pdf",
    },
  ],
  [
    "DAF-S-RH - 291.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/291.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2914.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/2989.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3000.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3008.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3011.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3012.pdf",
    },
  ],
  [
    "DAF-S-RH - 3035.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3035.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3080.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3087.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3104.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3105.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3106.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3138.pdf",
    },
  ],
  [
    "DAF-S-RH - 3161.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3161.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3188.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3211.pdf",
    },
  ],
  [
    "DAF-S-RH - 3293.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3293.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3334.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3338.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3358.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3375.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3389.pdf",
    },
  ],
  [
    "DAF-S-RH - 339.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/339.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3398.pdf",
    },
  ],
  [
    "DAF-S-RH - 3400.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3400.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3415.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3449.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3476.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3526.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3610.pdf",
    },
  ],
  [
    "DAF-S-RH - 3616.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3616.pdf",
    },
  ],
  [
    "DAF-S-RH - 3625.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3625.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3628.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3699.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3727.pdf",
    },
  ],
  [
    "DAF-S-RH - 3756.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3756.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3772.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3778.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3828.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3835.pdf",
    },
  ],
  [
    "DAF-S-RH - 3897.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3897.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3931.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3952.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3953.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3960.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3983.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3984.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/3988.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4017.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4022.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4026.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4036.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4039.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4050.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4087.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4095.pdf",
    },
  ],
  [
    "DAF-S-RH - 4133.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4133.pdf",
    },
  ],
  [
    "DAF-S-RH - 4134.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4134.pdf",
    },
  ],
  [
    "DAF-S-RH - 4166.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4166.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4168.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4175.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4179.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4182.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4187.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4193.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4198.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4214.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4221.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4225.pdf",
    },
  ],
  [
    "DAF-S-RH - 4226.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4226.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4228.pdf",
    },
  ],
  [
    "DAF-S-RH - 4232.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4232.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4235.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4238.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4242.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4248.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4249.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4253.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4261.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4265.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4281.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4282.pdf",
    },
  ],
  [
    "DAF-S-RH - 4286.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4286.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4293.pdf",
    },
  ],
  [
    "DAF-S-RH - 4321.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4321.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/4332.pdf",
    },
  ],
  [
    "DAF-S-RH - 794.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/794.pdf",
    },
  ],
  [
    "DAF-S-RH - 846.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/846.pdf",
    },
  ],
  [
    "DAF-S-RH - 873.pdf",
    "1er Trimestre",
    "Yezmin",
    "23-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RH/873.pdf",
    },
  ],
  [
    "DAF-s-RH - 4336.pdf",
    "1er Trimestre",
    "Yezmin",
    "24-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-s-RH/4336.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO ESC. PSN20240520001.pdf",
    "1er Trimestre",
    "Parque Vehicular",
    "28-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/PEDIDO%20ESC.%20PSN20240520001.pdf",
    },
  ],
  [
    "DAF-S-RM - AMABEL ENERO FEB MARZO AD 4.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/AMABEL%20ENERO%20FEB%20MARZO%20AD%204.pdf",
    },
  ],
  [
    "DAF-S-RM - ARCODEM ENE FEB MARZO AD 11.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/ARCODEM%20ENE%20FEB%20MARZO%20AD%2011.pdf",
    },
  ],
  [
    "DAF-S-RM - ARCODEM ENE FEB MARZO AD 11[1].pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/ARCODEM%20ENE%20FEB%20MARZO%20AD%2011[1].pdf",
    },
  ],
  [
    "DAF-S-RM - AURORA ENERO FEB MARZO AD 5.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/AURORA%20ENERO%20FEB%20MARZO%20AD%205.pdf",
    },
  ],
  [
    "DAF-S-RM - BLANCA ENE FEB MARZO AD 6.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/BLANCA%20ENE%20FEB%20MARZO%20AD%206.pdf",
    },
  ],
  [
    "DAF-S-RM - CARLOS ENERO FEB MARZO AD 7.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/CARLOS%20ENERO%20FEB%20MARZO%20AD%207.pdf",
    },
  ],
  [
    "DAF-S-RM - EDUARDO ENERO FEB MARZO AD 8.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/EDUARDO%20ENERO%20FEB%20MARZO%20AD%208.pdf",
    },
  ],
  [
    "DAF-S-RM - GRACIELA ENERO FEB MARZO AD 10.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/GRACIELA%20ENERO%20FEB%20MARZO%20AD%2010.pdf",
    },
  ],
  [
    "DAF-S-RM - JULIETA ENE FEB MARZO AD 12.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/JULIETA%20ENE%20FEB%20MARZO%20AD%2012.pdf",
    },
  ],
  [
    "DAF-S-RM - LEONARDO ENE FEB MARZO AD 16.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/LEONARDO%20ENE%20FEB%20MARZO%20AD%2016.pdf",
    },
  ],
  [
    "DAF-S-RM - MA DEL CARMEN ENE FEB MARZO AD 13.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/MA%20DEL%20CARMEN%20ENE%20FEB%20MARZO%20AD%2013.pdf",
    },
  ],
  [
    "DAF-S-RM - MARIA DEL CARMEN PARRA ENE FEB MARZO AD 14.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/MARIA%20DEL%20CARMEN%20PARRA%20ENE%20FEB%20MARZO%20AD%2014.pdf",
    },
  ],
  [
    "DAF-S-RM - NORBERTO ENE FEB MARZO AD 15.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/NORBERTO%20ENE%20FEB%20MARZO%20AD%2015.pdf",
    },
  ],
  [
    "DAF-S-RM - ODILON ENE FEB MARZO AD 17.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "29-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/ODILON%20ENE%20FEB%20MARZO%20AD%2017.pdf",
    },
  ],
  [
    "DAF-S-RM - SISTEMA CONTINO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-05-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/DAF-S-RM/SISTEMA%20CONTINO.pdf",
    },
  ],
  [
    "Prueba - Formato1.xls",
    "1er Trimestre",
    "Amparo",
    "12-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/Prueba/Formato1.xls",
    },
  ],
  [
    "Prueba - Formato 1 con link al editable.pdf",
    "1er Trimestre",
    "Amparo Flowers",
    "13-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/1er%20Trimestre/Prueba/Formato%201%20con%20link%20al%20editable.pdf",
    },
  ],
  // 2do Trimestre 2024
  [
    "DAJ - Contrato DAJ-032-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-032-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-033-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-033-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-051-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-051-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-054-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-054-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-055-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-055-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-056-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-056-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-066-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-066-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-067-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-067-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-068-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-068-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-069-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-069-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-070-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-070-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-073-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-073-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-074-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-074-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA MAYO.pdf",
    "2do Trimestre",
    "Parque Vehiculare",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURA%20MAYO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN DE RECURSOS.pdf",
    "2do Trimestre",
    "Parque Vehiculare",
    "18-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACIÓN%20DE%20RECURSOS.pdf",
    },
  ],
  [
    "DAF-S-RH - ALBERTO GARCIA LEAL_modified.pdf",
    "2do Trimestre",
    "Yezmin",
    "19-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RH/ALBERTO%20GARCIA%20LEAL_modified.pdf",
    },
  ],
  [
    "DAF-S-RH - MONICA YEZMIN HERNANDEZ AVILA_modified.pdf",
    "2do Trimestre",
    "Yezmin",
    "19-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RH/MONICA%20YEZMIN%20HERNANDEZ%20AVILA_modified.pdf",
    },
  ],
  [
    "DAF-S-RH - PABLO RIOS GAONA_modified.pdf",
    "2do Trimestre",
    "Yezmin",
    "19-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RH/PABLO%20RIOS%20GAONA_modified.pdf",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-032-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-032-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-033-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-033-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-051-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-051-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-054-2023.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-054-2023.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-055-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-055-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-056-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-056-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-066-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-066-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-067-2024.doc",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-067-2024.doc",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-068-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-068-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-069-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-069-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-070-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-070-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-073-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-073-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-074-2024.docx",
    "2do Trimestre",
    "Jorge Daniel Olguin",
    "20-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-074-2024.docx",
    },
  ],
  [
    "DAF-S-RM - ABRIL A  JUNIO JULIETA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20%20JUNIO%20JULIETA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A  JUNIO NORBERTO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20%20JUNIO%20NORBERTO.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO AMABEL.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20AMABEL.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO ARCODEM.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO AURORA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20AURORA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO BLANCA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20BLANCA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO CARLOS.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20CARLOS.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO EDUARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20EDUARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO GRACIELA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20GRACIELA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO LEONARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20LEONARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO MA CORTEZ.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20MA%20CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO MA PARRA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20MA%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL A JUNIO ODILON.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20A%20JUNIO%20ODILON.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL AMABEL.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20AMABEL.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL ARCODEM.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL AURORA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20AURORA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL BLANCA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20BLANCA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL CARLOS.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20CARLOS.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL EDUARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20EDUARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL GRACIELA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20GRACIELA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL JULIETA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20JULIETA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL LEONARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20LEONARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL MA CORTEZ.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20MA%20CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL MA PARRA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20MA%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL NORBERTO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20NORBERTO.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL ODILON.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20ODILON.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL SISTEMA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20SISTEMA.pdf",
    },
  ],
  [
    "DAF-S-RM - ABRIL Y MAYO SISTEMA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ABRIL%20Y%20MAYO%20SISTEMA.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO AMABEL.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20AMABEL.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO ARCODEM.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO AURORA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20AURORA.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO BLANCA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20BLANCA.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO CARLOS.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20CARLOS.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO EDUARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20EDUARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO GRACIELA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20GRACIELA.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO JULIETA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20JULIETA.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO LEONARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20LEONARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO MA CORTEZ.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20MA%20CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO MA PARRA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20MA%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO NORBERTO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20NORBERTO.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNIO ODILON.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNIO%20ODILON.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO AMABEL.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20AMABEL.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO ARCODEM.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO AURORA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20AURORA.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO BLANCA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20BLANCA.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO CARLOS.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20CARLOS.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO EDUARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20EDUARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO GRACIELA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20GRACIELA.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO JULIETA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20JULIETA.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO LEONARDO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20LEONARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO MA CORTEZ.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20MA%20CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO MA PARRA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20MA%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO NORBERTO.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20NORBERTO.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO ODILON.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20ODILON.pdf",
    },
  ],
  [
    "DAF-S-RM - MAYO SISTEMA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "21-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/MAYO%20SISTEMA.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "2do Trimestre",
    "Subdir de Ingresos",
    "25-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DAF-S-PF - O. DAF.SPF-68.24.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "25-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/O.%20DAF.SPF-68.24.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "2do Trimestre",
    "Maribel Butron",
    "26-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "2do Trimestre",
    "Maribel Butron",
    "26-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe Director General enero - marzo 2024.docx",
    "2do Trimestre",
    "Biibiana Limon",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/Informe%20Director%20General%20enero%20-%20marzo%202024.docx",
    },
  ],
  [
    "DAF-S-PF - Informe Director General octubre-diciembre 2023.pdf",
    "2do Trimestre",
    "Biibiana Limon",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/Informe%20Director%20General%20octubre-diciembre%202023.pdf",
    },
  ],
  [
    "DAF-S-RM - AXEL TOMAS FERNANDEZ CORTES.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/AXEL%20TOMAS%20FERNANDEZ%20CORTES.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS 351001.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURAS%20351001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240404002.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PSN20240404002.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240503001.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PSN20240503001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240604001.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PSN20240604001.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-065-2024.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/SPF-065-2024.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe Director General enero-marzo-2024.pdf",
    "2do Trimestre",
    "Bibiana Limon",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/Informe%20Director%20General%20enero-marzo-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - R-421-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-421-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-421-FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-421-FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-421-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-421-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-421-OSN20240426001.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-421-OSN20240426001.pdf",
    },
  ],
  [
    "DAF-S-RM - R-422-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-422-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-422-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-422-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-422-PSN20240618001.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-422-PSN20240618001.pdf",
    },
  ],
  [
    "DAF-S-RM - R-424-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-424-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-424-FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-424-FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-424-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-424-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-424-PSN20240404001.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-424-PSN20240404001.pdf",
    },
  ],
  [
    "DAF-S-RM - R-430-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-430-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-430-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-430-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-430-PSN20240618002.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-430-PSN20240618002.pdf",
    },
  ],
  [
    "DAF-S-RM - R-431-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-431-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-431-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-431-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-431-PSN20240618003.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-431-PSN20240618003.pdf",
    },
  ],
  [
    "DAF-S-RM - R-432-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-432-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-432-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-432-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-432-PSN20240618004.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-432-PSN20240618004.pdf",
    },
  ],
  [
    "DAF-S-RM - R-433-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-433-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-433-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-433-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-433-PSN20240618005.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-433-PSN20240618005.pdf",
    },
  ],
  [
    "DAF-S-RM - R-434-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-434-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-434-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-434-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-434-PSN0618006.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-434-PSN0618006.pdf",
    },
  ],
  [
    "DAF-S-RM - R-435-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-435-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-435-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-435-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - R-435-PSN20240618007.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-435-PSN20240618007.pdf",
    },
  ],
  [
    "DAF-S-RM - VW-COTIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/VW-COTIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - VW-FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/VW-FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - VW-OFICIO AUTORIZACION.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/VW-OFICIO%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - VW-PSN20240506001.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "27-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/VW-PSN20240506001.pdf",
    },
  ],
  [
    "DAF-S-PCF - Circular Cierre-2024.docx",
    "2do Trimestre",
    "Freddy Pacheco Montanez",
    "28-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/Circular%20Cierre-2024.docx",
    },
  ],
  [
    "DAF-S-PCF - CALENDARIO ANUAL 2024.pdf",
    "2do Trimestre",
    "FReddy",
    "28-06-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/CALENDARIO%20ANUAL%202024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N15.pdf",
    "2do Trimestre",
    "Beatriz Martinez",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/DICTAMEN%20N15.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N8.pdf",
    "2do Trimestre",
    "Beatriz Martinez",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/DICTAMEN%20N8.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN HACIENDA-A-FOCOE-GI-2024-4019-00155.pdf",
    "2do Trimestre",
    "Beatriz Martinez",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20HACIENDA-A-FOCOE-GI-2024-4019-00155.pdf",
    },
  ],
  [
    "DAF-S-RM - Fact. 438.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/Fact.%20438.pdf",
    },
  ],
  [
    "DAF-S-RM - Oficio de autorización de recursos N18.pdf",
    "2do Trimestre",
    "Licitaciones",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/Oficio%20de%20autorización%20de%20recursos%20N18.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-05-20001.pdf",
    "2do Trimestre",
    "Licitaciones",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-L.O.P.-05-20001.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO HACIENDA-A-PRISR-GI-2024-4019-00156.pdf",
    "2do Trimestre",
    "Beatriz Olvera",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/OFICIO%20HACIENDA-A-PRISR-GI-2024-4019-00156.pdf",
    },
  ],
  [
    "DAB - 2do.Trimestre_ actividadesvactor_archivo editable.xls",
    "2do Trimestre",
    "DAB",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2do.Trimestre_%20actividadesvactor_archivo%20editable.xls",
    },
  ],
  [
    "DAB - 2do.Trimestre_ Indicadoresvactor_archivo editable.xls",
    "2do Trimestre",
    "DAB",
    "01-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2do.Trimestre_%20Indicadoresvactor_archivo%20editable.xls",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FOCOE-GI-2024-4019-00152.pdf",
    "2do Trimestre",
    "Licitaciones CAASIM",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/HACIENDA-A-FOCOE-GI-2024-4019-00152.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-110-2024.pdf",
    "2do Trimestre",
    "Licitaciones CAASIM",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/SPF-110-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-111-2024.pdf",
    "2do Trimestre",
    "Licitaciones CAASIM",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/SPF-111-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-065-2024-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/SPF-065-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - AD-2-2024-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/AD-2-2024-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - AD-5-2024-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/AD-5-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - AD-7-2024-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/AD-7-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Oficio de autorización talachas-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/Oficio%20de%20autorización%20talachas-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-421-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-421-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-422-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-422-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-424-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-424-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-430-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-430-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-431-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-431-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-432-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-432-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-433-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-433-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-434-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-434-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-435-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-435-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - VW-OFICIO AUTORIZACION-salida.pdf",
    "2do Trimestre",
    "Parque Vehicular",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/VW-OFICIO%20AUTORIZACION-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FOGOE-GI-2024-4019-00154.pdf",
    "2do Trimestre",
    "Karla Mora",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/HACIENDA-A-FOGOE-GI-2024-4019-00154.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTIVIDADES DESAZOLVE-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ACTIVIDADES%20DESAZOLVE-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTIVIDADES PIPAS-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ACTIVIDADES%20PIPAS-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTIVIDADES PLANTAS DE TRATAM.-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ACTIVIDADES%20PLANTAS%20DE%20TRATAM.-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - GRAFICA 2DO. TRIM. ACT.PROY.13.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/GRAFICA%202DO.%20TRIM.%20ACT.PROY.13.pdf",
    },
  ],
  [
    "DAF-S-RM - GRAFICA 2DO. TRIM_PROY 22.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/GRAFICA%202DO.%20TRIM_PROY%2022.pdf",
    },
  ],
  [
    "DAF-S-RM - GRAFICA 2do.TRIM. PROY.19.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/GRAFICA%202do.TRIM.%20PROY.19.pdf",
    },
  ],
  [
    "DAF-S-RM - INDICADORES DESAZOLVE-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/INDICADORES%20DESAZOLVE-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - INDICADORES PIPAS-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/INDICADORES%20PIPAS-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - INDICADORES PLANTAS DE TRATAM.-salida.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/INDICADORES%20PLANTAS%20DE%20TRATAM.-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014020240401150139-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014020240401150139-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014220240401150204-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014220240401150204-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014320240401150215-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014320240401150215-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014420240401150227-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014420240401150227-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014520240401150238-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014520240401150238-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014620240401150249-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014620240401150249-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014720240401150259-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014720240401150259-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014820240401150310-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014820240401150310-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02014920240401150320-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02014920240401150320-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02015020240401150331-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02015020240401150331-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02015120240401150342-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02015120240401150342-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02015220240401150352-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02015220240401150352-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02015320240401150407-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02015320240401150407-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - doc02015420240401151026-salida (1).pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/doc02015420240401151026-salida%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS PIBEH 2DO TRIMESTRE.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURAS%20PIBEH%202DO%20TRIMESTRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS POLICIA HIDRICA 2DO TRIMESTRE.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURAS%20POLICIA%20HIDRICA%202DO%20TRIMESTRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS TELMEX 2DO TRIMESTRE.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURAS%20TELMEX%202DO%20TRIMESTRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS TELMEX ABRIL 2DO TRIMESTRE.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURAS%20TELMEX%20ABRIL%202DO%20TRIMESTRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS TELMEX JUNIO 2DO TRIMESTRE.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURAS%20TELMEX%20JUNIO%202DO%20TRIMESTRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS TELMEX MAYO 2DO TRIMESTRE.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FACTURAS%20TELMEX%20MAYO%202DO%20TRIMESTRE.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES DESAZOLVE-salida.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIVIDADES%20DESAZOLVE-salida.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES PIPAS-salida.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIVIDADES%20PIPAS-salida.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES PLANTAS DE TRATAM.-salida.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIVIDADES%20PLANTAS%20DE%20TRATAM.-salida.pdf",
    },
  ],
  [
    "DAB - GRAFICA 2DO. TRIM. ACT.PROY.13.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/GRAFICA%202DO.%20TRIM.%20ACT.PROY.13.pdf",
    },
  ],
  [
    "DAB - GRAFICA 2DO. TRIM_PROY 22.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/GRAFICA%202DO.%20TRIM_PROY%2022.pdf",
    },
  ],
  [
    "DAB - GRAFICA 2do.TRIM. PROY.19.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/GRAFICA%202do.TRIM.%20PROY.19.pdf",
    },
  ],
  [
    "DAB - INDICADORES DESAZOLVE-salida.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20DESAZOLVE-salida.pdf",
    },
  ],
  [
    "DAB - INDICADORES PIPAS-salida.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20PIPAS-salida.pdf",
    },
  ],
  [
    "DAB - INDICADORES PLANTAS DE TRATAM.-salida.pdf",
    "2do Trimestre",
    "Direccion de Abasto",
    "02-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20PLANTAS%20DE%20TRATAM.-salida.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo de Puestos de la CAASIM.pdf",
    "2do Trimestre",
    "Susana Martinez",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RH/F02a_Catálogo%20de%20Puestos%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura Validada 2024.pdf",
    "2do Trimestre",
    "Susana Martinez",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RH/F02b_Estructura%20Validada%202024.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_DECRETO 2019.pdf",
    "2do Trimestre",
    "Susana Martinez",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RH/F03_DECRETO%202019.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTIVIDADES PLANTA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/ACTIVIDADES%20PLANTA.pdf",
    },
  ],
  [
    "DAF-S-RM - GRÁFICA 2do.TRIM_ PLANTAS_PROY.19.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/GRÁFICA%202do.TRIM_%20PLANTAS_PROY.19.pdf",
    },
  ],
  [
    "DAF-S-RM - INDICADORES PLANTA.pdf",
    "2do Trimestre",
    "Cristina Mejia",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/INDICADORES%20PLANTA.pdf",
    },
  ],
  [
    "DAB - 1. Reportes trimestrales Abril Junio 2024 Indicadores Operación (1).xls",
    "2do Trimestre",
    "Direccion de Abasto",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/1.%20Reportes%20trimestrales%20Abril%20Junio%202024%20Indicadores%20Operación%20(1).xls",
    },
  ],
  [
    "DAB - 2DO TRIM. IND_ PTAR´S EXC.xls",
    "2do Trimestre",
    "Direccion de Abasto",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2DO%20TRIM.%20IND_%20PTAR´S%20EXC.xls",
    },
  ],
  [
    "DAB - 2do. trim Indicadores Pipas Exc.xlsx",
    "2do Trimestre",
    "Direccion de Abasto",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2do.%20trim%20Indicadores%20Pipas%20Exc.xlsx",
    },
  ],
  [
    "DAB - 2do.Trimestre_ actividadesvactor_archivo editable.xls",
    "2do Trimestre",
    "Direccion de Abasto",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2do.Trimestre_%20actividadesvactor_archivo%20editable.xls",
    },
  ],
  [
    "DAB - 2do.Trimestre_ Indicadoresvactor_archivo editable.xls",
    "2do Trimestre",
    "Direccion de Abasto",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2do.Trimestre_%20Indicadoresvactor_archivo%20editable.xls",
    },
  ],
  [
    "DAB - 2do.trim_Actividades Pipas Exc.xlsx",
    "2do Trimestre",
    "Direccion de Abasto",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2do.trim_Actividades%20Pipas%20Exc.xlsx",
    },
  ],
  [
    "DAB - ACT_2DO. TRI PLANTAS EXC.xls",
    "2do Trimestre",
    "Direccion de Abasto",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACT_2DO.%20TRI%20PLANTAS%20EXC.xls",
    },
  ],
  [
    "DAF-S-PF - 2Lineamientos SRH.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "03-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/2Lineamientos%20SRH.pdf",
    },
  ],
  [
    "DAF-S-PF - DAF-SPF-069-2024.pdf",
    "2do Trimestre",
    "Marleen Barrera",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/DAF-SPF-069-2024.pdf",
    },
  ],
  [
    "DAB - DESAZOLVE INDICADORES.pdf",
    "2do Trimestre",
    "Joana",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/DESAZOLVE%20INDICADORES.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES DESAZOLVE Y EQUI.pdf",
    "2do Trimestre",
    "Joana",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIVIDADES%20DESAZOLVE%20Y%20EQUI.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES_PIPAS.pdf",
    "2do Trimestre",
    "Joana",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIVIDADES_PIPAS.pdf",
    },
  ],
  [
    "DAB - INDICADORES DESAZOLVE.pdf",
    "2do Trimestre",
    "Joana",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20DESAZOLVE.pdf",
    },
  ],
  [
    "DAB - INDICADORES PLAN DE TRAT.pdf",
    "2do Trimestre",
    "Joana",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20PLAN%20DE%20TRAT.pdf",
    },
  ],
  [
    "DAB - PIPAS INDICADORES.pdf",
    "2do Trimestre",
    "Joana",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/PIPAS%20INDICADORES.pdf",
    },
  ],
  [
    "DAB - PLANTAS ACTIVIDADES.pdf",
    "2do Trimestre",
    "Joana",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/PLANTAS%20ACTIVIDADES.pdf",
    },
  ],
  [
    "DAF-S-PF - CFT 2022-2023.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/CFT%202022-2023.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-032-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-032-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-033-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-033-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-051-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-051-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-054-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-054-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-055-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-055-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-056-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-056-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-066-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-066-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-069-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-069-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-070-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-070-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-073-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-073-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-074-2024.pdf",
    "2do Trimestre",
    "Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-074-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-067-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-067-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-068-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CAASIM-DAJ-068-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-076-2024.docx",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-076-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-079-2024.docx",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-079-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-080-2024.docx",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-080-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-081-2024.docx",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-081-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-082-2024.docx",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-082-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-083-2024_.docx",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-083-2024_.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-084-2024.docx",
    "2do Trimestre",
    "Jorge Daniel",
    "04-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/CONTRATO%20DAJ-084-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-076-2024.pdf",
    "2do Trimestre",
    "Daniel Olguin",
    "05-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-076-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-079-2024.pdf",
    "2do Trimestre",
    "Daniel Olguin",
    "05-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-079-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-080-2024.pdf",
    "2do Trimestre",
    "Daniel Olguin",
    "05-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-080-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-081-2024.pdf",
    "2do Trimestre",
    "Daniel Olguin",
    "05-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-081-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-082-2024.pdf",
    "2do Trimestre",
    "Daniel Olguin",
    "05-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-082-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-083-2024.pdf",
    "2do Trimestre",
    "Daniel Olguin",
    "05-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-083-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-084-2024.pdf",
    "2do Trimestre",
    "Daniel Olguin",
    "05-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-084-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - R-422 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista Martinez",
    "08-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-422%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-430 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista Martinez",
    "08-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-430%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-431 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista Martinez",
    "08-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-431%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-432 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista Martinez",
    "08-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-432%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-433 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista Martinez",
    "08-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-433%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-434 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista Martinez",
    "08-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-434%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-435 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista Martinez",
    "08-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-435%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-PCF - I a) ESTADO DE SITUACIÓN FINANCIERA.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20a)%20ESTADO%20DE%20SITUACIÓN%20FINANCIERA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I b) ESTADO DE ACTIVIDADES.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20b)%20ESTADO%20DE%20ACTIVIDADES.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I c) ESTADO DE VARIACIÓN EN LA HACIENDA PÚBLICA.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20c)%20ESTADO%20DE%20VARIACIÓN%20EN%20LA%20HACIENDA%20PÚBLICA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I d) ESTADO DE CAMBIOS EN LA SITUACIÓN FINANCIERA.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20d)%20ESTADO%20DE%20CAMBIOS%20EN%20LA%20SITUACIÓN%20FINANCIERA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I e) ESTADO DE FLUJOS DE EFECTIVO.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20e)%20ESTADO%20DE%20FLUJOS%20DE%20EFECTIVO.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I f) ESTADO ANALÍTICO DEL ACTIVO.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20f)%20ESTADO%20ANALÍTICO%20DEL%20ACTIVO.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I g) ESTADO ANALÍTICO DE LA DEUDA Y OTROS PASIVOS.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20g)%20ESTADO%20ANALÍTICO%20DE%20LA%20DEUDA%20Y%20OTROS%20PASIVOS.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I h) INFORME SOBRE PASIVOS CONTINGENTES.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20h)%20INFORME%20SOBRE%20PASIVOS%20CONTINGENTES.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I i) NOTAS A LOS ESTADOS FINANCIEROS.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/I%20i)%20NOTAS%20A%20LOS%20ESTADOS%20FINANCIEROS.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II a) 1. EAI CLASIFICACIÓN ECONÓMICA.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20a)%201.%20EAI%20CLASIFICACIÓN%20ECONÓMICA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II a) 2. EAI POR FUENTE DE FINANCIAMIENTO.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20a)%202.%20EAI%20POR%20FUENTE%20DE%20FINANCIAMIENTO.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II a) 3. EAI CLASIFICACIÓN POR RUBROS DE INGRESOS A NIVEL CONCEPTO.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20a)%203.%20EAI%20CLASIFICACIÓN%20POR%20RUBROS%20DE%20INGRESOS%20A%20NIVEL%20CONCEPTO.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II a) 4. EAI ESTADO ANALÍTICO DE INGRESOS.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20a)%204.%20EAI%20ESTADO%20ANALÍTICO%20DE%20INGRESOS.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II b) 1. EAEPE CLASIFICACIÓN ADMINISTRATIVA.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20b)%201.%20EAEPE%20CLASIFICACIÓN%20ADMINISTRATIVA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II b) 2. EAEPE CLASIFICACIÓN ECONÓMICA Y POR OBJETO DEL GASTO.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20b)%202.%20EAEPE%20CLASIFICACIÓN%20ECONÓMICA%20Y%20POR%20OBJETO%20DEL%20GASTO.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II b) 3. EAEPE CLASIFICACIÓN FUNCIONAL _ PROGRAMÁTICA.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20b)%203.%20EAEPE%20CLASIFICACIÓN%20FUNCIONAL%20_%20PROGRAMÁTICA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II b) 4. EAEPE CLASIFICACIÓN ADMINISTRATIVA 2.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20b)%204.%20EAEPE%20CLASIFICACIÓN%20ADMINISTRATIVA%202.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II b) 5. EAEPE CLASIFICACIÓN ECONÓMICA (POR TIPO DE GASTO).xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20b)%205.%20EAEPE%20CLASIFICACIÓN%20ECONÓMICA%20(POR%20TIPO%20DE%20GASTO).xlsx",
    },
  ],
  [
    "DAF-S-PCF - II b) 6. EAEPE CLASIFICACIÓN POR OBJETO DEL GASTO (CAPÍTULO Y CONCEPTO).xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20b)%206.%20EAEPE%20CLASIFICACIÓN%20POR%20OBJETO%20DEL%20GASTO%20(CAPÍTULO%20Y%20CONCEPTO).xlsx",
    },
  ],
  [
    "DAF-S-PCF - II c) ENDEUDAMIENTO NETO.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20c)%20ENDEUDAMIENTO%20NETO.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II d) INTERESES DE LA DEUDA.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20d)%20INTERESES%20DE%20LA%20DEUDA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II e) FLUJO DE FONDOS.xlsx",
    "2do Trimestre",
    "Alicia Perezgrovas Cubas",
    "12-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/II%20e)%20FLUJO%20DE%20FONDOS.xlsx",
    },
  ],
  [
    "DAB - ACTIV DESAZOLVE 2DO. TRIM 2024.pdf",
    "2do Trimestre",
    "Joana",
    "15-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIV%20DESAZOLVE%202DO.%20TRIM%202024.pdf",
    },
  ],
  [
    "DAB - ACTIV PIPAS 2DO. TRIM 2024.pdf",
    "2do Trimestre",
    "Joana",
    "15-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIV%20PIPAS%202DO.%20TRIM%202024.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES PLANTAS 2DO.TRIME 2024.pdf",
    "2do Trimestre",
    "Joana",
    "15-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/ACTIVIDADES%20PLANTAS%202DO.TRIME%202024.pdf",
    },
  ],
  [
    "DAB - INDICADORES DESAZOLVE 2DO. TRIM 2024.pdf",
    "2do Trimestre",
    "Joana",
    "15-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20DESAZOLVE%202DO.%20TRIM%202024.pdf",
    },
  ],
  [
    "DAB - INDICADORES PIPAS 2DO. TRIM 2024.pdf",
    "2do Trimestre",
    "Joana",
    "15-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20PIPAS%202DO.%20TRIM%202024.pdf",
    },
  ],
  [
    "DAB - INDICADORES PLANTAS 2DO. TRIM 2024.pdf",
    "2do Trimestre",
    "Joana",
    "15-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/INDICADORES%20PLANTAS%202DO.%20TRIM%202024.pdf",
    },
  ],
  [
    "DAP - 7 HIPERVINCULO SOLICITUD DE LABORATORIO DE ANALISIS DE AGUA RESIDUAL.docx",
    "2do Trimestre",
    "Micaela Copca",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAP/7%20HIPERVINCULO%20SOLICITUD%20DE%20LABORATORIO%20DE%20ANALISIS%20DE%20AGUA%20RESIDUAL.docx",
    },
  ],
  [
    "DAP - REPOSICIÓN DE PERMISO DE DESCARGA DE AGUA RESIDUAL.docx",
    "2do Trimestre",
    "Micaela Copca",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAP/REPOSICIÓN%20DE%20PERMISO%20DE%20DESCARGA%20DE%20AGUA%20RESIDUAL.docx",
    },
  ],
  [
    "DAP - solicitud permiso de descarga de agua residual.docx",
    "2do Trimestre",
    "Micaela Copca",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAP/solicitud%20permiso%20de%20descarga%20de%20agua%20residual.docx",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOMICILIARIA.docx",
    "2do Trimestre",
    "Rosalba",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOMICILIARIA.docx",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOMICILIARIA.pdf",
    "2do Trimestre",
    "Rosalba",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOMICILIARIA.pdf",
    },
  ],
  [
    "DAB - 1apipas.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/1apipas.docx",
    },
  ],
  [
    "DAB - 1bpipas.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/1bpipas.docx",
    },
  ],
  [
    "DAB - 1cpipas.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/1cpipas.docx",
    },
  ],
  [
    "DAB - 2adesa.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2adesa.docx",
    },
  ],
  [
    "DAB - 2bdesa.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2bdesa.docx",
    },
  ],
  [
    "DAB - 2cdesa.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2cdesa.docx",
    },
  ],
  [
    "DAB - 3asane.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/3asane.docx",
    },
  ],
  [
    "DAB - 3bsane.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/3bsane.docx",
    },
  ],
  [
    "DAB - 3csane.docx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/3csane.docx",
    },
  ],
  [
    "DAP - REPOSICIÓN DE PERMISO DE DESCARGA DE AGUA RESIDUAL.pdf",
    "2do Trimestre",
    "Micaela Copca",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAP/REPOSICIÓN%20DE%20PERMISO%20DE%20DESCARGA%20DE%20AGUA%20RESIDUAL.pdf",
    },
  ],
  [
    "DAP - SOLICITUD DE LABORATORIO DE ANALISIS DE AGUA RESIDUAL.pdf",
    "2do Trimestre",
    "Micaela Copca",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAP/SOLICITUD%20DE%20LABORATORIO%20DE%20ANALISIS%20DE%20AGUA%20RESIDUAL.pdf",
    },
  ],
  [
    "DAP - SOLICITUD DE PERMISO DE DESCARGA DE AGUA RESIDUAL.pdf",
    "2do Trimestre",
    "Micaela Copca",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAP/SOLICITUD%20DE%20PERMISO%20DE%20DESCARGA%20DE%20AGUA%20RESIDUAL.pdf",
    },
  ],
  [
    "DCONS - HIPERVINCULO FORMATOS.docx",
    "2do Trimestre",
    "Rosalba",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCONS/HIPERVINCULO%20FORMATOS.docx",
    },
  ],
  [
    "DAF-S-RH - Tabulador 2024-salida.pdf",
    "2do Trimestre",
    "Susana",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RH/Tabulador%202024-salida.pdf",
    },
  ],
  [
    "DCOME - SOLICITUD DE AGUA POTABLE.docx",
    "2do Trimestre",
    "Miguel Vivar",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCOME/SOLICITUD%20DE%20AGUA%20POTABLE.docx",
    },
  ],
  [
    "DCOME - SOLICITUD DE AGUA POTABLE.pdf",
    "2do Trimestre",
    "Miguel Vivar",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCOME/SOLICITUD%20DE%20AGUA%20POTABLE.pdf",
    },
  ],
  [
    "DCONS - HIPERVINCULO  CONSTRUCCION DESCARGAS.docx",
    "2do Trimestre",
    "Rosalba",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCONS/HIPERVINCULO%20%20CONSTRUCCION%20DESCARGAS.docx",
    },
  ],
  [
    "DCONS - HIPERVINCULO PRESUPUESTO DESCARGAS.docx",
    "2do Trimestre",
    "Rosalba",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCONS/HIPERVINCULO%20PRESUPUESTO%20DESCARGAS.docx",
    },
  ],
  [
    "DCOME - Contratación de agua potable y alcantarillado sanitario para tarifa doméstica..pdf",
    "2do Trimestre",
    "Miguel Vivar",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCOME/Contratación%20de%20agua%20potable%20y%20alcantarillado%20sanitario%20para%20tarifa%20doméstica..pdf",
    },
  ],
  [
    "DCOME - Derivación doméstica..pdf",
    "2do Trimestre",
    "Miguel Vivar",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCOME/Derivación%20doméstica..pdf",
    },
  ],
  [
    "DAF-S-PF - tabulador editable.xlsx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/tabulador%20editable.xlsx",
    },
  ],
  [
    "DAf-S-PF - Tabulador 2024.docx",
    "2do Trimestre",
    "dd",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAf-S-PF/Tabulador%202024.docx",
    },
  ],
  [
    "DAF-S-PF - Tabulador 2024.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/Tabulador%202024.pdf",
    },
  ],
  [
    "DAF-S-PF - Subsidios Abr - Jun 2024.xlsx",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/Subsidios%20Abr%20-%20Jun%202024.xlsx",
    },
  ],
  [
    "DAF-S-PF - Subsidios Abril-Junio 2024.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/Subsidios%20Abril-Junio%202024.pdf",
    },
  ],
  [
    "DAJ - Subsidios.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "16-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Subsidios.pdf",
    },
  ],
  [
    "DAF-S-PF - GASTO POR CATEGORIA PROGRAMATICA.xlsx",
    "2do Trimestre",
    "Marisol",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/GASTO%20POR%20CATEGORIA%20PROGRAMATICA.xlsx",
    },
  ],
  [
    "DAF-S-PF - INDICADORES DE RESULTADOS JUNIO 2024.xlsx",
    "2do Trimestre",
    "Marisol",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/INDICADORES%20DE%20RESULTADOS%20JUNIO%202024.xlsx",
    },
  ],
  [
    "DAF-S-PF - PROGRAMAS Y PROYECTOS INVERSION.xlsx",
    "2do Trimestre",
    "Marisol",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/PROGRAMAS%20Y%20PROYECTOS%20INVERSION.xlsx",
    },
  ],
  [
    "DAF-S-PF - GASTO_POR_CATEGORIA_PROGRAMATICA.pdf",
    "2do Trimestre",
    "Marisol PF",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/GASTO_POR_CATEGORIA_PROGRAMATICA.pdf",
    },
  ],
  [
    "DAF-S-PF - INDICADORES_DE_RESULTADOS.pdf",
    "2do Trimestre",
    "Marisol PF",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/INDICADORES_DE_RESULTADOS.pdf",
    },
  ],
  [
    "DAF-S-PF - PROGRAMAS_Y_PROYECTOS_DE_INVERSION.pdf",
    "2do Trimestre",
    "Marisol PF",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/PROGRAMAS_Y_PROYECTOS_DE_INVERSION.pdf",
    },
  ],
  [
    "DAF-S-PF - GASTO CATEGORIA PROGRAMATICA LINKS.pdf",
    "2do Trimestre",
    "Marisol",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/GASTO%20CATEGORIA%20PROGRAMATICA%20LINKS.pdf",
    },
  ],
  [
    "DAF-S-PF - INDICADORES DE RESULTADOS.pdf",
    "2do Trimestre",
    "Marisol",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/INDICADORES%20DE%20RESULTADOS.pdf",
    },
  ],
  [
    "DAF-S-PF - PROGRAMAS Y PROYECTOS DE INVERSION.pdf",
    "2do Trimestre",
    "Marisol",
    "23-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/PROGRAMAS%20Y%20PROYECTOS%20DE%20INVERSION.pdf",
    },
  ],
  [
    "DAF-S-PF - 10EAI Clasificación Económica.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/10EAI%20Clasificación%20Económica.pdf",
    },
  ],
  [
    "DAF-S-PF - 11EAI Por Fuente de Financiamiento.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/11EAI%20Por%20Fuente%20de%20Financiamiento.pdf",
    },
  ],
  [
    "DAF-S-PF - 12EAI CRI a Nivel Concepto.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/12EAI%20CRI%20a%20Nivel%20Concepto.pdf",
    },
  ],
  [
    "DAF-S-PF - 13EAI Incluyendo Excedentes.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/13EAI%20Incluyendo%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PF - 14EAEP Clasificación Administrativa.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/14EAEP%20Clasificación%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PF - 15EAEP Clasificación Económica y COG.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/15EAEP%20Clasificación%20Económica%20y%20COG.pdf",
    },
  ],
  [
    "DAF-S-PF - 16EAEP Funcional Programática.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/16EAEP%20Funcional%20Programática.pdf",
    },
  ],
  [
    "DAF-S-PF - 17EAEP Por Ramo.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/17EAEP%20Por%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PF - 18EAEP Tipo de Gasto.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/18EAEP%20Tipo%20de%20Gasto.pdf",
    },
  ],
  [
    "DAF-S-PF - 19Endeudamiento Neto.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/19Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PF - 1edo sit Financiera.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/1edo%20sit%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PF - 20Intereses de la Deuda.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/20Intereses%20de%20la%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PF - 2Edo  Actividades.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/2Edo%20%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PF - 3Edo var Hacienda Pública.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/3Edo%20var%20Hacienda%20Pública.pdf",
    },
  ],
  [
    "DAF-S-PF - 4Edoc cam Situación Financiera.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/4Edoc%20cam%20Situación%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PF - 5Edo Flujos de Efectivo.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/5Edo%20Flujos%20de%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PF - 6Edo Analitico del Activo.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/6Edo%20Analitico%20del%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PF - 7Edo ana Deuda y Otros Pasivos.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/7Edo%20ana%20Deuda%20y%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PF - 8Inf Pasivos Contingentes.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/8Inf%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PF - 9Notas edos Financieros.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/9Notas%20edos%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - 10EAI Clasificación Económica.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/10EAI%20Clasificación%20Económica.pdf",
    },
  ],
  [
    "DAF-S-PCF - 11EAI Por Fuente de Financiamiento.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/11EAI%20Por%20Fuente%20de%20Financiamiento.pdf",
    },
  ],
  [
    "DAF-S-PCF - 12EAI CRI a Nivel Concepto.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/12EAI%20CRI%20a%20Nivel%20Concepto.pdf",
    },
  ],
  [
    "DAF-S-PCF - 13EAI Incluyendo Excedentes.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/13EAI%20Incluyendo%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - 14EAEP Clasificación Administrativa.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/14EAEP%20Clasificación%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - 15EAEP Clasificación Económica y COG.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/15EAEP%20Clasificación%20Económica%20y%20COG.pdf",
    },
  ],
  [
    "DAF-S-PCF - 16EAEP Funcional Programática.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/16EAEP%20Funcional%20Programática.pdf",
    },
  ],
  [
    "DAF-S-PCF - 17EAEP Por Ramo.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/17EAEP%20Por%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - 18EAEP Tipo de Gasto.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/18EAEP%20Tipo%20de%20Gasto.pdf",
    },
  ],
  [
    "DAF-S-PCF - 19Endeudamiento Neto.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/19Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - 1edo sit Financiera.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/1edo%20sit%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - 20Intereses de la Deuda.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/20Intereses%20de%20la%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PCF - 2Edo  Actividades.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/2Edo%20%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - 3Edo var Hacienda Pública.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/3Edo%20var%20Hacienda%20Pública.pdf",
    },
  ],
  [
    "DAF-S-PCF - 4Edoc cam Situación Financiera.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/4Edoc%20cam%20Situación%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - 5Edo Flujos de Efectivo.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/5Edo%20Flujos%20de%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - 6Edo Analitico del Activo.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/6Edo%20Analitico%20del%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - 7Edo ana Deuda y Otros Pasivos.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/7Edo%20ana%20Deuda%20y%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - 8Inf Pasivos Contingentes.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/8Inf%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - 9Notas edos Financieros.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/9Notas%20edos%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PF - 21Gto cat programatica.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/21Gto%20cat%20programatica.pdf",
    },
  ],
  [
    "DAF-S-PF - 22Prog y proy inversion.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/22Prog%20y%20proy%20inversion.pdf",
    },
  ],
  [
    "DAF-S-PF - 23 ind. resultados.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/23%20ind.%20resultados.pdf",
    },
  ],
  [
    "DAF-S-PCF - 1 FINAL 21B-31A.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/1%20FINAL%2021B-31A.pdf",
    },
  ],
  [
    "DAF-S-PCF - 1 FINAL 21B-31A.xlsx",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PCF/1%20FINAL%2021B-31A.xlsx",
    },
  ],
  [
    "DAF-S-PF - 24 PTO EGRE 2-24.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/24%20PTO%20EGRE%202-24.pdf",
    },
  ],
  [
    "DAF-S-PF - 25INGRESOS 2-24.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "24-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/25INGRESOS%202-24.pdf",
    },
  ],
  [
    "DCONS - 3 DESCARGAS.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "27-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCONS/3%20DESCARGAS.pdf",
    },
  ],
  [
    "DCONS - 4 PRESUPUESTO.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "27-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DCONS/4%20PRESUPUESTO.pdf",
    },
  ],
  [
    "DAB - 1apipas.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/1apipas.pdf",
    },
  ],
  [
    "DAB - 1bpipas.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/1bpipas.pdf",
    },
  ],
  [
    "DAB - 1cpipas.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/1cpipas.pdf",
    },
  ],
  [
    "DAB - 2adesa.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2adesa.pdf",
    },
  ],
  [
    "DAB - 2bdesa.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2bdesa.pdf",
    },
  ],
  [
    "DAB - 2cdesa.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/2cdesa.pdf",
    },
  ],
  [
    "DAB - 3asane.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/3asane.pdf",
    },
  ],
  [
    "DAB - 3bsane.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/3bsane.pdf",
    },
  ],
  [
    "DAB - 3csane.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/3csane.pdf",
    },
  ],
  [
    "DAB - GRAFICA 2DO. TRIMESTRE DESAZOLVE.xlsx",
    "2do Trimestre",
    "Joana",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/GRAFICA%202DO.%20TRIMESTRE%20DESAZOLVE.xlsx",
    },
  ],
  [
    "DAB - GRAFICA 2DO. TRIMESTRE PIPAS.xlsx",
    "2do Trimestre",
    "Joana",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/GRAFICA%202DO.%20TRIMESTRE%20PIPAS.xlsx",
    },
  ],
  [
    "DAB - GRAFICA 2do.TRIMESTRE PLANTAS.xlsx",
    "2do Trimestre",
    "Joana",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAB/GRAFICA%202do.TRIMESTRE%20PLANTAS.xlsx",
    },
  ],
  [
    "daf-s-rm - R-424-FACTURA-salida.pdf",
    "2do Trimestre",
    "Alexia",
    "29-07-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/daf-s-rm/R-424-FACTURA-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-422 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "08-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-422%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-430 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "08-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-430%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-431 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "08-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-431%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-432 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "08-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-432%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-433 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "08-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-433%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-434 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "08-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-434%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - R-435 FACTURA.pdf",
    "2do Trimestre",
    "Edgar Bautista",
    "08-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-435%20FACTURA.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 04-2024-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/CONVOCATORIA%2004-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 05-2024-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/CONVOCATORIA%2005-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 06-2024-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/CONVOCATORIA%2006-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 07-2024-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/CONVOCATORIA%2007-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FOCOE-GI-2024-4019-00152-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/HACIENDA-A-FOCOE-GI-2024-4019-00152-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - JA -N10-2024 SUSTANCIAS-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JA%20-N10-2024%20SUSTANCIAS-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - JA-N11-2024 GTO ORDEN SOC-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JA-N11-2024%20GTO%20ORDEN%20SOC-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - JA-N14-2024 OTROS MATERIALES-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JA-N14-2024%20OTROS%20MATERIALES-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - JA-N15-2024 MONTACARGAS-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JA-N15-2024%20MONTACARGAS-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - JA-N17-2024Grúa HIAB-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JA-N17-2024Grúa%20HIAB-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - JA-N8-2024 COMBUSTIBLES-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/JA-N8-2024%20COMBUSTIBLES-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN HACIENDA-A-FOCOE-GI-2024-4019-00155-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20HACIENDA-A-FOCOE-GI-2024-4019-00155-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - R-424-OFICIO AUTORIZACION-salida-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/R-424-OFICIO%20AUTORIZACION-salida-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-110-2024-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/SPF-110-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-111-2024-salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/SPF-111-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N10-2024 Sustancias Químicas  salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N10-2024%20Sustancias%20Químicas%20%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N11-2024 Gto orden social  salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N11-2024%20Gto%20orden%20social%20%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N14-2024 otros mat y art. de const. y rep.  salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N14-2024%20otros%20mat%20y%20art.%20de%20const.%20y%20rep.%20%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N15-2024 montacargas 3000KG  salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N15-2024%20montacargas%203000KG%20%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N17-2024 GRUA TIPO Tipo HIAB  salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N17-2024%20GRUA%20TIPO%20Tipo%20HIAB%20%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N19-2024 eqpo septico-aguas negras  salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N19-2024%20eqpo%20septico-aguas%20negras%20%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N20-2024 mtto maq y eqpo  salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N20-2024%20mtto%20maq%20y%20eqpo%20%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N8-2024 Combustibles salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N8-2024%20Combustibles%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PyA-N9-2024 Material de Limpieza salida.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/PyA-N9-2024%20Material%20de%20Limpieza%20salida.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO N19-2024 equipo septico  aguas negrsa.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FALLO%20N19-2024%20equipo%20septico%20%20aguas%20negrsa.pdf",
    },
  ],
  [
    "DAF-S-RM - Fallo-N10-2024 Sust. Químicas.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/Fallo-N10-2024%20Sust.%20Químicas.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO-N15-2024 montacargas 3000KG.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FALLO-N15-2024%20montacargas%203000KG.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO-N18-2024 camiones cisterna.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FALLO-N18-2024%20camiones%20cisterna.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO-N8-2023 combustible.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "09-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-RM/FALLO-N8-2023%20combustible.pdf",
    },
  ],
  [
    "DAF-S-PF - PID 2023-2028 CAASIM..pdf",
    "2do Trimestre",
    "Amparo Flores",
    "15-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/PID%202023-2028%20CAASIM..pdf",
    },
  ],
  [
    "DG-S-COMU - contrato._.pdf",
    "3er Trimestre",
    "Comunicacion Social",
    "20-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DG-S-COMU/contrato._.pdf",
    },
  ],
  [
    "DG-S-COMU - Factura._.pdf",
    "3er Trimestre",
    "Comunicacion Social",
    "20-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DG-S-COMU/Factura._.pdf",
    },
  ],
  [
    "DG-S-COMU - Requi._.pdf",
    "3er Trimestre",
    "Comunicacion Social",
    "20-08-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DG-S-COMU/Requi._.pdf",
    },
  ],
  [
    "DAF-S-RM - doc02970120240902122823.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "02-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/doc02970120240902122823.pdf",
    },
  ],
  [
    "DAF-S-RM - doc02970320240902122954.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "02-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/doc02970320240902122954.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO INSECTICIDA.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "02-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PEDIDO%20INSECTICIDA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT MARPA.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "02-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACT%20MARPA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT CASTILLEJA.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "02-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACT%20CASTILLEJA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT INSEC.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "02-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACT%20INSEC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE JULIO.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "03-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20DE%20JULIO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE JUNIO.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "03-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20DE%20JUNIO.pdf",
    },
  ],
  [
    "DAF-S-PF - Inf.Dir.Gen.a-j 2024.pdf",
    "2do Trimestre",
    "Amparo Flores",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAF-S-PF/Inf.Dir.Gen.a-j%202024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-110-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-110-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-112-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-112-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-110-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-110-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-112-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-112-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-105-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-105-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-106-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-106-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-107-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-107-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-108-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-108-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-109-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-109-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-105-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-105-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-106-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-106-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-107-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-107-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-108-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-108-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-109-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-109-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA AGOSTO.pdf",
    "3er Trimestre",
    "Cristina MEjia",
    "05-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20AGOSTO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE JUNIO, JULIO Y AGOSTO.pdf",
    "3er Trimestre",
    "Cristina MEjia",
    "05-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20DE%20JUNIO,%20JULIO%20Y%20AGOSTO.pdf",
    },
  ],
  [
    "DAF-S-RM - Autorizacion Pres. 3 pipas.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "20-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Autorizacion%20Pres.%203%20pipas.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "3er Trimestre",
    "Mary Butron",
    "20-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "3er Trimestre",
    "Mary Butron",
    "20-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTA DE APERTURA  EA-913005999-N31-2024 FORMAS VALORADAS.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/ACTA%20DE%20APERTURA%20%20EA-913005999-N31-2024%20FORMAS%20VALORADAS.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTA DE APERTURA DE PROPOSICIONES EA-913005999-N29-2024 SEGUROS.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/ACTA%20DE%20APERTURA%20DE%20PROPOSICIONES%20EA-913005999-N29-2024%20SEGUROS.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 08-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%2008-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 09-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%2009-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 10-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%2010-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 11-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%2011-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 12-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%2012-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 13-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%2013-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA 14-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%2014-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - EA-913005999-N27-2024 PRESENTACIÓN Y APERTURA DE PROPOSICIONES EQUIPAMENTO ELECTROMECÁNICO PARA PLANTAS DE BOMBEO EN LA ZONA DE INFLUENCIA DE LA CAASIM.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/EA-913005999-N27-2024%20PRESENTACIÓN%20Y%20APERTURA%20DE%20PROPOSICIONES%20EQUIPAMENTO%20ELECTROMECÁNICO%20PARA%20PLANTAS%20DE%20BOMBEO%20EN%20LA%20ZONA%20DE%20INFLUENCIA%20DE%20LA%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO EA-913005999-N21-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20EA-913005999-N21-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO EA-913005999-N26-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20EA-913005999-N26-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO EA-913005999-N27-2024 EQUIPAMENTO ELECTROMECÁNICO PARA PLANTAS DE BOMBEO EN LA ZONA DE INFLUENCIA DE LA CAASIM.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20EA-913005999-N27-2024%20EQUIPAMENTO%20ELECTROMECÁNICO%20PARA%20PLANTAS%20DE%20BOMBEO%20EN%20LA%20ZONA%20DE%20INFLUENCIA%20DE%20LA%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO EA-913005999-N29-2024 SEGUROS.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20EA-913005999-N29-2024%20SEGUROS.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO EA-913005999-N31-2024 FORMAS VALORADAS.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20EA-913005999-N31-2024%20FORMAS%20VALORADAS.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO EA-913005999-N35-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20EA-913005999-N35-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO N24.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20N24.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO N25.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20N25.pdf",
    },
  ],
  [
    "DAF-S-RM - Fallo N32.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Fallo%20N32.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO N34.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20N34.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N21-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N21-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N24-2024 MANTENIMIENTO DE MAQUINARIA Y EQUIPO (SEGUNDO PROCEDIMIENTO).pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N24-2024%20MANTENIMIENTO%20DE%20MAQUINARIA%20Y%20EQUIPO%20(SEGUNDO%20PROCEDIMIENTO).pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N25-2024 MATENIMIENTO E INSTALACIÓN DE EQUIPOSY HERRAMIENTAS PARA SUMINISTRO DE AGUA.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N25-2024%20MATENIMIENTO%20E%20INSTALACIÓN%20DE%20EQUIPOSY%20HERRAMIENTAS%20PARA%20SUMINISTRO%20DE%20AGUA.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N26-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N26-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N27-2024.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N27-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N29-2024 SEGUROS.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N29-2024%20SEGUROS.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N31-2024 FORMAS VALORADAS.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N31-2024%20FORMAS%20VALORADAS.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N32-2024 CEMENTO Y PRODUCTOS DE CONCRETO (SEGUNDO PROCEDIMIENTO).pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N32-2024%20CEMENTO%20Y%20PRODUCTOS%20DE%20CONCRETO%20(SEGUNDO%20PROCEDIMIENTO).pdf",
    },
  ],
  [
    "DAF-S-RM - Junta de Aclaraciones N34.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Junta%20de%20Aclaraciones%20N34.pdf",
    },
  ],
  [
    "DAF-S-RM - Junta de Aclaraciones N35.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Junta%20de%20Aclaraciones%20N35.pdf",
    },
  ],
  [
    "DAF-S-RM - Presentación y Apertura de Proposiciones N21.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Presentación%20y%20Apertura%20de%20Proposiciones%20N21.pdf",
    },
  ],
  [
    "DAF-S-RM - Presentación y Apertura de Proposiciones N24.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Presentación%20y%20Apertura%20de%20Proposiciones%20N24.pdf",
    },
  ],
  [
    "DAF-S-RM - Presentación y Apertura de Proposiciones N25.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Presentación%20y%20Apertura%20de%20Proposiciones%20N25.pdf",
    },
  ],
  [
    "DAF-S-RM - Presentación y Apertura de Proposiciones N26.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Presentación%20y%20Apertura%20de%20Proposiciones%20N26.pdf",
    },
  ],
  [
    "DAF-S-RM - Presentación y Apertura de Proposiciones N32.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Presentación%20y%20Apertura%20de%20Proposiciones%20N32.pdf",
    },
  ],
  [
    "DAF-S-RM - Presentación y Apertura de Proposiciones N34.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Presentación%20y%20Apertura%20de%20Proposiciones%20N34.pdf",
    },
  ],
  [
    "DAF-S-RM - Presentación y Apertura de Proposiciones N35.pdf",
    "3er Trimestre",
    "Jair Hernandez",
    "23-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Presentación%20y%20Apertura%20de%20Proposiciones%20N35.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT DE ENERO HASTA AGOSTO (1).pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACT%20DE%20ENERO%20HASTA%20AGOSTO%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - ADRIAN ORDAZ ARRIAGA.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/ADRIAN%20ORDAZ%20ARRIAGA.pdf",
    },
  ],
  [
    "DAF-S-RM - AXEL.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AXEL.pdf",
    },
  ],
  [
    "DAF-S-RM - MARPA IT.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/MARPA%20IT.pdf",
    },
  ],
  [
    "DAF-S-RM - AD-04-2024 AUTORIZACION.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AD-04-2024%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - AD-23-2024 AUTORIZACION.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AD-23-2024%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-RM - AD-25-2024 AUTORIZACION.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AD-25-2024%20AUTORIZACION.pdf",
    },
  ],
  [
    "DAF-S-PF - Circ. DAF-SPF-101-2024.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/Circ.%20DAF-SPF-101-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - A-274-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/A-274-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - DAF-SPF-120-2024-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DAF-SPF-120-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - DAF-SPF-128-2024-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DAF-SPF-128-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - DAF-SPF-133-2024-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DAF-SPF-133-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - DAF-SPF-136-2024-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DAF-SPF-136-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - DAF-SPF-177-2024-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DAF-SPF-177-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - FAC EXTNTORES-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FAC%20EXTNTORES-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - facturas PIBEH tercer trimestre.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/facturas%20PIBEH%20tercer%20trimestre.pdf",
    },
  ],
  [
    "DAF-S-RM - facturas policia hidrica tercer trimestre.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/facturas%20policia%20hidrica%20tercer%20trimestre.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240704001-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240704001-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240802001-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240802001-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240904001-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240904001-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX AGOSTO-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/TELMEX%20AGOSTO-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX JULIO-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/TELMEX%20JULIO-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX SEPTIEMBRE-salida.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/TELMEX%20SEPTIEMBRE-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AMABEL.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20AMABEL.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AURORA.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20AURORA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS CARLOS.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20CARLOS.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS EDUARDO.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20EDUARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GRACIELA.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20GRACIELA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS JULIETA.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20JULIETA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS LEONARDO.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20LEONARDO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MA CORTEZ.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20MA%20CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MA PARRA.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20MA%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS NORBERTO.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20NORBERTO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ODILON.pdf",
    "3er Trimestre",
    "Ines Flores",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20ODILON.pdf",
    },
  ],
  [
    "DAF-S-RM - EDUARDO MANTENIMIENTO.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/EDUARDO%20MANTENIMIENTO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA BLANCA CECILIA.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20BLANCA%20CECILIA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA GRUPO ARCODEM.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "24-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20GRUPO%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - Acta Transferencia Secundaria Direccion Comercial  (2009-2016)-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Acta%20Transferencia%20Secundaria%20Direccion%20Comercial%20%20(2009-2016)-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catalogo de Disposición Documental 2019-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catalogo%20de%20Disposición%20Documental%202019-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2008-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202008-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2009-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202009-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2010-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202010-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2011-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202011-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2012-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202012-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2013-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202013-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2014-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202014-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de disposición Documental 2015-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20disposición%20Documental%202015-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2016-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202016-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2017-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202017-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2018-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202018-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Catálogo de Disposición Documental 2020-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Catálogo%20de%20Disposición%20Documental%202020-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2008-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202008-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2009-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202009-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2010-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202010-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2011-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202011-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2012-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202012-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2013-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202013-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro general de Clasificación Archivistica 2014-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20general%20de%20Clasificación%20Archivistica%202014-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2015-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202015-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2016-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202016-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2017-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202017-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2020-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202020-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2021-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202021-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivistica 2022-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivistica%202022-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivística 2018-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivística%202018-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Cuadro General de Clasificación Archivística 2019-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Cuadro%20General%20de%20Clasificación%20Archivística%202019-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-043-2022 (1)-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Dictamen%20de%20Baja%20Documental%20y-o%20Transferencia%20Secundaria%20AGE-SEA-DBDTS-043-2022%20(1)-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-152-2023-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Dictamen%20de%20Baja%20Documental%20y-o%20Transferencia%20Secundaria%20AGE-SEA-DBDTS-152-2023-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen de Baja Documental y-o Transferencia Secundaria SEA-OR-DVS-277-2018-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Dictamen%20de%20Baja%20Documental%20y-o%20Transferencia%20Secundaria%20SEA-OR-DVS-277-2018-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental  2019-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%20%202019-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2008-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202008-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2009-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202009-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2010-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202010-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2011-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202011-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2012-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202012-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2013-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202013-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2014-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202014-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2015-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202015-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2016-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202016-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2017-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202017-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Guia de Archivo Documental 2018-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Guia%20de%20Archivo%20Documental%202018-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Informe PADA 2022-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Informe%20PADA%202022-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - Informe PADA 2023-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Informe%20PADA%202023-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PADA 2023-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PADA%202023-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - PADA 2024-salida.pdf",
    "3er Trimestre",
    "Guille Trejo",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PADA%202024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - AXEL.pdf",
    "3er Trimestre",
    "Ines Flores",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AXEL.pdf",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOMICILIARIA.docx",
    "3er Trimestre",
    "Rosalba",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOMICILIARIA.docx",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOMICILIARIA.pdf",
    "3er Trimestre",
    "Rosalba",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOMICILIARIA.pdf",
    },
  ],
  [
    "DAF-S-RM - 4e6dcecf-813c-47af-9a35-b5fe197405d8.pdf",
    "3er Trimestre",
    "Yadira Alarcon",
    "25-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/4e6dcecf-813c-47af-9a35-b5fe197405d8.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FGPAR-GI-2024-4019-00301.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/HACIENDA-A-FGPAR-GI-2024-4019-00301.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN SH-0077-2024.pdf",
    "3er Trimestre",
    "Auxiliar DAF",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20SH-0077-2024.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf",
    "3er Trimestre",
    "Susana Martine",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura 2024 CAASIM.pdf",
    "3er Trimestre",
    "Susana Martine",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/F02b_Estructura%202024%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_DECRETO Autorizado 2019.pdf",
    "3er Trimestre",
    "Susana Martine",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/F03_DECRETO%20Autorizado%202019.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Estatuto organico.pdf",
    "3er Trimestre",
    "Susana Martine",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Condiciones Generales de Trabajo 2022-2023.pdf",
    "3er Trimestre",
    "Susana Martine",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202022-2023.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Manual de Recursos Humano.pdf",
    "3er Trimestre",
    "Susana Martine",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-041-2024.pdf",
    "3er Trimestre",
    "Ines Flores",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/SPF-041-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-042-2024.pdf",
    "3er Trimestre",
    "Ines Flores",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/SPF-042-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - SPF-055-2024.pdf",
    "3er Trimestre",
    "Ines Flores",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/SPF-055-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20240923001 AUTORIZACION DE RECURSOS.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OSN20240923001%20AUTORIZACION%20DE%20RECURSOS.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20240923001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OSN20240923001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240805001 AUTORIZACION DE RECURSOS.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240805001%20AUTORIZACION%20DE%20RECURSOS.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240805001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240805001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240819001 AUTORIZACION DE RECURSOS.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240819001%20AUTORIZACION%20DE%20RECURSOS.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240819001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240819001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240909001 AUTORIZACION DE RECURSOS.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240909001%20AUTORIZACION%20DE%20RECURSOS.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20240909001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "26-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20240909001.pdf",
    },
  ],
  [
    "DAF-S-RH - 3289.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3289.docx",
    },
  ],
  [
    "DAF-S-RH - 3289.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3289.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3511.docx",
    },
  ],
  [
    "DAF-S-RH - 3511.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3511.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3598.docx",
    },
  ],
  [
    "DAF-S-RH - 3598.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3598.pdf",
    },
  ],
  [
    "DAF-S-RH - 4188.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4188.docx",
    },
  ],
  [
    "DAF-S-RH - 4188.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4188.pdf",
    },
  ],
  [
    "DAF-S-RH - 4276.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4276.docx",
    },
  ],
  [
    "DAF-S-RH - 4276.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4276.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4298.docx",
    },
  ],
  [
    "DAF-S-RH - 4298.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4298.pdf",
    },
  ],
  [
    "DAF-S-RH - 4346.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4346.docx",
    },
  ],
  [
    "DAF-S-RH - 4346.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4346.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4372.docx",
    },
  ],
  [
    "DAF-S-RH - 4372.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4372.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4375.docx",
    },
  ],
  [
    "DAF-S-RH - 4375.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4375.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4376.docx",
    },
  ],
  [
    "DAF-S-RH - 4376.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4376.pdf",
    },
  ],
  [
    "DAF-S-RH - 4381.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4381.docx",
    },
  ],
  [
    "DAF-S-RH - 4381.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4381.pdf",
    },
  ],
  [
    "DAF-S-RH - 4387.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4387.docx",
    },
  ],
  [
    "DAF-S-RH - 4387.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4387.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4388.docx",
    },
  ],
  [
    "DAF-S-RH - 4388.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4388.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393.docx",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4393.docx",
    },
  ],
  [
    "DAF-S-RH - 4393.pdf",
    "3er Trimestre",
    "Yezmin Hernandez",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4393.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA AGOSTO 2024.pdf",
    "3er Trimestre",
    "Arid Herrera",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20AGOSTO%202024.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO AGOSTO 2024.pdf",
    "3er Trimestre",
    "Arid Herrera",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PEDIDO%20AGOSTO%202024.pdf",
    },
  ],
  [
    "DAF-S-RM - REQUI AGOSTO 2024.pdf",
    "3er Trimestre",
    "Arid Herrera",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/REQUI%20AGOSTO%202024.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA SEPTIEMBRE 2024_compressed (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20SEPTIEMBRE%202024_compressed%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO SEPTIEMBRE 2024_compressed (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PEDIDO%20SEPTIEMBRE%202024_compressed%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - REQUI SEPTIEMBRE 2024_compressed.pdf",
    "3er Trimestre",
    "Arid Garcia",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/REQUI%20SEPTIEMBRE%202024_compressed.pdf",
    },
  ],
  [
    "DAF-S-RM - Oficio SPF-139-2024_ N35.pdf",
    "3er Trimestre",
    "KArla Mora",
    "28-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Oficio%20SPF-139-2024_%20N35.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN SH-0077-2024.pdf",
    "3er Trimestre",
    "Yadira Alarcon",
    "30-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20SH-0077-2024.pdf",
    },
  ],
  [
    "DAF-S-RH - 3289_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3511_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3598_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4188_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4188_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4276_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4276_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4298_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4346_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4346_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4372_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4381_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4381_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4387_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4387_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4388_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "30-09-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4393_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DG-S-COMU - Evidencia tercer trimestre 2024 (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "30-09-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DG-S-COMU/Evidencia%20tercer%20trimestre%202024%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - oficio autorizacion itp.pdf",
    "3er Trimestre",
    "Karla Mora",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/oficio%20autorizacion%20itp.pdf",
    },
  ],
  [
    "DAF-S-RH - 2Lineamientos SRH.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2Lineamientos%20SRH.pdf",
    },
  ],
  [
    "DAF-S-RH - CFT 2022-2023.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/CFT%202022-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - APERTURA ITP-01-2024 AUDITORIA (1).pdf",
    "3er Trimestre",
    "Beatri Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/APERTURA%20ITP-01-2024%20AUDITORIA%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO ITP-CAASIM-SRMYSG-DL-01-2024 (1).pdf",
    "3er Trimestre",
    "Beatri Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20ITP-CAASIM-SRMYSG-DL-01-2024%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - Junta de Aclaraciones ITP-CAASIM-SRMYSG-01-2024 (1).pdf",
    "3er Trimestre",
    "Beatri Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Junta%20de%20Aclaraciones%20ITP-CAASIM-SRMYSG-01-2024%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - oficio autorizacion itp.pdf",
    "3er Trimestre",
    "Beatri Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/oficio%20autorizacion%20itp.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N18.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20N18.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N25.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20N25.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N27 (1).pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20N27%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - factura C138 N18 (2).pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/factura%20C138%20N18%20(2).pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FGPAR-GI-2024-4019-00157.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/HACIENDA-A-FGPAR-GI-2024-4019-00157.pdf",
    },
  ],
  [
    "DAF-S-RM - Oficios de invitacion auditoria.pdf",
    "3er Trimestre",
    "Beatrti Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Oficios%20de%20invitacion%20auditoria.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N24.pdf",
    "3er Trimestre",
    "Beatriz Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20N24.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N26.pdf",
    "3er Trimestre",
    "Beatriz Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20N26.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION DE RECURSOS N26.pdf",
    "3er Trimestre",
    "Beatriz Olvera",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20DE%20RECURSOS%20N26.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen Auditoria.pdf",
    "3er Trimestre",
    "Karla Mora",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Dictamen%20Auditoria.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen_Auditoria_1.pdf",
    "3er Trimestre",
    "Karla Mora",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Dictamen_Auditoria_1.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen formas valoradas.pdf",
    "3er Trimestre",
    "Maria Fernanda",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/dictamen%20formas%20valoradas.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen seguros.pdf",
    "3er Trimestre",
    "Maria Fernanda",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/dictamen%20seguros.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CLAUDIO.pdf",
    "3er Trimestre",
    "Fernanda",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20CLAUDIO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA QUALITAS.pdf",
    "3er Trimestre",
    "Fernanda",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20QUALITAS.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GAEARQ.pdf",
    "3er Trimestre",
    "Fernanda",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURAS%20GAEARQ.pdf",
    },
  ],
  [
    "DAB - 3er. trimestre  Actividades Pipas.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/3er.%20trimestre%20%20Actividades%20Pipas.xlsx",
    },
  ],
  [
    "DAB - 3er. trimestre Indicadores Operación Pipas.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/3er.%20trimestre%20Indicadores%20Operación%20Pipas.xlsx",
    },
  ],
  [
    "DAB - ACTIV PIPAS OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIV%20PIPAS%20OCR.pdf",
    },
  ],
  [
    "DAB - ACTIV PLANTAS OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIV%20PLANTAS%20OCR.pdf",
    },
  ],
  [
    "DAB - ACTIV VACTOR OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIV%20VACTOR%20OCR.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES PLANTAS EXCEL.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIVIDADES%20PLANTAS%20EXCEL.xlsx",
    },
  ],
  [
    "DAB - ACTIVIDADES VACTOR.xls",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIVIDADES%20VACTOR.xls",
    },
  ],
  [
    "DAB - GRAFICA 3ER. TRIM PIPAS OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/GRAFICA%203ER.%20TRIM%20PIPAS%20OCR.pdf",
    },
  ],
  [
    "DAB - GRAFICA 3ER. TRIM PIPAS.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/GRAFICA%203ER.%20TRIM%20PIPAS.xlsx",
    },
  ],
  [
    "DAB - GRAFICA 3ER. TRIMESTRE DESAZOLVE OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/GRAFICA%203ER.%20TRIMESTRE%20DESAZOLVE%20OCR.pdf",
    },
  ],
  [
    "DAB - GRAFICA 3ER. TRIMESTRE DESAZOLVE.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/GRAFICA%203ER.%20TRIMESTRE%20DESAZOLVE.xlsx",
    },
  ],
  [
    "DAB - GRAFICA 3er.TRIMESTRE PLANTAS OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/GRAFICA%203er.TRIMESTRE%20PLANTAS%20OCR.pdf",
    },
  ],
  [
    "DAB - GRAFICA 3er.TRIMESTRE PLANTAS.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/GRAFICA%203er.TRIMESTRE%20PLANTAS.xlsx",
    },
  ],
  [
    "DAB - INDICADORES PIPAS OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADORES%20PIPAS%20OCR.pdf",
    },
  ],
  [
    "DAB - INDICADORES PLANTAS EXCEL.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADORES%20PLANTAS%20EXCEL.xlsx",
    },
  ],
  [
    "DAB - INDICADORES PLANTAS OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADORES%20PLANTAS%20OCR.pdf",
    },
  ],
  [
    "DAB - INDICADORES VACTOR OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADORES%20VACTOR%20OCR.pdf",
    },
  ],
  [
    "DAB - INDICADORES VACTOR.xls",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADORES%20VACTOR.xls",
    },
  ],
  [
    "DAJ - Juicio de Amparo 294-2024-IV.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Juicio%20de%20Amparo%20294-2024-IV.pdf",
    },
  ],
  [
    "DAJ - Juicio de Nulidad 49-2021.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Juicio%20de%20Nulidad%2049-2021.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-01-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-01-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-02-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-04-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-04-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-05-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-06-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-07-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-08-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-09-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-09-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-11-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-12-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-12-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-14-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-L.O.P.-01-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-01-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-L.O.P.-02-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-L.O.P.-03-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-L.O.P.-05-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-L.O.P.-07-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-L.O.P.-08-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-L.O.P.-09-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-09-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-01-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-01-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-02-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-04-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-04-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-05-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-06-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-07-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-08-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-09-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-09-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-11-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-12-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-12-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-14-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-01-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-01-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-02-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-03-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-05-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-07-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-08-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-09-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-09-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-01-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-01-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-02-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-04-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-04-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-05-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-06-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-07-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-08-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-09-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-09-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-11-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-12-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-12-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-14-2024.pdf",
    "3er Trimestre",
    "Abogado CAASIM",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-14-2024.pdf",
    },
  ],
  [
    "DAB - ACTIV PIPAS PROY 13.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIV%20PIPAS%20PROY%2013.pdf",
    },
  ],
  [
    "DAB - ACTIV VACTOR PROY 22.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIV%20VACTOR%20PROY%2022.pdf",
    },
  ],
  [
    "DAB - ACTIVI PLANTAS PROY 19.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACTIVI%20PLANTAS%20PROY%2019.pdf",
    },
  ],
  [
    "DAB - INDICADOR PIPAS PROY 13.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADOR%20PIPAS%20PROY%2013.pdf",
    },
  ],
  [
    "DAB - INDICADOR PLANTAS PROY 19.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADOR%20PLANTAS%20PROY%2019.pdf",
    },
  ],
  [
    "DAB - INDICADOR VACTOR PROY 22.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADOR%20VACTOR%20PROY%2022.pdf",
    },
  ],
  [
    "DAB - ACT PIPAS PROY 13 TERCER TRIM.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/ACT%20PIPAS%20PROY%2013%20TERCER%20TRIM.pdf",
    },
  ],
  [
    "DAB - INDICADORES TERCER TRIM PIPAS .pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/INDICADORES%20TERCER%20TRIM%20PIPAS%20.pdf",
    },
  ],
  [
    "DAB - PLANTAS TERCER TRIM  ACTIV.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/PLANTAS%20TERCER%20TRIM%20%20ACTIV.pdf",
    },
  ],
  [
    "DAB - TERCER TRIM VACTOR INDICA .pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/TERCER%20TRIM%20VACTOR%20INDICA%20.pdf",
    },
  ],
  [
    "DAB - TERCER TRIME INDI PLANTAS .pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/TERCER%20TRIME%20INDI%20PLANTAS%20.pdf",
    },
  ],
  [
    "DAB - TERCER TRIMES VACTOR ACTIV.pdf",
    "3er Trimestre",
    "Joana Paz",
    "02-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAB/TERCER%20TRIMES%20VACTOR%20ACTIV.pdf",
    },
  ],
  [
    "DAF-S-RH - 1008_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1816_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1850_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1850_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1853_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1853_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1989_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1989_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/1992_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2029_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2093_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2093_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2239_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2261_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 228_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2391_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2391_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2420_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2456_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2457_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2465_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2483_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2489_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2541_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2541_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2547_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2547_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2556_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2556_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 256_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/256_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2560_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2560_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2566_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2566_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2567_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2567_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2579_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2581_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2581_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2603_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2631_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2655_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2655_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2677_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2677_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2706_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2706_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2734_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2734_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2771_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2771_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2804_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2804_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2855_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2885_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2885_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2886_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2903_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2903_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 291_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/291_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2914_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2919_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2957_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2957_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2971_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2971_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2980_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2980_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/2989_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3000_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3001_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3001_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 301_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/301_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3011_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3012_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3026_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3027_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3027_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3032_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3032_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3035_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3035_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3070_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3070_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3080_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3088_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3088_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3104_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3105_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3106_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3138_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3161_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3166_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3166_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3188_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3211_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3213_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3293_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3293_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3321_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3321_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3334_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3338_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3358_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3366_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3389_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 339_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/339_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3390_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3398_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3406_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3406_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3449_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3475_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3475_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3476_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 349_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/349_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3526_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3583_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3609_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3610_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3616_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3616_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3625_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3625_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3628_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3699_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3725_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3726_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3726_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3727_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3733_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3733_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3735_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3735_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3750_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3756_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3756_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 376_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3772_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3778_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3828_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3835_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3878_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3890_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3890_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3893_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3918_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3931_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3952_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3953_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3960_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3961_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3961_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3962_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3962_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3967_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3967_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3970_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3970_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3978_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3978_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3983_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3984_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/3988_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4010_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4010_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4017_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4033_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4033_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4036_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4039_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4050_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4095_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4133_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4133_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4134_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4134_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4149_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4149_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4154_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4154_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4155_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4155_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4156_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4156_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4157_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4159_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4159_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4160_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4160_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4161_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4162_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4162_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4163_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4163_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4166_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4166_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4167_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4167_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4168_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4170_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4170_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4174_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4174_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4175_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4176_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4176_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4177_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4177_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4178_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4178_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4179_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4181_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4181_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4182_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4183_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4183_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4184_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4184_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4185_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4185_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4186_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4186_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4187_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4189_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4189_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4190_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4190_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4191_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4191_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4193_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4198_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4206_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4206_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4212_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4212_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4214_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4215_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4215_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4219_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4219_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4221_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4225_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4226_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4226_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4227_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4227_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4230_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4230_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4232_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4232_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4235_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4238_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4242_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4248_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4249_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4253_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4256_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4256_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4263_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4263_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4265_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4271_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4281_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4282_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4286_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4286_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4289_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4293_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4296_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4299_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4303_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4303_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4308_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4308_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4321_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4321_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4325_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4325_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4327_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4327_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4332_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4336_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4336_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4347_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4347_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4357_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4357_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4360_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4360_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4362_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/4362_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 794_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/794_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/846_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 873_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin",
    "03-10-2024",
    {
      text: "PDF",
      link: "http://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RH/873_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-105-2024-salida.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/SPF-105-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA ARGAB Y ASOCIADOS OSN20240923001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20ARGAB%20Y%20ASOCIADOS%20OSN20240923001.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA AUTONATION R-420 PSN20240805001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20AUTONATION%20R-420%20PSN20240805001.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA AUTONATION R-421 PSN20240909001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20AUTONATION%20R-421%20PSN20240909001.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CAMIONES LA HUERTA R-432 PSN20240819001.pdf",
    "3er Trimestre",
    "Edgar Bautista",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FACTURA%20CAMIONES%20LA%20HUERTA%20R-432%20PSN20240819001.pdf",
    },
  ],
  [
    "DAF-S-PF - Reporte de la Matriz.pdf",
    "3er Trimestre",
    "Marleen Osirio",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/Reporte%20de%20la%20Matriz.pdf",
    },
  ],
  [
    "DAF-S-PF - DAF-SPF-089.pdf",
    "3er Trimestre",
    "Marleen Osirio",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/DAF-SPF-089.pdf",
    },
  ],
  [
    "DAF-S-PF - DAF-SPF-090.pdf",
    "3er Trimestre",
    "Marleen Osirio",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/DAF-SPF-090.pdf",
    },
  ],
  [
    "DAF-S-PF - DAF-SPF-094.pdf",
    "3er Trimestre",
    "Marleen Osirio",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/DAF-SPF-094.pdf",
    },
  ],
  [
    "DAF-S-RM - CAASIM LD001, LD002 (D-INT-01, D-INT-02).pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/CAASIM%20LD001,%20LD002%20(D-INT-01,%20D-INT-02).pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-01-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-01-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-02-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-04-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-04-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-05-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-06-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-07-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-08-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-09-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-09-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-11-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-12-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-12-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO INVITACION CAASIM-HGO-AD-OP-14-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20INVITACION%20CAASIM-HGO-AD-OP-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-01-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-01-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-02-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-04-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-04-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-05-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-06-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-07-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-08-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-09-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-09-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-11-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-12-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-12-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-14-2024.pdf",
    "3er Trimestre",
    "David Abogado",
    "03-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-14-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO ADJ-114-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20ADJ-114-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-061-2024.doc",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-061-2024.doc",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-062-2024.doc",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-062-2024.doc",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-065-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-065-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-086-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-086-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-087-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-087-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-103-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-103-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-104-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-104-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-113-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20DAJ-113-2024.docx",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-061-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-061-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-062-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-062-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-065-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-065-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-086-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-086-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-087-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-087-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-103-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-103-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-104-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-104-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-113-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-113-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-114-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-114-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION MTTO.pdf",
    "3er Trimestre",
    "Dulce Licitaciones",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20MTTO.pdf",
    },
  ],
  [
    "DAF-S-RM - Junta de Aclaraciones EA-913005999-N38-2024.pdf",
    "3er Trimestre",
    "Karla Mora",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Junta%20de%20Aclaraciones%20EA-913005999-N38-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - Junta de Aclaraciones EA-913005999-N39-2024.pdf",
    "3er Trimestre",
    "Karla Mora",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/Junta%20de%20Aclaraciones%20EA-913005999-N39-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES EA-913005999-N40-2024.pdf",
    "3er Trimestre",
    "Karla Mora",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20EA-913005999-N40-2024.pdf",
    },
  ],
  [
    "DCONS - AVANCE FISICO-FINANCIERO.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/AVANCE%20FISICO-FINANCIERO.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-064.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-064.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-094.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-094.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-095.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-095.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-097.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-097.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-100.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-100.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-109.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-109.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-115.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-115.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-116.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-116.2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-120.2024.pdf",
    "3er Trimestre",
    "Rosalba DCONS",
    "04-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DCONS/CAASIM-DAJ-120.2024.pdf",
    },
  ],
  [
    "DAJ - Subsidios Jul - Sep 2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "09-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Subsidios%20Jul%20-%20Sep%202024.pdf",
    },
  ],
  [
    "DAF-S-PF - II_a_1_Ingresos economica sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_a_1_Ingresos%20economica%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_a_2_Ingresos Fuente Financiamiento sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_a_2_Ingresos%20Fuente%20Financiamiento%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_a_3_Ingresos CRI sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_a_3_Ingresos%20CRI%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_a_4_Ingresos Excedentes sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_a_4_Ingresos%20Excedentes%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_b_1_Egresos Administrativa sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_b_1_Egresos%20Administrativa%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_b_2_Egresos Economica y COG sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_b_2_Egresos%20Economica%20y%20COG%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_b_3_Egresos Funcional Programatica sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_b_3_Egresos%20Funcional%20Programatica%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_b_4_Egresos Ramo sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_b_4_Egresos%20Ramo%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_b_5_Egresos Economica_tipo de gto sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_b_5_Egresos%20Economica_tipo%20de%20gto%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_b_6_Egresos COG_capitulo concepto sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_b_6_Egresos%20COG_capitulo%20concepto%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_c_Endeudamiento neto sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_c_Endeudamiento%20neto%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_d_Intereses de la deuda sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_d_Intereses%20de%20la%20deuda%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - II_e_flujo de fondos sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/II_e_flujo%20de%20fondos%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_a_Edo Situacion Financiera sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_a_Edo%20Situacion%20Financiera%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_b_Edo Actividades sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_b_Edo%20Actividades%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_c_Edo Variacion Hacienda sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_c_Edo%20Variacion%20Hacienda%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_d_Edo Cambios Situacion sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_d_Edo%20Cambios%20Situacion%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_e_Edo Flujos de Efectivo sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_e_Edo%20Flujos%20de%20Efectivo%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_f_Edo Analitico Activo sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_f_Edo%20Analitico%20Activo%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_g_Edo Analitico Deuda sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_g_Edo%20Analitico%20Deuda%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_h_Pasivos Contingentes sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_h_Pasivos%20Contingentes%20sep2024.xlsx",
    },
  ],
  [
    "DAF-S-PF - I_i_Notas Edos Financieros sep2024.xlsx",
    "3er Trimestre",
    "Alicia Perez Grovas",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/I_i_Notas%20Edos%20Financieros%20sep2024.xlsx",
    },
  ],
  [
    "DAf-S-PF - GASTO POR CATEGORIA PROGRAMATICA.xlsx",
    "3er Trimestre",
    "amparo Flores",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAf-S-PF/GASTO%20POR%20CATEGORIA%20PROGRAMATICA.xlsx",
    },
  ],
  [
    "DAf-S-PF - INDICADORES DE RESULTADOS.xlsx",
    "3er Trimestre",
    "amparo Flores",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAf-S-PF/INDICADORES%20DE%20RESULTADOS.xlsx",
    },
  ],
  [
    "DAf-S-PF - PROGRAMAS Y PROYECTOS INVERSION.xlsx",
    "3er Trimestre",
    "amparo Flores",
    "17-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAf-S-PF/PROGRAMAS%20Y%20PROYECTOS%20INVERSION.xlsx",
    },
  ],
  [
    "DAF-S-PF - a) Gasto por Categoría Programática .pdf",
    "3er Trimestre",
    "Amparo Flores",
    "21-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/a)%20Gasto%20por%20Categoría%20Programática%20.pdf",
    },
  ],
  [
    "DAF-S-PF - b) Programas y Proyectos de Inversión.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "21-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/b)%20Programas%20y%20Proyectos%20de%20Inversión.pdf",
    },
  ],
  [
    "DAF-S-PF - c) Indicadores de Resultados (1).pdf",
    "3er Trimestre",
    "Amparo Flores",
    "21-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/c)%20Indicadores%20de%20Resultados%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoria programatica al 30 de septiembre.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "21-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programatica%20al%2030%20de%20septiembre.pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de Resultados al 30 septiembre.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "21-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/Indicadores%20de%20Resultados%20al%2030%20septiembre.pdf",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversion al 30 septiembre.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "21-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversion%20al%2030%20septiembre.pdf",
    },
  ],
  [
    "DAF-S-PCF - 10Edo. Ana. Ing..docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/10Edo.%20Ana.%20Ing..docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 1Edo S. Fin.docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/1Edo%20S.%20Fin.docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 2Edo act..docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/2Edo%20act..docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 3Edo V.Hda. Pub.docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/3Edo%20V.Hda.%20Pub.docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 4Edo.C Sit.Fin.docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/4Edo.C%20Sit.Fin.docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 5Edo.C.Flujo.Efec.docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/5Edo.C.Flujo.Efec.docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 6Edo. Ana. Act..docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/6Edo.%20Ana.%20Act..docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 7Edo.Ana. deuda.docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/7Edo.Ana.%20deuda.docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 8Inf.Pasivos.C..docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/8Inf.Pasivos.C..docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 9Nota.Edo.Fin..docx.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/9Nota.Edo.Fin..docx.pdf",
    },
  ],
  [
    "DAF-S-PCF - 1. CLASIFICACIÓN POR OBJETO DEL GASTO.pdf",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/1.%20CLASIFICACIÓN%20POR%20OBJETO%20DEL%20GASTO.pdf",
    },
  ],
  [
    "DAF-S-PCF - 1. CLASIFICACIÓN POR OBJETO DEL GASTO.xlsx",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/1.%20CLASIFICACIÓN%20POR%20OBJETO%20DEL%20GASTO.xlsx",
    },
  ],
  [
    "DAF-S-PCF - 2. CLASIFICACIÓN ECONÓMICA (TIPO DE GASTO).pdf",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/2.%20CLASIFICACIÓN%20ECONÓMICA%20(TIPO%20DE%20GASTO).pdf",
    },
  ],
  [
    "DAF-S-PCF - 2. CLASIFICACIÓN ECONÓMICA (TIPO DE GASTO).xlsx",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/2.%20CLASIFICACIÓN%20ECONÓMICA%20(TIPO%20DE%20GASTO).xlsx",
    },
  ],
  [
    "DAF-S-PCF - 3. CLASIFICACIÓN ADMINISTRATIVA.pdf",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/3.%20CLASIFICACIÓN%20ADMINISTRATIVA.pdf",
    },
  ],
  [
    "DAF-S-PCF - 3. CLASIFICACIÓN ADMINISTRATIVA.xlsx",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/3.%20CLASIFICACIÓN%20ADMINISTRATIVA.xlsx",
    },
  ],
  [
    "DAF-S-PCF - 4. CLASIFICACIÓN FUNCIONAL (FINALIDAD Y FUNCIÓN).pdf",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/4.%20CLASIFICACIÓN%20FUNCIONAL%20(FINALIDAD%20Y%20FUNCIÓN).pdf",
    },
  ],
  [
    "DAF-S-PCF - 4. CLASIFICACIÓN FUNCIONAL (FINALIDAD Y FUNCIÓN).xls",
    "3er Trimestre",
    "Freddy",
    "25-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/4.%20CLASIFICACIÓN%20FUNCIONAL%20(FINALIDAD%20Y%20FUNCIÓN).xls",
    },
  ],
  [
    "DAF-S-PCF - 1.Estado de Situación Financiera.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/1.Estado%20de%20Situación%20Financiera.docx",
    },
  ],
  [
    "DAF-S-PCF - 10.Estado Analitico de Ingresos -Clasificacion Economica.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/10.Estado%20Analitico%20de%20Ingresos%20-Clasificacion%20Economica.docx",
    },
  ],
  [
    "DAF-S-PCF - 11.Estado Analitico de Ingresos  por Fuente de Financiamiento.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/11.Estado%20Analitico%20de%20Ingresos%20%20por%20Fuente%20de%20Financiamiento.docx",
    },
  ],
  [
    "DAF-S-PCF - 12.Estado Analítico de Ingresos  Clasificación por Rubros a Nivel Concepto.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/12.Estado%20Analítico%20de%20Ingresos%20%20Clasificación%20por%20Rubros%20a%20Nivel%20Concepto.docx",
    },
  ],
  [
    "DAF-S-PCF - 13.Estado Analítico de Ingresos  incluyendo los ingresos excedentes  Generados.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/13.Estado%20Analítico%20de%20Ingresos%20%20incluyendo%20los%20ingresos%20excedentes%20%20Generados.docx",
    },
  ],
  [
    "DAF-S-PCF - 14.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Administrativa.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/14.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Administrativa.docx",
    },
  ],
  [
    "DAF-S-PCF - 15.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Económica y por Objeto del Gasto.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/15.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Económica%20y%20por%20Objeto%20del%20Gasto.docx",
    },
  ],
  [
    "DAF-S-PCF - 16.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Funcional - Programática.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/16.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Funcional%20-%20Programática.docx",
    },
  ],
  [
    "DAF-S-PCF - 17.Estado Analítico del Ejercicio del Presupuesto de Egresos  Identificado por Ramo.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/17.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Identificado%20por%20Ramo.docx",
    },
  ],
  [
    "DAF-S-PCF - 18.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Económica Tipo de Gasto.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/18.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Económica%20Tipo%20de%20Gasto.docx",
    },
  ],
  [
    "DAF-S-PCF - 19.Endeudamiento Neto.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/19.Endeudamiento%20Neto.docx",
    },
  ],
  [
    "DAF-S-PCF - 2.Estado de Actividades.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/2.Estado%20de%20Actividades.docx",
    },
  ],
  [
    "DAF-S-PCF - 20.Intereses de la Deuda.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/20.Intereses%20de%20la%20Deuda.docx",
    },
  ],
  [
    "DAF-S-PCF - 3.Estado de Variacion en Hacienda PublicaPatrimonio.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/3.Estado%20de%20Variacion%20en%20Hacienda%20PublicaPatrimonio.docx",
    },
  ],
  [
    "DAF-S-PCF - 4.Estado de Cambios en la Situacion Financiera.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/4.Estado%20de%20Cambios%20en%20la%20Situacion%20Financiera.docx",
    },
  ],
  [
    "DAF-S-PCF - 5.Estado de Flujos de Efectivo.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/5.Estado%20de%20Flujos%20de%20Efectivo.docx",
    },
  ],
  [
    "DAF-S-PCF - 6.Estado Analitico del Activo.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/6.Estado%20Analitico%20del%20Activo.docx",
    },
  ],
  [
    "DAF-S-PCF - 7.Estado Analitico de la Deuda y Otros Pasivos.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/7.Estado%20Analitico%20de%20la%20Deuda%20y%20Otros%20Pasivos.docx",
    },
  ],
  [
    "DAF-S-PCF - 8.Informe de Pasivos contingentes.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/8.Informe%20de%20Pasivos%20contingentes.docx",
    },
  ],
  [
    "DAF-S-PCF - 9.Notas a los Estados Financieros.docx",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/9.Notas%20a%20los%20Estados%20Financieros.docx",
    },
  ],
  [
    "DAF-S-PCF - ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 3ER TRIMESTRE 2024.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/ESTADO%20ANALÍTICO%20DEL%20EJERCICIO%20DEL%20PRESUPUESTO%20DE%20EGRESOS%203ER%20TRIMESTRE%202024.pdf",
    },
  ],
  [
    "DAF-S-PCF - ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 3ER TRIMESTRE 2024.xls",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/ESTADO%20ANALÍTICO%20DEL%20EJERCICIO%20DEL%20PRESUPUESTO%20DE%20EGRESOS%203ER%20TRIMESTRE%202024.xls",
    },
  ],
  [
    "DAF-S-PCF - 1.Estado de Situación Financiera.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/1.Estado%20de%20Situación%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - 10.Estado Analitico de Ingresos -Clasificacion Economica.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/10.Estado%20Analitico%20de%20Ingresos%20-Clasificacion%20Economica.pdf",
    },
  ],
  [
    "DAF-S-PCF - 11.Estado Analitico de Ingresos  por Fuente de Financiamiento.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/11.Estado%20Analitico%20de%20Ingresos%20%20por%20Fuente%20de%20Financiamiento.pdf",
    },
  ],
  [
    "DAF-S-PCF - 12.Estado Analítico de Ingresos  Clasificación por Rubros a Nivel Concepto.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/12.Estado%20Analítico%20de%20Ingresos%20%20Clasificación%20por%20Rubros%20a%20Nivel%20Concepto.pdf",
    },
  ],
  [
    "DAF-S-PCF - 13.Estado Analítico de Ingresos  incluyendo los ingresos excedentes  Generados.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/13.Estado%20Analítico%20de%20Ingresos%20%20incluyendo%20los%20ingresos%20excedentes%20%20Generados.pdf",
    },
  ],
  [
    "DAF-S-PCF - 14.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Administrativa.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/14.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - 15.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Económica y por Objeto del Gasto.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/15.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Económica%20y%20por%20Objeto%20del%20Gasto.pdf",
    },
  ],
  [
    "DAF-S-PCF - 16.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Funcional – Programática.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/16.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Funcional%20–%20Programática.pdf",
    },
  ],
  [
    "DAF-S-PCF - 17.Estado Analítico del Ejercicio del Presupuesto de Egresos  Identificado por Ramo.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/17.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Identificado%20por%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - 18.Estado Analítico del Ejercicio del Presupuesto de Egresos  Clasificación Económica Tipo de Gasto.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/18.Estado%20Analítico%20del%20Ejercicio%20del%20Presupuesto%20de%20Egresos%20%20Clasificación%20Económica%20Tipo%20de%20Gasto.pdf",
    },
  ],
  [
    "DAF-S-PCF - 19.Endeudamiento Neto.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/19.Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - 2.Estado de Actividades.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/2.Estado%20de%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - 20.Intereses de la Deuda.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/20.Intereses%20de%20la%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PCF - 3.Estado de Variacion en Hacienda PublicaPatrimonio.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/3.Estado%20de%20Variacion%20en%20Hacienda%20PublicaPatrimonio.pdf",
    },
  ],
  [
    "DAF-S-PCF - 4.Estado de Cambios en la Situacion Financiera.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/4.Estado%20de%20Cambios%20en%20la%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - 5.Estado de Flujos de Efectivo.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/5.Estado%20de%20Flujos%20de%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - 6.Estado Analitico del Activo.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/6.Estado%20Analitico%20del%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - 7.Estado Analitico de la Deuda y Otros Pasivos.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/7.Estado%20Analitico%20de%20la%20Deuda%20y%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - 8.Informe de Pasivos contingentes.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/8.Informe%20de%20Pasivos%20contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - 9.Notas a los Estados Financieros.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/9.Notas%20a%20los%20Estados%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 3ER TRIMESTRE 2024.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/ESTADO%20ANALÍTICO%20DEL%20EJERCICIO%20DEL%20PRESUPUESTO%20DE%20EGRESOS%203ER%20TRIMESTRE%202024.pdf",
    },
  ],
  [
    "DAF-S-PCF - ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 2024.pdf",
    "3er Trimestre",
    "Freddy",
    "28-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-PCF/ESTADO%20ANALÍTICO%20DEL%20EJERCICIO%20DEL%20PRESUPUESTO%20DE%20EGRESOS%202024.pdf",
    },
  ],
  [
    "DAF-S-RM - PC MINI SPLIT.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "30-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PC%20MINI%20SPLIT.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20241002001.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "30-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PC20241002001.pdf",
    },
  ],
  [
    "DAF-S-RM - REFACCIONES.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "30-10-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/REFACCIONES.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-085-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-085-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-088-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-088-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-122-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-122-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-124-2024.doc",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-124-2024.doc",
    },
  ],
  [
    "DAJ - Contrato DAJ-125-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-125-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-131-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-131-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-140-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-140-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-142-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-142-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-085-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-085-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-088-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-088-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-122-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-122-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-124-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-124-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-125-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-125-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-131-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-131-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-140-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-140-2024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO CAASIM-DAJ-142-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/CONTRATO%20CAASIM-DAJ-142-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-128-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-128-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-137-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-137-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-138-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-138-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-139-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-139-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-141-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-141-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-143-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-143-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-144-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-144-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-145-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-145-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-146-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-146-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-147-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-147-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-149-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-149-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-150-2024.docx",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-150-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-128-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-128-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-137-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-137-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-138-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-138-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-139-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-139-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-141-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-141-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-143-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-143-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-144-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-144-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-145-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-145-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-146-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-146-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-147-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-147-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-149-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-149-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-150-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "06-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-150-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FEDERICO-OFICIO-AUTORIZACIÓN-RECURSOS.pdf",
    "3er Trimestre",
    "Egarcito Bautista",
    "07-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/FEDERICO-OFICIO-AUTORIZACIÓN-RECURSOS.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20241025001-FEDERICO-PEDIDO-SERVICIO.pdf",
    "3er Trimestre",
    "Egarcito Bautista",
    "07-11-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAF-S-RM/PSN20241025001-FEDERICO-PEDIDO-SERVICIO.pdf",
    },
  ],
  [
    "DAF - PC20241121001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "02-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF/PC20241121001.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20241121001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PC20241121001.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20241126001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PC20241126001.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORZACIÓN DE RECURSOS ERIFICACIÓN.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "03-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORZACIÓN%20DE%20RECURSOS%20ERIFICACIÓN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA VERIFICACIÓN.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "03-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20VERIFICACIÓN.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20241111001 ORDEN DESERVICIO VERIFICACIÓN.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "03-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OSN20241111001%20ORDEN%20DESERVICIO%20VERIFICACIÓN.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "4to Trimestre",
    "Mary Butron",
    "10-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "4to Trimestre",
    "Mary Butron",
    "10-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DAB - 4 Trime_ Actividades Pipas excel.xlsx",
    "4to Trimestre",
    "Joana Martinez",
    "18-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4%20Trime_%20Actividades%20Pipas%20excel.xlsx",
    },
  ],
  [
    "DAB - 4TO TRIM_ INDICADORES PTAR´S EXCEL.xls",
    "4to Trimestre",
    "Joana Martinez",
    "18-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20TRIM_%20INDICADORES%20PTAR´S%20EXCEL.xls",
    },
  ],
  [
    "DAB - 4to. Trim_ Indicadores Pipas excel.xlsx",
    "4to Trimestre",
    "Joana Martinez",
    "18-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4to.%20Trim_%20Indicadores%20Pipas%20excel.xlsx",
    },
  ],
  [
    "DAB - ACTIVIDADES 4TO TRIM PTAR´S EXCEL.xls",
    "4to Trimestre",
    "Joana Martinez",
    "18-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/ACTIVIDADES%204TO%20TRIM%20PTAR´S%20EXCEL.xls",
    },
  ],
  [
    "DAB - 4TO TRIM PIPAS ACTIVIDADES.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20TRIM%20PIPAS%20ACTIVIDADES.pdf",
    },
  ],
  [
    "DAB - 4TO TRIM PIPAS INDICADORES.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20TRIM%20PIPAS%20INDICADORES.pdf",
    },
  ],
  [
    "DAB - ACTIVIDADES PIPAS 4TO OCR.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/ACTIVIDADES%20PIPAS%204TO%20OCR.pdf",
    },
  ],
  [
    "DAB - GRAFICA 4TO. TRIM PIPAS pdf.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/GRAFICA%204TO.%20TRIM%20PIPAS%20pdf.pdf",
    },
  ],
  [
    "DAB - GRAFICA 4TO. TRIMESTRE DESAZOLVE pdf.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/GRAFICA%204TO.%20TRIMESTRE%20DESAZOLVE%20pdf.pdf",
    },
  ],
  [
    "DAB - GRAFICA 4TO. TRIMESTRE PLANTAS pdf.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/GRAFICA%204TO.%20TRIMESTRE%20PLANTAS%20pdf.pdf",
    },
  ],
  [
    "DAB - INDICADORES PIPAS 4TO_ OCR.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/INDICADORES%20PIPAS%204TO_%20OCR.pdf",
    },
  ],
  [
    "DAB - 4TO. TRIM PLANTAS ACTIV_PROY 19.pdf",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO.%20TRIM%20PLANTAS%20ACTIV_PROY%2019.pdf",
    },
  ],
  [
    "DAB - 4TO. TRIM PLANTAS INDICA PROY19.pdf",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO.%20TRIM%20PLANTAS%20INDICA%20PROY19.pdf",
    },
  ],
  [
    "DAB - ACTIV_PLANTAS OCR.pdf",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/ACTIV_PLANTAS%20OCR.pdf",
    },
  ],
  [
    "DAB - ACT_DESAZOLVE EXCEL.xls",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/ACT_DESAZOLVE%20EXCEL.xls",
    },
  ],
  [
    "DAB - ACT_DESAZOLVE OCR.pdf",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/ACT_DESAZOLVE%20OCR.pdf",
    },
  ],
  [
    "DAB - INDICADOR DESAZOLVE EXCEL.xls",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/INDICADOR%20DESAZOLVE%20EXCEL.xls",
    },
  ],
  [
    "DAB - INDICADOR_PLANTAS OCR.pdf",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/INDICADOR_PLANTAS%20OCR.pdf",
    },
  ],
  [
    "DAB - INDIC_DESAZOLVE OCR.pdf",
    "4to Trimestre",
    "Joana ",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/INDIC_DESAZOLVE%20OCR.pdf",
    },
  ],
  [
    "DAB - PROY 13 ACTIV_PIPAS 4TO TRIMESTRE .pdf",
    "4to Trimestre",
    "Joana",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2013%20ACTIV_PIPAS%204TO%20TRIMESTRE%20.pdf",
    },
  ],
  [
    "DAB - PROY 13 INDICADOR 4TO. TRIM_PIPAS.pdf",
    "4to Trimestre",
    "Joana",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2013%20INDICADOR%204TO.%20TRIM_PIPAS.pdf",
    },
  ],
  [
    "DAB - PROY 19 ACT_PTAR´S 4TO TRIM.pdf",
    "4to Trimestre",
    "Joana",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2019%20ACT_PTAR´S%204TO%20TRIM.pdf",
    },
  ],
  [
    "DAB - PROY 19 INDICADOR_PTAR´S 4TO TRIM.pdf",
    "4to Trimestre",
    "Joana",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2019%20INDICADOR_PTAR´S%204TO%20TRIM.pdf",
    },
  ],
  [
    "DAB - PROY 22 ACT_DESAZOLVE 4TO TRIM.pdf",
    "4to Trimestre",
    "Joana",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2022%20ACT_DESAZOLVE%204TO%20TRIM.pdf",
    },
  ],
  [
    "DAB - PROY 22 INDICADOR_ DESAZOLVE 4TO TRIM.pdf",
    "4to Trimestre",
    "Joana",
    "19-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2022%20INDICADOR_%20DESAZOLVE%204TO%20TRIM.pdf",
    },
  ],
  [
    "DAB - ACT_PROY 13 PIPA 4TO_TRIM OCR.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/ACT_PROY%2013%20PIPA%204TO_TRIM%20OCR.pdf",
    },
  ],
  [
    "DAB - ACT_PROY 19 PLANTAS 4TO_TRIM OCR.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/ACT_PROY%2019%20PLANTAS%204TO_TRIM%20OCR.pdf",
    },
  ],
  [
    "DAB - DESAZOLVE OCR_ACTIV_ 4TO TRIM.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/DESAZOLVE%20OCR_ACTIV_%204TO%20TRIM.pdf",
    },
  ],
  [
    "DAB - DESAZOLVE OCR_IND_4TO TRIM.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/DESAZOLVE%20OCR_IND_4TO%20TRIM.pdf",
    },
  ],
  [
    "DAB - IND_PROY 13 PIPA 4TO_TRIM OCR.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/IND_PROY%2013%20PIPA%204TO_TRIM%20OCR.pdf",
    },
  ],
  [
    "DAB - IND_PROY 19 PLANTAS 4TO TRIMESTRE.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/IND_PROY%2019%20PLANTAS%204TO%20TRIMESTRE.pdf",
    },
  ],
  [
    "DAB - PLANTAS ACT_4TO TRIM.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PLANTAS%20ACT_4TO%20TRIM.pdf",
    },
  ],
  [
    "DAB - PROY 13 IND_4TO TRIMESTRE PIPAS.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2013%20IND_4TO%20TRIMESTRE%20PIPAS.pdf",
    },
  ],
  [
    "DAB - PROY 13 PIPAS 4TO. TRIM ACT.pdf",
    "4to Trimestre",
    "Joana Martinez",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/PROY%2013%20PIPAS%204TO.%20TRIM%20ACT.pdf",
    },
  ],
  [
    "DAB - 4TO DESAZOLVE ACT.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20DESAZOLVE%20ACT.pdf",
    },
  ],
  [
    "DAB - 4TO DESAZOLVE INDICADOR.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20DESAZOLVE%20INDICADOR.pdf",
    },
  ],
  [
    "DAB - 4TO PIPAS ACT.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20PIPAS%20ACT.pdf",
    },
  ],
  [
    "DAB - 4TO PIPAS INDICADOR .pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20PIPAS%20INDICADOR%20.pdf",
    },
  ],
  [
    "DAB - 4TO PLANTAS ACT.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20PLANTAS%20ACT.pdf",
    },
  ],
  [
    "DAB - 4TO PLANTAS INDICADOR.pdf",
    "4to Trimestre",
    "Joana Abasto",
    "20-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAB/4TO%20PLANTAS%20INDICADOR.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE NOVIEMBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "26-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20DE%20NOVIEMBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE OCTUBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "26-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20DE%20OCTUBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE SEPTIEMBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "26-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20DE%20SEPTIEMBRE.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura 2024 CAASIM.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/F02b_Estructura%202024%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_DECRETO Autorizado 2019.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/F03_DECRETO%20Autorizado%202019.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Estatuto organico.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Condiciones Generales de Trabajo 2022-2023.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202022-2023.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Manual de Recursos Humano.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf",
    },
  ],
  [
    "DAF-S-RH - 1008_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1816_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1850_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1850_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1853_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1853_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1989_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1989_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/1992_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2029_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2093_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2093_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2239_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2261_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 228_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2391_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2391_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2420_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2456_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2457_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2465_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2483_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2489_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2492_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2492_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2547_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2547_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2556_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2556_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 256_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/256_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2560_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2560_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2566_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2566_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2567_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2567_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2579_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2581_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2581_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2603_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2631_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2647_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2647_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2655_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2655_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2677_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2677_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2706_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2706_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2734_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2734_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2771_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2771_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2855_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2863_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2863_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2885_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2885_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2886_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2903_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2903_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 291_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/291_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2914_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2919_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2957_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2957_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2971_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2971_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2980_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2980_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/2989_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3000_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3001_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3001_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 301_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/301_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3011_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3012_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3026_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3027_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3027_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3032_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3032_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3070_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3070_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3080_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3088_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3088_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3104_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3105_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3106_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3138_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3161_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3166_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3166_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3188_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3197_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3197_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3211_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3213_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3289_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3321_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3321_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3334_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3338_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3358_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3366_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3389_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 339_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/339_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3390_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3398_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3406_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3406_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3449_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3475_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3475_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3476_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 349_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/349_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3511_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3521_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3521_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3526_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3583_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3598_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3609_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3610_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3616_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3616_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3625_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3625_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3628_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3699_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3725_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3726_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3726_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3727_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3733_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3733_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3735_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3735_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3750_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3756_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3756_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 376_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3772_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3778_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3828_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3835_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3878_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3890_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3890_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3893_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3918_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3931_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3952_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3953_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3960_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3961_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3961_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3962_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3962_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3967_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3967_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3970_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3970_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3978_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3978_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3983_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3984_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/3988_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4010_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4010_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4017_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4019_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4019_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4033_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4033_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4036_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4039_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4043_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4043_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4050_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4095_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4149_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4149_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4154_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4154_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4155_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4155_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4156_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4156_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4157_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4159_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4159_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4160_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4160_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4161_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4162_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4162_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4163_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4163_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4166_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4166_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4167_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4167_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4168_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4170_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4170_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4174_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4174_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4175_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4177_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4177_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4178_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4178_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4179_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4181_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4181_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4182_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4183_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4183_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4184_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4184_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4185_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4185_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4186_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4186_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4187_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4189_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4189_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4193_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4198_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4206_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4206_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4212_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4212_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4214_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4215_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4215_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4219_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4219_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4221_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4225_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4227_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4227_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4230_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4230_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4235_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4238_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4242_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4248_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4249_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4253_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4263_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4263_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4265_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4271_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4275_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4275_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4276_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4276_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4281_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4282_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4286_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4286_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4289_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4293_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4296_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4298_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4299_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4303_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4303_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4325_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4325_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4332_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4336_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4336_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4342_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4342_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4357_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4357_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4360_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4360_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4362_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4362_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4372_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4381_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4381_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4387_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4387_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4388_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4393_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4404_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4404_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4408_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4408_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4409_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4409_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4411_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4411_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4413_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4413_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4414_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4414_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4415_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4416_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4416_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4417_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4417_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4418_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/4418_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 794_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/794_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/846_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 873_modified.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "27-12-2024",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RH/873_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DG-S-COMU - platicas de cultura del agua  (1).pdf",
    "4to Trimestre",
    "Erick Parra",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DG-S-COMU/platicas%20de%20cultura%20del%20agua%20%20(1).pdf",
    },
  ],
  [
    "daf-s-rm - Acta de  Fallo N-7-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/Acta%20de%20%20Fallo%20N-7-2024.pdf",
    },
  ],
  [
    "daf-s-rm - Acta de FALLO N-2-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/Acta%20de%20FALLO%20N-2-2024.pdf",
    },
  ],
  [
    "daf-s-rm - Acta de FALLO N-3-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/Acta%20de%20FALLO%20N-3-2024.pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE FALLO N-4-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20FALLO%20N-4-2024.pdf",
    },
  ],
  [
    "daf-s-rm - Acta de FALLO N-5-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/Acta%20de%20FALLO%20N-5-2024.pdf",
    },
  ],
  [
    "daf-s-rm - Acta de FALLO N-6-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/Acta%20de%20FALLO%20N-6-2024.pdf",
    },
  ],
  [
    "daf-s-rm - Acta de FALLO-N-1-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/Acta%20de%20FALLO-N-1-2024.pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE PRESENTACION Y APERTURA DE PROPOSICIONES N-2-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20N-2-2024.pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE PRESENTACION Y APERTURA DE PROPOSICIONES N-3-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20N-3-2024.pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE PRESENTACION Y APERTURA DE PROPOSICIONES N-4-2024 (1).pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20N-4-2024%20(1).pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE PRESENTACION Y APERTURA DE PROPOSICIONES N-6-2024 (1).pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20N-6-2024%20(1).pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE PRESENTACION Y APERTURA DE PROPOSICIONES N-7-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20N-7-2024.pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE PRESENTACION Y APERTURA DE PROPOSICIONES-N-1-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES-N-1-2024.pdf",
    },
  ],
  [
    "daf-s-rm - ACTA DE PRESENTACION Y APERTURA DE PROPOSIONES N-5-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/ACTA%20DE%20PRESENTACION%20Y%20APERTURA%20DE%20PROPOSIONES%20N-5-2024.pdf",
    },
  ],
  [
    "daf-s-rm - CONVOCATORIA-N-1-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/CONVOCATORIA-N-1-2024.pdf",
    },
  ],
  [
    "daf-s-rm - JUNTA DE ACLARACIONES N-2-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/JUNTA%20DE%20ACLARACIONES%20N-2-2024.pdf",
    },
  ],
  [
    "daf-s-rm - JUNTA DE ACLARACIONES N-3-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/JUNTA%20DE%20ACLARACIONES%20N-3-2024.pdf",
    },
  ],
  [
    "daf-s-rm - JUNTA DE ACLARACIONES N-4-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/JUNTA%20DE%20ACLARACIONES%20N-4-2024.pdf",
    },
  ],
  [
    "daf-s-rm - JUNTA DE ACLARACIONES N-5-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/JUNTA%20DE%20ACLARACIONES%20N-5-2024.pdf",
    },
  ],
  [
    "daf-s-rm - JUNTA DE ACLARACIONES N-6-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/JUNTA%20DE%20ACLARACIONES%20N-6-2024.pdf",
    },
  ],
  [
    "daf-s-rm - JUNTA DE ACLARACIONES N-7-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/JUNTA%20DE%20ACLARACIONES%20N-7-2024.pdf",
    },
  ],
  [
    "daf-s-rm - JUNTA DE ACLARACIONES-N-1-2024.pdf",
    "4to Trimestre",
    "Norma RM",
    "27-12-2024",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/daf-s-rm/JUNTA%20DE%20ACLARACIONES-N-1-2024.pdf",
    },
  ],
  [
    "DAF-S-PF - Cuotas-y Tarifas2025.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "02-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Cuotas-y%20Tarifas2025.pdf",
    },
  ],
  [
    "DAF-S-RM - 858.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/858.pdf",
    },
  ],
  [
    "DAF-S-RM - 1834.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/1834.pdf",
    },
  ],
  [
    "DAF-S-RM - Autorización ADPE015-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Autorización%20ADPE015-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - Autorización ADPE016-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Autorización%20ADPE016-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - COMPROBACIÓN ARACELI ZEPEDA RIVERA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/COMPROBACIÓN%20ARACELI%20ZEPEDA%20RIVERA.pdf",
    },
  ],
  [
    "DAF-S-RM - COMPROBACIÓN ASAEL MERAZ CABRERA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/COMPROBACIÓN%20ASAEL%20MERAZ%20CABRERA.pdf",
    },
  ],
  [
    "DAF-S-RM - COMPROBACIÓN CASTRO DIESEL.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/COMPROBACIÓN%20CASTRO%20DIESEL.pdf",
    },
  ],
  [
    "DAF-S-RM - COMPROBACIÓN LUIS ANTONIO.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/COMPROBACIÓN%20LUIS%20ANTONIO.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N50.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Dictamen%20N50.pdf",
    },
  ],
  [
    "DAF-S-RM - Comprobacion PIBEH.pdf",
    "4to Trimestre",
    "Dulce Lic",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Comprobacion%20PIBEH.pdf",
    },
  ],
  [
    "DAf-S-RM - Comprobacion Vales de Despensa.pdf",
    "4to Trimestre",
    "Dulce Lic",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAf-S-RM/Comprobacion%20Vales%20de%20Despensa.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE NOVIEMBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20DE%20NOVIEMBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE OCTUBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20DE%20OCTUBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DE SEPTIEMBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20DE%20SEPTIEMBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA DICIDMBRE.PDF",
    "4to Trimestre",
    "Cristina Mejia",
    "03-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20DICIDMBRE.PDF",
    },
  ],
  [
    "DAF-S-RM - AXEL 88.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AXEL%2088.pdf",
    },
  ],
  [
    "DAF-S-RM - CARE 4965.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/CARE%204965.pdf",
    },
  ],
  [
    "DAF-S-RM - CAREI 4964.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/CAREI%204964.pdf",
    },
  ],
  [
    "DAF-S-RM - INSEL COMMERCE 25.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INSEL%20COMMERCE%2025.pdf",
    },
  ],
  [
    "DAF-S-RM - JOSE CASTILLEJA 29.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JOSE%20CASTILLEJA%2029.pdf",
    },
  ],
  [
    "DAF-S-RM - LEMUS 25111.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/LEMUS%2025111.pdf",
    },
  ],
  [
    "DAF-S-RM - LETICIA RODRIGUEZ 191.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/LETICIA%20RODRIGUEZ%20191.pdf",
    },
  ],
  [
    "DAF-S-RM - LETICIA RODRIGUEZ 192.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/LETICIA%20RODRIGUEZ%20192.pdf",
    },
  ],
  [
    "DAF-S-RM - MONTSERRAT 173.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/MONTSERRAT%20173.pdf",
    },
  ],
  [
    "DAF-S-RM - OLIVERIO 772.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OLIVERIO%20772.pdf",
    },
  ],
  [
    "DAF-S-RM - RAUL MTZ B3908.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/RAUL%20MTZ%20B3908.pdf",
    },
  ],
  [
    "DAF-S-RM - TERESA DE JESUS 258.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/TERESA%20DE%20JESUS%20258.pdf",
    },
  ],
  [
    "DAF-S-RM - Factua 31 N-4-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factua%2031%20N-4-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - Factua 813 PS-24-IP-02.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factua%20813%20PS-24-IP-02.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA 1810 N-5-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%201810%20N-5-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - factura 1876 PS-24-FE-03.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/factura%201876%20PS-24-FE-03.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura 1877 PS-24-IP-03.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factura%201877%20PS-24-IP-03.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura 30 N-3-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factura%2030%20N-3-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura 32 N-1-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factura%2032%20N-1-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura 36 N-7-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factura%2036%20N-7-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura 37 N-6-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factura%2037%20N-6-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura 802 N-2-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Factura%20802%20N-2-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - factura 814 PS-24-IP-01.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/factura%20814%20PS-24-IP-01.pdf",
    },
  ],
  [
    "DAF-S-RM - N-1-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-1-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-2-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-2-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-3-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-3-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-4-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-4-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-5-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-5-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-6-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-6-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-7-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-7-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DAP-3541-2024 N66.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DAP-3541-2024%20N66.pdf",
    },
  ],
  [
    "DAF-S-RM - DAP-3553-2024 N65.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DAP-3553-2024%20N65.pdf",
    },
  ],
  [
    "DAF-S-RM - DAyPT-507-2024 N51.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DAyPT-507-2024%20N51.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N63.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N63.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N76.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N76.pdf",
    },
  ],
  [
    "DAF-S-RM - DPV-0041-2024 N56.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DPV-0041-2024%20N56.pdf",
    },
  ],
  [
    "DAF-S-RM - DTICS-283-2024 N55.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DTICS-283-2024%20N55.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FGPAR-GI-2023-4019-02774 N65.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/HACIENDA-A-FGPAR-GI-2023-4019-02774%20N65.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FGPAR-GI-2023-4019-02798 N76.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/HACIENDA-A-FGPAR-GI-2023-4019-02798%20N76.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-IGFGP-GI-2023-4019-02770 N66.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/HACIENDA-A-IGFGP-GI-2023-4019-02770%20N66.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-SITCH-GI-2023-4019-02701 N51.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/HACIENDA-A-SITCH-GI-2023-4019-02701%20N51.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-254-2024 N56.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-254-2024%20N56.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-255-2024 N55.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-255-2024%20N55.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-265-2024 N63.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-265-2024%20N63.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-295-2024 ADPE14.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-295-2024%20ADPE14.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-296-2024 ADPE13.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-296-2024%20ADPE13.pdf",
    },
  ],
  [
    "DAF-S-RM - DAP-2858-2024 N41.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DAP-2858-2024%20N41.pdf",
    },
  ],
  [
    "DAF-S-RM - DAP-3220-2024 N45.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DAP-3220-2024%20N45.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FGPAR-GI-2024-4019-00509 N41.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/HACIENDA-A-FGPAR-GI-2024-4019-00509%20N41.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-143-2024 N45.pdf",
    "4to Trimestre",
    "Yair Serrano",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-143-2024%20N45.pdf",
    },
  ],
  [
    "DAF-S-RM - G-772-82f14b85-5e28-4637-b1a3-f424dd2a0375.pdf",
    "4to Trimestre",
    "Ines Flores",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/G-772-82f14b85-5e28-4637-b1a3-f424dd2a0375.pdf",
    },
  ],
  [
    "DAF-S-RM - N-1-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-1-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-2-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-2-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-3-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-3-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-4-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-4-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-5-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-5-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-6-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-6-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-7-2024.pdf",
    "4to Trimestre",
    "Norma RH",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-7-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - N-1-2024 oficio.pdf",
    "4to Trimestre",
    "Norma RM",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-1-2024%20oficio.pdf",
    },
  ],
  [
    "DAF-S-RM - N-2-2024 oficio.pdf",
    "4to Trimestre",
    "Norma RM",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-2-2024%20oficio.pdf",
    },
  ],
  [
    "DAF-S-RM - N-3-2024 oficio.pdf",
    "4to Trimestre",
    "Norma RM",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-3-2024%20oficio.pdf",
    },
  ],
  [
    "DAF-S-RM - N-4-2024 oficio.pdf",
    "4to Trimestre",
    "Norma RM",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-4-2024%20oficio.pdf",
    },
  ],
  [
    "DAF-S-RM - N-5-2024 oficio.pdf",
    "4to Trimestre",
    "Norma RM",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-5-2024%20oficio.pdf",
    },
  ],
  [
    "DAF-S-RM - N-6-2024 oficio.pdf",
    "4to Trimestre",
    "Norma RM",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-6-2024%20oficio.pdf",
    },
  ],
  [
    "DAF-S-RM - N-7-2024 oficio.pdf",
    "4to Trimestre",
    "Norma RM",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/N-7-2024%20oficio.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSO ADL06.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSO%20ADL06.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO ADPE10.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20ADPE10.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO ADPE9.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20ADPE9.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO N44.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20N44.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO N54.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20N54.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO N57.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20N57.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO N67.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20N67.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO N69.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20N69.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO N73.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20N73.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSO N74.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSO%20N74.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N44.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N44.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N54.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N54.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N57.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N57.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N67.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N67.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N69.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N69.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N73.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N73.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N74.pdf",
    "4to Trimestre",
    "Beatriz Martinez",
    "06-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N74.pdf",
    },
  ],
  [
    "DAJ - Subsidios Oct - Dic 2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Subsidios%20Oct%20-%20Dic%202024.pdf",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-117-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/CONTRATO%20DAJ-117-2024.docx",
    },
  ],
  [
    "DAJ - CONTRATO DAJ-121-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/CONTRATO%20DAJ-121-2024.docx",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION RECURSOS N48.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20RECURSOS%20N48.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N38.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N38.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N48.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N48.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N52.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N52.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N75.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N75.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N77.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N77.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N79.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N79.pdf",
    },
  ],
  [
    "DAF-S-RM - Oficio autorizacion de los recursos N75.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/Oficio%20autorizacion%20de%20los%20recursos%20N75.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION N38.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20N38.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION N52.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20N52.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION N77.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20N77.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS ADI.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20ADI.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS N79.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20N79.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-117-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-117-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-121-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-121-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS ARGAB Y ASOCIADOS.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20ARGAB%20Y%20ASOCIADOS.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS FEDERICO 1.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20FEDERICO%201.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS FEDERICO 2.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20FEDERICO%202.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEH.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEH.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20241111001 ARGAB Y ASOCIADOS.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OSN20241111001%20ARGAB%20Y%20ASOCIADOS.pdf",
    },
  ],
  [
    "DAF-S-RM - PS20241217001 FEDERICO 1.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PS20241217001%20FEDERICO%201.pdf",
    },
  ],
  [
    "DAF-S-RM - PS20241219001 AUTONATION.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PS20241219001%20AUTONATION.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20241025001 FEDERICO 2.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PSN20241025001%20FEDERICO%202.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20241210001 GEH.pdf",
    "4to Trimestre",
    "Egarcito Bautista",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PSN20241210001%20GEH.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMÉN N70.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMÉN%20N70.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMÉN N72.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMÉN%20N72.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMÉN N80.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMÉN%20N80.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN ADL05-2024.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20ADL05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N46.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N46.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N53.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N53.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N59.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N59.pdf",
    },
  ],
  [
    "DAF-S-RM - OF. AUTORIZACION AMPLIACION N20 CONT 90.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OF.%20AUTORIZACION%20AMPLIACION%20N20%20CONT%2090.pdf",
    },
  ],
  [
    "DAF-S-RM - OF. AUTORIZACION AMPLIACION N22 CONT 142.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OF.%20AUTORIZACION%20AMPLIACION%20N22%20CONT%20142.pdf",
    },
  ],
  [
    "DAF-S-RM - OF. AUTORIZACION N70.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OF.%20AUTORIZACION%20N70.pdf",
    },
  ],
  [
    "DAF-S-RM - OF. AUTORIZACION N72.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OF.%20AUTORIZACION%20N72.pdf",
    },
  ],
  [
    "DAF-S-RM - OF. AUTORIZACION N80.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OF.%20AUTORIZACION%20N80.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS ANTICIPADAS.pdf",
    "4to Trimestre",
    "Karla Mora",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20ANTICIPADAS.pdf",
    },
  ],
  [
    "DAF-S-RM - aoficio autorizacion adpe 11.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/aoficio%20autorizacion%20adpe%2011.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen N43.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/dictamen%20N43.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio autorizacion adpe 12.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/oficio%20autorizacion%20adpe%2012.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio autorizacion N43.pdf",
    "4to Trimestre",
    "Karla Mora Abonce",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/oficio%20autorizacion%20N43.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen arrendamiento.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/dictamen%20arrendamiento.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen catastro.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/dictamen%20catastro.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen mantenimiento.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/dictamen%20mantenimiento.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen seguros.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/dictamen%20seguros.pdf",
    },
  ],
  [
    "DAF-S-RM - herramientas dictamen.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/herramientas%20dictamen.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio anticipadas.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/oficio%20anticipadas.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio buzos.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/oficio%20buzos.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio catastro.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/oficio%20catastro.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio gotin.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/oficio%20gotin.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio platah.pdf",
    "4to Trimestre",
    "Mafer Garcia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/oficio%20platah.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA AXEL TOMAS FERNANDEZ.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20AXEL%20TOMAS%20FERNANDEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - facturas PIBEH cuarto trimestre-salida.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/facturas%20PIBEH%20cuarto%20trimestre-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURATELMEXNOVIEMBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURATELMEXNOVIEMBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURATELMEXOCTUBRE.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURATELMEXOCTUBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURATELMEXSEPT.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURATELMEXSEPT.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20241002001 (1).pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PC20241002001%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - policia hidrica 4to trimestre.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/policia%20hidrica%204to%20trimestre.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20241002001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PSN20241002001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20241101001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PSN20241101001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20241202003.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PSN20241202003.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20241220001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PSN20241220001.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-0284-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-0284-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-189-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-189-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-217-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-217-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-245-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-245-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-276-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "07-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-276-2024.pdf",
    },
  ],
  [
    "DG-S-COMU - FACTURA DIC 2024.pdf",
    "4to Trimestre",
    "Desconocido",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DG-S-COMU/FACTURA%20DIC%202024.pdf",
    },
  ],
  [
    "DG-S-COMU - FACTURA NOV 2024.pdf",
    "4to Trimestre",
    "Desconocido",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DG-S-COMU/FACTURA%20NOV%202024.pdf",
    },
  ],
  [
    "DG-S-COMU - FACTURA OCTUBRE 2024.pdf",
    "4to Trimestre",
    "Desconocido",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DG-S-COMU/FACTURA%20OCTUBRE%202024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-16-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-16-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-17-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-17-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-18-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-18-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-19-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-19-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-20-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-20-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-21-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-21-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-22-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-22-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-23-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-23-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-24-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-24-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-25-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-25-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-26-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-26-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-27-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-27-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-28-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-28-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-29-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-29-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-30-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-30-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-31-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-31-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-32-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-32-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-33-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-33-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-34-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-34-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-35-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-35-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-36-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-36-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-37-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-37-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-38-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-38-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-39-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-39-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-40-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-40-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-41-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-41-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-42-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-42-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-43-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-43-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-44-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-44-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-02-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-03-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-05-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-06-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-07-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-08-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-L.O.P.-10-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-10-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-L.O.P.-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-L.O.P.-13-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-13-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-L.O.P.-14-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-16-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-16-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-17-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-17-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-18-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-18-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-19-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-19-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-20-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-20-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-21-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-21-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-22-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-22-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-23-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-23-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-24-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-24-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-25-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-25-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-26-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-26-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-27-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-27-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-28-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-28-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-29-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-29-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-30-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-30-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-31-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-31-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-32-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-32-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-33-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-33-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-34-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-34-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-35-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-35-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-36-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-36-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-37-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-37-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-38-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-38-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-39-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-39-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-40-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-40-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-41-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-41-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-42-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-42-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-43-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-43-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-44-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-44-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-02-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-03-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-05-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-06-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-07-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-08-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-13-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-13-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-14-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.10-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.10-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-16-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-16-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-17-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-17-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-18-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-18-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-19-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-19-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-20-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-20-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-21-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-21-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-22-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-22-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-23-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-23-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-24-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-24-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-25-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-25-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-26-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-26-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-27-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-27-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-28-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-28-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-29-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-29-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-30-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-30-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-31-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-31-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-32-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-32-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-33-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-33-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-34-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-34-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-35-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-35-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-36-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-36-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-37-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-37-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-38-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-38-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-39-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-39-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-40-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-40-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-41-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-41-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-42-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-42-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-43-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-43-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-44-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-44-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-INV3-OP-02-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-INV3-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-INV3-OP-03-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-INV3-OP-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-INV3-OP-05-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-INV3-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-INV3-OP-06-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-INV3-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-INV3-OP-07-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-INV3-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-INV3-OP-08-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-INV3-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-INV3-OP-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-INV3-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-L.O.P.-10-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-L.O.P.-10-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-L.O.P.-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-L.O.P.-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-L.O.P.-13-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-L.O.P.-13-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-L.O.P.-14-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-L.O.P.-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-16-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-16-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-17-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-17-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-18-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-18-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-19-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-19-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-20-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-20-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-21-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-21-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-22-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-22-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-23-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-23-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-24-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-24-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-25-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-25-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-26-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-26-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-27-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-27-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-28-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-28-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-29-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-29-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-30-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-30-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-31-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-31-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-32-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-32-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-33-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-33-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-34-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-34-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-35-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-35-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-36-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-36-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-37-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-37-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-38-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-38-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-39-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-39-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-40-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-40-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-41-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-41-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-42-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-42-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-43-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-43-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-44-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-44-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-INV3-OP-07-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-INV3-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-02-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-INV3-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-03-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-INV3-OP-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-05-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-INV3-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-06-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-INV3-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-07-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-INV3-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-08-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-INV3-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-INV3-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-10-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-L.O.P.-10-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-L.O.P.-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-13-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-L.O.P.-13-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-14-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20CAASIM-HGO-L.O.P.-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-16-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-16-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-17-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-17-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-18-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-18-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-19-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-19-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-20-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-20-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-21-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-21-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-22-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-22-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-23-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-23-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-24-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-24-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-25-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-25-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-26-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-26-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-27-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-27-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-28-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-28-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-29-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-29-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-30-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-30-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-31-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-31-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-32-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-32-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-33-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-33-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-34-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-34-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-35-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-35-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-36-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-36-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-37-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-37-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-38-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-38-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-39-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-39-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-40-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-40-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-41-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-41-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-42-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-42-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-43-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-43-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-44-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-44-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-02-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-INV3-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-03-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-INV3-OP-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-05-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-INV3-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-06-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-INV3-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-07-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-INV3-OP-07-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-08-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-INV3-OP-08-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-INV3-OP-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-L.O.P.-11-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-L.O.P.-11-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-L.O.P.-13-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-L.O.P.-13-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-L.O.P.-14-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-L.O.P.-14-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-L.O.P.10-2024.pdf",
    "4to Trimestre",
    "Abogado",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-L.O.P.10-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ADL-04-2024.pdf",
    "4to Trimestre",
    "Beatriz Olvera",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ADL-04-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE-172024.pdf",
    "4to Trimestre",
    "Elisa Samperio",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/ADPE-172024.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE-182024.pdf",
    "4to Trimestre",
    "Elisa Samperio",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/ADPE-182024.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE-202024.pdf",
    "4to Trimestre",
    "Elisa Samperio",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/ADPE-202024.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE-212024.pdf",
    "4to Trimestre",
    "Elisa Samperio",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/ADPE-212024.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE-222024.pdf",
    "4to Trimestre",
    "Elisa Samperio",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/ADPE-222024.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE192024.pdf",
    "4to Trimestre",
    "Elisa Samperio",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/ADPE192024.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen n40.pdf",
    "4to Trimestre",
    "Mafer",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/dictamen%20n40.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA MARA REBECA-salida.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20MARA%20REBECA-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA SICEMYC-salida.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURA%20SICEMYC-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-239-2024-salida.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-239-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-300-2024-salida.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "08-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-300-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - AXEL 7003.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/AXEL%207003.pdf",
    },
  ],
  [
    "DAF-S-RM - CAREI 6001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/CAREI%206001.pdf",
    },
  ],
  [
    "DAF-S-RM - CAREI 6002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/CAREI%206002.pdf",
    },
  ],
  [
    "DAF-S-RM - CONSORCIO 7005.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/CONSORCIO%207005.pdf",
    },
  ],
  [
    "DAF-S-RM - GALUME 2002.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/GALUME%202002.pdf",
    },
  ],
  [
    "DAF-S-RM - INSEL 6005.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/INSEL%206005.pdf",
    },
  ],
  [
    "DAF-S-RM - JOSE ANTONIO 4004.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JOSE%20ANTONIO%204004.pdf",
    },
  ],
  [
    "DAF-S-RM - JUAN CARLOS 6006.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUAN%20CARLOS%206006.pdf",
    },
  ],
  [
    "DAF-S-RM - LETICIA 6004.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/LETICIA%206004.pdf",
    },
  ],
  [
    "DAF-S-RM - LETICIA 7001.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/LETICIA%207001.pdf",
    },
  ],
  [
    "DAF-S-RM - MONSERRAT 2004.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/MONSERRAT%202004.pdf",
    },
  ],
  [
    "DAF-S-RM - RAUL 7004.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/RAUL%207004.pdf",
    },
  ],
  [
    "DAF-S-RM - TERESA DE  JESUS 6003.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/TERESA%20DE%20%20JESUS%206003.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS SCDEN-salida.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20SCDEN-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-314-2024-salida.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-314-2024-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N47.pdf",
    "4to Trimestre",
    "Dulce",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N47.pdf",
    },
  ],
  [
    "DAJ - Contrato  DAJ-185-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20%20DAJ-185-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-183-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-183-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-184-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-184-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-186-2024.doc",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-186-2024.doc",
    },
  ],
  [
    "DAJ - Contrato DAJ-187-2024.doc",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-187-2024.doc",
    },
  ],
  [
    "DAJ - Contrato DAJ-188-2024.doc",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-188-2024.doc",
    },
  ],
  [
    "DAJ - Contrato DAJ-189-2024.doc",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-189-2024.doc",
    },
  ],
  [
    "DAJ - Contrato DAJ-271-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-271-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-272-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-272-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-280-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-280-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-281-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-281-2024.docx",
    },
  ],
  [
    "DAF-S-PF - Contrato DAJ-171-2024.docx",
    "4to Trimestre",
    "Marleen Barrera",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Contrato%20DAJ-171-2024.docx",
    },
  ],
  [
    "DAJ - Contrato DAJ-171-2024.docx",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-171-2024.docx",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AMABEL ONTIVEROS.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20AMABEL%20ONTIVEROS.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ARCODEM.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AURORA GARCIA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20AURORA%20GARCIA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS BLANCA CECILIA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20BLANCA%20CECILIA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS CARLOS IBARRA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20CARLOS%20IBARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GRACIELA PEREZ.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20GRACIELA%20PEREZ.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS JULIETA CABRERA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20JULIETA%20CABRERA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS LEONARDO PEREZ.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20LEONARDO%20PEREZ.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MA DEL CARMEN CORTEZ.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20MA%20DEL%20CARMEN%20CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MA DEL CARMEN PARRA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20MA%20DEL%20CARMEN%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - facturas mant eduardo javier baños.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/facturas%20mant%20eduardo%20javier%20baños.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MANTENIMIENTO GLIDER.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20MANTENIMIENTO%20GLIDER.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS NORBERTO SILVA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20NORBERTO%20SILVA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ODILON GEMPO.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20ODILON%20GEMPO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS RENTA EDUARDO JAVIER BAÑOS.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20RENTA%20EDUARDO%20JAVIER%20BAÑOS.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS RENTA GLIDER.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/FACTURAS%20RENTA%20GLIDER.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-056-2024 (2).pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-056-2024%20(2).pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-178-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-178-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-215-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-215-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-246-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-246-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-274-2024.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/SPF-274-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-171-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-171-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-183-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-183-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-184-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-184-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-185-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-185-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-186-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-186-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-187-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-187-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-188-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-188-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-189-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-189-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-271-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-271-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-272-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-272-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-280-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-280-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-281-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-281-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-064-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-064-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-094-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-094-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-095-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-095-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-097-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-097-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-100-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-100-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-109-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-109-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-115-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-115-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-116-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-116-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-120-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-120-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-126-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-126-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-127-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-127-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-128-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-128-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-129-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-129-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-132-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-132-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-133-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-133-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-134-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-134-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-135-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-135-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-136-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-136-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-137-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-137-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-138-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-138-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-139-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-139-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-141-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-141-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-143-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-143-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-144-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-144-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-145-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-145-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-146-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-146-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-147-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-147-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-149-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-149-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-150-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-150-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-154-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-154-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-155-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-155-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-156-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-156-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-157-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-157-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-164-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-164-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-165-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-165-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-166-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-166-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-168-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-168-2024.pdf",
    },
  ],
  [
    "DCONS - Contrato DAJ-169-2024.pdf",
    "4to Trimestre",
    "Blanca Martinezz",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/Contrato%20DAJ-169-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CASA SUSY.pdf",
    "4to Trimestre",
    "Ines Flores",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/CASA%20SUSY.pdf",
    },
  ],
  [
    "DAF-S-RM - JUAN CARLSO LEMUS.pdf",
    "4to Trimestre",
    "Ines Flores",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/JUAN%20CARLSO%20LEMUS.pdf",
    },
  ],
  [
    "DAF-S-RM - OLIVERIO.pdf",
    "4to Trimestre",
    "Ines Flores",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OLIVERIO.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-168-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-168-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-169-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-169-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-190-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-190-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-191-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-191-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-192-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-192-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-193-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-193-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-194-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-194-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-195-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-195-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-196-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-196-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-197-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-197-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-198-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-198-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-199-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-199-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-200-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-200-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-201-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-201-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-203-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-203-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-204-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-204-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-205-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-205-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-206-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-206-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-207-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-207-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-209-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-209-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-213-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-213-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-214-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-214-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-215-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-215-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-216-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-216-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-217-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-217-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-221-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-221-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-222-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-222-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-223-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-223-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-227-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-227-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/CONVOCATORIA.pdf",
    },
  ],
  [
    "DAF-S-RM - ITP-1-24 obra.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/ITP-1-24%20obra.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-229-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-229-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-230-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-230-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-234-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-234-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-235-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-235-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-236-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-236-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-239-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-239-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-240-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-240-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-241-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-241-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-243-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-243-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-246-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-246-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-247-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-247-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-248-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-248-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-249-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-249-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-175-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-175-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-176-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-176-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-177-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-177-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-208-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-208-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-224-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-224-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-251-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-251-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-252-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-252-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-268-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-268-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-064-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Convenio%20DAJ-064-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-065-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Convenio%20DAJ-065-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-066-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Convenio%20DAJ-066-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-067-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Convenio%20DAJ-067-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-068-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Convenio%20DAJ-068-2024.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-073-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "13-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Convenio%20DAJ-073-2024.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Situacion Financiera.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Situacion%20Financiera.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado de Actividades.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20de%20Actividades.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. h) Pasivos Contingentes.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20h)%20Pasivos%20Contingentes.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Estados Financieros.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- a) 1.Estado Analitico de Ingresos-Clasificacion Economica 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20a)%201.Estado%20Analitico%20de%20Ingresos-Clasificacion%20Economica%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- a) 2.Estado Analitico de Ingresos-Clasificacion por Fuente de Financiamiento 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20a)%202.Estado%20Analitico%20de%20Ingresos-Clasificacion%20por%20Fuente%20de%20Financiamiento%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- a) 3.Estado Analitico de Ingresos-Clasificacion por Rubro de Ingresos a nivel Concepto 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20a)%203.Estado%20Analitico%20de%20Ingresos-Clasificacion%20por%20Rubro%20de%20Ingresos%20a%20nivel%20Concepto%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- a) 4.Estado Analitico de Ingresos incluyendo los ingresos excedentes generados 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20a)%204.Estado%20Analitico%20de%20Ingresos%20incluyendo%20los%20ingresos%20excedentes%20generados%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- b) 1.Estado Analitico del Presupuesto de Egresos-Clasificacion Administrativa 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20b)%201.Estado%20Analitico%20del%20Presupuesto%20de%20Egresos-Clasificacion%20Administrativa%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- b) 2.Estado Analitico del Presupuesto de Egresos-Clasificacion Economica y por Objeto del Gasto 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20b)%202.Estado%20Analitico%20del%20Presupuesto%20de%20Egresos-Clasificacion%20Economica%20y%20por%20Objeto%20del%20Gasto%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- b) 3.Estado Analitico del Presupuesto de Egresos-Clasificacion Funcional-Programatica 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20b)%203.Estado%20Analitico%20del%20Presupuesto%20de%20Egresos-Clasificacion%20Funcional-Programatica%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- b) 4.Estado Analitico del Presupuesto de Egresos Identificado por Ramo 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20b)%204.Estado%20Analitico%20del%20Presupuesto%20de%20Egresos%20Identificado%20por%20Ramo%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- b) 5.Estado Analitico del Presupuesto de Egresos-Clasificacion Economica-Tipo de Gasto 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20b)%205.Estado%20Analitico%20del%20Presupuesto%20de%20Egresos-Clasificacion%20Economica-Tipo%20de%20Gasto%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- b) 6.Estado Analitico del Presupuesto de Egresos-Clasificacion por Objeto del Gasto (Capitulo y Concepto) 4to trimestre 2024.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20b)%206.Estado%20Analitico%20del%20Presupuesto%20de%20Egresos-Clasificacion%20por%20Objeto%20del%20Gasto%20(Capitulo%20y%20Concepto)%204to%20trimestre%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- c) Endeudamiento Neto.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20c)%20Endeudamiento%20Neto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- d) Intereses de la Deuda.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20d)%20Intereses%20de%20la%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II.- e) Flujo de Fondos.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.-%20e)%20Flujo%20de%20Fondos.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Situacion Financiera.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado de Actividades.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20de%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Activo.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Deuda y Otros Pasivos.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Deuda%20y%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. h) Informe Pasivos Contingentes.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Estados Financieros.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) 1. Estado Ingresos Economica.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20a)%201.%20Estado%20Ingresos%20Economica.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) 2. Estado Ingresos Fuente Financiamiento.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20a)%202.%20Estado%20Ingresos%20Fuente%20Financiamiento.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) 3. Estado Ingresos Rubros Ingreso.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20a)%203.%20Estado%20Ingresos%20Rubros%20Ingreso.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) 4. Estado Ingresos Excedentes.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20a)%204.%20Estado%20Ingresos%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1. Estado Egresos Administrativa.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20b)%201.%20Estado%20Egresos%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. Estado Egresos Economica y Objeto Gasto.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Economica%20y%20Objeto%20Gasto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. Estado Egresos Funcional Programatica.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20Funcional%20Programatica.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. Estado Egresos Ramo.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 5. Estado Egresos Economica Tipo Gasto.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20b)%205.%20Estado%20Egresos%20Economica%20Tipo%20Gasto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses Deuda.pdf",
    "4to Trimestre",
    "Blanca Trigueros",
    "23-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoria programática.xlsx",
    "4to Trimestre",
    "Amparo Flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programática.xlsx",
    },
  ],
  [
    "DAF-S-PF - Gasto por Categoría Programática (1).pdf",
    "4to Trimestre",
    "Amparo Flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Gasto%20por%20Categoría%20Programática%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de Resultados (1).pdf",
    "4to Trimestre",
    "Amparo Flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Indicadores%20de%20Resultados%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de resultados.xlsx",
    "4to Trimestre",
    "Amparo Flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados.xlsx",
    },
  ],
  [
    "DAF-S-PF - Programas y Proyectos de Inversión (1).pdf",
    "4to Trimestre",
    "Amparo Flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Programas%20y%20Proyectos%20de%20Inversión%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversión.xlsx",
    "4to Trimestre",
    "Amparo Flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión.xlsx",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoría programática.docx",
    "4to Trimestre",
    "Amparo flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Gasto%20por%20categoría%20programática.docx",
    },
  ],
  [
    "DAF-S-PF - Indicadores de resultados.docx",
    "4to Trimestre",
    "Amparo flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados.docx",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversión.docx",
    "4to Trimestre",
    "Amparo flores",
    "27-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión.docx",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoría programática.pdf",
    "4to Trimestre",
    "Marisol",
    "29-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Gasto%20por%20categoría%20programática.pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de resultados.pdf",
    "4to Trimestre",
    "Marisol",
    "29-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados.pdf",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversión.pdf",
    "4to Trimestre",
    "Marisol",
    "29-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión.pdf",
    },
  ],
  [
    "DAF-S-PCF - EAEPE 4O TRIMESTRE 2024.xlsx",
    "4to Trimestre",
    "Iveth Freddy",
    "29-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/EAEPE%204O%20TRIMESTRE%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - ESTADO ANALITICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS 4O TRIMESTRE 2024.pdf",
    "4to Trimestre",
    "Iveth Freddy",
    "29-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/ESTADO%20ANALITICO%20DEL%20EJERCICIO%20DEL%20PRESUPUESTO%20DE%20EGRESOS%204O%20TRIMESTRE%202024.pdf",
    },
  ],
  [
    "DAF-S-PCF - Trasparencia-presupuesto.pdf",
    "4to Trimestre",
    "Alberto Garcia",
    "29-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/Trasparencia-presupuesto.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIOS INVITACION CAASIM-HGO-INV3-OP-02-2024.pdf",
    "4to Trimestre",
    "David Sanchez",
    "31-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIOS%20INVITACION%20CAASIM-HGO-INV3-OP-02-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIOS INVITACION CAASIM-HGO-INV3-OP-03-2024.pdf",
    "4to Trimestre",
    "David Sanchez",
    "31-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIOS%20INVITACION%20CAASIM-HGO-INV3-OP-03-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIOS INVITACION CAASIM-HGO-INV3-OP-05-2024.pdf",
    "4to Trimestre",
    "David Sanchez",
    "31-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIOS%20INVITACION%20CAASIM-HGO-INV3-OP-05-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIOS INVITACION CAASIM-HGO-INV3-OP-06-2024.pdf",
    "4to Trimestre",
    "David Sanchez",
    "31-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIOS%20INVITACION%20CAASIM-HGO-INV3-OP-06-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIOS INVITACION CAASIM-HGO-INV3-OP-08-2024.pdf",
    "4to Trimestre",
    "David Sanchez",
    "31-01-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-RM/OFICIOS%20INVITACION%20CAASIM-HGO-INV3-OP-08-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-097 - 2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "04-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-097%20-%202024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-122-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "04-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-122-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-140-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "04-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-140-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-142-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "04-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-142-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-153-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "04-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-153-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-154-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "04-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-154-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-172-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "04-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-172-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-202-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-202-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-210-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-210-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-212-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-212-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-219-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-219-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-220-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-220-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-225-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-225-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-226-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-226-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-231-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-231-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-233-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-233-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-244-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-244-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-253-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-253-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-256-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-256-2024.pdf",
    },
  ],
  [
    "DCONS - 944 REHAB. ACUEDUCTO TELLEZ 20 DIAM.pdf",
    "4to Trimestre",
    "Blanca",
    "07-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/944%20REHAB.%20ACUEDUCTO%20TELLEZ%2020%20DIAM.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-064-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-064-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-094-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-094-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-095-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-095-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-097-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-097-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-115.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-115.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-116-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-116-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-120-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-120-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-137-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-137-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-138-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-138-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-139-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-139-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-143-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-143-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-144-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-144-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-145-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-145-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-146-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-146-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-100-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-100-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-109-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-109-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-126-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-126-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-127-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-127-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-128-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-128-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-129-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-129-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-132-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-132-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-133-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-133-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-134-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-134-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-135-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-135-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-136-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-136-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-141-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-141-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-147-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-147-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-155-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-155-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIN-DAJ-150-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIN-DAJ-150-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-154-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-154-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-156-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-156-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-157-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-157-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-16-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-16-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-164-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-164-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-165-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-165-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-166-2024 (2).pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-166-2024%20(2).pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-168-2024.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/CAASIM-DAJ-168-2024.pdf",
    },
  ],
  [
    "DCONS - A-494 1 (1).pdf",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/A-494%201%20(1).pdf",
    },
  ],
  [
    "DCONS - AVANCE FINANCIERO.xlsx",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/AVANCE%20FINANCIERO.xlsx",
    },
  ],
  [
    "DCONS - AVANCE FISICO.xlsx",
    "4to Trimestre",
    "Blanca E R M",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/AVANCE%20FISICO.xlsx",
    },
  ],
  [
    "DG-S-COMU - FACTURA CLAUDIO ARNULFO 2025-02-10 at 12.37.11 PM.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DG-S-COMU/FACTURA%20CLAUDIO%20ARNULFO%202025-02-10%20at%2012.37.11%20PM.pdf",
    },
  ],
  [
    "DG-S-COMU - FACTURA CLAUDIO ARNULFO 2025-02-10 at 12.37.12 PM.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "10-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DG-S-COMU/FACTURA%20CLAUDIO%20ARNULFO%202025-02-10%20at%2012.37.12%20PM.pdf",
    },
  ],
  [
    "DCONS - avance fisico financiero E..xlsx",
    "4to Trimestre",
    "Blanca E R M",
    "11-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DCONS/avance%20fisico%20financiero%20E..xlsx",
    },
  ],
  [
    "DG-S-COMU - CONTRATO.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "11-02-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DG-S-COMU/CONTRATO.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe DG 3er. trimestre 2024.pdf",
    "4to Trimestre",
    "Biviana Limon",
    "07-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Informe%20DG%203er.%20trimestre%202024.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe DG 4to. trimestre 2024.pdf",
    "4to Trimestre",
    "Biviana Limon",
    "07-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PF/Informe%20DG%204to.%20trimestre%202024.pdf",
    },
  ],
  [
    "DAF-S-PCF - AVANCE FINANCIERO.pdf",
    "4to Trimestre",
    "Blanca Martinez",
    "13-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/AVANCE%20FINANCIERO.pdf",
    },
  ],
  [
    "DAF-S-PCF - AVANCE FISICO.pdf",
    "4to Trimestre",
    "Blanca Martinez",
    "13-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAF-S-PCF/AVANCE%20FISICO.pdf",
    },
  ],
  [
    "DAJ - Acuerdo que crea el Comité de Obra de la CAASIM.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Acuerdo%20que%20crea%20el%20Comité%20de%20Obra%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - 1008_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/1008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/1022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1816_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/1816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1850_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/1850_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1853_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/1853_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/1979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/1992_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2029_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2093_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2093_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2239_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2261_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 228_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2391_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2391_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2420_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2456_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2457_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2465_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2483_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2489_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2492_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2492_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2538_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2538_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2547_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2547_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2556_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2556_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 256_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/256_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2560_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2560_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2566_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2566_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2567_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2567_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2579_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2581_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2581_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2603_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2631_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2647_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2647_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2655_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2655_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2677_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2677_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2706_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2706_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2734_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2734_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2771_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2771_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2855_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2863_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2863_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2885_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2885_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2886_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2903_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2903_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2914_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2919_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2957_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2957_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2971_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2971_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2980_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2980_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2989_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3000_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3001_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3001_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3011_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3012_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3026_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3027_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3027_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3032_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3032_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3080_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3088_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3088_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3104_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3105_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3106_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3138_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3161_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3166_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3166_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3188_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3197_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3197_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3211_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3213_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3289_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3321_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3321_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3334_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3338_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3358_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3366_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3389_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 339_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/339_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3390_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3398_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3406_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3406_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3449_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3455_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3455_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3475_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3475_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3476_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 349_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/349_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3511_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3521_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3521_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3526_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3583_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3598_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3609_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3610_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3616_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3616_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3625_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3625_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3628_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3699_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3725_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3726_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3726_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3727_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3733_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3733_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3735_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3735_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3750_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3756_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3756_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 376_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3772_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3778_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3828_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3835_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3878_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3890_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3890_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3893_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3918_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3931_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3952_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3953_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3960_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3961_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3961_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3962_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3962_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3967_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3967_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3970_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3970_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3978_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3978_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3983_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3984_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3988_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4010_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4010_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4017_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4019_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4019_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4033_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4033_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4036_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4039_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4043_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4043_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4050_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4086_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4086_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4095_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4149_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4149_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4154_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4154_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4155_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4155_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4156_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4156_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4157_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4159_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4159_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4160_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4160_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4161_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4162_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4162_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4167_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4167_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4168_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4170_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4170_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4174_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4174_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4175_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4177_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4177_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4178_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4178_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4179_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4181_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4181_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4182_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4183_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4183_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4184_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4184_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4185_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4185_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4186_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4186_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4187_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4189_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4189_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4193_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4198_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4206_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4206_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4212_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4212_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4214_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4215_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4215_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4219_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4219_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4221_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4225_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4230_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4230_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4235_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4238_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4242_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4248_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4249_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4253_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4263_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4263_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4265_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4271_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4275_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4275_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4276_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4276_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4281_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4282_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4286_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4286_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4289_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4293_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4296_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4298_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4299_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4303_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4303_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4325_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4325_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4332_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4336_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4336_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4357_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4357_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4360_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4360_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4362_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4362_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4372_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4381_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4381_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4387_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4387_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4388_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4393_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4404_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4404_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4408_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4408_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4413_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4413_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4414_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4414_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4415_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4416_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4416_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4417_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4417_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4418_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4418_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4434_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4434_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4439_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4439_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4445_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4445_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4458_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4458_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4462_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4462_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 794_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/794_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/846_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 873_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "26-03-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/873_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "1er Trimestre",
    "Maribel Butron",
    "26-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "1er Trimestre",
    "Maribel Butron",
    "26-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DAF-S-PF - PRESUPUESTO ASIGNADO 2025 (1).pdf",
    "1er Trimestre",
    "Marisol",
    "26-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/PRESUPUESTO%20ASIGNADO%202025%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - DAF.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DAF.pdf",
    },
  ],
  [
    "DAF-S-PF - DAJ.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DAJ.pdf",
    },
  ],
  [
    "DAF-S-PF - DAP.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DAP.pdf",
    },
  ],
  [
    "DAF-S-PF - DAyPT.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DAyPT.pdf",
    },
  ],
  [
    "DAF-S-PF - DC.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DC.pdf",
    },
  ],
  [
    "DAF-S-PF - DG.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DG.pdf",
    },
  ],
  [
    "DAF-S-PF - DGVyFPT.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DGVyFPT.pdf",
    },
  ],
  [
    "DAF-S-PF - DIU.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DIU.pdf",
    },
  ],
  [
    "DAF-S-PF - DpLLAP.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DpLLAP.pdf",
    },
  ],
  [
    "DAF-S-PF - DTIC´s.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DTIC´s.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-13-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-14-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-16-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-17-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-18-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-18-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-19-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-19-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-20-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-21-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-22-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-23-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-25-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-25-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-306-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-306-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-316-2024.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-316-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-38-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-38-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOB EDO HGO.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOB%20EDO%20HGO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS VEH. RIVERA.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20VEH.%20RIVERA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS VER ARGAB-2.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20VER%20ARGAB-2.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS VER ARGAB.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20VER%20ARGAB.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS CAM HUERTA-2.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20CAM%20HUERTA-2.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250310001 VER ARGAB-2.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OSN20250310001%20VER%20ARGAB-2.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250210006 GOB EDO HGO.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250210006%20GOB%20EDO%20HGO.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250218001 CAM HUERTA.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250218001%20CAM%20HUERTA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250303001 VER ARGAB.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250303001%20VER%20ARGAB.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250314001 CAM RIVERA.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250314001%20CAM%20RIVERA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250325001 CAM HUERTA-2.pdf",
    "1er Trimestre",
    "Edgar Bautista Martinez",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250325001%20CAM%20HUERTA-2.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-046-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-046-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-047-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-047-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-048-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-048-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-049-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-049-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-051-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-051-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CUSTODIOS ENERO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURA%20CUSTODIOS%20ENERO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CUSTODIOS FEB MARZO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURA%20CUSTODIOS%20FEB%20MARZO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA HIDRICA ENERO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURA%20HIDRICA%20ENERO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AURORA GARCIA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20AURORA%20GARCIA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS CARLOS IBARRA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20CARLOS%20IBARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS HIDRICA FEB MARZO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20HIDRICA%20FEB%20MARZO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS JULIETA CABRERA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20JULIETA%20CABRERA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MARIA DEL CARMEN PARRA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20MARIA%20DEL%20CARMEN%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS NORBERTO SILVA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20NORBERTO%20SILVA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ODILON GEMPO COPCA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20ODILON%20GEMPO%20COPCA.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-35-2025.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-35-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - TELEFONOS DE MEXICO ENERO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "27-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/TELEFONOS%20DE%20MEXICO%20ENERO.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-26-2025.pdf",
    "1er Trimestre",
    "Sandy SG",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-37-2025.pdf",
    "1er Trimestre",
    "Sandy SG",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/SPF-37-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS BLANCA CECILIA SALAZAR.pdf",
    "1er Trimestre",
    "Sandy SG",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20BLANCA%20CECILIA%20SALAZAR.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GRUPO ARCODEM.pdf",
    "1er Trimestre",
    "Sandy SG",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20GRUPO%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - TELEFONOS DE MEXICO FEBRERO.pdf",
    "1er Trimestre",
    "Sandy SG",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/TELEFONOS%20DE%20MEXICO%20FEBRERO.pdf",
    },
  ],
  [
    "DAF-S-PF - Circular DAF-SPF-18-2025.pdf",
    "1er Trimestre",
    "Marisol PF",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Circular%20DAF-SPF-18-2025.pdf",
    },
  ],
  [
    "DAF-S-PF - Circular DAF-SPF-18-2025.pdf",
    "1er Trimestre",
    "Marisol PF",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Circular%20DAF-SPF-18-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS CAM HUERTA.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20CAM%20HUERTA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS BLANCA CECILIA SALAZAR.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20BLANCA%20CECILIA%20SALAZAR.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GRUPO ARCODEM.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/FACTURAS%20GRUPO%20ARCODEM.pdf",
    },
  ],
  [
    "DAF-S-RM - TELEFONOS DE MEXICO FEBRERO.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/TELEFONOS%20DE%20MEXICO%20FEBRERO.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura 2024 CAASIM.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F02b_Estructura%202024%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_DECRETO Autorizado 2019.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_DECRETO%20Autorizado%202019.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Estatuto organico.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Condiciones Generales de Trabajo 2024-2025.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202024-2025.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Manual de Recursos Humano.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Abasto.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Abasto.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Admon.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Admon.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Atencion .pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Atencion%20.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Comercial.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Comercial.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. General.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20General.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Gestión.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Gestión.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Infraestructura.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Infraestructura.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Juridico.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Juridico.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. para Llevar.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20para%20Llevar.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Tics.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Tics.pdf",
    },
  ],
  [
    "DAF-S-RH - F08_Tabulador.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "28-03-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/F08_Tabulador.pdf",
    },
  ],
  [
    "DAf-S-RM - dictamen n1.pdf",
    "1er Trimestre",
    "Fernanda RM",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAf-S-RM/dictamen%20n1.pdf",
    },
  ],
  [
    "DAf-S-RM - oficio auto.pdf",
    "1er Trimestre",
    "Fernanda RM",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAf-S-RM/oficio%20auto.pdf",
    },
  ],
  [
    "DAB - GRAFICA 1ER. TRIM_ABASTECIMIENTO DE VOLÚMEN DE AGUA REQUERIDO.xlsx",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/GRAFICA%201ER.%20TRIM_ABASTECIMIENTO%20DE%20VOLÚMEN%20DE%20AGUA%20REQUERIDO.xlsx",
    },
  ],
  [
    "DAB - MIR 1ER. TRIM_ABASTECIMIENTO DE VOLÚMEN DE AGUA REQUERIDO.xls",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/MIR%201ER.%20TRIM_ABASTECIMIENTO%20DE%20VOLÚMEN%20DE%20AGUA%20REQUERIDO.xls",
    },
  ],
  [
    "DAB - POA 1ER.TRIM_ABASTECIMIENTO DE VOLÚMEN DE AGUA REQUERIDO.xls",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/POA%201ER.TRIM_ABASTECIMIENTO%20DE%20VOLÚMEN%20DE%20AGUA%20REQUERIDO.xls",
    },
  ],
  [
    "DAF-S-PF - Circular Firma F3 ocr.pdf",
    "1er Trimestre",
    "Dionisio PF",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Circular%20Firma%20F3%20ocr.pdf",
    },
  ],
  [
    "DAF-S-PF - reporte mir antpry 2025.pdf",
    "1er Trimestre",
    "Dionisio PF",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/reporte%20mir%20antpry%202025.pdf",
    },
  ],
  [
    "DAB - ACTIV_1ER_TRIM DIR_ABASTO Y PLANTAS OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/ACTIV_1ER_TRIM%20DIR_ABASTO%20Y%20PLANTAS%20OCR.pdf",
    },
  ],
  [
    "DAB - GRAFICA 1ER. TRIM_ABASTECIMIENTO DE VOLÚMEN DE AGUA REQUERIDO OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/GRAFICA%201ER.%20TRIM_ABASTECIMIENTO%20DE%20VOLÚMEN%20DE%20AGUA%20REQUERIDO%20OCR.pdf",
    },
  ],
  [
    "DAB - INDIC_ 1ER_TRIM DIR_ABASTO Y PLANTAS.pdf",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/INDIC_%201ER_TRIM%20DIR_ABASTO%20Y%20PLANTAS.pdf",
    },
  ],
  [
    "DAB - ABASTO Y PLANTAS 1ER. TRIMES_MIR OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/ABASTO%20Y%20PLANTAS%201ER.%20TRIMES_MIR%20OCR.pdf",
    },
  ],
  [
    "DAB - ABASTO Y PLANTAS_1ER. TRIMES_POA OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/ABASTO%20Y%20PLANTAS_1ER.%20TRIMES_POA%20OCR.pdf",
    },
  ],
  [
    "DAB - DIRECCIÓN ABASTO Y PLANTAS MIR_1ER_TRIMESTRE .pdf",
    "1er Trimestre",
    "Joana Paz DAB",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/DIRECCIÓN%20ABASTO%20Y%20PLANTAS%20MIR_1ER_TRIMESTRE%20.pdf",
    },
  ],
  [
    "DAB - DIRECCIÓN ABASTO Y PLANTAS POA_1ER_TRIMESTRE .pdf",
    "1er Trimestre",
    "Joana Paz DAB",
    "01-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAB/DIRECCIÓN%20ABASTO%20Y%20PLANTAS%20POA_1ER_TRIMESTRE%20.pdf",
    },
  ],
  [
    "DAF-S-PCF - CALENDARIO DE CIERRE MENSUAL 2025.docx",
    "1er Trimestre",
    "Fredy Pacheco DAF",
    "02-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/CALENDARIO%20DE%20CIERRE%20MENSUAL%202025.docx",
    },
  ],
  [
    "DAF-S-PCF - CALENDARIO DE CIERRE MENSUAL 2025.pdf",
    "1er Trimestre",
    "Fredy Pacheco DAF",
    "02-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/CALENDARIO%20DE%20CIERRE%20MENSUAL%202025.pdf",
    },
  ],
  [
    "DAF-S-PCF - CALENDARIO DE CIERRE 2025.pdf",
    "1er Trimestre",
    "Freddy Montano",
    "02-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/CALENDARIO%20DE%20CIERRE%202025.pdf",
    },
  ],
  [
    "DG-S-COMU - Comunicacion1.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "02-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DG-S-COMU/Comunicacion1.pdf",
    },
  ],
  [
    "DG-S-COMU - Comunicacion2.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "02-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DG-S-COMU/Comunicacion2.pdf",
    },
  ],
  [
    "DAF-S-PF - DICTAMEN EJERCICIO 2024_0001.pdf",
    "1er Trimestre",
    "Mirella PF",
    "03-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/DICTAMEN%20EJERCICIO%202024_0001.pdf",
    },
  ],
  [
    "DAF-S-PF - Estados Financieros 2024_0001.pdf",
    "1er Trimestre",
    "Mirella PF",
    "03-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Estados%20Financieros%202024_0001.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-004-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Convenio%20DAJ-004-2025.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00050820250403150326.pdf",
    "1er Trimestre",
    "Arid COMU",
    "04-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DG-S-COMU/doc00050820250403150326.pdf",
    },
  ],
  [
    "DG-S-COMU - Comunicacion3.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "04-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DG-S-COMU/Comunicacion3.pdf",
    },
  ],
  [
    "DG-S-COMU - Comunicacion4.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "04-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DG-S-COMU/Comunicacion4.pdf",
    },
  ],
  [
    "DAJ - Reporte de Subsidios Ene - Mar 2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Reporte%20de%20Subsidios%20Ene%20-%20Mar%202025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-004-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-004-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-005-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-005-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-007-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-007-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-008-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-008-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-010-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-010-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-011-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-011-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-012-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-012-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-013-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-013-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-014-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-014-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-028-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-028-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-029-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-029-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-031-2025.pdf",
    "1er Trimestre",
    "Jorge Juridicoo",
    "10-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-031-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-001-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-001-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-002-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-002-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-015-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-015-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-016-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-016-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-017-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-017-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-018-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-018-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-020-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-020-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-021-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-021-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-022-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-022-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-023-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-023-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-024-2025.pdf",
    "1er Trimestre",
    "Jorge Daniell",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-024-2025.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado de Variacion Hacienda.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20de%20Variacion%20Hacienda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. h) Pasivos Contingentes.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20h)%20Pasivos%20Contingentes.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Edos Financieros.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Edos%20Financieros.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. a) EAI con excedentes.xls",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20a)%20EAI%20con%20excedentes.xls",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1 EAEPE Clasificación Administrativa.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.1%20EAEPE%20Clasificación%20Administrativa.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2 EAEPE Identificado por Ramo.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20EAEPE%20Identificado%20por%20Ramo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. EAEPE Clasificación Económica-Tipo de Gasto.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%202.%20EAEPE%20Clasificación%20Económica-Tipo%20de%20Gasto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. EAEPE COG (Capitulo y Concepto).xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%203.%20EAEPE%20COG%20(Capitulo%20y%20Concepto).xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. EAEPE Clasificación Funcional.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%204.%20EAEPE%20Clasificación%20Funcional.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. d) Interes de la Deuda.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20d)%20Interes%20de%20la%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo de Fondos.xlsx",
    "1er Trimestre",
    "Blanca Trinajeros",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20de%20Fondos.xlsx",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoria programática (1).xlsx",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programática%20(1).xlsx",
    },
  ],
  [
    "DAF-S-PF - GASTO_POR_CATEGORIA_PROGRAMATICA.pdf",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/GASTO_POR_CATEGORIA_PROGRAMATICA.pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de resultados_2025.xlsx",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados_2025.xlsx",
    },
  ],
  [
    "DAF-S-PF - INICADORES_DE_RESULTADOS.pdf",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/INICADORES_DE_RESULTADOS.pdf",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversión (1).xlsx",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión%20(1).xlsx",
    },
  ],
  [
    "DAF-S-PF - PROGRAMAS_Y_PROYECTOS_DE_INVERSION.pdf",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/PROGRAMAS_Y_PROYECTOS_DE_INVERSION.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda Publica.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda%20Publica.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda y otros Pasivos.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda%20y%20otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. h) Informe sobre Pasivos Contingentes.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20sobre%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Estados Financieros.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) Estado Ingresos Excedentes.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20a)%20Estado%20Ingresos%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1. Estado Egresos Clasificacion Administrativa.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.1.%20Estado%20Egresos%20Clasificacion%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2. Estado Egresos Identificado Ramo.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.2.%20Estado%20Egresos%20Identificado%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. Estado Egresos Clasificacion Economica.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Clasificacion%20Economica.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. Estado Egresos COG.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20COG.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. Estado Egresos Clasificacion Funcional.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Clasificacion%20Funcional.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses Deuda.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo Fondos.pdf",
    "1er Trimestre",
    "Blanca",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20Fondos.pdf",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoria programatica link.pdf",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programatica%20link.pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de Resultasdos link.pdf",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Indicadores%20de%20Resultasdos%20link.pdf",
    },
  ],
  [
    "DAF-S-PF - Programas y Proyectos de Inversión link.pdf",
    "1er Trimestre",
    "Marisol",
    "21-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PF/Programas%20y%20Proyectos%20de%20Inversión%20link.pdf",
    },
  ],
  [
    "DAF-S-PCF - JGSO 12.13 ESTADO ANALITICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS - CLASIFICACIÓN POR OBJETO DEL GASTO CAP Y CONC.pdf",
    "1er Trimestre",
    "Iveth Hernandez Pasten",
    "23-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/JGSO%2012.13%20ESTADO%20ANALITICO%20DEL%20EJERCICIO%20DEL%20PRESUPUESTO%20DE%20EGRESOS%20-%20CLASIFICACIÓN%20POR%20OBJETO%20DEL%20GASTO%20CAP%20Y%20CONC.pdf",
    },
  ],
  [
    "DAJ - NAVISTAR, CAMION PIPA 2018.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "24-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/NAVISTAR,%20CAMION%20PIPA%202018.pdf",
    },
  ],
  [
    "DAJ - NP300, AÑO 2014.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "24-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/NP300,%20AÑO%202014.pdf",
    },
  ],
  [
    "DAJ - SILVERADO 1500, AÑO 2007.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "24-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/SILVERADO%201500,%20AÑO%202007.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250203001.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "25-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250203001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250303002.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "25-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250303002.pdf",
    },
  ],
  [
    "DAF-S-PCF - Estados Presupuestables 1er trimestre 2025 CAASIM.pdf",
    "1er Trimestre",
    "Iveth Pasten",
    "25-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/Estados%20Presupuestables%201er%20trimestre%202025%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-PCF - Estados Presupuestables 1er trimestre 2025 CAASIM.xlsx",
    "1er Trimestre",
    "Iveth Pasten",
    "25-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/Estados%20Presupuestables%201er%20trimestre%202025%20CAASIM.xlsx",
    },
  ],
  [
    "DAF-S-PCF - Trasparencia-presupuesto.pdf",
    "1er Trimestre",
    "Iveth ",
    "29-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/Trasparencia-presupuesto.pdf",
    },
  ],
  [
    "DAF-S-PCF - Edo analitico ingresos 1T-2025.xlsx",
    "1er Trimestre",
    "Amparo Flores",
    "29-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/Edo%20analitico%20ingresos%201T-2025.xlsx",
    },
  ],
  [
    "DAF-S-PCF - Edo analitico ingresos 1T-2025_.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "29-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/Edo%20analitico%20ingresos%201T-2025_.pdf",
    },
  ],
  [
    "DAF-S-PCF - Edo analitico ingresos.pdf",
    "1er Trimestre",
    "Amparoo Flores",
    "29-04-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/Edo%20analitico%20ingresos.pdf",
    },
  ],
  [
    "DAf-S-RM - PEDIDO PSN20250422001.pdf",
    "1er Trimestre",
    "Ines Flores",
    "02-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAf-S-RM/PEDIDO%20PSN20250422001.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS ARGAB Y ASOCIADOS 168-362.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20ARGAB%20Y%20ASOCIADOS%20168-362.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION 421.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20421.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION 425.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20425.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS CAMIOES LA HUERTA 483.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20CAMIOES%20LA%20HUERTA%20483.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS CTRL VEH GOB EDO HGO.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20CTRL%20VEH%20GOB%20EDO%20HGO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEMI 456-1.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEMI%20456-1.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEMI 456-2.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEMI%20456-2.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEMI 457.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEMI%20457.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250402001 CAMIONES LA HUERTA 483.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OSN20250402001%20CAMIONES%20LA%20HUERTA%20483.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250402002 CTRL VEH GOB EDO HGO.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OSN20250402002%20CTRL%20VEH%20GOB%20EDO%20HGO.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250407001 ARGAB Y ASOCIADOS 168-362.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/OSN20250407001%20ARGAB%20Y%20ASOCIADOS%20168-362.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250402001 AUTONATION 421.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250402001%20AUTONATION%20421.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250414001 GEMI 456-1.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250414001%20GEMI%20456-1.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250415001 AUTONATION 425.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250415001%20AUTONATION%20425.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250416005 GEMI 456-2.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250416005%20GEMI%20456-2.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250421001 GEMI 457.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RM/PSN20250421001%20GEMI%20457.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-055-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-055-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-065-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-065-2025.pdf",
    },
  ],
  [
    "DAF-S-PCF - CUENTA PÚBLICA CONSOLIDADA 2024.doc",
    "1er Trimestre",
    "Freddy Dr",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/CUENTA%20PÚBLICA%20CONSOLIDADA%202024.doc",
    },
  ],
  [
    "DAF-S-PCF - CUENTA PÚBLICA CONSOLIDADA 2024.xlsx",
    "1er Trimestre",
    "Freddy Dr",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/CUENTA%20PÚBLICA%20CONSOLIDADA%202024.xlsx",
    },
  ],
  [
    "DAF-S-PCF - CUENTA PUBLICA 2024.pdf",
    "1er Trimestre",
    "Freddy",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-PCF/CUENTA%20PUBLICA%202024.pdf",
    },
  ],
  [
    "DAJ - Acuerdo que crea el CCDI de la CAASIM.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Acuerdo%20que%20crea%20el%20CCDI%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DCONS - FISICO FINANCIERO ESTATAL.pdf",
    "1er Trimestre",
    "Blanca E R M",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DCONS/FISICO%20FINANCIERO%20ESTATAL.pdf",
    },
  ],
  [
    "DCONS - FISICO FINANCIERO PROPIO.pdf",
    "1er Trimestre",
    "Blanca E R M",
    "05-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DCONS/FISICO%20FINANCIERO%20PROPIO.pdf",
    },
  ],
  [
    "DAF-s-RM - AMABEL ONTIVEROS VILLA CAASIM-DAJ-024.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/AMABEL%20ONTIVEROS%20VILLA%20CAASIM-DAJ-024.pdf",
    },
  ],
  [
    "DAF-s-RM - BRUSON SKY TRACK N52.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/BRUSON%20SKY%20TRACK%20N52.pdf",
    },
  ],
  [
    "DAF-s-RM - CESAR AMADOR DE LA FUENTE N77.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/CESAR%20AMADOR%20DE%20LA%20FUENTE%20N77.pdf",
    },
  ],
  [
    "DAF-s-RM - CLORO DE HIDALGO N63.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/CLORO%20DE%20HIDALGO%20N63.pdf",
    },
  ],
  [
    "DAF-s-RM - CONSTRUCCIONES MILCH N61.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/CONSTRUCCIONES%20MILCH%20N61.pdf",
    },
  ],
  [
    "DAF-s-RM - GRACIELA PEREZ PAULIN  CAASIM-DAJ-019.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/GRACIELA%20PEREZ%20PAULIN%20%20CAASIM-DAJ-019.pdf",
    },
  ],
  [
    "DAF-s-RM - GRUPO HIDALGUENSE DE DESARROLLO N55.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/GRUPO%20HIDALGUENSE%20DE%20DESARROLLO%20N55.pdf",
    },
  ],
  [
    "DAF-s-RM - JET VAN CAR RENTAL N56.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/JET%20VAN%20CAR%20RENTAL%20N56.pdf",
    },
  ],
  [
    "DAF-s-RM - LETICIA RODRIGUEZ CERON N57.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/LETICIA%20RODRIGUEZ%20CERON%20N57.pdf",
    },
  ],
  [
    "DAF-s-RM - MA DEL CARMEN CORTEZ CASTRO CAASIM-DAJ-018.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/MA%20DEL%20CARMEN%20CORTEZ%20CASTRO%20CAASIM-DAJ-018.pdf",
    },
  ],
  [
    "DAF-s-RM - MARA REBECA AVILA LOZADA CAASIM-DAJ-021.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/MARA%20REBECA%20AVILA%20LOZADA%20CAASIM-DAJ-021.pdf",
    },
  ],
  [
    "DAF-s-RM - QUALITAS COMPAÑIA DE SEGUROS N58.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/QUALITAS%20COMPAÑIA%20DE%20SEGUROS%20N58.pdf",
    },
  ],
  [
    "DAF-s-RM - SISTEMAS CONTINO N54.pdf",
    "1er Trimestre",
    "Licitaciones CAASIM",
    "06-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAF-s-RM/SISTEMAS%20CONTINO%20N54.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-142-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-142-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-236-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-236-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-242-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-242-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-244-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-244-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-044-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-044-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-233-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-233-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-235-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-235-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-238-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-238-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-245-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-245-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-248-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-248-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-251-2024.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "08-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-251-2024.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2029_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/2239_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3080_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3188_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3476_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3750_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3952_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/3979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4175_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/4214_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_modified.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "22-05-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/1er%20Trimestre/DAF-S-RH/846_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-019-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "27-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-019-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-025-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "27-05-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-025-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-047-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-047-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-048-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-048-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-049-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-049-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-050-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-050-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-066-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Contrato%20DAJ-066-2025.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-067-2025.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "03-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/1er%20Trimestre/DAJ/Convenio%20DAJ-067-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION 423.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20423.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION 490.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20490.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS CAMPESINO 516.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20CAMPESINO%20516.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS CAMPESINO 518.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20CAMPESINO%20518.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEMI 458.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEMI%20458.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS HUERTA 483.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20HUERTA%20483.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250429001 AUTONATION 423.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250429001%20AUTONATION%20423.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250513001 GEMI 458.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250513001%20GEMI%20458.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250513002 HUERTA 483.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250513002%20HUERTA%20483.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250513003 AUTONATION R490.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250513003%20AUTONATION%20R490.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250515001 CAMPESINO 516.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250515001%20CAMPESINO%20516.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250516002 CAMPESINO 518.pdf",
    "2do Trimestre",
    "Edgar Martinez Bautista",
    "04-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250516002%20CAMPESINO%20518.pdf",
    },
  ],
  [
    "DAJ - Decreto que reforma al Decreto de creación de la CAASIM.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "17-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Decreto%20que%20reforma%20al%20Decreto%20de%20creación%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAJ - Estatuto Orgánico de la CAASIM 2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "18-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Estatuto%20Orgánico%20de%20la%20CAASIM%202025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-006-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "20-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-006-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-009-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "20-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-009-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-036-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "20-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-036-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-038-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "20-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-038-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-046-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "20-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-046-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-034-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-034-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-039-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-039-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-045-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-045-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-060-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-060-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-061-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-061-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-062-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-062-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-063-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-063-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-067-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-067-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-072-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-072-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-073-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel Juridico",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-073-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION  DE RECURSOS CAASIM-HGO-L.O.P.-01-2025 OCR.pdf",
    "2do Trimestre",
    "David Sanchez Hernandez",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/AUTORIZACION%20%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-01-2025%20OCR.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-01-2025 OCR.pdf",
    "2do Trimestre",
    "David Sanchez Hernandez",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-01-2025%20OCR.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "2do Trimestre",
    "Maribel Butron",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "2do Trimestre",
    "Maribel Butron",
    "23-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DCONS - 126-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/126-2024.pdf",
    },
  ],
  [
    "DCONS - 127-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/127-2024.pdf",
    },
  ],
  [
    "DCONS - 128-2024 .pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/128-2024%20.pdf",
    },
  ],
  [
    "DCONS - 129-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/129-2024.pdf",
    },
  ],
  [
    "DCONS - 132-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/132-2024.pdf",
    },
  ],
  [
    "DCONS - 133-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/133-2024.pdf",
    },
  ],
  [
    "DCONS - 134-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/134-2024.pdf",
    },
  ],
  [
    "DCONS - 135-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/135-2024.pdf",
    },
  ],
  [
    "DCONS - 136-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/136-2024.pdf",
    },
  ],
  [
    "DCONS - 141-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/141-2024.pdf",
    },
  ],
  [
    "DCONS - 143-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/143-2024.pdf",
    },
  ],
  [
    "DCONS - 144-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/144-2024.pdf",
    },
  ],
  [
    "DCONS - 145-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/145-2024.pdf",
    },
  ],
  [
    "DCONS - 146-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/146-2024.pdf",
    },
  ],
  [
    "DCONS - 147-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/147-2024.pdf",
    },
  ],
  [
    "DCONS - 155-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/155-2024.pdf",
    },
  ],
  [
    "DCONS - 156-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/156-2024.pdf",
    },
  ],
  [
    "DCONS - 157-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/157-2024.pdf",
    },
  ],
  [
    "DCONS - 164-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/164-2024.pdf",
    },
  ],
  [
    "DCONS - 165-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/165-2024.pdf",
    },
  ],
  [
    "DCONS - 166-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/166-2024.pdf",
    },
  ],
  [
    "DCONS - 168-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/168-2024.pdf",
    },
  ],
  [
    "DCONS - 169-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/169-2024.pdf",
    },
  ],
  [
    "DCONS - 172-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/172-2024.pdf",
    },
  ],
  [
    "DCONS - 268-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/268-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE01-2025 Servicios de informática.pdf",
    "2do Trimestre",
    "Desconocido",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/ADPE01-2025%20Servicios%20de%20informática.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE02-2025 Mantenimiento de Vehículos.pdf",
    "2do Trimestre",
    "Desconocido",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/ADPE02-2025%20Mantenimiento%20de%20Vehículos.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AGRICOLA 516.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AGRICOLA%20516.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AGRICOLA 518.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AGRICOLA%20518.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AGRICOLA 519.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AGRICOLA%20519.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AGRICOLA 520.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AGRICOLA%20520.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AGRICOLA 525.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AGRICOLA%20525.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION 423 (1).pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20423%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION 490 (1).pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20490%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS EXTREME 4 LLANTAS 428 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20EXTREME%204%20LLANTAS%20428%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS EXTREME DOM LLANTAS 428 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20EXTREME%20DOM%20LLANTAS%20428%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS EXTREME MANTTO 428.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20EXTREME%20MANTTO%20428.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS EXTREME MANTTO 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20EXTREME%20MANTTO%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS EXTREME SERV DOM 428.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20EXTREME%20SERV%20DOM%20428.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS EXTREME SERV DOM 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20EXTREME%20SERV%20DOM%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEMI 458 (1).pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEMI%20458%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS HUERTA 483 (1).pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20HUERTA%20483%20(1).pdf",
    },
  ],
  [
    "DCONS - 1. NECESIDAD DE PROYECTO.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/1.%20NECESIDAD%20DE%20PROYECTO.pdf",
    },
  ],
  [
    "DCONS - 10. PRESENTANCION DE PROPUESTAS FAFEF 00134 2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/10.%20PRESENTANCION%20DE%20PROPUESTAS%20FAFEF%2000134%202023.pdf",
    },
  ],
  [
    "DCONS - 11. PROPUESTA ECONOMICA N19-2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/11.%20PROPUESTA%20ECONOMICA%20N19-2023.pdf",
    },
  ],
  [
    "DCONS - 11. PROPUESTA TÉCNICA PARA EVALUACÓN AACF.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/11.%20PROPUESTA%20TÉCNICA%20PARA%20EVALUACÓN%20AACF.pdf",
    },
  ],
  [
    "DCONS - 12. EVALUACIÓN TENICA.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/12.%20EVALUACIÓN%20TENICA.pdf",
    },
  ],
  [
    "DCONS - 13 EVALUACIÓN ECONÓMICA N19-2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/13%20EVALUACIÓN%20ECONÓMICA%20N19-2023.pdf",
    },
  ],
  [
    "DCONS - 14. FALLO DE LPN-19-2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/14.%20FALLO%20DE%20LPN-19-2023.pdf",
    },
  ],
  [
    "DCONS - 15. CONTRATO CAASIM DAJ177 2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/15.%20CONTRATO%20CAASIM%20DAJ177%202023.pdf",
    },
  ],
  [
    "DCONS - 16. a. CONVENIO CAASIM-MUNICIPIOS 2004.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/16.%20a.%20CONVENIO%20CAASIM-MUNICIPIOS%202004.pdf",
    },
  ],
  [
    "DCONS - 16. b. Localización geográfica del proyecto.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/16.%20b.%20Localización%20geográfica%20del%20proyecto.pdf",
    },
  ],
  [
    "DCONS - 16. c. Publicación POEH 15 Mpios atiende CAASIM.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/16.%20c.%20Publicación%20POEH%2015%20Mpios%20atiende%20CAASIM.pdf",
    },
  ],
  [
    "DCONS - 17. MANUAL DE OPERACIÓN PARA BACHEO.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/17.%20MANUAL%20DE%20OPERACIÓN%20PARA%20BACHEO.pdf",
    },
  ],
  [
    "DCONS - 18. Factura 1; Mezcla.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/18.%20Factura%201;%20Mezcla.pdf",
    },
  ],
  [
    "DCONS - 19. Factura 2; Agregados.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/19.%20Factura%202;%20Agregados.pdf",
    },
  ],
  [
    "DCONS - 2. PLANEACIÓN (CARTERA DE PROYECTOS 1173 30-03-23).pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/2.%20PLANEACIÓN%20(CARTERA%20DE%20PROYECTOS%201173%2030-03-23).pdf",
    },
  ],
  [
    "DCONS - 20. Factura 3; Mezcla.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/20.%20Factura%203;%20Mezcla.pdf",
    },
  ],
  [
    "DCONS - 21. Factura 4; Agregados.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/21.%20Factura%204;%20Agregados.pdf",
    },
  ],
  [
    "DCONS - 22. Factura 5; Mezcla.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/22.%20Factura%205;%20Mezcla.pdf",
    },
  ],
  [
    "DCONS - 23. Factura 6;  Agregados.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/23.%20Factura%206;%20%20Agregados.pdf",
    },
  ],
  [
    "DCONS - 24. Solicitud de proveedor para ampliar plazo.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/24.%20Solicitud%20de%20proveedor%20para%20ampliar%20plazo.pdf",
    },
  ],
  [
    "DCONS - 25. Solicitud de DC a DAF para ampiar plazo .pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/25.%20Solicitud%20de%20DC%20a%20DAF%20para%20ampiar%20plazo%20.pdf",
    },
  ],
  [
    "DCONS - 26. Dictamen Técnico para justificar la modificación de plazo.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/26.%20Dictamen%20Técnico%20para%20justificar%20la%20modificación%20de%20plazo.pdf",
    },
  ],
  [
    "DCONS - 26. Factura 7; Mezcla.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/26.%20Factura%207;%20Mezcla.pdf",
    },
  ],
  [
    "DCONS - 27. Factura 8; Agregados.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/27.%20Factura%208;%20Agregados.pdf",
    },
  ],
  [
    "DCONS - 28. Dictamen Técnico para justificar la modificación de plazo.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/28.%20Dictamen%20Técnico%20para%20justificar%20la%20modificación%20de%20plazo.pdf",
    },
  ],
  [
    "DCONS - 29. CONVENIO DE AMPLIACIÓN CAASIM 64 2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/29.%20CONVENIO%20DE%20AMPLIACIÓN%20CAASIM%2064%202023.pdf",
    },
  ],
  [
    "DCONS - 3. PRECIOS VALIDADOS.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/3.%20PRECIOS%20VALIDADOS.pdf",
    },
  ],
  [
    "DCONS - 30. Factura 9; Mezcla.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/30.%20Factura%209;%20Mezcla.pdf",
    },
  ],
  [
    "DCONS - 31. Factura 10; Agregados.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/31.%20Factura%2010;%20Agregados.pdf",
    },
  ],
  [
    "DCONS - 32. Factura 11; Mezcla.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/32.%20Factura%2011;%20Mezcla.pdf",
    },
  ],
  [
    "DCONS - 33. Factura 12; Agregados.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/33.%20Factura%2012;%20Agregados.pdf",
    },
  ],
  [
    "DCONS - 34. Solicitud al proveedor de convenio para la modificación de metas.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/34.%20Solicitud%20al%20proveedor%20de%20convenio%20para%20la%20modificación%20de%20metas.pdf",
    },
  ],
  [
    "DCONS - 35. Contestación de proveedor para modificación de metas.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/35.%20Contestación%20de%20proveedor%20para%20modificación%20de%20metas.pdf",
    },
  ],
  [
    "DCONS - 36. Solicitud a la DAF para convenio modificatorio de metas.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/36.%20Solicitud%20a%20la%20DAF%20para%20convenio%20modificatorio%20de%20metas.pdf",
    },
  ],
  [
    "DCONS - 37. CONVENIO MODIFICATORIO CAASIM DAJ 012.2024.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/37.%20CONVENIO%20MODIFICATORIO%20CAASIM%20DAJ%20012.2024.pdf",
    },
  ],
  [
    "DCONS - 37. Factura 13; Agregados.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/37.%20Factura%2013;%20Agregados.pdf",
    },
  ],
  [
    "DCONS - 39. Solicitud de la DC a la DAF para convenio modificatorio de monto.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/39.%20Solicitud%20de%20la%20DC%20a%20la%20DAF%20para%20convenio%20modificatorio%20de%20monto.pdf",
    },
  ],
  [
    "DCONS - 4. DICTAMEN DE FACTIBILIDAD MATERIALES BACHEO.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/4.%20DICTAMEN%20DE%20FACTIBILIDAD%20MATERIALES%20BACHEO.pdf",
    },
  ],
  [
    "DCONS - 40. Factura 14; Mezcla.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/40.%20Factura%2014;%20Mezcla.pdf",
    },
  ],
  [
    "DCONS - 41. DICTAMEN FINAL M2 00135.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/41.%20DICTAMEN%20FINAL%20M2%2000135.pdf",
    },
  ],
  [
    "DCONS - 42. CONVENIO MODIFICATORIO CAASIM-DAJ-056-2024 2 centavos.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/42.%20CONVENIO%20MODIFICATORIO%20CAASIM-DAJ-056-2024%202%20centavos.pdf",
    },
  ],
  [
    "DCONS - 43. Cierre (comendio de facturas).pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/43.%20Cierre%20(comendio%20de%20facturas).pdf",
    },
  ],
  [
    "DCONS - 5. OFICIO DE AUTORIZACIÓN.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/5.%20OFICIO%20DE%20AUTORIZACIÓN.pdf",
    },
  ],
  [
    "DCONS - 6. Solicitud para tramite de adquisición.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/6.%20Solicitud%20para%20tramite%20de%20adquisición.pdf",
    },
  ],
  [
    "DCONS - 7. PUBLICACIÓN DE CONVOCATORIO N19-2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/7.%20PUBLICACIÓN%20DE%20CONVOCATORIO%20N19-2023.pdf",
    },
  ],
  [
    "DCONS - 8. BASES DE LICITACIÓN N19-2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/8.%20BASES%20DE%20LICITACIÓN%20N19-2023.pdf",
    },
  ],
  [
    "DCONS - 9. JUNTA DE ACLARACIONES LPN-EA-913005999-N19-2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/9.%20JUNTA%20DE%20ACLARACIONES%20LPN-EA-913005999-N19-2023.pdf",
    },
  ],
  [
    "DCONS - Línea de tiempo FAFEF 00135 2023.pdf",
    "2do Trimestre",
    "Marai DCONS",
    "24-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/Línea%20de%20tiempo%20FAFEF%2000135%202023.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA AXEL (1).pdf",
    "2do Trimestre",
    "Alejandra Novia del Artur",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURA%20AXEL%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA MARPA 1 (1).pdf",
    "2do Trimestre",
    "Alejandra Novia del Artur",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURA%20MARPA%201%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA MARPA 2 (1).pdf",
    "2do Trimestre",
    "Alejandra Novia del Artur",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURA%20MARPA%202%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA AXEL (1) (1).pdf",
    "2do Trimestre",
    "Alejandra Novia del Artur",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SUFICIENCIA%20AXEL%20(1)%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA MARPA 1 (1) (1).pdf",
    "2do Trimestre",
    "Alejandra Novia del Artur",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SUFICIENCIA%20MARPA%201%20(1)%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA MARPA 2 (1) (1).pdf",
    "2do Trimestre",
    "Alejandra Novia del Artur",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SUFICIENCIA%20MARPA%202%20(1)%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - CASA SUSY.pdf",
    "2do Trimestre",
    "Ines Flores",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/CASA%20SUSY.pdf",
    },
  ],
  [
    "DAF-S-RM - CONSORCIO ESVICMEX.pdf",
    "2do Trimestre",
    "Ines Flores",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/CONSORCIO%20ESVICMEX.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-0109-2025 REFACCIONES.pdf",
    "2do Trimestre",
    "Ines Flores",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-0109-2025%20REFACCIONES.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-76-2025 EQ. COMPUTO.pdf",
    "2do Trimestre",
    "Ines Flores",
    "25-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-76-2025%20EQ.%20COMPUTO.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura Carei.pdf",
    "2do Trimestre",
    "Dulce SG",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/Factura%20Carei.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-0107-2025.pdf",
    "2do Trimestre",
    "Dulce SG",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-0107-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-069-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-069-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-072-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-072-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-077-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-077-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura Carei OCR.pdf",
    "2do Trimestre",
    "Dulce RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/Factura%20Carei%20OCR.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-0107-2025 OCR.pdf",
    "2do Trimestre",
    "Dulce RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-0107-2025%20OCR.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250429001 AUTONATION 423 (1).pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250429001%20AUTONATION%20423%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250513001 GEMI 458 (1).pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250513001%20GEMI%20458%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250513002 HUERTA 483 (1).pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250513002%20HUERTA%20483%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250513003 AUTONATION 490.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250513003%20AUTONATION%20490.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250515001 AGRICOLA 516.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250515001%20AGRICOLA%20516.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250516002 AGRICOLA 518.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250516002%20AGRICOLA%20518.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250529002 AGRICOLA 519.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250529002%20AGRICOLA%20519.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250529003 AGRICOLA 520.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250529003%20AGRICOLA%20520.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250529004 AGRICOLA 525.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250529004%20AGRICOLA%20525.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250602001 EXTREME MANTTO 428.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250602001%20EXTREME%20MANTTO%20428.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250602002 EXTREME SERV DOM 428.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250602002%20EXTREME%20SERV%20DOM%20428.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250602003 EXTREME MANTTO 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250602003%20EXTREME%20MANTTO%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250602004 EXTREME SERV DOM 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250602004%20EXTREME%20SERV%20DOM%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250602005 EXTREME DOM LLANTAS 428 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250602005%20EXTREME%20DOM%20LLANTAS%20428%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250609001 EXTREME 4 LLANTAS 428 429.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250609001%20EXTREME%204%20LLANTAS%20428%20429.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS GOB EDO 404.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20GOB%20EDO%20404.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS GOB EDO 473.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20GOB%20EDO%20473.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS GOB EDO BAJA 16 VEH..pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20GOB%20EDO%20BAJA%2016%20VEH..pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS GOB EDO BAJA 27 VEH..pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20GOB%20EDO%20BAJA%2027%20VEH..pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS GOB EDO CONTROL VEH. 15 VEH..pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20GOB%20EDO%20CONTROL%20VEH.%2015%20VEH..pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250624001 GOB EDO 404.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OSN20250624001%20GOB%20EDO%20404.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250620001 GOB EDO 473.pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250620001%20GOB%20EDO%20473.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250624001 GOB EDO BAJA 16 VEH..pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250624001%20GOB%20EDO%20BAJA%2016%20VEH..pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250624002 GOB EDO BAJA 27 VEH..pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250624002%20GOB%20EDO%20BAJA%2027%20VEH..pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250624003 GOB EDO CONTROL VEH. 15 VEH..pdf",
    "2do Trimestre",
    "Edgar Martinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250624003%20GOB%20EDO%20CONTROL%20VEH.%2015%20VEH..pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA GRACIELA PEREZ ENE-JUN.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURA%20GRACIELA%20PEREZ%20ENE-JUN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AMABEL ONTIVEROS ENE-JUN.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20AMABEL%20ONTIVEROS%20ENE-JUN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ARRENDAMIENTO EDUARDO BAÑOS ENE-JUN.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20ARRENDAMIENTO%20EDUARDO%20BAÑOS%20ENE-JUN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AURORA GARCIA ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20AURORA%20GARCIA%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS CARLOS IBARRA ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20CARLOS%20IBARRA%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS CUSTODIOS ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20CUSTODIOS%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GRUPO ARCODEM ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20GRUPO%20ARCODEM%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS JULIETA CABRERA ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20JULIETA%20CABRERA%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MA. DEL CARMEN CORTEZ ENE-JUN.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20MA.%20DEL%20CARMEN%20CORTEZ%20ENE-JUN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MANT EDUARDO BAÑOS ENE-JUN.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20MANT%20EDUARDO%20BAÑOS%20ENE-JUN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MARA REBECA AVILA ENE-JUN.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20MARA%20REBECA%20AVILA%20ENE-JUN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MARIA DEL CARMEN PARRA ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20MARIA%20DEL%20CARMEN%20PARRA%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS NORBERTO SILVA ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20NORBERTO%20SILVA%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ODILON GEMPO ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20ODILON%20GEMPO%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS POLICIA HIDRICA ENE-JUN (1).pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURAS%20POLICIA%20HIDRICA%20ENE-JUN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250402002.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250402002.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250502001.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250502001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250602006.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PSN20250602006.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-070-2025.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-070-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-090-2025.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-090-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-110-2025.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-110-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX FAC ABRIL.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/TELMEX%20FAC%20ABRIL.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX FAC JUNIO.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/TELMEX%20FAC%20JUNIO.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX FAC MAYO.pdf",
    "2do Trimestre",
    "Sandy RM",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/TELMEX%20FAC%20MAYO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS ARGAB 437.pdf",
    "2do Trimestre",
    "Edgar MArtinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20ARGAB%20437.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250619001 ARGAB 437.pdf",
    "2do Trimestre",
    "Edgar MArtinez",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OSN20250619001%20ARGAB%20437.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA BLANCA CECILIA ENE-JUN (2).pdf",
    "2do Trimestre",
    "SAndy",
    "26-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FACTURA%20BLANCA%20CECILIA%20ENE-JUN%20(2).pdf",
    },
  ],
  [
    "DAF-S-RH - 1008_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/1008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/1022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1816_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/1816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1850_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/1850_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1853_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/1853_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/1979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/1992_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2029_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2093_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2093_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2239_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2261_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 228_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2391_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2391_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2420_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2456_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2457_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2465_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2483_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2489_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2492_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2492_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2538_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2538_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2547_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2547_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2556_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2556_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 256_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/256_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2560_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2560_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2566_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2566_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2567_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2567_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2579_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2581_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2581_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2603_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2631_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2647_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2647_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2655_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2655_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2677_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2677_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2706_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2706_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2734_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2734_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2771_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2771_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2855_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2863_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2863_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2885_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2885_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2886_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2903_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2903_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2914_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2919_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2957_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2957_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2971_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2971_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2980_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2980_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/2989_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3000_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3001_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3001_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3011_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3012_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3026_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3027_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3027_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3032_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3032_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3080_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3088_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3088_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3104_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3105_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3106_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3138_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3161_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3166_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3166_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3188_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3197_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3197_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3211_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3213_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3289_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3321_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3321_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3334_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3338_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3358_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3366_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3389_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 339_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/339_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3390_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3398_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3406_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3406_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3449_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3455_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3455_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3475_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3475_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3476_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 349_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/349_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3511_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3521_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3521_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3526_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3583_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3598_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3609_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3610_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3625_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3625_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3628_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3699_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3725_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3726_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3726_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3727_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3733_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3733_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3735_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3735_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3750_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3756_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3756_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 376_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3772_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3778_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3828_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3835_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3878_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3890_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3890_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3893_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3918_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3931_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3952_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3953_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3960_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3961_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3961_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3962_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3962_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3967_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3967_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3970_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3970_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3978_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3978_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3983_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3984_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/3988_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4010_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4010_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4017_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4019_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4019_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4033_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4033_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4036_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4039_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4043_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4043_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4050_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4086_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4086_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4095_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4149_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4149_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4154_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4154_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4155_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4155_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4156_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4156_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4157_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4159_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4159_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4160_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4160_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4161_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4162_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4162_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4167_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4167_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4168_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4170_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4170_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4174_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4174_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4175_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4177_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4177_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4178_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4178_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4179_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4181_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4181_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4182_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4183_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4183_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4184_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4184_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4185_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4185_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4186_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4186_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4187_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4189_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4189_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4193_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4198_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4206_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4206_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4212_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4212_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4214_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4215_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4215_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4219_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4219_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4221_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4225_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4230_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4230_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4235_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4238_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4242_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4248_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4249_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4253_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4263_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4263_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4265_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4271_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4275_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4275_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4276_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4276_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4281_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4282_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4286_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4286_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4289_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4293_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4296_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4298_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4299_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4303_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4303_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4325_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4325_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4332_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4336_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4336_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4357_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4357_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4360_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4360_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4362_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4362_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4372_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4381_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4381_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4387_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4387_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4388_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4393_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4404_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4404_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4408_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4408_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4413_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4413_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4414_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4414_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4415_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4416_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4416_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4417_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4417_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4418_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4418_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4434_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4434_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4439_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4439_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4445_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4445_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4458_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4458_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4462_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4462_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4479_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4479_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4484_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/4484_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 794_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/794_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/846_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 873_modified.pdf_Caratula.pdf",
    "2do Trimestre",
    "Monica Yezmin Hernandez",
    "26-06-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/873_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00134920250626152241.pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/doc00134920250626152241.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00135020250626152622.pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/doc00135020250626152622.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00135120250626152800.pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/doc00135120250626152800.pdf",
    },
  ],
  [
    "DG-S-COMU - Pedido_Servicio_PSN20250522001 (1) (1).pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/Pedido_Servicio_PSN20250522001%20(1)%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - Pedido_Servicio_PSN20250617001 (1) (1) (1).pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/Pedido_Servicio_PSN20250617001%20(1)%20(1)%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - Pedido_Servicio_PSN20250617001 (1) (1).pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/Pedido_Servicio_PSN20250617001%20(1)%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura_1001_565C9103-07A4-4C03-9B03-16776836601F (2) (1).pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/RORA5504099D6_Factura_1001_565C9103-07A4-4C03-9B03-16776836601F%20(2)%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura_994_E6FC49E1-4D96-4CEA-90B5-10FC04184060 (3).pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/RORA5504099D6_Factura_994_E6FC49E1-4D96-4CEA-90B5-10FC04184060%20(3).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura_998_80CA372B-C49B-4234-A7D2-267804A2C157 (1).pdf",
    "2do Trimestre",
    "Arid Garcia",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/RORA5504099D6_Factura_998_80CA372B-C49B-4234-A7D2-267804A2C157%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - Informe Director General enero-marzo 2025.pdf",
    "2do Trimestre",
    "Bibiana Limon",
    "27-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/Informe%20Director%20General%20enero-marzo%202025.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00137320250627163411 (1).pdf",
    "2do Trimestre",
    "Erick Parra",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/doc00137320250627163411%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - doc00138120250630103509.pdf",
    "2do Trimestre",
    "Erick Parra",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/doc00138120250630103509.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00137220250627163204.pdf",
    "2do Trimestre",
    "Erick PArra",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/doc00137220250627163204.pdf",
    },
  ],
  [
    "DG-S-COMU - platicas2trimestre.pdf",
    "2do Trimestre",
    "Erick Parra",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DG-S-COMU/platicas2trimestre.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM (1).pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM%20(1).pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura 2024 CAASIM.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F02b_Estructura%202024%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Abasto.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Abasto.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Admon.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Admon.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Atencion .pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Atencion%20.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Comercial.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Comercial.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. General.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20General.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Gestión.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Gestión.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Infraestructura.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Infraestructura.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Juridico.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Juridico.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. para Llevar.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20para%20Llevar.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Tics.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Tics.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Estatuto organico.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf",
    },
  ],
  [
    "DAF-S-RH - F08_Tabulador.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F08_Tabulador.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Condiciones Generales de Trabajo 2024-2025.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202024-2025.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Manual de Recursos Humano.pdf",
    "2do Trimestre",
    "Nancy RH",
    "30-06-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION VESTUARIO.pdf",
    "2do Trimestre",
    "Maria Fernanda",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/AUTORIZACION%20VESTUARIO.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN VESTUARIO.pdf",
    "2do Trimestre",
    "Maria Fernanda",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/DICTAMEN%20VESTUARIO.pdf",
    },
  ],
  [
    "DAB - SOLICITUD DESCARGA DOMICILIARIA.docx",
    "2do Trimestre",
    "Joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/SOLICITUD%20DESCARGA%20DOMICILIARIA.docx",
    },
  ],
  [
    "DAB - SOLICITUD DESCARGA DOMICILIARIA.pdf",
    "2do Trimestre",
    "Joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/SOLICITUD%20DESCARGA%20DOMICILIARIA.pdf",
    },
  ],
  [
    "DAF-S-RM - SOLICITUD DESCARGA DOMICILIARIA.docx",
    "2do Trimestre",
    "Blanca ERM",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SOLICITUD%20DESCARGA%20DOMICILIARIA.docx",
    },
  ],
  [
    "DAF-S-RM - SOLICITUD DESCARGA DOMICILIARIA.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SOLICITUD%20DESCARGA%20DOMICILIARIA.pdf",
    },
  ],
  [
    "DAB - 3ER. TRIM_MIR DIR_ABASTO Y PTARS OCR.pdf",
    "2do Trimestre",
    "Joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/3ER.%20TRIM_MIR%20DIR_ABASTO%20Y%20PTARS%20OCR.pdf",
    },
  ],
  [
    "DAB - 3ER. TRIM_POA DIR_ABASTO Y PTARS OCR.pdf",
    "2do Trimestre",
    "Joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/3ER.%20TRIM_POA%20DIR_ABASTO%20Y%20PTARS%20OCR.pdf",
    },
  ],
  [
    "DAB - GRAFICA 2DO. TRIM_ DIR_ABASTO Y PTARS_ORC.pdf",
    "2do Trimestre",
    "Joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/GRAFICA%202DO.%20TRIM_%20DIR_ABASTO%20Y%20PTARS_ORC.pdf",
    },
  ],
  [
    "DAB - MIR DIR_ABASTO Y PTARS EXCEL.xls",
    "2do Trimestre",
    "Joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/MIR%20DIR_ABASTO%20Y%20PTARS%20EXCEL.xls",
    },
  ],
  [
    "DAB - POA  DIR_ABASTO Y PTARS EXCEL.xls",
    "2do Trimestre",
    "Joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/POA%20%20DIR_ABASTO%20Y%20PTARS%20EXCEL.xls",
    },
  ],
  [
    "DAB - MIR DIR_ABASTO Y PTARS 2DO. TRIMESTRE 2025.pdf",
    "2do Trimestre",
    "joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/MIR%20DIR_ABASTO%20Y%20PTARS%202DO.%20TRIMESTRE%202025.pdf",
    },
  ],
  [
    "DAB - POA DIR_ABASTO Y PTARS 2DO.TRIMESTRE 2025.pdf",
    "2do Trimestre",
    "joana Abasto",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAB/POA%20DIR_ABASTO%20Y%20PTARS%202DO.TRIMESTRE%202025.pdf",
    },
  ],
  [
    "DAF-S-RM - FORMATOS DE LINKS FORMATOS UTILIZADOS.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/FORMATOS%20DE%20LINKS%20FORMATOS%20UTILIZADOS.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-068-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-068-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-071-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "01-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-071-2025.pdf",
    },
  ],
  [
    "DAF-S-RH - DAF.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DAF.pdf",
    },
  ],
  [
    "DAF-S-RH - DAJ.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DAJ.pdf",
    },
  ],
  [
    "DAF-S-RH - DAP.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DAP.pdf",
    },
  ],
  [
    "DAF-S-RH - DAyPT.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DAyPT.pdf",
    },
  ],
  [
    "DAF-S-RH - DC.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DC.pdf",
    },
  ],
  [
    "DAF-S-RH - DGVyFPT.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DGVyFPT.pdf",
    },
  ],
  [
    "DAF-S-RH - DIU.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DIU.pdf",
    },
  ],
  [
    "DAF-S-RH - DpLLAP.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DpLLAP.pdf",
    },
  ],
  [
    "DAF-S-RH - DTIC´s.pdf",
    "2do Trimestre",
    "Nancy RH",
    "02-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RH/DTIC´s.pdf",
    },
  ],
  [
    "DCONS - CAASIM DAJ-064-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM%20DAJ-064-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-094-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-094-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-095-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-095-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-097-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-097-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-100-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-100-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-109-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-109-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-115-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-115-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-116-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-116-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-120-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-120-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-137-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-137-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-138-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-138-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-139-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-139-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-149-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-149-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-150-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-150-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-175-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-175-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-176-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-176-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-177-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-177-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-191-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-191-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-192-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-192-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-193-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-193-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-196-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-196-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-197-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-197-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-209-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-209-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-213-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-213-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-214-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-214-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-215-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-215-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-216-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-216-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-217-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-217-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-229-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-229-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-230-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "07-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/CAASIM-DAJ-230-2024.pdf",
    },
  ],
  [
    "DCONS - 126-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/126-2024.pdf",
    },
  ],
  [
    "DCONS - 127-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/127-2024.pdf",
    },
  ],
  [
    "DCONS - 128-2024 .pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/128-2024%20.pdf",
    },
  ],
  [
    "DCONS - 129-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/129-2024.pdf",
    },
  ],
  [
    "DCONS - 132-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/132-2024.pdf",
    },
  ],
  [
    "DCONS - 133-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/133-2024.pdf",
    },
  ],
  [
    "DCONS - 134-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/134-2024.pdf",
    },
  ],
  [
    "DCONS - 135-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/135-2024.pdf",
    },
  ],
  [
    "DCONS - 136-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/136-2024.pdf",
    },
  ],
  [
    "DCONS - 141-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/141-2024.pdf",
    },
  ],
  [
    "DCONS - 143-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/143-2024.pdf",
    },
  ],
  [
    "DCONS - 144-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/144-2024.pdf",
    },
  ],
  [
    "DCONS - 145-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/145-2024.pdf",
    },
  ],
  [
    "DCONS - 146-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/146-2024.pdf",
    },
  ],
  [
    "DCONS - 147-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/147-2024.pdf",
    },
  ],
  [
    "DCONS - 155-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/155-2024.pdf",
    },
  ],
  [
    "DCONS - 156-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/156-2024.pdf",
    },
  ],
  [
    "DCONS - 157-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/157-2024.pdf",
    },
  ],
  [
    "DCONS - 164-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/164-2024.pdf",
    },
  ],
  [
    "DCONS - 165-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/165-2024.pdf",
    },
  ],
  [
    "DCONS - 166-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/166-2024.pdf",
    },
  ],
  [
    "DCONS - 168-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/168-2024.pdf",
    },
  ],
  [
    "DCONS - 169-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/169-2024.pdf",
    },
  ],
  [
    "DCONS - 172-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/172-2024.pdf",
    },
  ],
  [
    "DCONS - 268-2024.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "08-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/268-2024.pdf",
    },
  ],
  [
    "DCONS - doc04888720250710162718.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/doc04888720250710162718.pdf",
    },
  ],
  [
    "DCONS - doc04888820250710162746.pdf",
    "2do Trimestre",
    "Blanca ERM",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DCONS/doc04888820250710162746.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE01 Aselam.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/ADPE01%20Aselam.pdf",
    },
  ],
  [
    "DAF-S-RM - N69 Valdespino.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N69%20Valdespino.pdf",
    },
  ],
  [
    "DAF-S-RM - N73 SCDEN.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N73%20SCDEN.pdf",
    },
  ],
  [
    "DAF-S-RM - N74 SCDEN.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N74%20SCDEN.pdf",
    },
  ],
  [
    "DAF-S-RM - N76 3JR.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N76%203JR.pdf",
    },
  ],
  [
    "DAF-S-RM - N76 GCA.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N76%20GCA.pdf",
    },
  ],
  [
    "DAF-S-RM - N80.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N80.pdf",
    },
  ],
  [
    "DAF-S-RM - ADPE01 Aselam.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/ADPE01%20Aselam.pdf",
    },
  ],
  [
    "DAF-S-RM - N69 Valdespino.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N69%20Valdespino.pdf",
    },
  ],
  [
    "DAF-S-RM - N73 SCDEN.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N73%20SCDEN.pdf",
    },
  ],
  [
    "DAF-S-RM - N74 SCDEN.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N74%20SCDEN.pdf",
    },
  ],
  [
    "DAF-S-RM - N76 3JR.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N76%203JR.pdf",
    },
  ],
  [
    "DAF-S-RM - N76 GCA.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N76%20GCA.pdf",
    },
  ],
  [
    "DAF-S-RM - N80.pdf",
    "2do Trimestre",
    "Admon Finanzas",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/N80.pdf",
    },
  ],
  [
    "DAJ - Reporte de Subsidios Abr-Jun 2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "14-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Reporte%20de%20Subsidios%20Abr-Jun%202025.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. a) Edo Situacion Financiera.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20a)%20Edo%20Situacion%20Financiera.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. b) Edo Actividades.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20b)%20Edo%20Actividades.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. c) Edo Variacion Hacienda Publica.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20c)%20Edo%20Variacion%20Hacienda%20Publica.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. d) Edo Cambios Situacion Financiera.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20d)%20Edo%20Cambios%20Situacion%20Financiera.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. e) Edo Flujos Efectivo.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20e)%20Edo%20Flujos%20Efectivo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. f) Edo Analitico Activo.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20f)%20Edo%20Analitico%20Activo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. g) Edo Analitico Deuda Otros Pasivos.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20g)%20Edo%20Analitico%20Deuda%20Otros%20Pasivos.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. h) Informe Pasivos Contingentes.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Edos Financieros.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Edos%20Financieros.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. a) EAI con excedentes.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20a)%20EAI%20con%20excedentes.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1 EAEPE Clasf. Administrativa.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.1%20EAEPE%20Clasf.%20Administrativa.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2 EAEPE Clasf. Ramo.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20EAEPE%20Clasf.%20Ramo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. EAEPE Clasf. Economica.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%202.%20EAEPE%20Clasf.%20Economica.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. EAEPE Clasf. Objeto del Gasto.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%203.%20EAEPE%20Clasf.%20Objeto%20del%20Gasto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. EAEPE Clasf. Funcional.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%204.%20EAEPE%20Clasf.%20Funcional.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses de la Deuda.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20de%20la%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo de Fondos.xlsx",
    "2do Trimestre",
    "Blanca Trinagueros",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20de%20Fondos.xlsx",
    },
  ],
  [
    "DAF-S-PF - GASTO POR CATEGORIA PROGRAMATICA.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/GASTO%20POR%20CATEGORIA%20PROGRAMATICA.pdf",
    },
  ],
  [
    "DAF-S-PF - INDICADORES DE RESULTADOS.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/INDICADORES%20DE%20RESULTADOS.pdf",
    },
  ],
  [
    "DAF-S-PF - PROGRAMAS Y PROYRCTOS DE INVERSION.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/PROGRAMAS%20Y%20PROYRCTOS%20DE%20INVERSION.pdf",
    },
  ],
  [
    "DAF-s-pF - Gasto por categoria programática.xlsx",
    "2do Trimestre",
    "planeacion financiera",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-s-pF/Gasto%20por%20categoria%20programática.xlsx",
    },
  ],
  [
    "DAF-s-pF - Indicadores de Resultados.xlsx",
    "2do Trimestre",
    "planeacion financiera",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-s-pF/Indicadores%20de%20Resultados.xlsx",
    },
  ],
  [
    "DAF-s-pF - Programas y proyectos de inversión.xlsx",
    "2do Trimestre",
    "planeacion financiera",
    "16-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-s-pF/Programas%20y%20proyectos%20de%20inversión.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda Publica.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda%20Publica.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda Otros Pasivos.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. h) Informe Pasivos Contingentes.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Estados Financieros.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) Estado Ingresos Excedentes.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20a)%20Estado%20Ingresos%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1 Estado Egresos Clasificacion Administrativa.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.1%20Estado%20Egresos%20Clasificacion%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2 Estado Egresos Identificado Ramo.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20Estado%20Egresos%20Identificado%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. Estado Egresos Clasificacion Economica.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Clasificacion%20Economica.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. Estado Egresos COG.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20COG.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. Estado Egresos Clasificacion Funcional.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Clasificacion%20Funcional.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses Deuda.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo Fondos.pdf",
    "2do Trimestre",
    "Planeacion Financiera",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20Fondos.pdf",
    },
  ],
  [
    "DAF-S-PCF - DAJ-0672025.pdf",
    "2do Trimestre",
    "Blanca ETT",
    "17-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/DAJ-0672025.pdf",
    },
  ],
  [
    "DAF-S-PF - links gasto por categoria programatica.pdf",
    "2do Trimestre",
    "Marisol PF",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/links%20gasto%20por%20categoria%20programatica.pdf",
    },
  ],
  [
    "DAF-S-PF - links indicadores de resultados.pdf",
    "2do Trimestre",
    "Marisol PF",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/links%20indicadores%20de%20resultados.pdf",
    },
  ],
  [
    "DAF-S-PF - Links programas y proyectos de inversion.pdf",
    "2do Trimestre",
    "Marisol PF",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/Links%20programas%20y%20proyectos%20de%20inversion.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-056-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-056-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-064-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-064-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-078-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-078-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-218-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-218-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-238-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-238-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-254-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-254-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-257-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-257-2024.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-258-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "24-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/CAASIM-DAJ-258-2024.pdf",
    },
  ],

  [
    "DAF-S-PCF - Estados Presupuestales segundo trimestre 2025.pdf",
    "2do Trimestre",
    "Ivett PCF",
    "30-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/Estados%20Presupuestales%20segundo%20trimestre%202025.pdf",
    },
  ],
  [
    "DAF-S-PCF - Estados Presupuestales segundo trimestre 2025.xlsx",
    "2do Trimestre",
    "Ivett PCF",
    "30-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/Estados%20Presupuestales%20segundo%20trimestre%202025.xlsx",
    },
  ],
  [
    "DAF-S-PCF - Trasparencia-presupuesto.pdf",
    "2do Trimestre",
    "Ivett PCF",
    "30-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PCF/Trasparencia-presupuesto.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO PC20250725004.pdf",
    "2do Trimestre",
    "Ines Flores",
    "30-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PEDIDO%20PC20250725004.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20250725001.pdf",
    "2do Trimestre",
    "Dulce Licitaciones",
    "31-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PC20250725001.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20250725002.pdf",
    "2do Trimestre",
    "Dulce Licitaciones",
    "31-07-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/PC20250725002.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-076-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "08-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-076-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-079-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "08-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-079-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-081-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "08-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-081-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-087-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "08-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-087-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-089-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "08-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-089-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-093-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "08-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-093-2025.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe Director General abril - junio 2025.pdf",
    "2do Trimestre",
    "Bibiana Limon",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-PF/Informe%20Director%20General%20abril%20-%20junio%202025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-088-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-088-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-090-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-090-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-092-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-092-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-094-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-094-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-095-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-095-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-096-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-096-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-097-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "25-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-097-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-218-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "28-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-218-2024.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMÉN TÉCNICO Y ECONOMICO EA-913003989-N215-2025.pdf",
    "2do Trimestre",
    "Licitaciones CAASIM",
    "29-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/DICTAMÉN%20TÉCNICO%20Y%20ECONOMICO%20EA-913003989-N215-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION DE RECURSOS EA-913003989-N215-2025.pdf",
    "2do Trimestre",
    "Licitaciones CAASIM",
    "29-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20DE%20RECURSOS%20EA-913003989-N215-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-091-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "29-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-091-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-098-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "29-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-098-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-099-2025.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "29-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAJ/Contrato%20DAJ-099-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913003989-N181-2025.pdf",
    "2do Trimestre",
    "Licitaciones",
    "29-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/DICTAMEN%20EA-913003989-N181-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-166OF-2025.pdf",
    "2do Trimestre",
    "Licitaciones",
    "29-08-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/2do%20Trimestre/DAF-S-RM/SPF-166OF-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-131-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-131-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-161-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-161-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-162-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-162-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-163-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-163-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-237-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-237-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-254-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-254-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-257-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-257-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-258-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-258-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-259-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "01-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-259-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-273-2024.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "02-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/4to%20Trimestre/DAJ/Contrato%20DAJ-273-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-070-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-070-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-074-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-074-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-085-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-085-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-092-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-092-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-098-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-098-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-099-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-099-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-100-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-100-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-101-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-101-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-102-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-102-2025.pdf",
    },
  ],
  [
    "DAJ - CREACIÓN DEL COMITE DE OBRAS PÚBLICAS Y SERVICIOS RELACIONADOS CON LAS MISMAS DE LA CAASIM.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "08-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/CREACIÓN%20DEL%20COMITE%20DE%20OBRAS%20PÚBLICAS%20Y%20SERVICIOS%20RELACIONADOS%20CON%20LAS%20MISMAS%20DE%20LA%20CAASIM.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-091-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "10-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-091-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-103-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "10-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-103-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-082-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "10-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-082-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-083-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "10-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-083-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-108-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "19-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-108-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-112-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-112-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-113-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-113-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-114-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-114-2025.pdf",
    },
  ],
  [
    "DAJ - ACUERDO QUE CREA EL COMITE DE OBRAS PÚBLICAS Y SERVICIOS RELACIONADOS CON LAS MISMAS DE LA CAASIM (1).pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/ACUERDO%20QUE%20CREA%20EL%20COMITE%20DE%20OBRAS%20PÚBLICAS%20Y%20SERVICIOS%20RELACIONADOS%20CON%20LAS%20MISMAS%20DE%20LA%20CAASIM%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION DE RECURSOS VERIFICACION 8 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20DE%20RECURSOS%20VERIFICACION%208%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS BAJA 16 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20BAJA%2016%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS BAJA 27 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20BAJA%2027%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS BAJA REG ESTATAL 3 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20BAJA%20REG%20ESTATAL%203%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS CONTROL ESTATAL 15 VEH.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20CONTROL%20ESTATAL%2015%20VEH.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS R-152.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20R-152.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS R-404.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20R-404.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS R-473.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20R-473.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250624001 R-404.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OSN20250624001%20R-404.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250717001 R-152.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OSN20250717001%20R-152.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250819001 VERIFICACION 8 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OSN20250819001%20VERIFICACION%208%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20250819002 BAJA REG ESTATAL 3 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OSN20250819002%20BAJA%20REG%20ESTATAL%203%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250620001 R-473.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PSN20250620001%20R-473.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250624001 BAJA 16 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PSN20250624001%20BAJA%2016%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250624002 BAJA 27 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PSN20250624002%20BAJA%2027%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250624003 CONTROL ESTATAL 15 VEH_.pdf",
    "3er Trimestre",
    "Edgar Martinez",
    "23-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PSN20250624003%20CONTROL%20ESTATAL%2015%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-I - Contrato Oxxo 2025.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "24-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/Contrato%20Oxxo%202025.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "24-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "24-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen EA-913003989-N231-2025.pdf",
    "3er Trimestre",
    "Servicios Generales",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Dictamen%20EA-913003989-N231-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen EA-913003989-N276-2025.pdf",
    "3er Trimestre",
    "Servicios Generales",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Dictamen%20EA-913003989-N276-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen EA-913005999-N4-2025.pdf",
    "3er Trimestre",
    "Servicios Generales",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Dictamen%20EA-913005999-N4-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen EA-913005999-N5-2025.pdf",
    "3er Trimestre",
    "Servicios Generales",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Dictamen%20EA-913005999-N5-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen EA-913005999-N9-2025.pdf",
    "3er Trimestre",
    "Servicios Generales",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Dictamen%20EA-913005999-N9-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SH-0357-2025.pdf",
    "3er Trimestre",
    "Servicios Generales",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SH-0357-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-125-2025.pdf",
    "3er Trimestre",
    "Servicios Generales",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SPF-125-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA OLIVER IBARRA.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURA%20OLIVER%20IBARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURACION AGOSTO TELMEX.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURACION%20AGOSTO%20TELMEX.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURACION JULIO TELMEX.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURACION%20JULIO%20TELMEX.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURACION SEP TELMEX.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURACION%20SEP%20TELMEX.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250702001.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PSN20250702001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250821001.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PSN20250821001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20250922001.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PSN20250922001.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-134-2025.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SPF-134-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-160-2025.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SPF-160-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-166-2025.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SPF-166-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-182-2025.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SPF-182-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMÉN EA-913003989-N300-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMÉN%20EA-913003989-N300-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMÉN EA-913005999-N14-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMÉN%20EA-913005999-N14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMÉN EA-913005999-N6-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMÉN%20EA-913005999-N6-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CAREI.pdf",
    "3er Trimestre",
    "Alejandra RM",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURA%20CAREI.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CORIN.pdf",
    "3er Trimestre",
    "Alejandra RM",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURA%20CORIN.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA INSEL 1 (1).pdf",
    "3er Trimestre",
    "Alejandra RM",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURA%20INSEL%201%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA INSEL 2.pdf",
    "3er Trimestre",
    "Alejandra RM",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURA%20INSEL%202.pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL CAREI.pdf",
    "3er Trimestre",
    "Alejandra RM",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20CAREI.pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL CORIN (1).pdf",
    "3er Trimestre",
    "Alejandra RM",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20CORIN%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL INSEL (1).pdf",
    "3er Trimestre",
    "Alejandra RM",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20INSEL%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - REQUI AGOSTO1 (1).PDF",
    "3er Trimestre",
    "Arid Garcia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DG-S-COMU/REQUI%20AGOSTO1%20(1).PDF",
    },
  ],
  [
    "DG-S-COMU - REQUI JULIO (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DG-S-COMU/REQUI%20JULIO%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - REQUI SEPTIEMBRE (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DG-S-COMU/REQUI%20SEPTIEMBRE%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura_1004_3E1ED0E5-46A1-43A1-AAFF-2A9D939C963F (3) (2) (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DG-S-COMU/RORA5504099D6_Factura_1004_3E1ED0E5-46A1-43A1-AAFF-2A9D939C963F%20(3)%20(2)%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura__1008_B7EAEE83-0085-4463-BCA6-5E073164414C (1) (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DG-S-COMU/RORA5504099D6_Factura__1008_B7EAEE83-0085-4463-BCA6-5E073164414C%20(1)%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura__1011_04EAB449-1199-41EC-8A06-33FBE6771570 (1).pdf",
    "3er Trimestre",
    "Arid Garcia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DG-S-COMU/RORA5504099D6_Factura__1011_04EAB449-1199-41EC-8A06-33FBE6771570%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA INSEL UNIDO.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURA%20INSEL%20UNIDO.pdf",
    },
  ],
  [
    "DAF-S-RM - FAC ARRENDAMIENTO EDUARDO BAÑOS ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FAC%20ARRENDAMIENTO%20EDUARDO%20BAÑOS%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FAC GRUPO ARCODEM ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FAC%20GRUPO%20ARCODEM%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FAC MANTENIMIENTO EDUARDO BAÑOS ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FAC%20MANTENIMIENTO%20EDUARDO%20BAÑOS%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT CARLOS IBARRA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACT%20CARLOS%20IBARRA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AMABEL ONTIVEROS ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20AMABEL%20ONTIVEROS%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AURORA GARCIA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20AURORA%20GARCIA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MA DEL CARMEN CORTEZ ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20MA%20DEL%20CARMEN%20CORTEZ%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MARA REBECA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20MARA%20REBECA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MARIA DEL CARMEN PARRA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20MARIA%20DEL%20CARMEN%20PARRA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS NORBERTO SILVA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20NORBERTO%20SILVA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ODILON GEMPO COPCA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20ODILON%20GEMPO%20COPCA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS POLICIA HIDRICA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20POLICIA%20HIDRICA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-01-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-01-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-03-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-03-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-AD-OP-07-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-07-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-11-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-12-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-INV3-OP-13-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-INV3-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION DE RECURSOS CAASIM-HGO-L.O.P.-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACION%20DE%20RECURSOS%20CAASIM-HGO-L.O.P.-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACIÓN DE RECURSOS CAASIM-HGO-AD-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/AUTORIZACIÓN%20DE%20RECURSOS%20CAASIM-HGO-AD-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-01-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-01-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-03-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-03-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-07-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-07-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-11-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-12-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-13-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-01-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-01-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-03-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-03-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-07-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-07-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-01-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-01-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-03-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-03-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-07-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-07-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-11-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-12-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-13-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-AD-OP-01-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20CAASIM-HGO-AD-OP-01-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-AD-OP-02-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20CAASIM-HGO-AD-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-AD-OP-03-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20CAASIM-HGO-AD-OP-03-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-AD-OP-04-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20CAASIM-HGO-AD-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-AD-OP-05-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20CAASIM-HGO-AD-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-AD-OP-06-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20CAASIM-HGO-AD-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-AD-OP-07-2025.pdf",
    "3er Trimestre",
    "David Sanchez",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20DE%20PROPOSICIONES%20CAASIM-HGO-AD-OP-07-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS CUSTODIOS ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "25-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20CUSTODIOS%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN DE RECURSOS EA-913003989-N300-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACIÓN%20DE%20RECURSOS%20EA-913003989-N300-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACIÓN DE RECURSOS EA-913005999-N14-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACIÓN%20DE%20RECURSOS%20EA-913005999-N14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS BLANCA SALAZAR ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20BLANCA%20SALAZAR%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GRACIELA PEREZ ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20GRACIELA%20PEREZ%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS JULIETA CABRERA ENERO-SEP.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FACTURAS%20JULIETA%20CABRERA%20ENERO-SEP.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTA DE APERTURA EA-913003989-258-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/ACTA%20DE%20APERTURA%20EA-913003989-258-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTA DE FALLO EA-913003989-258-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/ACTA%20DE%20FALLO%20EA-913003989-258-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - ACTA DE JUNTA DE ACLARACIONES EA-913003989-258-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/ACTA%20DE%20JUNTA%20DE%20ACLARACIONES%20EA-913003989-258-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVOCATORIA EA-913003989-N258-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/CONVOCATORIA%20EA-913003989-N258-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN DE FALLO EA-913003989-258-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20DE%20FALLO%20EA-913003989-258-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN INVITACION No. ITP-CAASIM-SRMYSG-SAL-012025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20INVITACION%20No.%20ITP-CAASIM-SRMYSG-SAL-012025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES No. ITP-CAASIM-SRMYSG-SAL-012025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20No.%20ITP-CAASIM-SRMYSG-SAL-012025.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio anual de autorizacion de recursos (1).pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/oficio%20anual%20de%20autorizacion%20de%20recursos%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION DE RECURSOS 258-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20DE%20RECURSOS%20258-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FAC.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/FAC.pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL (2).pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20(2).pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-104-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-104-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-111-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-111-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-117-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-117-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN FALLO EA-913005999-N8-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20FALLO%20EA-913005999-N8-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - JUNTA DE ACLARACIONES ITP-CAASIM-SRMYSG-SAL-01-2025 (1).pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/JUNTA%20DE%20ACLARACIONES%20ITP-CAASIM-SRMYSG-SAL-01-2025%20(1).pdf",
    },
  ],
  [
    "DAF-S-RM - DISTRIBUIDORA HIDALGUENSE.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DISTRIBUIDORA%20HIDALGUENSE.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura Adrian.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Factura%20Adrian.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO SPF-113-2025.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/OFICIO%20SPF-113-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20250725001.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PC20250725001.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20250725002.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PC20250725002.pdf",
    },
  ],
  [
    "DAf-S-RM - SPF-103OF-2025.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAf-S-RM/SPF-103OF-2025.pdf",
    },
  ],
  [
    "DAf-S-RM - SPF-122-2025.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAf-S-RM/SPF-122-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FOFIR-GI-2025-4019-00143.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/HACIENDA-A-FOFIR-GI-2025-4019-00143.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913003989-N349-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20EA-913003989-N349-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913005999-N7-2025.pdf",
    "3er Trimestre",
    "Licitaciones",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/DICTAMEN%20EA-913005999-N7-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-109-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "26-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-109-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Oficios Secretaría de Hacienda.pdf",
    "3er Trimestre",
    "Licitaciones",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Oficios%20Secretaría%20de%20Hacienda.pdf",
    },
  ],
  [
    "DAJ - NORMAS GENERALES PARA EL REGISTRO, AFECTACIÓN, DISPOSICIÓN FINAL Y BAJA.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/NORMAS%20GENERALES%20PARA%20EL%20REGISTRO,%20AFECTACIÓN,%20DISPOSICIÓN%20FINAL%20Y%20BAJA.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura 2024 CAASIM.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F02b_Estructura%202024%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Abasto.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Abasto.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Admon.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Admon.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Atencion .pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Atencion%20.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Comercial.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Comercial.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. General.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20General.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Gestión.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Gestión.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Infraestructura.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Infraestructura.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Juridico.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Juridico.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. para Llevar.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20para%20Llevar.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Tics.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Dir.%20Tics.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Estatuto organico.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf",
    },
  ],
  [
    "DAF-S-RH - F08_Tabulador.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F08_Tabulador.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Condiciones Generales de Trabajo 2024-2025.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202024-2025.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Manual de Recursos Humano.pdf",
    "3er Trimestre",
    "Nancy Templos",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen n12.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/dictamen%20n12.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen n279.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/dictamen%20n279.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen n3.pdf",
    "3er Trimestre",
    "Licitaciones CAASIM",
    "29-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/dictamen%20n3.pdf",
    },
  ],
  [
    "DAF-S-RH - 1008_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/1008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/1022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1816_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/1816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1850_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/1850_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1853_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/1853_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/1979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/1992_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2029_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2093_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2093_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2239_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2261_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 228_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2391_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2391_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2420_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2456_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2457_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2465_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2483_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2489_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2492_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2492_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2538_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2538_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2547_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2547_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2556_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2556_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 256_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/256_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2560_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2560_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2566_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2566_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2567_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2567_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2579_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2581_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2581_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2603_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2631_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2647_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2647_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2655_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2655_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2677_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2677_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2706_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2706_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2734_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2734_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2771_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2771_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2855_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2863_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2863_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2885_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2885_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2886_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2903_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2903_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2914_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2919_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2957_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2957_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2971_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2971_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2980_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2980_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/2989_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3000_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3001_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3001_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3008_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3011_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3012_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3026_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3027_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3027_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3032_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3032_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3080_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3088_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3088_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3104_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3105_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3106_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3138_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3161_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3166_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3166_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3188_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3197_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3197_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3211_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3213_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3289_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3321_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3321_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3334_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3338_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3358_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3366_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3389_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 339_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/339_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3390_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3398_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3406_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3406_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3449_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3455_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3455_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3475_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3475_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3476_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 349_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/349_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3511_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3521_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3521_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3526_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3583_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3598_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3609_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3610_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3625_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3625_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3628_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3699_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3725_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3726_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3726_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3727_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3733_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3733_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3735_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3735_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3750_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3756_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3756_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 376_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3769_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3772_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3778_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3816_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3828_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3835_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3878_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3890_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3890_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3893_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3918_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3931_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3952_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3953_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3960_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3961_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3961_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3962_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3962_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3967_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3967_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3970_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3970_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3978_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3978_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3979_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3983_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3984_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/3988_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4010_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4010_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4017_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4019_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4019_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4022_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4026_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4033_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4033_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4036_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4039_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4043_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4043_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4050_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4086_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4086_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4087_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4095_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4149_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4149_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4154_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4154_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4155_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4155_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4156_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4156_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4157_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4159_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4159_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4160_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4160_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4161_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4161_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4162_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4162_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4167_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4167_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4168_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4170_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4170_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4174_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4174_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4175_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4177_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4177_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4178_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4178_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4179_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4181_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4181_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4182_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4183_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4183_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4184_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4184_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4185_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4185_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4186_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4186_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4187_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4189_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4189_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4193_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4198_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4206_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4206_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4212_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4212_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4214_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4215_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4215_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4219_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4219_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4221_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4225_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4228_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4230_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4230_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4235_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4238_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4242_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4248_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4249_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4253_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4261_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4263_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4263_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4265_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4271_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4275_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4275_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4276_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4276_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4281_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4282_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4286_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4286_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4289_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4289_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4293_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4296_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4298_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4299_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4303_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4303_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4325_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4325_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4332_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4336_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4336_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4357_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4357_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4360_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4360_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4362_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4362_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4372_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4375_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4376_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4381_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4381_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4387_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4387_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4388_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4393_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4404_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4404_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4408_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4408_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4413_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4413_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4414_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4414_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4415_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4415_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4416_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4416_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4417_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4417_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4418_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4418_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4434_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4434_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4439_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4439_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4445_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4445_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4458_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4458_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4462_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4462_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4479_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4479_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4484_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/4484_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 794_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/794_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/846_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 873_modified.pdf_Caratula.pdf",
    "3er Trimestre",
    "Monica Yezmin Hernandez",
    "29-09-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RH/873_modified.pdf_Caratula.pdf",
    },
  ],
  [
    "DG-S-COMU - evidencia jul-sep.pdf",
    "3er Trimestre",
    "Erick Parra",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DG-S-COMU/evidencia%20jul-sep.pdf",
    },
  ],
  [
    "DAF-S-RM - Factura Conamat (F-69).pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Factura%20Conamat%20(F-69).pdf",
    },
  ],
  [
    "DAF-S-RM - Factura Gove 1444.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Factura%20Gove%201444.pdf",
    },
  ],
  [
    "DAF-S-RM - Facturas Oliverio.pdf",
    "3er Trimestre",
    "Cristina Mejia",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/Facturas%20Oliverio.pdf",
    },
  ],
  [
    "DCOME - 1Solitud agua potable.docx",
    "3er Trimestre",
    "Amparo Flores",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCOME/1Solitud%20agua%20potable.docx",
    },
  ],
  [
    "DCOME - 1Solitud agua potable.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCOME/1Solitud%20agua%20potable.pdf",
    },
  ],
  [
    "DCOME - 2Solicitud agua potable derivación.docx",
    "3er Trimestre",
    "Amparo Flores",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCOME/2Solicitud%20agua%20potable%20derivación.docx",
    },
  ],
  [
    "DCOME - 2Solicitud agua potable derivación.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCOME/2Solicitud%20agua%20potable%20derivación.pdf",
    },
  ],
  [
    "DCOME - AguaPotable.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCOME/AguaPotable.pdf",
    },
  ],
  [
    "DCOME - AguaPotableDerivación.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCOME/AguaPotableDerivación.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-106-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-106-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-107-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "30-09-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-107-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-02-2025.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-02-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-04-2025.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-04-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-05-2025.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-06-2025.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-11-2025.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-12-2025.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES CAASIM-HGO-INV3-OP-13-2025-salida.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20CAASIM-HGO-INV3-OP-13-2025-salida.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACIONES No. ITP-CAASIM-SRMYSG-SAL-01-2025.pdf",
    "3er Trimestre",
    "Recursos Materiales",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/INVITACIONES%20No.%20ITP-CAASIM-SRMYSG-SAL-01-2025.pdf",
    },
  ],
  [
    "DAB - 3ER.TRIM_MIR DIR_ABASTO Y PTAR´S OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/3ER.TRIM_MIR%20DIR_ABASTO%20Y%20PTAR´S%20OCR.pdf",
    },
  ],
  [
    "DAB - 3ER.TRIM_POA DIR_ABASTO Y PTAR´S OCR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/3ER.TRIM_POA%20DIR_ABASTO%20Y%20PTAR´S%20OCR.pdf",
    },
  ],
  [
    "DAB - GRAFICA 3ER. TRIM_ DIR_ABASTO Y PTARS.xlsx",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/GRAFICA%203ER.%20TRIM_%20DIR_ABASTO%20Y%20PTARS.xlsx",
    },
  ],
  [
    "DAB - MIR 3ER.TRIM_ ABASTO Y PTAR´S EXCEL.xls",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/MIR%203ER.TRIM_%20ABASTO%20Y%20PTAR´S%20EXCEL.xls",
    },
  ],
  [
    "DAB - POA 3ER. TRIM_ABASTO Y PTAR´S EXCEL.xls",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/POA%203ER.%20TRIM_ABASTO%20Y%20PTAR´S%20EXCEL.xls",
    },
  ],
  [
    "DAB - 3ER. Trimestre Actividad_Dir_Abasto y PT.pdf",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/3ER.%20Trimestre%20Actividad_Dir_Abasto%20y%20PT.pdf",
    },
  ],
  [
    "DAB - 3er.Trimestre Indicador_ Dir_Abasto y PT.pdf",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/3er.Trimestre%20Indicador_%20Dir_Abasto%20y%20PT.pdf",
    },
  ],
  [
    "DAB - GRAFICA 3ER. TRIM_ DIR_ABASTO Y PTARS ocr.pdf",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/GRAFICA%203ER.%20TRIM_%20DIR_ABASTO%20Y%20PTARS%20ocr.pdf",
    },
  ],
  [
    "DAB - DIR_ABASTO Y PTARS_3ER_TRIM_ MIR.pdf",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/DIR_ABASTO%20Y%20PTARS_3ER_TRIM_%20MIR.pdf",
    },
  ],
  [
    "DAB - DIR_ABASTO Y PTARS_3ER_TRIM_ POA.pdf",
    "3er Trimestre",
    "Joana Paz",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAB/DIR_ABASTO%20Y%20PTARS_3ER_TRIM_%20POA.pdf",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOM.docx",
    "3er Trimestre",
    "Blanca DCONS",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOM.docx",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOM.pdf",
    "3er Trimestre",
    "Blanca DCONS",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOM.pdf",
    },
  ],
  [
    "DCONS - HOJA PARA SOLICITUD DE LINKS.pdf",
    "3er Trimestre",
    "Blanca DCONS",
    "01-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/HOJA%20PARA%20SOLICITUD%20DE%20LINKS.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-119-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-119-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-120-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-120-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-121-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-121-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-123-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-123-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-124-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-124-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-125-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-125-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-126-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-126-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-127-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-127-2025.pdf",
    },
  ],
  [
    "DCONS - avances de obra 3er trimestre.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/avances%20de%20obra%203er%20trimestre.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 093.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%20093.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 101.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%20101.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 102.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%20102.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 112.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%20112.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 113.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%20113.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 114.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%20114.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 123.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%20123.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 67.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%2067.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 94.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "03-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CONTRATO%2094.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-126-2024 Bacheo Z-4.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-126-2024%20Bacheo%20Z-4.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-127-2024 Bacheo Z-3.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-127-2024%20Bacheo%20Z-3.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-128-2024 Bacheo Z-2..pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-128-2024%20Bacheo%20Z-2..pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-129-2024 Bacheo Z1.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-129-2024%20Bacheo%20Z1.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-132-2024 Alc Z-4.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-132-2024%20Alc%20Z-4.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-135-2025 Agua Z-1.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-135-2025%20Agua%20Z-1.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-141-2024  Redes Z-5.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-141-2024%20%20Redes%20Z-5.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-143-2024 Redes Z-3.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-143-2024%20Redes%20Z-3.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-144-2024 Redes Z-4.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-144-2024%20Redes%20Z-4.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-145-2024 Redes Z-1.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-145-2024%20Redes%20Z-1.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-147-2025 Agua Z-3.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-147-2025%20Agua%20Z-3.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-155-2024 Agua Z-2.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-155-2024%20Agua%20Z-2.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-46-2024 Descargas.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/AER%20CAASIM-DAJ-46-2024%20Descargas.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-094-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-094-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-097-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-097-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-109-2025.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-109-2025.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-120-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-120-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-149-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-149-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-175-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-175-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-177-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-177-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-197-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-197-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-95-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "06-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/CAASIM-DAJ-95-2024.pdf",
    },
  ],
  [
    "DCONS - SEGUNDO TRIMESTRE CONTRATO CAASIM-DAJ-252-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "09-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/SEGUNDO%20TRIMESTRE%20CONTRATO%20CAASIM-DAJ-252-2024.pdf",
    },
  ],
  [
    "DCONS - UNIDO PRIMER TRIMESTE CONTRATO DAJ-252-2024.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "09-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DCONS/UNIDO%20PRIMER%20TRIMESTE%20CONTRATO%20DAJ-252-2024.pdf",
    },
  ],
  [
    "DAJ - Reporte Subsidios Tercer Trimestre 2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "10-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Reporte%20Subsidios%20Tercer%20Trimestre%202025.pdf",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoria programática 30 sep.xlsx",
    "3er Trimestre",
    "Planeacion Financiera",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programática%2030%20sep.xlsx",
    },
  ],
  [
    "DAF-S-PF - Indicadores de Resultdos septiembre 2025.xlsx",
    "3er Trimestre",
    "Planeacion Financiera",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Indicadores%20de%20Resultdos%20septiembre%202025.xlsx",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversión.xlsx",
    "3er Trimestre",
    "Planeacion Financiera",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión.xlsx",
    },
  ],
  [
    "DAF-S-PF - A)GASTOS POR CATEGORIA PROGRAMATICA.pdf",
    "3er Trimestre",
    "Planeacion Financiera",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/A)GASTOS%20POR%20CATEGORIA%20PROGRAMATICA.pdf",
    },
  ],
  [
    "DAF-S-PF - B)PROGRAMAS Y PROYECTOS DE INVERSION.pdf",
    "3er Trimestre",
    "Planeacion Financiera",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/B)PROGRAMAS%20Y%20PROYECTOS%20DE%20INVERSION.pdf",
    },
  ],
  [
    "DAF-S-PF - C)INDICADORES DE RESULTADOS.pdf",
    "3er Trimestre",
    "Planeacion Financiera",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/C)INDICADORES%20DE%20RESULTADOS.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. h) Pasivos Contingentes.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20h)%20Pasivos%20Contingentes.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Edos Financieros.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Edos%20Financieros.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. a) EAI con excedentes.xls",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20a)%20EAI%20con%20excedentes.xls",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1 EAEPE Clasificacion Administrativa.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%201.1%20EAEPE%20Clasificacion%20Administrativa.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2 EAEPE Identificado por Ramo.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20EAEPE%20Identificado%20por%20Ramo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. EAEPE Clasificacion Economica-Tipo de Gasto.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%202.%20EAEPE%20Clasificacion%20Economica-Tipo%20de%20Gasto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. EAEPE COG (Capitulo y Concepto).xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%203.%20EAEPE%20COG%20(Capitulo%20y%20Concepto).xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. EAEPE Clasificacion Funcional.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%204.%20EAEPE%20Clasificacion%20Funcional.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses de la Deuda.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20de%20la%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo de Fondos.xlsx",
    "3er Trimestre",
    "Blanca ERM",
    "17-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20de%20Fondos.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda Publica.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda%20Publica.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda Otros Pasivos.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. h) Informe Pasivos Contingentes.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Estados Financieros.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) Estado Ingresos Excedentes.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20a)%20Estado%20Ingresos%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1. Estado Egresos Clasificacion Administrativa.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%201.1.%20Estado%20Egresos%20Clasificacion%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2. Estado Egresos Identificado Ramo.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%201.2.%20Estado%20Egresos%20Identificado%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. Estado Egresos Clasificacion Economica.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Clasificacion%20Economica.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. Estado Egresos COG.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20COG.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. Estado Egresos Clasificacion Funcional.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Clasificacion%20Funcional.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses Deuda.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo Fondos.pdf",
    "3er Trimestre",
    "Blanca ERM",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20Fondos.pdf",
    },
  ],
  [
    "DAF-S-PCF - EDITABLES 3ER TRIMESTRE 2025.xlsx",
    "3er Trimestre",
    "Ivette Flores",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/EDITABLES%203ER%20TRIMESTRE%202025.xlsx",
    },
  ],
  [
    "DAF-S-PCF - PDF 3ER TRIMESTRE 2025.pdf",
    "3er Trimestre",
    "Ivette Flores",
    "21-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/PDF%203ER%20TRIMESTRE%202025.pdf",
    },
  ],
  [
    "DAF-S-PCF - EDITABLE INGRESOS 3ER TRIMESTRE 2025.xlsx",
    "3er Trimestre",
    "Dalia Ivette",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/EDITABLE%20INGRESOS%203ER%20TRIMESTRE%202025.xlsx",
    },
  ],
  [
    "DAF-S-PCF - PDF INGRESOS 3ER TRIMESTRE 2025.pdf",
    "3er Trimestre",
    "Dalia Ivette",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/PDF%20INGRESOS%203ER%20TRIMESTRE%202025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-128-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-128-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-129-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-129-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-131-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-131-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-132-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-132-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-133-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-133-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-136-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-136-2025.pdf",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversiónSEP.xlsx",
    "3er Trimestre",
    "Marisol",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversiónSEP.xlsx",
    },
  ],
  [
    "DAF-S-I - Monto Mensual 3er. trimestre Oxxo 2025.xlsx",
    "3er Trimestre",
    "Maribel Butron",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/Monto%20Mensual%203er.%20trimestre%20Oxxo%202025.xlsx",
    },
  ],
  [
    "DAF-S-I - Monto Mensual Rec. Oxxo 3er. Trim. 2025.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/Monto%20Mensual%20Rec.%20Oxxo%203er.%20Trim.%202025.pdf",
    },
  ],
  [
    "DAF-S-I - Monto Total 3er. trimestre Oxxo 2025.xlsx",
    "3er Trimestre",
    "Maribel Butron",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/Monto%20Total%203er.%20trimestre%20Oxxo%202025.xlsx",
    },
  ],
  [
    "DAF-S-I - Monto Total Rec. Oxxo 3er. Trim 2025.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/Monto%20Total%20Rec.%20Oxxo%203er.%20Trim%202025.pdf",
    },
  ],
  [
    "DAF-S-PCF - Trasparencia-presupuesto Ingresos.pdf",
    "3er Trimestre",
    "Ivette Flores",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/Trasparencia-presupuesto%20Ingresos.pdf",
    },
  ],
  [
    "DAF-S-PCF - Trasparencia-presupuesto.pdf",
    "3er Trimestre",
    "Ivette Flores",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PCF/Trasparencia-presupuesto.pdf",
    },
  ],
  [
    "DAF-S-I - HIPERVINCULOS SERVICIO OXXO.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/HIPERVINCULOS%20SERVICIO%20OXXO.pdf",
    },
  ],
  [
    "DAF-S-PF - links gasto por categoria programatica septiembre.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/links%20gasto%20por%20categoria%20programatica%20septiembre.pdf",
    },
  ],
  [
    "DAF-S-PF - Links indicadores de resultados septiembre.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Links%20indicadores%20de%20resultados%20septiembre.pdf",
    },
  ],
  [
    "DAF-S-PF - Links programa sy proyectos de inversion.pdf",
    "3er Trimestre",
    "Amparo Flores",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Links%20programa%20sy%20proyectos%20de%20inversion.pdf",
    },
  ],
  [
    "DAF-S-RM - PC20251017001.PDF",
    "3er Trimestre",
    "Ines Flores",
    "22-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/PC20251017001.PDF",
    },
  ],
  [
    "DAF-S-PF - links gasto por categoria programatica septiembre.pdf",
    "3er Trimestre",
    "Marisol",
    "23-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/links%20gasto%20por%20categoria%20programatica%20septiembre.pdf",
    },
  ],
  [
    "DAF-S-PF - Links indicadores de resultados septiembre.pdf",
    "3er Trimestre",
    "Marisol",
    "23-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Links%20indicadores%20de%20resultados%20septiembre.pdf",
    },
  ],
  [
    "DAF-S-PF - Links programa sy proyectos de inversion.pdf",
    "3er Trimestre",
    "Marisol",
    "23-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Links%20programa%20sy%20proyectos%20de%20inversion.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-134-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "27-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-134-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-135-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "27-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-135-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-137-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "27-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-137-2025.pdf",
    },
  ],
  [
    "DAF-S-I - 27 mensual (1).pdf",
    "3er Trimestre",
    "Maribel Butron",
    "28-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/27%20mensual%20(1).pdf",
    },
  ],
  [
    "DAF-S-I - 27totaltrim.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "28-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/27totaltrim.pdf",
    },
  ],
  [
    "DAF-S-RM - doc07519120251030160235.pdf",
    "3er Trimestre",
    "Sandy RM",
    "31-10-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-RM/doc07519120251030160235.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-352-2023.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2023/4to%20Trimestre/DAJ/Contrato%20DAJ-352-2023.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-078-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-078-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-090-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-090-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-091-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-091-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-092-2024.pdf",
    "2do Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/2do%20Trimestre/DAJ/Contrato%20DAJ-092-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-096-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-096-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-099-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-099-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-119-2024.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "03-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2024/3er%20Trimestre/DAJ/Contrato%20DAJ-119-2024.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-105-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-105-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-118-2025.pdf",
    "3er Trimestre",
    "Jorge Daniel",
    "05-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAJ/Contrato%20DAJ-118-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-139-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "05-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-139-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-140-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "05-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-140-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-142-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "05-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-142-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-143-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "05-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-143-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-144-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "05-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-144-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-145-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "07-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-145-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-146-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "07-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-146-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - N69-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "24-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/N69-2023.pdf",
    },
  ],
  [
    "DAF-S-RM - N74-2023.pdf",
    "4to Trimestre",
    "Licitaciones",
    "24-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/N74-2023.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe de Director General julio-septiembre 2025.pdf",
    "3er Trimestre",
    "Biviana Limon",
    "26-11-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-PF/Informe%20de%20Director%20General%20julio-septiembre%202025.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251112001 AUTONATION R-499.pdf",
    "4to Trimestre",
    "4to Trimestre",
    "03-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251112001%20AUTONATION%20R-499.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251112002 AUTONATION R-500.pdf",
    "4to Trimestre",
    "4to Trimestre",
    "03-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251112002%20AUTONATION%20R-500.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251112003 AUTONATION R-491.pdf",
    "4to Trimestre",
    "4to Trimestre",
    "03-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251112003%20AUTONATION%20R-491.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125002 GEMI R-486 MANTTO VEH_.pdf",
    "4to Trimestre",
    "4to Trimestre",
    "03-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125002%20GEMI%20R-486%20MANTTO%20VEH_.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125003 GEMI R-486 REMPLAZO REFACC.pdf",
    "4to Trimestre",
    "4to Trimestre",
    "03-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125003%20GEMI%20R-486%20REMPLAZO%20REFACC.pdf",
    },
  ],
  [
    "DAJ - Exp. 348-2025-4.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "03-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Exp.%20348-2025-4.pdf",
    },
  ],
  [
    "DAF-S-I - Contrato Oxxo 2025 Testado (1).pdf",
    "4to Trimestre",
    "Maribel Butron",
    "04-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Contrato%20Oxxo%202025%20Testado%20(1).pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-122-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-122-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-138-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-138-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-147-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-147-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-148-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-148-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-149-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-149-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-150-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-150-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-151-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-151-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-152-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-152-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-153-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-153-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-154-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-154-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-155-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-155-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-159-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-159-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-162-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-162-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-DAJ-165-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-DAJ-165-2025.pdf",
    },
  ],
  [
    "DAF-S-I/2daVersion - Contrato Oxxo 2025.pdf",
    "3er Trimestre",
    "Maribel Butron",
    "09-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/3er%20Trimestre/DAF-S-I/2daVersion/Contrato%20Oxxo%202025.pdf",
    },
  ],

  [
    "DAJ - Contrato DAJ-141-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-141-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-161-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "10-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-161-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-160-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-160-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-166-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-166-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-167-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-167-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-168-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-168-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-170-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-170-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-176-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-176-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - ALIMENTOS.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/ALIMENTOS.pdf",
    },
  ],
  [
    "DAF-S-RM - AXEL AGUA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/AXEL%20AGUA.pdf",
    },
  ],
  [
    "DAF-S-RM - FAC ALIMENTOS.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FAC%20ALIMENTOS.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT AGUA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACT%20AGUA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT EXTINTOR.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACT%20EXTINTOR.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT GOVE LIMPIEZA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACT%20GOVE%20LIMPIEZA.pdf",
    },
  ],
  [
    "DAF-S-RM - FRANK EXTINTOR.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FRANK%20EXTINTOR.pdf",
    },
  ],
  [
    "DAF-S-RM - GOVE MATERIAL DE LIMPIEZA.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "17-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/GOVE%20MATERIAL%20DE%20LIMPIEZA.pdf",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOM.docx",
    "4to Trimestre",
    "Blanca E R M",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOM.docx",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOM.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOM.pdf",
    },
  ],
  [
    "DG-S-COMU - D18DB4C6-9506-4A87-9301-7503DDC2AD1F (3).pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/D18DB4C6-9506-4A87-9301-7503DDC2AD1F%20(3).pdf",
    },
  ],
  [
    "DG-S-COMU - doc00320220251218104833.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/doc00320220251218104833.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00320320251218105103.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/doc00320320251218105103.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00320420251218105110.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/doc00320420251218105110.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00320520251218105121.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/doc00320520251218105121.pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura_1015_80C21C62-0EC4-44CA-8539-F6D79614242F (1).pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/RORA5504099D6_Factura_1015_80C21C62-0EC4-44CA-8539-F6D79614242F%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura_1019_6A8EA92A-7A6A-4827-8841-3ABCD54757D5 (1).pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/RORA5504099D6_Factura_1019_6A8EA92A-7A6A-4827-8841-3ABCD54757D5%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura__1023_B66BC03A-E81A-40CB-9535-0910DCF2C141 (2).pdf",
    "4to Trimestre",
    "Arid Garcia",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/RORA5504099D6_Factura__1023_B66BC03A-E81A-40CB-9535-0910DCF2C141%20(2).pdf",
    },
  ],
  [
    "DCONS - DescargaDOM.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "18-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/DescargaDOM.pdf",
    },
  ],
  [
    "DAF-S-RH - 1008_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/1008_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/1022_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1816_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/1816_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1850_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/1850_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1853_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/1853_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/1979_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/1992_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2029_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2029_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2093_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2093_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2239_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2261_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2261_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 228_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/228_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2391_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2391_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2420_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2456_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2457_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2465_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2483_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2489_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2492_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2492_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2538_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2538_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2547_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2547_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2556_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2556_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 256_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/256_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2560_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2560_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2566_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2566_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2567_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2567_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2579_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2581_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2581_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2603_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2631_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2647_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2647_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2655_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2655_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2677_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2677_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2706_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2706_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2734_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2734_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2769_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2771_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2771_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2855_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2863_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2863_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2885_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2885_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2886_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2903_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2903_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2914_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2919_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2957_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2957_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2971_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2971_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2980_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2980_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/2989_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3000_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3001_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3001_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3008_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3011_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3012_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3026_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3026_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3027_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3027_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3032_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3032_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3080_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3087_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3088_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3088_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3104_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3105_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3106_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3138_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3161_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3161_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3166_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3166_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3188_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3334_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3338_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3358_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3366_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3375_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3389_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 339_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/339_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3390_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3398_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3406_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3406_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3415_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3449_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3455_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3455_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3475_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3475_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3476_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 349_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/349_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3511_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3521_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3521_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3526_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3583_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3598_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3609_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3610_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3628_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3699_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3725_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3726_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3726_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3727_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3733_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3733_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3750_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 376_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/376_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3769_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3772_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3778_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3816_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3828_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3835_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3878_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3890_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3890_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3893_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3918_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3931_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3952_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3953_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3960_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3961_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3961_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3962_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3962_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3967_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3967_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3970_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3970_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3978_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3978_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3979_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3983_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3984_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3988_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4010_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4010_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4017_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4019_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4019_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4022_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4026_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4033_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4033_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4036_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4039_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4043_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4043_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4050_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4086_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4086_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4087_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4095_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4149_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4149_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4154_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4154_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4155_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4155_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4156_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4156_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4157_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4159_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4159_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4160_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4160_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4161_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4161_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4162_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4162_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4167_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4167_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4168_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4170_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4170_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4175_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4177_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4177_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4178_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4178_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4179_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4181_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4181_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4182_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4183_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4183_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4184_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4184_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4185_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4185_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4186_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4186_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4187_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4189_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4189_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4193_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4198_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4206_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4206_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4214_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4215_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4215_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4219_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4219_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4221_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4225_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4228_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4230_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4230_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4235_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4238_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4242_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4248_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4249_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4253_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4261_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4263_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4263_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4265_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4271_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4275_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4275_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4281_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4282_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4286_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4286_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4289_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4289_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4293_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4296_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4298_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4299_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4325_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4325_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4332_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4336_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4336_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4357_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4357_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4360_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4360_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4362_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4362_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4372_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4375_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4376_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4387_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4387_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4388_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4393_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4404_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4404_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4408_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4408_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4413_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4413_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4414_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4414_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4415_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4415_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4416_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4416_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4417_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4417_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4418_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4418_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4434_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4434_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4439_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4439_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4445_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4445_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4458_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4458_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4462_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4462_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4479_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4479_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4481_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4481_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4484_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4484_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4491_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4491_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4492_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4492_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4504_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4504_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4511_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/4511_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 794_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/794_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/846_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 967_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "23-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/967_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura 2025 CAASIM.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F02b_Estructura%202025%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Abasto.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Abasto.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Admon.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Admon.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Atencion .pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Atencion%20.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Comercial.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Comercial.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. General.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20General.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Gestión.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Gestión.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Infraestructura.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Infraestructura.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Juridico.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Juridico.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. para Llevar.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20para%20Llevar.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Tics.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Dir.%20Tics.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Estatuto organico.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf",
    },
  ],
  [
    "DAF-S-RH - F08_Tabulador.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F08_Tabulador.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Condiciones Generales de Trabajo 2024-2025.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202024-2025.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Manual de Recursos Humano.pdf",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf",
    },
  ],
  [
    "DAF-S-RH - ~$00_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$00_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$01_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$01_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$03_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$03_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$06_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$06_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$08_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$08_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$14_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$14_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$20_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$20_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$22_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$22_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$27_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$27_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$29_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$29_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$31_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$31_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$34_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$34_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$38_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$38_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$39_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$39_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$47_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$47_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$50_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$50_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$53_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$53_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$55_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$55_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$56_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$56_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$60_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$60_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$61_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$61_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$63_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$63_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$66_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$66_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$67_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$67_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$69_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$69_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$71_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$71_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$79_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$79_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$80_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$80_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$81_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$81_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$83_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$83_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$85_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$85_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$86_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$86_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$89_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$89_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$92_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$92_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$93_modified.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$93_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$F-S-RH_-_1008_modified.pdf_summary.docx",
    "4to Trimestre",
    "Nancy Templos",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/~$F-S-RH_-_1008_modified.pdf_summary.docx",
    },
  ],
  [
    "DG-S-COMU - doc00327820251223141626.pdf",
    "4to Trimestre",
    "Arid Garcia",
    "24-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/doc00327820251223141626.pdf",
    },
  ],
  [
    "DAF-S-RH - 3197_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "29-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3197_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "29-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3211_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "29-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3213_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3321_mod.pdf_Caratula.pdf",
    "4to Trimestre",
    "Monica Yezmin Hernandez",
    "29-12-2025",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RH/3321_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAJ - Contrato CAASIM-LD001,LD002 (D-INT01, D-INT-02).pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "29-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20CAASIM-LD001,LD002%20(D-INT01,%20D-INT-02).pdf",
    },
  ],
  [
    "DAf-S-RM - FACT, 36074 MANUEL SERAFIN.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/FACT,%2036074%20MANUEL%20SERAFIN.pdf",
    },
  ],
  [
    "DAf-S-RM - FACT. A46 CLAUDIO.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/FACT.%20A46%20CLAUDIO.pdf",
    },
  ],
  [
    "DAf-S-RM - FACT. BBD36 INSEL.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/FACT.%20BBD36%20INSEL.pdf",
    },
  ],
  [
    "DAf-S-RM - FACT. C37 CORIN.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/FACT.%20C37%20CORIN.pdf",
    },
  ],
  [
    "DAf-S-RM - FACT. D9E64 MANUEL SERAFIN.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/FACT.%20D9E64%20MANUEL%20SERAFIN.pdf",
    },
  ],
  [
    "DAf-S-RM - PEDIDO PC20251224001 SERAFIN.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/PEDIDO%20PC20251224001%20SERAFIN.pdf",
    },
  ],
  [
    "DAf-S-RM - PEDIDO PC20251224002 SERAFIN.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/PEDIDO%20PC20251224002%20SERAFIN.pdf",
    },
  ],
  [
    "DAf-S-RM - PEDIDO PC20251226003 INSEL.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/PEDIDO%20PC20251226003%20INSEL.pdf",
    },
  ],
  [
    "DAf-S-RM - PEDIDO PSN20251226001 CORIN.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/PEDIDO%20PSN20251226001%20CORIN.pdf",
    },
  ],
  [
    "DAf-S-RM - PEDIDO PSN20251226003 CLAUDIO.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAf-S-RM/PEDIDO%20PSN20251226003%20CLAUDIO.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-075-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-075-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-086-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-086-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-163-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-163-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-182-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-182-2025.pdf",
    },
  ],
  [
    "DAB - DIR_ABASTO Y PTAR 4TO. TRIM_MIR.xls",
    "4to Trimestre",
    "Joana Abasto",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/DIR_ABASTO%20Y%20PTAR%204TO.%20TRIM_MIR.xls",
    },
  ],
  [
    "DAB - DIR_ABASTO Y PTAR 4TO. TRIM_POA.xls",
    "4to Trimestre",
    "Joana Abasto",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/DIR_ABASTO%20Y%20PTAR%204TO.%20TRIM_POA.xls",
    },
  ],
  [
    "DAB - GRAFICA 4TO. TRIM_ DIR_ABASTO Y PTARS.xlsx",
    "4to Trimestre",
    "Joana Abasto",
    "30-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/GRAFICA%204TO.%20TRIM_%20DIR_ABASTO%20Y%20PTARS.xlsx",
    },
  ],
  [
    "DAB - Dir_Abasto y Ptar Excel Mir 4to. Tri.xls",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/Dir_Abasto%20y%20Ptar%20Excel%20Mir%204to.%20Tri.xls",
    },
  ],
  [
    "DAB - GRAFICA 4TO. TRIM_ DIR_ABASTO Y PTARS OCR.pdf",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/GRAFICA%204TO.%20TRIM_%20DIR_ABASTO%20Y%20PTARS%20OCR.pdf",
    },
  ],
  [
    "DAB - Mir  4to.Trim_Dir_Abasto y Ptar OCR.pdf",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/Mir%20%204to.Trim_Dir_Abasto%20y%20Ptar%20OCR.pdf",
    },
  ],
  [
    "DAB - Poa 4to.Trim_Dir_Abasto y Ptar OCR.pdf",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/Poa%204to.Trim_Dir_Abasto%20y%20Ptar%20OCR.pdf",
    },
  ],
  [
    "DAF-S-RM - 176.2025 contrato.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/176.2025%20contrato.pdf",
    },
  ],
  [
    "DAF-S-RM - contrato servicio de limpieza.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/contrato%20servicio%20de%20limpieza.pdf",
    },
  ],
  [
    "DAF-S-RM - Convenio de ampliación de emulsión.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Convenio%20de%20ampliación%20de%20emulsión.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN FALLO MATERIAL DE OFICINA.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20FALLO%20MATERIAL%20DE%20OFICINA.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen N31 difusion.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/dictamen%20N31%20difusion.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen servicio de limpieza.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/dictamen%20servicio%20de%20limpieza.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN VESTUARIO.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20VESTUARIO.pdf",
    },
  ],
  [
    "DAF-S-RM - invitaciones material de oficina.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/invitaciones%20material%20de%20oficina.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio de autorizacion de recurso Excepcion 10.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/oficio%20de%20autorizacion%20de%20recurso%20Excepcion%2010.pdf",
    },
  ],
  [
    "DAF-S-RM - Oficio de Autorizacion de Recursos Anticipadas.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Oficio%20de%20Autorizacion%20de%20Recursos%20Anticipadas.pdf",
    },
  ],
  [
    "DAF-S-RM - oficios autorizacion Material de oficina.pdf",
    "4to Trimestre",
    "Licitaciones",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/oficios%20autorizacion%20Material%20de%20oficina.pdf",
    },
  ],
  [
    "DAB - 4to_trim_Mir DirecciondeAbastoyPtar.pdf",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/4to_trim_Mir%20DirecciondeAbastoyPtar.pdf",
    },
  ],
  [
    "DAB - 4to_trim_Poa DirecciondeAbastoyPtar.pdf",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/4to_trim_Poa%20DirecciondeAbastoyPtar.pdf",
    },
  ],
  [
    "DAF-S-RM - contrato materialo de oficina.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/contrato%20materialo%20de%20oficina.pdf",
    },
  ],
  [
    "DAB - Mir Dir_AbastoyPtar 4to Trimes.pdf",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/Mir%20Dir_AbastoyPtar%204to%20Trimes.pdf",
    },
  ],
  [
    "DAB - Poa Dir_AbastoyPtar 4to_Trimes.pdf",
    "4to Trimestre",
    "Joana Paz",
    "31-12-2025",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/Poa%20Dir_AbastoyPtar%204to_Trimes.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION FISCALES.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20FISCALES.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION N421.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20N421.pdf",
    },
  ],
  [
    "DAF-S-RM - AUTORIZACION N807.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/AUTORIZACION%20N807.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N17.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N17.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N19.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N19.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N27.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N27.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N30.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N30.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N32.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N32.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N36.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N36.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N37.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N37.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN N421.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20N421.pdf",
    },
  ],
  [
    "DAF-S-RM - dictamen n45.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/dictamen%20n45.pdf",
    },
  ],
  [
    "DAF-S-RM - oficio auto n45.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/oficio%20auto%20n45.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N18.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N18.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N24.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N24.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N25.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N25.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N28.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N28.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N34.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N34.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N40.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N40.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N41.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N41.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTÁMEN N48.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTÁMEN%20N48.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS ADPE06bis.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20ADPE06bis.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS ADPE12.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20ADPE12.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS ADPE17.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20ADPE17.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS ADPE18.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20ADPE18.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS AMP MEDIDORES.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20AMP%20MEDIDORES.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS AMPLIACION SERV INT.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20AMPLIACION%20SERV%20INT.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS CABLE 4-0.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20CABLE%204-0.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS CABLE 500.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20CABLE%20500.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS EQ BOMBEO.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20EQ%20BOMBEO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS LAMELLAS.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20LAMELLAS.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS MACROMEDIDORES.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20MACROMEDIDORES.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS N18.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20N18.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS N25.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20N25.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS N28.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20N28.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS N34.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20N34.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS N41.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20N41.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOS N48.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOS%20N48.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO RECURSOSCABLE 3-0.pdf",
    "4to Trimestre",
    "Licitaciones",
    "02-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20RECURSOSCABLE%203-0.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS 6 VERIFICACIONES NOV-1-.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%206%20VERIFICACIONES%20NOV-1-.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION MANTENIMIENTO R-491.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20MANTENIMIENTO%20R-491.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS AUTONATION MANTENIMIENTO R-500.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20AUTONATION%20MANTENIMIENTO%20R-500.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEMI MANTENIMIENTO R-486.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEMI%20MANTENIMIENTO%20R-486.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GEMI MANTENIMIENTO R_486 REM-REF.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GEMI%20MANTENIMIENTO%20R_486%20REM-REF.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO 10,000 AGRICOLA R-517.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-517.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO 10,000 AGRICOLA R-518.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-518.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO 10,000 AGRICOLA R-519.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-519.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO 10,000 AGRICOLA R-527.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-527.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO 10,000 AGRICOLA R-529.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-529.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AUTONATION R-498.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AUTONATION%20R-498.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AUTONATION R-499.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AUTONATION%20R-499.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO ELEGANTES R-426.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20ELEGANTES%20R-426.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO LLANTAS FEDERICO.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20LLANTAS%20FEDERICO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-10,000 AGRICOLA R-516.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-10,000%20AGRICOLA%20R-516.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-10,000 AGRICOLA R-523.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-10,000%20AGRICOLA%20R-523.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-10,000 AGRICOLA R-525.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-10,000%20AGRICOLA%20R-525.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-517.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-517.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-520.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-520.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-521.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-521.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-522.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-522.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-524.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-524.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-526.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-526.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-527.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-527.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-528.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-528.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO-5000 AGRICOLA R-529.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO-5000%20AGRICOLA%20R-529.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS PERMISO PRIVADO PIPAS.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20PERMISO%20PRIVADO%20PIPAS.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN 20251010001 2 VERIFICACIONES OCT.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OSN%2020251010001%202%20VERIFICACIONES%20OCT.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20251125001 6 VERIFICACIONES NOV-1-.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OSN20251125001%206%20VERIFICACIONES%20NOV-1-.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251028001 PERMISO PRIVADO PIPAS.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251028001%20PERMISO%20PRIVADO%20PIPAS.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251112001 MANTENIMIENTO AUTONATION R-499.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251112001%20MANTENIMIENTO%20AUTONATION%20R-499.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251112002 MANTENIMIENTO AUTONATION R-500.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251112002%20MANTENIMIENTO%20AUTONATION%20R-500.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251112003 MANTENIMIENTO AUTONATION R-491.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251112003%20MANTENIMIENTO%20AUTONATION%20R-491.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125002 MANTENIMIENTO GEMI R-486.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125002%20MANTENIMIENTO%20GEMI%20R-486.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125003 MANTENIMIENTO GEMI R-486 REM-REF.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125003%20MANTENIMIENTO%20GEMI%20R-486%20REM-REF.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125004 MANTENIMIENTO-5000 AGRICOLA R-517.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125004%20MANTENIMIENTO-5000%20AGRICOLA%20R-517.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125005 MANTENIMIENTO-5000 AGRICOLA R-529.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125005%20MANTENIMIENTO-5000%20AGRICOLA%20R-529.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125006 MANTENIMIENTO-5000 AGRICOLA R-527.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125006%20MANTENIMIENTO-5000%20AGRICOLA%20R-527.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125007 MANTENIMIENTO-5000 AGRICOLA R-528.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125007%20MANTENIMIENTO-5000%20AGRICOLA%20R-528.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125008 MANTENIMIENTO-5000 AGRICOLA R-524.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125008%20MANTENIMIENTO-5000%20AGRICOLA%20R-524.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125009 MANTENIMIENTO-5000 AGRICOLA R-522.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125009%20MANTENIMIENTO-5000%20AGRICOLA%20R-522.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125010 MANTENIMIENTO-5000 AGRICOLA R-521.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125010%20MANTENIMIENTO-5000%20AGRICOLA%20R-521.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125011 MANTENIMIENTO-5000 AGRICOLA R-520.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125011%20MANTENIMIENTO-5000%20AGRICOLA%20R-520.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125012 MANTENIMIENTO-5000 AGRICOLA R-526.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125012%20MANTENIMIENTO-5000%20AGRICOLA%20R-526.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251125013 MANTENIMIENTO AUTONATION R-498.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251125013%20MANTENIMIENTO%20AUTONATION%20R-498.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251126001 MANTENIMIENTO LLANTAS FEDERICO.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251126001%20MANTENIMIENTO%20LLANTAS%20FEDERICO.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251201001 MANTENIMIENTO AUTONATION R-423.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251201001%20MANTENIMIENTO%20AUTONATION%20R-423.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217002 MANTENIMIENTO-10,000 AGRICOLA R-523.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217002%20MANTENIMIENTO-10,000%20AGRICOLA%20R-523.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217003 MANTENIMIENT-10,000 AGRICOLA R-525.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217003%20MANTENIMIENT-10,000%20AGRICOLA%20R-525.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217004 MANTENIMIENTO-10,000 AGRICOLA R-516.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217004%20MANTENIMIENTO-10,000%20AGRICOLA%20R-516.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217005 MANTENIMIENTO 10,000 AGRICOLA R-519.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217005%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-519.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217006 MANTENIMIENTO 10,000 AGRICOLA R-517.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217006%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-517.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217007 MANTENIMIENTO 10,000 AGRICOLA R-527.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217007%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-527.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217008 MANTENIMIENTO 10,000 AGRICOLA R-529.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217008%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-529.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217009 MANTENIMIENTO 10,000 AGRICOLA R-518.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217009%20MANTENIMIENTO%2010,000%20AGRICOLA%20R-518.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251217010 MANTENIMIENTO ELEGANTES R-426.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251217010%20MANTENIMIENTO%20ELEGANTES%20R-426.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913003989-N449-2025.pdf",
    "4to Trimestre",
    "Betty Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20EA-913003989-N449-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N22-2025.pdf",
    "4to Trimestre",
    "Betty Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N29-2025.pdf",
    "4to Trimestre",
    "Betty Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N29-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N33-2025.pdf",
    "4to Trimestre",
    "Betty Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N33-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N42-2025.pdf",
    "4to Trimestre",
    "Betty Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N42-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N49-2025.pdf",
    "4to Trimestre",
    "Betty Martinez",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N49-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - BOTIQUIN.pdf",
    "4to Trimestre",
    "Cristina Mejio",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/BOTIQUIN.pdf",
    },
  ],
  [
    "DAF-S-RM - MEDICINAS.pdf",
    "4to Trimestre",
    "Cristina Mejio",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/MEDICINAS.pdf",
    },
  ],
  [
    "DG-S-COMU - evidencia4trimestre.pdf",
    "4to Trimestre",
    "Erick Parra",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DG-S-COMU/evidencia4trimestre.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913003989-N449-2025.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20EA-913003989-N449-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N22-2025.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N29-2025.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N29-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N33-2025.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N33-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N42-2025.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N42-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN ES-913005999-N49-2025.pdf",
    "4to Trimestre",
    "Licitaciones",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20ES-913005999-N49-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-08-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-08-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-10-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-10-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-11-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-12-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-13-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-16-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-18-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-18-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-19-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-19-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-20-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-24-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-24-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-25-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-25-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-AD-OP-26-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-AD-OP-26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-INV3-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-INV3-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-05-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN CAASIM-HGO-L.O.P.-06-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DICTAMEN%20CAASIM-HGO-L.O.P.-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-08-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-08-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-10-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-10-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-11-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-12-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-13-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-16-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-18-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-18-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-19-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-19-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-20-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-24-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-24-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-25-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-25-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - FALLO CAASIM-HGO-AD-OP-26-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FALLO%20CAASIM-HGO-AD-OP-26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-08-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-08-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-10-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-10-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-11-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-12-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-13-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-16-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-18-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-18-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-19-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-19-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-20-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-24-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-24-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-25-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-25-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-AD-OP-26-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-AD-OP-26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-INV3-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-INV3-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-INV3-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-INV3-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-INV3-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-INV3-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-INV3-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-INV3-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-INV3-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-INV3-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - INVITACION CAASIM-HGO-INV3-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/INVITACION%20CAASIM-HGO-INV3-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-08-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-08-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-10-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-10-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-11-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-12-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-13-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-16-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-18-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-18-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-19-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-19-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-20-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-24-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-24-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-25-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-25-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-AD-OP-26-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-AD-OP-26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-INV3-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-INV3-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-INV3-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-INV3-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-INV3-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-INV3-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-INV3-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-INV3-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-INV3-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-INV3-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-INV3-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-INV3-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-L.O.P.-05-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-L.O.P.-05-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO DE AUTORIZACION CAASIM-HGO-L.O.P.-06-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20DE%20AUTORIZACION%20CAASIM-HGO-L.O.P.-06-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-08-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-08-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-10-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-10-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-11-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-11-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-12-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-12-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-13-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-13-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-14-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-14-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-15-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-15-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-16-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-17-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-17-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-18-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-18-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-19-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-19-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-20-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-21-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-21-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-22-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-22-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-23-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-23-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-24-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-24-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-25-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-25-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - PRESENTACION Y APERTURA CAASIM-HGO-AD-OP-26-2025.pdf",
    "4to Trimestre",
    "Abogado CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PRESENTACION%20Y%20APERTURA%20CAASIM-HGO-AD-OP-26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - 097.2025.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/097.2025.pdf",
    },
  ],
  [
    "DAF-S-RM - ARRENDAMIENTO GLIDER ENE-OCT.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/ARRENDAMIENTO%20GLIDER%20ENE-OCT.pdf",
    },
  ],
  [
    "DAF-S-RM - CUSTODIOS ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/CUSTODIOS%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FAC ELT273860.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FAC%20ELT273860.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AMABEL ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20AMABEL%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ARCODEM ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20ARCODEM%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS ARRENDAMIENTO EDUARDO ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20ARRENDAMIENTO%20EDUARDO%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS AURORA ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20AURORA%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS BLANCA CECILIA ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20BLANCA%20CECILIA%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS CARLOS IBARRA ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20CARLOS%20IBARRA%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS GRACIELA PEREZ ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20GRACIELA%20PEREZ%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURAS MANT EDUARDO ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/FACTURAS%20MANT%20EDUARDO%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - JULIETA CABRERA ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/JULIETA%20CABRERA%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - MA DEL CARMEN CORTEZ ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/MA%20DEL%20CARMEN%20CORTEZ%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - MANTENIMIENTO GLIDER ENE-OCT.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/MANTENIMIENTO%20GLIDER%20ENE-OCT.pdf",
    },
  ],
  [
    "DAF-S-RM - MARA REBECA ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/MARA%20REBECA%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - MARIA DEL CARMEN PARRA ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/MARIA%20DEL%20CARMEN%20PARRA%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - NORBERTO SILVA ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/NORBERTO%20SILVA%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - ODILON GEMPO ENE-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/ODILON%20GEMPO%20ENE-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - OLIVER IBARRA SEPT-DIC.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OLIVER%20IBARRA%20SEPT-DIC.pdf",
    },
  ],
  [
    "DAF-S-RM - policia hidrica ene-dic.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/policia%20hidrica%20ene-dic.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251002001.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251002001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251031001.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251031001.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251202002.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251202002.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20251224001.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20251224001.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-209-2025.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-209-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-236-2025.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-236-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-281-2025.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-281-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-314-2025.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-314-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX FAC DICIEMBRE.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/TELMEX%20FAC%20DICIEMBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX FAC NOVIEMBRE.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/TELMEX%20FAC%20NOVIEMBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - TELMEX FAC OCTUBRE.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/TELMEX%20FAC%20OCTUBRE.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N16-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N20-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N26-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N448-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N448-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N46-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N46-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N609-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N609-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SH-3622-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SH-3622-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-307-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-307-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-315-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-315-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-330-2025.pdf",
    "4to Trimestre",
    "DAF CAASIM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-330-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - 097.2025.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/097.2025.pdf",
    },
  ],
  [
    "DAF-S-RM - ARRENDAMIENTO GLIDER ENE-OCT.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/ARRENDAMIENTO%20GLIDER%20ENE-OCT.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-255.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-255.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-312.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-312.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-313.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-313.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-324.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-324.pdf",
    },
  ],
  [
    "DAF-S-RM - accesorios de computo.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/accesorios%20de%20computo.pdf",
    },
  ],
  [
    "DAF-S-RM - alimentacion 8760.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/alimentacion%208760.pdf",
    },
  ],
  [
    "DAF-S-RM - alimentación 24000.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/alimentación%2024000.pdf",
    },
  ],
  [
    "DAF-S-RM - fac accesorios de computo.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/fac%20accesorios%20de%20computo.pdf",
    },
  ],
  [
    "DAF-S-RM - fac botiquin.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/fac%20botiquin.pdf",
    },
  ],
  [
    "DAF-S-RM - fac medicinas.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/fac%20medicinas.pdf",
    },
  ],
  [
    "DAF-S-RM - gastos de oficina.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/gastos%20de%20oficina.pdf",
    },
  ],
  [
    "DAF-S-RM - persianas.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/persianas.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO BOTIQUÍN.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PEDIDO%20BOTIQUÍN.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO MEDICAMENTOS.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PEDIDO%20MEDICAMENTOS.pdf",
    },
  ],
  [
    "DAF-S-RM - PEDIDO SELLOS.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PEDIDO%20SELLOS.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N26.pdf",
    "4to Trimestre",
    "Sandy RM",
    "05-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N26.pdf",
    },
  ],
  [
    "DAF-S-RM - acta_de_apertura_de_proposiciones-firmada (2).pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/acta_de_apertura_de_proposiciones-firmada%20(2).pdf",
    },
  ],
  [
    "DAF-S-RM - acta_de_apertura_de_proposiciones-firmada.pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/acta_de_apertura_de_proposiciones-firmada.pdf",
    },
  ],
  [
    "DAF-S-RM - acta_de_fallo-firmada (2).pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/acta_de_fallo-firmada%20(2).pdf",
    },
  ],
  [
    "DAF-S-RM - acta_de_fallo-firmada.pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/acta_de_fallo-firmada.pdf",
    },
  ],
  [
    "DAF-S-RM - acta_junta_de_aclaraciones-firmada (2).pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/acta_junta_de_aclaraciones-firmada%20(2).pdf",
    },
  ],
  [
    "DAF-S-RM - acta_junta_de_aclaraciones-firmada.pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/acta_junta_de_aclaraciones-firmada.pdf",
    },
  ],
  [
    "DAF-S-RM - Bases N-1 convocatoria.pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Bases%20N-1%20convocatoria.pdf",
    },
  ],
  [
    "DAF-S-RM - Bases N6 convocatoria.pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Bases%20N6%20convocatoria.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen de bases (2).pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20de%20bases%20(2).pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen de bases.PDF",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20de%20bases.PDF",
    },
  ],
  [
    "DAF-S-RM - suficiencia presupuestal (2).pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/suficiencia%20presupuestal%20(2).pdf",
    },
  ],
  [
    "DAF-S-RM - suficiencia presupuestal.pdf",
    "4to Trimestre",
    "Norma Torres",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/suficiencia%20presupuestal.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS 2 VERIFICACIONES OCT.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%202%20VERIFICACIONES%20OCT.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AUTONATION R-423.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AUTONATION%20R-423.pdf",
    },
  ],
  [
    "DAF-S-RM - fac madera.pdf",
    "4to Trimestre",
    "Ines Flores",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/fac%20madera.pdf",
    },
  ],
  [
    "DAF-S-RM - suficiencia botiquin.pdf",
    "4to Trimestre",
    "Ines Flores",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/suficiencia%20botiquin.pdf",
    },
  ],
  [
    "DAF-S-RM - suficiencia medicinas.pdf",
    "4to Trimestre",
    "Ines Flores",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/suficiencia%20medicinas.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-174-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-174-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-178-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-178-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-181-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-181-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-183-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-183-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-184-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-184-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-194-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-194-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS -DIAGNOSTICO- MANTENIMIENTO AUTONATION R-497.pdf",
    "4to Trimestre",
    "Edgar Bautista",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20-DIAGNOSTICO-%20MANTENIMIENTO%20AUTONATION%20R-497.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AGRICOLA R-520.pdf",
    "4to Trimestre",
    "Edgar Bautista",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AGRICOLA%20R-520.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AGRICOLA R-524.pdf",
    "4to Trimestre",
    "Edgar Bautista",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AGRICOLA%20R-524.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AUTONATION R-425.pdf",
    "4to Trimestre",
    "Edgar Bautista",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AUTONATION%20R-425.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AUTONATION R-493.pdf",
    "4to Trimestre",
    "Edgar Bautista",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AUTONATION%20R-493.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO AUTONATION R-497.pdf",
    "4to Trimestre",
    "Edgar Bautista",
    "06-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20AUTONATION%20R-497.pdf",
    },
  ],
  [
    "DAB - MIRabasto y Ptars4oT_2025 .pdf",
    "4to Trimestre",
    "Joana Paz",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/MIRabasto%20y%20Ptars4oT_2025%20.pdf",
    },
  ],
  [
    "DAB - POAabasto y Ptars4oT_2025.pdf",
    "4to Trimestre",
    "Joana Paz",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAB/POAabasto%20y%20Ptars4oT_2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N16-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N16-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N20-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N20-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N26-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N26-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N448-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N448-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N46-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N46-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N609-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Dictamen%20N609-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SH-3622-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SH-3622-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-307-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-307-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-315-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-315-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-330-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-330-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-333-2025.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/SPF-333-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - HACIENDA-A-FGPAR-GI-2025-4019-00351.pdf",
    "4to Trimestre",
    "Licitaciones CAASIM",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/HACIENDA-A-FGPAR-GI-2025-4019-00351.pdf",
    },
  ],
  [
    "DAF-S-RM - Contrato Oxxo ultimo.pdf",
    "4to Trimestre",
    "Sibdireccion Ingresos",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Contrato%20Oxxo%20ultimo.pdf",
    },
  ],
  [
    "DAF-S-RM - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "4to Trimestre",
    "Sibdireccion Ingresos",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-RM - Monto Total 4to. trimestre Oxxo 2025.xlsx",
    "4to Trimestre",
    "Sibdireccion Ingresos",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Monto%20Total%204to.%20trimestre%20Oxxo%202025.xlsx",
    },
  ],
  [
    "DAF-S-RM - Monto Total 4to. trimestre Oxxo 2025[1].xlsx",
    "4to Trimestre",
    "Sibdireccion Ingresos",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Monto%20Total%204to.%20trimestre%20Oxxo%202025[1].xlsx",
    },
  ],
  [
    "DAF-S-RM - Montos Recaudados Oxxo 4to. Trim 2025.pdf",
    "4to Trimestre",
    "Sibdireccion Ingresos",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Montos%20Recaudados%20Oxxo%204to.%20Trim%202025.pdf",
    },
  ],
  [
    "DAF-S-RM - Total Rec. Oxxo 4to. Trimestre 2025.pdf",
    "4to Trimestre",
    "Sibdireccion Ingresos",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/Total%20Rec.%20Oxxo%204to.%20Trimestre%202025.pdf",
    },
  ],
  [
    "DAP - Contaminantes.docx",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Contaminantes.docx",
    },
  ],
  [
    "DAP - Contaminantes.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Contaminantes.pdf",
    },
  ],
  [
    "DAP - Permiso descarga.docx",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Permiso%20descarga.docx",
    },
  ],
  [
    "DAP - Permiso descarga.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Permiso%20descarga.pdf",
    },
  ],
  [
    "DAP - Reposicion.docx",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Reposicion.docx",
    },
  ],
  [
    "DAP - Reposicion.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Reposicion.pdf",
    },
  ],
  [
    "DAP - CONTRATO CAASIM.DAJ.1342025.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/CONTRATO%20CAASIM.DAJ.1342025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-179-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-179-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-180-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-180-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-185-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-185-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-186-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-186-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-187-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-187-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-188-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-188-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-189-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-189-2025.pdf",
    },
  ],
  [
    "DAP - contaminantes4oT.2025.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/contaminantes4oT.2025.pdf",
    },
  ],
  [
    "DAP - Renovacion4oT.2025.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Renovacion4oT.2025.pdf",
    },
  ],
  [
    "DAP - Reposición4oT.2025.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/Reposición4oT.2025.pdf",
    },
  ],
  [
    "DCOME - Derivacion .pdf",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCOME/Derivacion%20.pdf",
    },
  ],
  [
    "DCOME - Solicitud.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCOME/Solicitud.pdf",
    },
  ],
  [
    "DAF-S-I - Contrato Oxxo ultimo.pdf",
    "4to Trimestre",
    "Maribel Butron",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Contrato%20Oxxo%20ultimo.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "4to Trimestre",
    "Maribel Butron",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - Monto Mensual 4to. trimestre Oxxo 2025.xlsx",
    "4to Trimestre",
    "Maribel Butron",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Monto%20Mensual%204to.%20trimestre%20Oxxo%202025.xlsx",
    },
  ],
  [
    "DAF-S-I - Monto Total 4to. trimestre Oxxo 2025.xlsx",
    "4to Trimestre",
    "Maribel Butron",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Monto%20Total%204to.%20trimestre%20Oxxo%202025.xlsx",
    },
  ],
  [
    "DAF-S-I - Montos Recaudados Oxxo 4to. Trim 2025.pdf",
    "4to Trimestre",
    "Maribel Butron",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Montos%20Recaudados%20Oxxo%204to.%20Trim%202025.pdf",
    },
  ],
  [
    "DAF-S-I - Total Rec. Oxxo 4to. Trimestre 2025.pdf",
    "4to Trimestre",
    "Maribel Butron",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Total%20Rec.%20Oxxo%204to.%20Trimestre%202025.pdf",
    },
  ],
  [
    "DAP - CONTRATO CAASIM.DAJ.134.2025.pdf",
    "4to Trimestre",
    "Micaela Copca",
    "07-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAP/CONTRATO%20CAASIM.DAJ.134.2025.pdf",
    },
  ],
  [
    "DAF-S-PF - Cuotas y tarifas CAASIM 2026 (ocr).pdf",
    "4to Trimestre",
    "Plaenacion Financiera",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Cuotas%20y%20tarifas%20CAASIM%202026%20(ocr).pdf",
    },
  ],
  [
    "DAF-S-I - INGmensual4oT.2025.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/INGmensual4oT.2025.pdf",
    },
  ],
  [
    "DAF-S-I - INGtrim4oT.2025.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/INGtrim4oT.2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-171-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-171-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-172-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-172-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-190-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-190-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-193-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-193-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-195-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-195-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-198-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-198-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-199-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-199-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-200-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-200-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-201-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-201-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-207-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-207-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-208-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-208-2025.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-106-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "08-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Convenio%20DAJ-106-2025.pdf",
    },
  ],
  [
    "DAF-S-RM - doc02424720260109161425.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "13-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/doc02424720260109161425.pdf",
    },
  ],
  [
    "DAF-S-RM - doc02424820260109161456.pdf",
    "4to Trimestre",
    "Cristina Mejia",
    "13-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/doc02424820260109161456.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-126-2024 Bacheo Z-4.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-126-2024%20Bacheo%20Z-4.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-127-2024 Bacheo Z-3.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-127-2024%20Bacheo%20Z-3.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-128-2024 Bacheo Z-2..pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-128-2024%20Bacheo%20Z-2..pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-129-2024 Bacheo Z1.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-129-2024%20Bacheo%20Z1.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-132-2024 Alc Z-4.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-132-2024%20Alc%20Z-4.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-135-2025 Agua Z-1.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-135-2025%20Agua%20Z-1.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-141-2024  Redes Z-5.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-141-2024%20%20Redes%20Z-5.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-143-2024 Redes Z-3.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-143-2024%20Redes%20Z-3.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-144-2024 Redes Z-4.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-144-2024%20Redes%20Z-4.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-145-2024 Redes Z-1.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-145-2024%20Redes%20Z-1.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-147-2025 Agua Z-3.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-147-2025%20Agua%20Z-3.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-155-2024 Agua Z-2.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-155-2024%20Agua%20Z-2.pdf",
    },
  ],
  [
    "DCONS - AER CAASIM-DAJ-46-2024 Descargas.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/AER%20CAASIM-DAJ-46-2024%20Descargas.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-094-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-094-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-097-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-097-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-109-2025.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-109-2025.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-120-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-120-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-149-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-149-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-175-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-175-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-177-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-177-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-197-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-197-2024.pdf",
    },
  ],
  [
    "DCONS - CAASIM-DAJ-95-2024.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CAASIM-DAJ-95-2024.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 101.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%20101.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 102.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%20102.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 112.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%20112.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 113.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%20113.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 114.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%20114.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 123.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%20123.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 67.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%2067.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 93.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%2093.pdf",
    },
  ],
  [
    "DCONS - CONTRATO 94.pdf",
    "4to Trimestre",
    "Blanca",
    "14-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/CONTRATO%2094.pdf",
    },
  ],
  [
    "DCONS - avances de obra  dic 2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/avances%20de%20obra%20%20dic%202025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM DAJ-126-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM%20DAJ-126-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM DAJ-127.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM%20DAJ-127.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM DAJ-67-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM%20DAJ-67-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-094-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-094-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-101-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-101-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-102-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-102-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-107-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-107-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-112-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-112-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-113-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-113-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-114-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-114-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-120-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-120-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-121-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-121-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-123-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-123-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-124-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-124-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-125-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-125-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-128-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-128-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-129-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-129-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-131-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-131-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-143-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-143-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-144-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-144-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-145-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-145-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-146-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-146-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-149-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-149-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-150-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-150-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-151-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-151-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-154-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-154-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-155-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-155-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-166-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-166-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-167-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-167-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-168-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-168-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-170-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-170-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-171-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-171-2025.pdf",
    },
  ],
  [
    "DCONS - FACT. CAASIM-DAJ-93-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.%20CAASIM-DAJ-93-2025.pdf",
    },
  ],
  [
    "DCONS - FACT.CAASIM-DAJ-147-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.CAASIM-DAJ-147-2025.pdf",
    },
  ],
  [
    "DCONS - FACT.CAASIM-DAJ-148-2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "15-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/FACT.CAASIM-DAJ-148-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-196-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "19-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-196-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-197-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "19-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-197-2025.pdf",
    },
  ],
  [
    "DCONS - Avance fis y finan 23.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "20-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/Avance%20fis%20y%20finan%2023.pdf",
    },
  ],
  [
    "DCONS - avance fisico financiero 2025.pdf",
    "4to Trimestre",
    "Blanca E R M",
    "20-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DCONS/avance%20fisico%20financiero%202025.pdf",
    },
  ],
  [
    "DAJ - Subsidios Octubre - Diciembre 2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Subsidios%20Octubre%20-%20Diciembre%202025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-202-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-202-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-212-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-212-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-222-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-222-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-224-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-224-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-226-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-226-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-228-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-228-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-229-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-229-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-233-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-233-2025.pdf",
    },
  ],
  [
    "DAF-S-PF - CAASIM.PTO.2026.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "21-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/CAASIM.PTO.2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-173-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-173-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-223-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-223-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-230-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-230-2025.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-101-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Convenio%20DAJ-101-2025.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-102-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Convenio%20DAJ-102-2025.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-103-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Convenio%20DAJ-103-2025.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. h) Pasivos Contingentes.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20h)%20Pasivos%20Contingentes.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Edos Financieros.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Edos%20Financieros.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. a) EAI con excedentes.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20a)%20EAI%20con%20excedentes.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1 EAEPE Clasificacion Administrativa.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%201.1%20EAEPE%20Clasificacion%20Administrativa.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2 EAEPE Identificado por Ramo.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20EAEPE%20Identificado%20por%20Ramo.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. EAEPE Clasificacion Economica-Tipo de Gasto.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%202.%20EAEPE%20Clasificacion%20Economica-Tipo%20de%20Gasto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. EAEPE COG (Capitulo y Concepto).xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%203.%20EAEPE%20COG%20(Capitulo%20y%20Concepto).xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. EAEPE Clasificacion Funcional.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%204.%20EAEPE%20Clasificacion%20Funcional.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. d) Interes de la Deuda.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20d)%20Interes%20de%20la%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo de Fondos.xlsx",
    "4to Trimestre",
    "Blanca Trinajeros",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20de%20Fondos.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda Publica.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda%20Publica.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda Otros Pasivos.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. h) Informe Pasivos Contingentes.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Estados Financieros.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) Estado Ingresos Excedentes.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20a)%20Estado%20Ingresos%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1. Estado Egresos Clasificacion Administrativa.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%201.1.%20Estado%20Egresos%20Clasificacion%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2 Estado Egresos Identificado Ramo.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20Estado%20Egresos%20Identificado%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. Estado Egresos Clasificacion Economica.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Clasificacion%20Economica.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. Estado Egresos COG.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20COG.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. Estado Egresos Clasificacion Funcional.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Clasificacion%20Funcional.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses Deuda.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo Fondos.pdf",
    "4to Trimestre",
    "Blanca ERM",
    "23-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20Fondos.pdf",
    },
  ],
  [
    "DAF-S-PCF - EDITABLE EAEPE COG, T GTO, ADMIN Y FUNCIONAL.xlsx",
    "4to Trimestre",
    "IVETH PCF",
    "26-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/EDITABLE%20EAEPE%20COG,%20T%20GTO,%20ADMIN%20Y%20FUNCIONAL.xlsx",
    },
  ],
  [
    "DAF-S-PCF - EDITABLE EAI.xlsx",
    "4to Trimestre",
    "IVETH PCF",
    "26-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/EDITABLE%20EAI.xlsx",
    },
  ],
  [
    "DAF-S-PCF - PDF EAEPE COG, T GTO, ADMIN Y FUNCIONAL.pdf",
    "4to Trimestre",
    "IVETH PCF",
    "26-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/PDF%20EAEPE%20COG,%20T%20GTO,%20ADMIN%20Y%20FUNCIONAL.pdf",
    },
  ],
  [
    "DAF-S-PCF - PDF EAI.pdf",
    "4to Trimestre",
    "IVETH PCF",
    "26-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/PDF%20EAI.pdf",
    },
  ],
  [
    "DAF-S-PCF - Estado Egresos COG, TG, ADMIN Y FUNCIONAL.pdf",
    "4to Trimestre",
    "Ivett",
    "26-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/Estado%20Egresos%20COG,%20TG,%20ADMIN%20Y%20FUNCIONAL.pdf",
    },
  ],
  [
    "DAF-S-PCF - Estado Ingresos.pdf",
    "4to Trimestre",
    "Ivett",
    "26-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PCF/Estado%20Ingresos.pdf",
    },
  ],
  [
    "DAF-S-PF - a) Gasto por Categoría Programática (1).pdf",
    "4to Trimestre",
    "Marisol Bautista",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/a)%20Gasto%20por%20Categoría%20Programática%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - b) Programas y Proyectos de Inversión (1).pdf",
    "4to Trimestre",
    "Marisol Bautista",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/b)%20Programas%20y%20Proyectos%20de%20Inversión%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - c) Indicadores de Resultados (1).pdf",
    "4to Trimestre",
    "Marisol Bautista",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/c)%20Indicadores%20de%20Resultados%20(1).pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-169-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-169-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-177-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-177-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-192-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-192-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-231-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-231-2025.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-232-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Contrato%20DAJ-232-2025.pdf",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoria programática 31 dic.xlsx",
    "4to Trimestre",
    "Marisol Bautista",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programática%2031%20dic.xlsx",
    },
  ],
  [
    "DAF-S-PF - Indicadores de resultados 31 diciembre 25.xlsx",
    "4to Trimestre",
    "Marisol Bautista",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados%2031%20diciembre%2025.xlsx",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversión 31 dic.xlsx",
    "4to Trimestre",
    "Marisol Bautista",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión%2031%20dic.xlsx",
    },
  ],
  [
    "DAF - Dictamen de Baja Documental AGE-SEA-DBDTS-275-2025.pdf",
    "4to Trimestre",
    "Shaid Archivo",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF/Dictamen%20de%20Baja%20Documental%20AGE-SEA-DBDTS-275-2025.pdf",
    },
  ],
  [
    "DAF - Dictamen de Baja Documental AGE-SEA-DBDTS-284-2025.pdf",
    "4to Trimestre",
    "Shaid Archivo",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF/Dictamen%20de%20Baja%20Documental%20AGE-SEA-DBDTS-284-2025.pdf",
    },
  ],
  [
    "DAF - Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-278-2025.pdf",
    "4to Trimestre",
    "Shaid Archivo",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF/Dictamen%20de%20Baja%20Documental%20y-o%20Transferencia%20Secundaria%20AGE-SEA-DBDTS-278-2025.pdf",
    },
  ],
  [
    "DAF - Informe 2025 ocr.pdf",
    "4to Trimestre",
    "Shaid Archivo",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF/Informe%202025%20ocr.pdf",
    },
  ],
  [
    "DAF - PADA OCR 2026.pdf",
    "4to Trimestre",
    "Shaid Archivo",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF/PADA%20OCR%202026.pdf",
    },
  ],
  [
    "DAF-S-PF - Estado por categoria programatica ok1.pdf",
    "4to Trimestre",
    "Marisol Bautista",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Estado%20por%20categoria%20programatica%20ok1.pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de Resultados.pdf",
    "4to Trimestre",
    "Marisol Bautista",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Indicadores%20de%20Resultados.pdf",
    },
  ],
  [
    "DAF-S-PF - Programa y proyectos de inversion.pdf",
    "4to Trimestre",
    "Marisol Bautista",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Programa%20y%20proyectos%20de%20inversion.pdf",
    },
  ],
  [
    "DAF - DICTAMEN 2025.pdf",
    "4to Trimestre",
    "Hector Shaid",
    "28-01-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF/DICTAMEN%202025.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZASCION AUTONATION R-490.pdf",
    "4to Trimestre",
    "Egarcito Martinez",
    "03-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZASCION%20AUTONATION%20R-490.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260126001 AUTONATION R-490.pdf",
    "4to Trimestre",
    "Egarcito Martinez",
    "03-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260126001%20AUTONATION%20R-490.pdf",
    },
  ],
  [
    "DAJ - CUOTAS Y TARIFAS 2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CUOTAS%20Y%20TARIFAS%202026.pdf",
    },
  ],
  [
    "DAJ - Lineamientos generales para la atención de ajuste a la facturación.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Lineamientos%20generales%20para%20la%20atención%20de%20ajuste%20a%20la%20facturación.pdf",
    },
  ],
  [
    "DAJ - Normas para Cancelar Adeudos a Cargo de Terceros.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/Normas%20para%20Cancelar%20Adeudos%20a%20Cargo%20de%20Terceros.pdf",
    },
  ],
  [
    "DAF-S-I - Monto total Erogado 4to. Trim. Oxxo 2025.pdf",
    "4to Trimestre",
    "Maribel Butron",
    "10-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Monto%20total%20Erogado%204to.%20Trim.%20Oxxo%202025.pdf",
    },
  ],
  [
    "DAF-S-I - Monto Total Erogado 4to. trimestre Oxxo 2025.xlsx",
    "4to Trimestre",
    "Maribel Butron",
    "10-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Monto%20Total%20Erogado%204to.%20trimestre%20Oxxo%202025.xlsx",
    },
  ],
  [
    "DAF-S-I - Edo analitico 4to. Trim. Oxxo 2025.docx",
    "4to Trimestre",
    "Maribel Butron",
    "10-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/Edo%20analitico%204to.%20Trim.%20Oxxo%202025.docx",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-092-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-092-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-094-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-094-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-095-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-095-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-096-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-096-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-098-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-098-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-099-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-099-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-100-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-100-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-104-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel Olguin",
    "11-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-104-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-091-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-091-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-093-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-093-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-109-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-109-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-111-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-111-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-156-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-156-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-158-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-158-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-164-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-164-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-203-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-203-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-204-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-204-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-209-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-209-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-213-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "20-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-213-2025.pdf",
    },
  ],
  [
    "DAF-S-I - 4to. Trim. Oxxo 2025.pdf",
    "4to Trimestre",
    "Amparo Flores",
    "25-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-I/4to.%20Trim.%20Oxxo%202025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-001-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-001-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-002-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-002-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-024-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-024-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-025-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-025-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-028-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-028-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-029-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-029-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-030-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-030-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-031-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-031-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-032-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-032-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-033-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-033-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-035-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-035-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-036-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-036-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-037-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-037-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-494 AUTONATION.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-494%20AUTONATION.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-516 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-516%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-517 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-517%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-518 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-518%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-519 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-519%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-521 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-521%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-522 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-522%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-526 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-526%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS R-528 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20R-528%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212002 MANTENIMIENTO R-522 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212002%20MANTENIMIENTO%20R-522%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212003 MANTENIMIENTO R-526 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212003%20MANTENIMIENTO%20R-526%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212004 MANTENIMIENTO R-516 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212004%20MANTENIMIENTO%20R-516%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212005 MANTENIMIENTO  R-528 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212005%20MANTENIMIENTO%20%20R-528%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212006 MANTENIMIENTO R-518 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212006%20MANTENIMIENTO%20R-518%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212007 MANTENIMIENTO R-517 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212007%20MANTENIMIENTO%20R-517%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212008 MANTENIMIENTO R-519 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212008%20MANTENIMIENTO%20R-519%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260212009 MANTENIMIENTO R-521 CASA AGRICOLA.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260212009%20MANTENIMIENTO%20R-521%20CASA%20AGRICOLA.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260220001 MANTENIMIENTO R-494 AUTONATION.pdf",
    "4to Trimestre",
    "Edgar Martinez",
    "26-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-RM/PSN20260220001%20MANTENIMIENTO%20R-494%20AUTONATION.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-071-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-071-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-175-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-175-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-214-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-214-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-215-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-215-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-216-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "27-02-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-216-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-006-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "02-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-006-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-007-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "02-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-007-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-008-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "02-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-008-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-034-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "02-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-034-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-210-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "02-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-210-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-001-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-001-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-004-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-004-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-005-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-005-2026.pdf",
    },
  ],
  [
    "DAJ - CEA-COLAB-ORG-01-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "06-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CEA-COLAB-ORG-01-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-004-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-004-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-005-2026.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-005-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-206-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-206-2025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-211-2025.pdf",
    "4to Trimestre",
    "Jorge Daniel",
    "09-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAJ/CAASIM-DAJ-211-2025.pdf",
    },
  ],
  [
    "1. CONTRATO CAASIM DAJ177 2023.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/1.%20CONTRATO%20CAASIM%20DAJ177%202023.pdf",
    },
  ],
  [
    "2. CONVENIO DE AMPLIACIÓN CAASIM 64 2023.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/2.%20CONVENIO%20DE%20AMPLIACIÓN%20CAASIM%2064%202023.pdf",
    },
  ],
  [
    "3. CONVENIO MODIFICATORIO CAASIM-DAJ-056-2024 2 centavos.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/3.%20CONVENIO%20MODIFICATORIO%20CAASIM-DAJ-056-2024%202%20centavos.pdf",
    },
  ],
  [
    "4. Convenio modificatorio de metas CAASIM DAJ 012.2024.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/4.%20Convenio%20modificatorio%20de%20metas%20CAASIM%20DAJ%20012.2024.pdf",
    },
  ],
  [
    "5. Póliza 1000083 $1,076664.19.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/5.%20Póliza%201000083%20$1,076664.19.pdf",
    },
  ],
  [
    "6. Póliza 1000082 $304,651.33.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/6.%20Póliza%201000082%20$304,651.33.pdf",
    },
  ],
  [
    "7. Póliza 1000054 $1,009,272.95.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/7.%20Póliza%201000054%20$1,009,272.95.pdf",
    },
  ],
  [
    "8. Póliza 1000053 $322,462.88.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/8.%20Póliza%201000053%20$322,462.88.pdf",
    },
  ],
  [
    "9. Póliza 1203435 $1,181,916.94.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/9.%20Póliza%201203435%20$1,181,916.94.pdf",
    },
  ],
  [
    "10. Póliza 1203436 203,418.99.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/10.%20Póliza%201203436%20203,418.99.pdf",
    },
  ],
  [
    "11. Póliza 1200728 $493,849.26.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/11.%20Póliza%201200728%20$493,849.26.pdf",
    },
  ],
  [
    "12. Póliza 1200729 $95,104.32.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/12.%20Póliza%201200729%20$95,104.32.pdf",
    },
  ],
  [
    "13. Póliza 0101379 $1,286,729.47.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/13.%20Póliza%200101379%20$1,286,729.47.pdf",
    },
  ],
  [
    "14. Póliza 0101378 $306,837.70.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/14.%20Póliza%200101378%20$306,837.70.pdf",
    },
  ],
  [
    "15. Póliza 0202619 $936,952.65.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/15.%20Póliza%200202619%20$936,952.65.pdf",
    },
  ],
  [
    "16. Póliza 0201468 $173,280.15.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/16.%20Póliza%200201468%20$173,280.15.pdf",
    },
  ],
  [
    "17. Póliza 0301690 $376,654.51.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/17.%20Póliza%200301690%20$376,654.51.pdf",
    },
  ],
  [
    "18. Póliza 0303248 $724,288.86.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/18.%20Póliza%200303248%20$724,288.86.pdf",
    },
  ],
  [
    "19. Factura 1 Mezcla.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/19.%20Factura%201%20Mezcla.pdf",
    },
  ],
  [
    "20. Factura 2 Agregados.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/20.%20Factura%202%20Agregados.pdf",
    },
  ],
  [
    "21. Factura 3 Mezcla.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/21.%20Factura%203%20Mezcla.pdf",
    },
  ],
  [
    "22. Factura 4 Agregados.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/22.%20Factura%204%20Agregados.pdf",
    },
  ],
  [
    "23. Factura 5 Mezcla.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/23.%20Factura%205%20Mezcla.pdf",
    },
  ],
  [
    "24. Factura 6 agregados.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/24.%20Factura%206%20agregados.pdf",
    },
  ],
  [
    "25. Factura 7 Mezcla.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/25.%20Factura%207%20Mezcla.pdf",
    },
  ],
  [
    "26. Factura 8 Agregados.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/26.%20Factura%208%20Agregados.pdf",
    },
  ],
  [
    "27. Factura 9 Mezcla.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/27.%20Factura%209%20Mezcla.pdf",
    },
  ],
  [
    "28. Factura 10 Agregados.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/28.%20Factura%2010%20Agregados.pdf",
    },
  ],
  [
    "29. Factura 11 Mezcla.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/29.%20Factura%2011%20Mezcla.pdf",
    },
  ],
  [
    "30. Factura 12 Agregados.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/30.%20Factura%2012%20Agregados.pdf",
    },
  ],
  [
    "31. Factura 13 Agregados.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/31.%20Factura%2013%20Agregados.pdf",
    },
  ],
  [
    "32. Factura 14 Mezcla.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/32.%20Factura%2014%20Mezcla.pdf",
    },
  ],
  [
    "33. FACTURA 1, MEZCLA ASFALTICA Y EMIULSIÓN.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/33.%20FACTURA%201,%20MEZCLA%20ASFALTICA%20Y%20EMIULSIÓN.zip",
    },
  ],
  [
    "34. FACTURA 2, AGREGADOS.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/34.%20FACTURA%202,%20AGREGADOS.zip",
    },
  ],
  [
    "35. FACTURA 3, MEZCLA ASFALTICA Y EMULSIÓN.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/35.%20FACTURA%203,%20MEZCLA%20ASFALTICA%20Y%20EMULSIÓN.zip",
    },
  ],
  [
    "36. FACTURA 4, AGREGADOS.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/36.%20FACTURA%204,%20AGREGADOS.zip",
    },
  ],
  [
    "37. FACTURA 5, MEZCLA ASFALTICA Y EMULSIÓN.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/37.%20FACTURA%205,%20MEZCLA%20ASFALTICA%20Y%20EMULSIÓN.zip",
    },
  ],
  [
    "38. FACTURA 6, AGREGADOS.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/38.%20FACTURA%206,%20AGREGADOS.zip",
    },
  ],
  [
    "39. FACTURA 7, MEZCLA ASFALTICA Y EMULSIÓN.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/39.%20FACTURA%207,%20MEZCLA%20ASFALTICA%20Y%20EMULSIÓN.zip",
    },
  ],
  [
    "40. FACTURA 8, AGREGADOS.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/40.%20FACTURA%208,%20AGREGADOS.zip",
    },
  ],
  [
    "41. FACTURA 9, MEZCLA ASFALTICA Y EMULSIÓN.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/41.%20FACTURA%209,%20MEZCLA%20ASFALTICA%20Y%20EMULSIÓN.zip",
    },
  ],
  [
    "42. FACTURA 10, AGREGADOS.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/42.%20FACTURA%2010,%20AGREGADOS.zip",
    },
  ],
  [
    "43. FACTURA 11, MEZCLA ASFALTICA Y EMULSIÓN.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/43.%20FACTURA%2011,%20MEZCLA%20ASFALTICA%20Y%20EMULSIÓN.zip",
    },
  ],
  [
    "44.  FACTURA 12, AGREGADOS.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/44.%20%20FACTURA%2012,%20AGREGADOS.zip",
    },
  ],
  [
    "45. FACTURA 14, AGREGADOS.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/45.%20FACTURA%2014,%20AGREGADOS.zip",
    },
  ],
  [
    "46. FACTURA 13, MEZCLA ASFALTICA Y EMULSIÓN.zip",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/46.%20FACTURA%2013,%20MEZCLA%20ASFALTICA%20Y%20EMULSIÓN.zip",
    },
  ],
  [
    "47. Acta de validación FAFEF 00135 2023.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/47.%20Acta%20de%20validación%20FAFEF%2000135%202023.pdf",
    },
  ],
  [
    "48. Tarjeta Inf. Anexo 1.pdf",
    "Contratos",
    "Lic Marai",
    "12-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/DCONS/Contratos-120326/48.%20Tarjeta%20Inf.%20Anexo%201.pdf",
    },
  ],
  [
    "DAF-S-PF - Informe de Director General octubre-diciembre 2025.pdf",
    "4to Trimestre",
    "Biviana Limon",
    "17-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2025/4to%20Trimestre/DAF-S-PF/Informe%20de%20Director%20General%20octubre-diciembre%202025.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-046-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-046-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-048-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-048-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-049-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-049-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-052-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-052-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-003-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-003-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-009-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-009-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-011-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-011-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-012-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "19-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-012-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-010-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "25-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-010-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-041-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "25-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-041-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-051-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "25-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-051-2026.pdf",
    },
  ],
  [
    "DAF-S-PCF - DAF-SPCF-8-2026.docx",
    "1er Trimestre",
    "Adriana Dra",
    "25-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/DAF-SPCF-8-2026.docx",
    },
  ],
  [
    "DAF-S-PCF - DAF-SPCF-8-2026.pdf",
    "1er Trimestre",
    "Adriana Dra",
    "25-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/DAF-SPCF-8-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - CONVENIO CEAA.pdf",
    "1er Trimestre",
    "Ines Flroes",
    "25-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/CONVENIO%20CEAA.pdf",
    },
  ],

  [
    "Ejercicio2026 - RENOVACIÓN Y PERMISO DE DESCARGA DE AGUA RESIDUAL1.pdf",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/RENOVACIÓN%20Y%20PERMISO%20DE%20DESCARGA%20DE%20AGUA%20RESIDUAL1.pdf",
    },
  ],
  [
    "Ejercicio2026 - RENOVACIÓN Y PERMISO DE DESCARGA DE AGUA RESIDUAL2.docx",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/RENOVACIÓN%20Y%20PERMISO%20DE%20DESCARGA%20DE%20AGUA%20RESIDUAL2.docx",
    },
  ],
  [
    "Ejercicio2026 - REPOSICIÓN DE PERMISO1.pdf",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/REPOSICIÓN%20DE%20PERMISO1.pdf",
    },
  ],
  [
    "Ejercicio2026 - REPOSICIÓN DE PERMISO2.docx",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/REPOSICIÓN%20DE%20PERMISO2.docx",
    },
  ],
  [
    "Ejercicio2026 - solicitud de análisis fisicoquimicos para agua residual1.pdf",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/solicitud%20de%20análisis%20fisicoquimicos%20para%20agua%20residual1.pdf",
    },
  ],
  [
    "Ejercicio2026 - solicitud de análisis fisicoquimicos para agua residual2.docx",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/solicitud%20de%20análisis%20fisicoquimicos%20para%20agua%20residual2.docx",
    },
  ],
  [
    "DAF-S-RM - Dictamen N1.pdf",
    "1er Trimestre",
    "Ines Flores",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/Dictamen%20N1.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N3.pdf",
    "1er Trimestre",
    "Ines Flores",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/Dictamen%20N3.pdf",
    },
  ],
  [
    "DAF-S-RM - Dictamen N4.pdf",
    "1er Trimestre",
    "Ines Flores",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/Dictamen%20N4.pdf",
    },
  ],
  [
    "DAF-S-RM - SH-0215-2026.pdf",
    "1er Trimestre",
    "Ines Flores",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SH-0215-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-47-2026.pdf",
    "1er Trimestre",
    "Ines Flores",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-47-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-047-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-047-2026.pdf",
    },
  ],
  [
    "Ejercicio2026 - RENOVACIÓN Y PERMISO DESCARGA AGUA RESIDUAL.pdf",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/RENOVACIÓN%20Y%20PERMISO%20DESCARGA%20AGUA%20RESIDUAL.pdf",
    },
  ],
  [
    "Ejercicio2026 - REPOSICIÓN DE PERMISO.pdf",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/REPOSICIÓN%20DE%20PERMISO.pdf",
    },
  ],
  [
    "Ejercicio2026 - Solictud de análisis fisicoquímicos para agua residual.pdf",
    "",
    "Micaela Copca",
    "26-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026//Ejercicio2026/Solictud%20de%20análisis%20fisicoquímicos%20para%20agua%20residual.pdf",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOM.docx",
    "1er Trimestre",
    "Blanca E R M",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOM.docx",
    },
  ],
  [
    "DCONS - SOLICITUD DESCARGA DOM.pdf",
    "1er Trimestre",
    "Blanca E R M",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/SOLICITUD%20DESCARGA%20DOM.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00406420260326140523.pdf",
    "1er Trimestre",
    "Arid Garcia",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DG-S-COMU/doc00406420260326140523.pdf",
    },
  ],
  [
    "DG-S-COMU - doc00406520260326140712.pdf",
    "1er Trimestre",
    "Arid Garcia",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DG-S-COMU/doc00406520260326140712.pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura_1032_F524C33A-4F63-4B99-B223-05C32CAFFB69 (1) (1).pdf",
    "1er Trimestre",
    "Arid Garcia",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DG-S-COMU/RORA5504099D6_Factura_1032_F524C33A-4F63-4B99-B223-05C32CAFFB69%20(1)%20(1).pdf",
    },
  ],
  [
    "DG-S-COMU - RORA5504099D6_Factura__1030_2AD4B8AC-852A-4618-98B5-133B072573C9 (1).pdf",
    "1er Trimestre",
    "Arid Garcia",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DG-S-COMU/RORA5504099D6_Factura__1030_2AD4B8AC-852A-4618-98B5-133B072573C9%20(1).pdf",
    },
  ],
  [
    "DCONS - PDF FORMATO CONSTRUCCION DE DESCARGAS DOMICILIARIAS.pdf",
    "1er Trimestre",
    "Blanca E RM",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/PDF%20FORMATO%20CONSTRUCCION%20DE%20DESCARGAS%20DOMICILIARIAS.pdf",
    },
  ],
  [
    "DCONS - PDF FORMATO PRESUPUESTO DE DESCARGAS.pdf",
    "1er Trimestre",
    "Blanca E RM",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/PDF%20FORMATO%20PRESUPUESTO%20DE%20DESCARGAS.pdf",
    },
  ],
  [
    "DAJ - Contrato-CAASIM-DAJ-001-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "27-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato-CAASIM-DAJ-001-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-014-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-014-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-015-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-015-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - CUSTODIOS ENERO CONTRATO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/CUSTODIOS%20ENERO%20CONTRATO.pdf",
    },
  ],
  [
    "DAF-S-RM - CUSTODIOS FEBRERO Y MARZO CONTRATO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/CUSTODIOS%20FEBRERO%20Y%20MARZO%20CONTRATO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CUSTODIOS ENERO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20CUSTODIOS%20ENERO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CUSTODIOS FEBRERO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20CUSTODIOS%20FEBRERO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA CUSTODIOS MARZO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20CUSTODIOS%20MARZO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA PATRULLAJE ENERO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20PATRULLAJE%20ENERO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA PATRULLAJE FEBRERO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20PATRULLAJE%20FEBRERO.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA PATRULLAJE MARZO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20PATRULLAJE%20MARZO.pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL CUSTODIOS ENERO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20CUSTODIOS%20ENERO.pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL PATRULLAJE ENERO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20PATRULLAJE%20ENERO.pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL PATRULLAJE FEBRERO Y MARZO.pdf",
    "1er Trimestre",
    "Servicios Generales",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20PATRULLAJE%20FEBRERO%20Y%20MARZO.pdf",
    },
  ],
  [
    "DAB - MIR 1er_ trimestre_Plantas y pipas Excel.xls",
    "1er Trimestre",
    "Joana Paz",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/MIR%201er_%20trimestre_Plantas%20y%20pipas%20Excel.xls",
    },
  ],
  [
    "DAB - MIR 1er_trimestre desazolve excel.xls",
    "1er Trimestre",
    "Joana Paz",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/MIR%201er_trimestre%20desazolve%20excel.xls",
    },
  ],
  [
    "DAB - POA 1er_trimestre desazolve Excel.xls",
    "1er Trimestre",
    "Joana Paz",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/POA%201er_trimestre%20desazolve%20Excel.xls",
    },
  ],
  [
    "DAB - POA 1er_trimestre plantas y pipas Excel.xls",
    "1er Trimestre",
    "Joana Paz",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/POA%201er_trimestre%20plantas%20y%20pipas%20Excel.xls",
    },
  ],
  [
    "DAF-S-RM - FACT ARCHIVO PADRON DE USUARIOS.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20ARCHIVO%20PADRON%20DE%20USUARIOS.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT ARCODEM ALM.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20ARCODEM%20ALM.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT AURORA GARCIA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20AURORA%20GARCIA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT CARLOS IBARRA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20CARLOS%20IBARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT FABIAN MORALES.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20FABIAN%20MORALES.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT GRACIELA PEREZ.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20GRACIELA%20PEREZ.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT JULIETA CABRERA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20JULIETA%20CABRERA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT MA. DEL CARMEN CORTEZ.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20MA.%20DEL%20CARMEN%20CORTEZ.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT MARIA DEL CARMEN PARRA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20MARIA%20DEL%20CARMEN%20PARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT NORBERTO SILVA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20NORBERTO%20SILVA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT ODILON COPCA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20ODILON%20COPCA.pdf",
    },
  ],
  [
    "DAF-S-RM - FACT OLIVER IBARRA.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACT%20OLIVER%20IBARRA.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-008-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-008-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-009-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-009-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-010-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-010-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-017-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-017-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-018-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-018-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-019-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-019-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-021-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-021-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-022-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-022-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-028-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-028-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-029-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-029-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-031-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-031-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-20-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-20-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SPF-23-2026.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SPF-23-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - SUFICIENCIA PRESUPUESTAL CUSTODIOS FEBRERO Y MARZO (1).pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/SUFICIENCIA%20PRESUPUESTAL%20CUSTODIOS%20FEBRERO%20Y%20MARZO%20(1).pdf",
    },
  ],
  [
    "DAF-S-PF - LINEAMIENTOS 2026.pdf",
    "1er Trimestre",
    "Planeacion Financiera",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/LINEAMIENTOS%202026.pdf",
    },
  ],
  [
    "DAF-S-PF - LINEAMIENTOS 2026.pdf",
    "1er Trimestre",
    "Amparo Flores",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/LINEAMIENTOS%202026.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOB EDO R-556.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOB%20EDO%20R-556.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS MANTENIMIENTO VEHICULAR R-491.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20MANTENIMIENTO%20VEHICULAR%20R-491.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS PAGO DERECHOS VEHICULOS ORGANISMO.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20PAGO%20DERECHOS%20VEHICULOS%20ORGANISMO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS PAGO GOB EDO R-171.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20PAGO%20GOB%20EDO%20R-171.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS PAGO GOB EDO R-559.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20PAGO%20GOB%20EDO%20R-559.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20260223001 GOB EDO R-556.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OSN20260223001%20GOB%20EDO%20R-556.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20260223001 PAGO GOB EDO R-559.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OSN20260223001%20PAGO%20GOB%20EDO%20R-559.pdf",
    },
  ],
  [
    "DAF-S-RM - OSN20260310001 PAGO GOB EDO R-171.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OSN20260310001%20PAGO%20GOB%20EDO%20R-171.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260303005 PAGO DERECHOS VEHICULOS ORGANISMO.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260303005%20PAGO%20DERECHOS%20VEHICULOS%20ORGANISMO.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260317001 MANTENIMIENTO VEHICULAR R-491.pdf",
    "1er Trimestre",
    "Edgar Martinez",
    "30-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260317001%20MANTENIMIENTO%20VEHICULAR%20R-491.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Abasto.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Abasto.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Admon.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Admon.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Atencion .pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Atencion%20.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Comercial.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Comercial.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. General.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20General.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Gestión.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Gestión.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Infraestructura.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Infraestructura.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Juridico.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Juridico.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. para Llevar.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20para%20Llevar.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Dir. Tics.pdf",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Dir.%20Tics.pdf",
    },
  ],
  [
    "DAF-S-RH - ~$00_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$00_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$01_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$01_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$03_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$03_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$06_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$06_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$08_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$08_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$14_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$14_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$20_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$20_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$22_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$22_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$27_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$27_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$29_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$29_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$31_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$31_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$34_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$34_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$38_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$38_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$39_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$39_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$47_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$47_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$50_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$50_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$53_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$53_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$55_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$55_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$56_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$56_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$60_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$60_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$61_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$61_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$63_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$63_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$66_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$66_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$67_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$67_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$69_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$69_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$71_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$71_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$79_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$79_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$80_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$80_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$81_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$81_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$83_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$83_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$85_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$85_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$86_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$86_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$89_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$89_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$92_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$92_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$93_modified.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$93_modified.docx",
    },
  ],
  [
    "DAF-S-RH - ~$F-S-RH_-_1008_modified.pdf_summary.docx",
    "1er Trimestre",
    "Nancy RH",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/~$F-S-RH_-_1008_modified.pdf_summary.docx",
    },
  ],
  [
    "DCONS - CUENTA PUBLICA EXCEL.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/CUENTA%20PUBLICA%20EXCEL.xlsx",
    },
  ],
  [
    "DCONS - CUENTA PUBLICA WORD.docx",
    "1er Trimestre",
    "Blanca Trigueros",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/CUENTA%20PUBLICA%20WORD.docx",
    },
  ],
  [
    "DAF-S-RM - FACTURA CUSTODIOS.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20CUSTODIOS.pdf",
    },
  ],
  [
    "DAF-S-RM - FACTURA PATRULLAJE.pdf",
    "1er Trimestre",
    "Cristina Mejia",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/FACTURA%20PATRULLAJE.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto Mir_1er. Trime_activ 1.9 OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto%20Mir_1er.%20Trime_activ%201.9%20OCR.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto Poa_1er. Trime_activ 1.9 ocr.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto%20Poa_1er.%20Trime_activ%201.9%20ocr.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto_1 trim_Mir_activ  1.10 ocr.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto_1%20trim_Mir_activ%20%201.10%20ocr.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto_1er. Trim_ Poa_ activ 1.10 ocr.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto_1er.%20Trim_%20Poa_%20activ%201.10%20ocr.pdf",
    },
  ],
  [
    "DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F02b_Estructura 2025 CAASIM.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F02b_Estructura%202025%20CAASIM.pdf",
    },
  ],
  [
    "DAF-S-RH - F03_Estatuto organico.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf",
    },
  ],
  [
    "DAF-S-RH - F08_Tabulador.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F08_Tabulador.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Condiciones Generales de Trabajo 2024-2025.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202024-2025.pdf",
    },
  ],
  [
    "DAF-S-RH - F16a_Manual de Recursos Humano.pdf",
    "1er Trimestre",
    "Nancy Templos",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf",
    },
  ],
  [
    "DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf",
    "1er Trimestre",
    "Maribel Butron",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf",
    },
  ],
  [
    "DAF-S-I - MESES SIN INTERESES.pdf",
    "1er Trimestre",
    "Maribel Butron",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf",
    },
  ],
  [
    "DCONS - CUENTA PUBLICA CONSOLIDADA.pdf",
    "1er Trimestre",
    "Blanca Trigueros",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/CUENTA%20PUBLICA%20CONSOLIDADA.pdf",
    },
  ],

  [
    "DAB - Grafica 1er.Trimes_Desazolve.xlsx",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Grafica%201er.Trimes_Desazolve.xlsx",
    },
  ],
  [
    "DAB - Grafica 1er.Trimes_Pipas y Ptar.xlsx",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Grafica%201er.Trimes_Pipas%20y%20Ptar.xlsx",
    },
  ],
  [
    "DAB - Mir_1trimestre_2026_desazolve OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Mir_1trimestre_2026_desazolve%20OCR.pdf",
    },
  ],
  [
    "DAB - Mir_1trimestre_2026_pipas y ptar OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Mir_1trimestre_2026_pipas%20y%20ptar%20OCR.pdf",
    },
  ],
  [
    "DAB - Poa_1trimestre _2026_pipas y ptar OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Poa_1trimestre%20_2026_pipas%20y%20ptar%20OCR.pdf",
    },
  ],
  [
    "DAB - Poa_1trimestre_2026_desazolve OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Poa_1trimestre_2026_desazolve%20OCR.pdf",
    },
  ],
  [
    "DAB - Grafica 1er.Trimes_Desazolve.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Grafica%201er.Trimes_Desazolve.pdf",
    },
  ],
  [
    "DAB - Grafica 1er.Trimes_Pipas y Ptar OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Grafica%201er.Trimes_Pipas%20y%20Ptar%20OCR.pdf",
    },
  ],
  [
    "DAB - 1ER _TRIM_DIR_ABASTO_MIR_DESAZOLVE_.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1ER%20_TRIM_DIR_ABASTO_MIR_DESAZOLVE_.pdf",
    },
  ],
  [
    "DAB - 1ER_TRIM_DIR_ABASTO_MIR_PIPAS Y PTAR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1ER_TRIM_DIR_ABASTO_MIR_PIPAS%20Y%20PTAR.pdf",
    },
  ],
  [
    "DAB - 1ER_TRIM_DIR_ABASTO_POA_DESAZOLVE.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1ER_TRIM_DIR_ABASTO_POA_DESAZOLVE.pdf",
    },
  ],
  [
    "DAB - 1ER_TRIM_DIR_ABASTO_POA_DIR_ABASTO.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1ER_TRIM_DIR_ABASTO_POA_DIR_ABASTO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS EXPEDICION OPINION DE CUMPLIMIENTO.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20EXPEDICION%20OPINION%20DE%20CUMPLIMIENTO.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-534.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-534.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-535.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-535.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-536.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-536.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-537.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-537.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-538.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-538.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-553.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-553.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-554.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-554.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-555.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-555.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-557.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-557.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO R-558.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20R-558.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS GOBIERNO EDO RAM HR31975.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20GOBIERNO%20EDO%20RAM%20HR31975.pdf",
    },
  ],
  [
    "DAF-S-RM - OFICIO AUTORIZACION RECURSOS VERIFICACION R-491-R-495-R-496-R-500.pdf",
    "1er Trimestre",
    "Egarcito Bautista",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACION%20RECURSOS%20VERIFICACION%20R-491-R-495-R-496-R-500.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto Mir_1er. Trime_activ 1.9 OCR.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto%20Mir_1er.%20Trime_activ%201.9%20OCR.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto Poa_1er. Trime_activ 1.9 ocr.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto%20Poa_1er.%20Trime_activ%201.9%20ocr.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto_1 trim_Mir_activ  1.10 ocr.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto_1%20trim_Mir_activ%20%201.10%20ocr.pdf",
    },
  ],
  [
    "DAB - Dir_Abasto_1er. Trim_ Poa_ activ 1.10 ocr.pdf",
    "1er Trimestre",
    "Joana Paz",
    "31-03-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/Dir_Abasto_1er.%20Trim_%20Poa_%20activ%201.10%20ocr.pdf",
    },
  ],
  [
    "DAF-S-PCF - Calendario de cierre 2026.docx",
    "1er Trimestre",
    "Adriana",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/Calendario%20de%20cierre%202026.docx",
    },
  ],
  [
    "DAF-S-PF - Copia de a69_f25.xlsx",
    "1er Trimestre",
    "Diego PF",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Copia%20de%20a69_f25.xlsx",
    },
  ],
  [
    "DAF-S-PF - Dictamen de los estados y anexos 2025.pdf",
    "1er Trimestre",
    "Diego PF",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Dictamen%20de%20los%20estados%20y%20anexos%202025.pdf",
    },
  ],
  [
    "DAF-S-PF - Estados financieros dictaminados 2025.pdf",
    "1er Trimestre",
    "Diego PF",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Estados%20financieros%20dictaminados%202025.pdf",
    },
  ],
  [
    "DAF-S-PCF - Calendario de cierre 2026.pdf",
    "1er Trimestre",
    "Adriana",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/Calendario%20de%20cierre%202026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-021-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-021-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-022-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-022-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-039-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-039-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-040-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-040-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-045-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-045-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-050-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-050-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-053-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-053-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-056-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-056-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-016-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-016-2026.pdf",
    },
  ],
  [
    "DAJ - CAASIM-DAJ-017-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/CAASIM-DAJ-017-2026.pdf",
    },
  ],
  [
    "DCONS - FACTURAS DAJ-135-2025.pdf",
    "1er Trimestre",
    "Blanca ERM",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/FACTURAS%20DAJ-135-2025.pdf",
    },
  ],
  [
    "DCONS - FINIQUITO DAJ-135-2025.pdf",
    "1er Trimestre",
    "Blanca ERM",
    "06-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCONS/FINIQUITO%20DAJ-135-2025.pdf",
    },
  ],
  [
    "DAF-S-RH - 1008_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/1008_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1022_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/1022_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1816_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/1816_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1850_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/1850_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1853_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/1853_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1979_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/1979_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 1992_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/1992_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2093_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2093_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2239_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2239_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2261_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2261_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 228_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/228_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2420_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2420_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2456_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2456_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2457_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2457_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2465_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2465_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2483_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2483_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2489_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2489_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2492_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2492_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2538_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2538_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2547_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2547_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2556_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2556_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2560_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2560_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2566_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2566_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2567_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2567_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2579_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2579_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2581_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2581_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2603_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2603_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2631_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2631_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2647_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2647_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2655_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2655_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2677_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2677_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2734_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2734_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2769_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2769_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2771_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2771_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2855_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2855_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2863_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2863_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2885_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2885_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2886_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2886_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2914_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2914_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2919_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2919_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2957_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2957_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2971_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2971_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2980_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2980_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 2989_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/2989_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3000_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3000_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3001_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3001_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3008_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3008_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3011_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3011_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3012_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3012_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3026_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3026_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3027_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3027_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3032_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3032_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3080_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3080_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3087_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3087_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3088_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3088_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3104_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3104_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3105_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3105_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3106_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3106_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3138_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3138_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3166_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3166_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3188_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3188_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3197_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3197_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3211_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3211_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3213_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3213_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3321_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3321_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3334_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3334_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3338_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3338_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3358_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3358_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3366_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3366_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3375_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3375_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3389_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3389_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 339_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/339_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3390_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3390_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3398_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3398_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3406_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3406_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3415_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3415_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3449_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3449_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3455_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3455_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3475_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3475_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3476_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3476_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3511_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3511_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3521_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3521_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3526_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3526_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3583_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3583_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3598_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3598_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3609_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3609_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3610_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3610_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3628_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3628_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3699_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3699_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3725_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3725_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3726_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3726_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3727_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3727_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3750_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3750_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 376_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/376_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3769_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3769_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3772_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3772_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3778_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3778_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3816_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3816_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3828_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3828_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3835_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3835_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3878_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3878_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3890_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3890_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3893_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3893_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3918_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3918_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3931_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3931_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3952_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3952_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3953_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3953_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3960_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3960_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3961_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3961_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3962_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3962_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3967_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3967_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3970_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3970_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3978_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3978_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3979_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3979_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3983_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3983_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3984_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3984_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 3988_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/3988_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4010_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4010_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4017_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4017_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4019_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4019_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4022_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4022_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4026_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4026_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4033_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4033_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4036_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4036_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4039_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4039_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4043_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4043_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4050_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4050_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4086_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4086_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4087_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4087_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4095_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4095_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4149_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4149_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4154_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4154_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4155_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4155_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4156_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4156_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4157_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4157_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4159_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4159_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4160_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4160_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4161_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4161_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4162_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4162_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4167_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4167_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4168_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4168_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4170_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4170_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4175_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4175_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4177_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4177_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4178_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4178_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4179_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4179_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4181_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4181_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4182_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4182_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4183_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4183_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4184_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4184_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4185_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4185_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4186_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4186_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4187_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4187_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4189_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4189_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4193_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4193_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4198_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4198_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4206_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4206_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4214_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4214_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4215_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4215_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4219_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4219_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4221_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4221_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4225_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4225_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4228_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4228_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4230_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4230_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4235_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4235_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4238_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4238_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4242_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4242_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4248_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4248_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4249_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4249_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4253_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4253_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4261_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4261_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4263_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4263_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4265_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4265_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4271_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4271_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4275_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4275_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4281_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4281_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4282_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4282_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4289_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4289_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4293_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4293_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4296_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4296_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4298_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4298_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4299_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4299_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4325_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4325_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4332_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4332_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4336_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4336_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4357_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4357_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4360_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4360_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4362_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4362_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4372_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4372_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4375_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4375_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4376_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4376_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4388_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4388_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4393_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4393_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4404_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4404_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4408_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4408_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4413_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4413_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4414_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4414_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4415_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4415_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4416_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4416_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4417_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4417_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4418_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4418_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4439_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4439_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4445_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4445_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4462_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4462_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4479_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4479_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4481_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4481_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4491_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4491_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4492_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4492_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4504_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4504_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 4511_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/4511_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 794_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/794_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 846_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/846_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - 967_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/967_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - a3316_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/a3316_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - b4260_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/b4260_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - c4326_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/c4326_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - d4379_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/d4379_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - f4478_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/f4478_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - g4556_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/g4556_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - h4559_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/h4559_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - i4563_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/i4563_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - j4564_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/j4564_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - k4577_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/k4577_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DAF-S-RH - l4294_mod.pdf_Caratula.pdf",
    "1er Trimestre",
    "Monica Yezmin Hernandez",
    "07-04-2026",
    {
      text: "PDF",
      link: "https://caasim.hidalgo.gob.mx/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RH/l4294_mod.pdf_Caratula.pdf",
    },
  ],
  [
    "DG-S-COMU - primertrimestre26.pdf",
    "1er Trimestre",
    "Erick Parra",
    "07-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DG-S-COMU/primertrimestre26.pdf",
    },
  ],
  [
    "DCOME - Solitud agua potable.docx",
    "1er Trimestre",
    "Miguel Vivar",
    "07-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCOME/Solitud%20agua%20potable.docx",
    },
  ],
  [
    "DCOME - Solitud agua potable.pdf",
    "1er Trimestre",
    "Miguel Vivar",
    "07-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCOME/Solitud%20agua%20potable.pdf",
    },
  ],
  [
    "DCOME - formato para hipervinculo COMERCIAL.pdf",
    "1er Trimestre",
    "Miguel vivar",
    "07-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DCOME/formato%20para%20hipervinculo%20COMERCIAL.pdf",
    },
  ],
  [
    "DAB - 9 formato Mir  1.10.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20Mir%20%201.10.pdf",
    },
  ],
  [
    "DAB - 9 formato para hipervinculo 1.9 mir.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20para%20hipervinculo%201.9%20mir.pdf",
    },
  ],
  [
    "DAB - 9 formato para hipervinculo 1.9 poa.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20para%20hipervinculo%201.9%20poa.pdf",
    },
  ],
  [
    "DAB - 9 formato Poa 1.10.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20Poa%201.10.pdf",
    },
  ],
  [
    "DAB - 1er_Trimestre Desazolve y Equipos Especiales mir ocr.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1er_Trimestre%20Desazolve%20y%20Equipos%20Especiales%20mir%20ocr.pdf",
    },
  ],
  [
    "DAB - 1er_Trimestre Desazolve y Equipos Especiales poa ocr.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1er_Trimestre%20Desazolve%20y%20Equipos%20Especiales%20poa%20ocr.pdf",
    },
  ],
  [
    "DAB - 1er_Trimestre Pipas y Ptar mir ocr.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1er_Trimestre%20Pipas%20y%20Ptar%20mir%20ocr.pdf",
    },
  ],
  [
    "DAB - 1er_Trimestre Pipas y Ptar Poa ocr.pdf",
    "1er Trimestre",
    "Joana Abasto",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/1er_Trimestre%20Pipas%20y%20Ptar%20Poa%20ocr.pdf",
    },
  ],
  [
    "DAB - 9 formato  1.10  poa.pdf",
    "1er Trimestre",
    "Joana Paz",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20%201.10%20%20poa.pdf",
    },
  ],
  [
    "DAB - 9 formato Mir  1.10.pdf",
    "1er Trimestre",
    "Joana Paz",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20Mir%20%201.10.pdf",
    },
  ],
  [
    "DAB - 9 formato para hipervinculo 1.9 mir.pdf",
    "1er Trimestre",
    "Joana Paz",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20para%20hipervinculo%201.9%20mir.pdf",
    },
  ],
  [
    "DAB - 9 formato para hipervinculo 1.9 poa.pdf",
    "1er Trimestre",
    "Joana Paz",
    "08-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAB/9%20formato%20para%20hipervinculo%201.9%20poa.pdf",
    },
  ],
  [
    "DAJ - Subsidios 1er Trim. 2026.pdf",
    "1er Trimestre",
    "JOrge Daniel",
    "09-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Subsidios%201er%20Trim.%202026.pdf",
    },
  ],
  
  ['DAJ - Contrato-DAJ-023-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguin', '14-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato-DAJ-023-2026.pdf'}],['DAJ - Convenio DAJ-008-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguin', '14-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-008-2026.pdf'}]
,
['DAF-S-PF - 1. a) Estado Actividades.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20a)%20Estado%20Actividades.xlsx'}],['DAF-S-PF - 1. b) Estado Situacion Financiera.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20b)%20Estado%20Situacion%20Financiera.xlsx'}],['DAF-S-PF - 1. c) Estado Variacion Hacienda.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20c)%20Estado%20Variacion%20Hacienda.xlsx'}],['DAF-S-PF - 1. d) Estado Cambios Situacion.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20d)%20Estado%20Cambios%20Situacion.xlsx'}],['DAF-S-PF - 1. e) Estado Flujos Efectivo.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20e)%20Estado%20Flujos%20Efectivo.xlsx'}],['DAF-S-PF - 1. f) Estado Analitico Activo.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20f)%20Estado%20Analitico%20Activo.xlsx'}],['DAF-S-PF - 1. g) Estado Analitico Deuda.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20g)%20Estado%20Analitico%20Deuda.xlsx'}],['DAF-S-PF - 1. h) Pasivos Contingentes.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20h)%20Pasivos%20Contingentes.xlsx'}],['DAF-S-PF - 1. i) Notas Edos Financieros.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20i)%20Notas%20Edos%20Financieros.xlsx'}],['DAF-S-PF - II. a) EAI con excedentes.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20a)%20EAI%20con%20excedentes.xlsx'}],['DAF-S-PF - II. b) 1.1 EAEPE Clasificacion Administrativa.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%201.1%20EAEPE%20Clasificacion%20Administrativa.xlsx'}],['DAF-S-PF - II. b) 1.2 EAEPE Identificado por Ramo.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%201.2%20EAEPE%20Identificado%20por%20Ramo.xlsx'}],['DAF-S-PF - II. b) 2. EAEPE Clasificacion Economica-Tipo de Gasto.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%202.%20EAEPE%20Clasificacion%20Economica-Tipo%20de%20Gasto.xlsx'}],['DAF-S-PF - II. b) 3. EAEPE COG (Capitulo y Concepto).xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%203.%20EAEPE%20COG%20(Capitulo%20y%20Concepto).xlsx'}],['DAF-S-PF - II. b) 4. EAEPE Clasificacion Funcional.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%204.%20EAEPE%20Clasificacion%20Funcional.xlsx'}],['DAF-S-PF - II. c) Endeudamiento Neto.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20c)%20Endeudamiento%20Neto.xlsx'}],['DAF-S-PF - II. d) Interes de la Deuda.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20d)%20Interes%20de%20la%20Deuda.xlsx'}],['DAF-S-PF - II. e) Flujo de Fondos.xlsx', '1er Trimestre', 'Blanca Trigueros', '17-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20e)%20Flujo%20de%20Fondos.xlsx'}]
,
['DAF-S-PCF - I. a) Estado Actividades.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.pdf'}],['DAF-S-PCF - I. b) Estado Situacion Financiera.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.pdf'}],['DAF-S-PCF - I. c) Estado Variacion Hacienda Publica.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda%20Publica.pdf'}],['DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf'}],['DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf'}],['DAF-S-PCF - I. f) Estado Analitico Activo.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.pdf'}],['DAF-S-PCF - I. g) Estado Analitico Deuda Otros Pasivos.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda%20Otros%20Pasivos.pdf'}],['DAF-S-PCF - I. h) Informe Pasivos Contingentes.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.pdf'}],['DAF-S-PCF - I. i) Notas Estados Financieros.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf'}],['DAF-S-PCF - II. a) Estado Ingresos Excedentes.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20a)%20Estado%20Ingresos%20Excedentes.pdf'}],['DAF-S-PCF - II. b) 1.1. Estado Egresos Clasificacion Administrativa.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.1.%20Estado%20Egresos%20Clasificacion%20Administrativa.pdf'}],['DAF-S-PCF - II. b) 1.2 Estado Egresos Identificado Ramo.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20Estado%20Egresos%20Identificado%20Ramo.pdf'}],['DAF-S-PCF - II. b) 2. Estado Egresos Clasificacion Economica.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Clasificacion%20Economica.pdf'}],['DAF-S-PCF - II. b) 3. Estado Egresos COG.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20COG.pdf'}],['DAF-S-PCF - II. b) 4. Estado Egresos Clasificacion Funcional.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Clasificacion%20Funcional.pdf'}],['DAF-S-PCF - II. c) Endeudamiento Neto.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf'}],['DAF-S-PCF - II. d) Intereses Deuda.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf'}],['DAF-S-PCF - II. e) Flujo Fondos.pdf', '1er Trimestre', 'Diana Trigueros', '21-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20Fondos.pdf'}]
,
['DAF-S-PF - A)GASTO POR CATEGORIA PROGRAMATICA.pdf', '1er Trimestre', 'Planeacion Financiera', '22-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/A)GASTO%20POR%20CATEGORIA%20PROGRAMATICA.pdf'}],['DAF-S-PF - B)PROGRAMAS Y PROYECTOS DE INVERSION (2).pdf', '1er Trimestre', 'Planeacion Financiera', '22-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/B)PROGRAMAS%20Y%20PROYECTOS%20DE%20INVERSION%20(2).pdf'}],['DAF-S-PF - C)INDICADORES DE RESULTADOS.pdf', '1er Trimestre', 'Planeacion Financiera', '22-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/C)INDICADORES%20DE%20RESULTADOS.pdf'}]
,
['DAF-S-PF - Gasto por categoria programática Marzo.xlsx', '1er Trimestre', 'Planeacion Financiera Ingresos', '23-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programática%20Marzo.xlsx'}],['DAF-S-PF - Indicadores de resultados Marzo.xlsx', '1er Trimestre', 'Planeacion Financiera Ingresos', '23-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados%20Marzo.xlsx'}],['DAF-S-PF - Programas y proyectos de inversión Marzo.xlsx', '1er Trimestre', 'Planeacion Financiera Ingresos', '23-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión%20Marzo.xlsx'}]
,
['DAF-S-PF - Estado por categoria programatica.pdf', '1er Trimestre', 'Planeacion Financiera Ingresos', '23-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Estado%20por%20categoria%20programatica.pdf'}],['DAF-S-PF - Indicadores de Resultados.pdf', '1er Trimestre', 'Planeacion Financiera Ingresos', '23-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Indicadores%20de%20Resultados.pdf'}],['DAF-S-PF - Programa y proyectos de inversion.pdf', '1er Trimestre', 'Planeacion Financiera Ingresos', '23-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Programa%20y%20proyectos%20de%20inversion.pdf'}]
,
['DAF-S-PCF - EDITABLE EAEPE COG, T GTO, ADMIN Y FUNCIONAL 1er trim.xlsx', '1er Trimestre', 'Departamento de Presupuesto CAASIM', '27-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/EDITABLE%20EAEPE%20COG,%20T%20GTO,%20ADMIN%20Y%20FUNCIONAL%201er%20trim.xlsx'}],['DAF-S-PCF - EDITABLE EAI 1er trim.xlsx', '1er Trimestre', 'Departamento de Presupuesto CAASIM', '27-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/EDITABLE%20EAI%201er%20trim.xlsx'}],['DAF-S-PCF - PDF EAEPE COG, T GTO, ADMIN Y FUNCIONAL 1er trim.pdf', '1er Trimestre', 'Departamento de Presupuesto CAASIM', '27-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/PDF%20EAEPE%20COG,%20T%20GTO,%20ADMIN%20Y%20FUNCIONAL%201er%20trim.pdf'}],['DAF-S-PCF - PDF EAI 1ER TRIM.pdf', '1er Trimestre', 'Departamento de Presupuesto CAASIM', '27-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/PDF%20EAI%201ER%20TRIM.pdf'}]
,
['DAF-S-PCF - Estado Egresos COG, TG, ADMIN Y FUNCIONAL.pdf', '1er Trimestre', 'Departamento de Presupuesto CAASIM', '28-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/Estado%20Egresos%20COG,%20TG,%20ADMIN%20Y%20FUNCIONAL.pdf'}],['DAF-S-PCF - Estado Ingresos.pdf', '1er Trimestre', 'Departamento de Presupuesto CAASIM', '28-04-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/Estado%20Ingresos.pdf'}]
,
['DAF-S-I - Contrato OXXO 2026 TESTADO.pdf', '1er Trimestre', 'Maribel Butrón Rosales', '11-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/Contrato%20OXXO%202026%20TESTADO.pdf'}],['DAF-S-I - Monto Mensual 1er. trimestre Oxxo 2026.xlsx', '1er Trimestre', 'Maribel Butrón Rosales', '11-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/Monto%20Mensual%201er.%20trimestre%20Oxxo%202026.xlsx'}],['DAF-S-I - Montos recaudados 1er trim 2026.pdf', '1er Trimestre', 'Maribel Butrón Rosales', '11-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/Montos%20recaudados%201er%20trim%202026.pdf'}]
,
  [
    "DAJ - Contrato-DAJ-023-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "14-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato-DAJ-023-2026.pdf",
    },
  ],
  [
    "DAJ - Convenio DAJ-008-2026.pdf",
    "1er Trimestre",
    "Jorge Daniel Olguin",
    "14-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-008-2026.pdf",
    },
  ],
  [
    "DAF-S-PF - 1. a) Estado Actividades.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20a)%20Estado%20Actividades.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. b) Estado Situacion Financiera.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20b)%20Estado%20Situacion%20Financiera.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. c) Estado Variacion Hacienda.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20c)%20Estado%20Variacion%20Hacienda.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. d) Estado Cambios Situacion.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20d)%20Estado%20Cambios%20Situacion.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. e) Estado Flujos Efectivo.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20e)%20Estado%20Flujos%20Efectivo.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. f) Estado Analitico Activo.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20f)%20Estado%20Analitico%20Activo.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. g) Estado Analitico Deuda.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20g)%20Estado%20Analitico%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. h) Pasivos Contingentes.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20h)%20Pasivos%20Contingentes.xlsx",
    },
  ],
  [
    "DAF-S-PF - 1. i) Notas Edos Financieros.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/1.%20i)%20Notas%20Edos%20Financieros.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. a) EAI con excedentes.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20a)%20EAI%20con%20excedentes.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. b) 1.1 EAEPE Clasificacion Administrativa.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%201.1%20EAEPE%20Clasificacion%20Administrativa.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. b) 1.2 EAEPE Identificado por Ramo.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%201.2%20EAEPE%20Identificado%20por%20Ramo.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. b) 2. EAEPE Clasificacion Economica-Tipo de Gasto.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%202.%20EAEPE%20Clasificacion%20Economica-Tipo%20de%20Gasto.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. b) 3. EAEPE COG (Capitulo y Concepto).xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%203.%20EAEPE%20COG%20(Capitulo%20y%20Concepto).xlsx",
    },
  ],
  [
    "DAF-S-PF - II. b) 4. EAEPE Clasificacion Funcional.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20b)%204.%20EAEPE%20Clasificacion%20Funcional.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. c) Endeudamiento Neto.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20c)%20Endeudamiento%20Neto.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. d) Interes de la Deuda.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20d)%20Interes%20de%20la%20Deuda.xlsx",
    },
  ],
  [
    "DAF-S-PF - II. e) Flujo de Fondos.xlsx",
    "1er Trimestre",
    "Blanca Trigueros",
    "17-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/II.%20e)%20Flujo%20de%20Fondos.xlsx",
    },
  ],
  [
    "DAF-S-PCF - I. a) Estado Actividades.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. b) Estado Situacion Financiera.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. c) Estado Variacion Hacienda Publica.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda%20Publica.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. f) Estado Analitico Activo.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. g) Estado Analitico Deuda Otros Pasivos.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda%20Otros%20Pasivos.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. h) Informe Pasivos Contingentes.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - I. i) Notas Estados Financieros.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. a) Estado Ingresos Excedentes.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20a)%20Estado%20Ingresos%20Excedentes.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.1. Estado Egresos Clasificacion Administrativa.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.1.%20Estado%20Egresos%20Clasificacion%20Administrativa.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 1.2 Estado Egresos Identificado Ramo.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20Estado%20Egresos%20Identificado%20Ramo.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 2. Estado Egresos Clasificacion Economica.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Clasificacion%20Economica.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 3. Estado Egresos COG.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20COG.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. b) 4. Estado Egresos Clasificacion Funcional.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Clasificacion%20Funcional.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. c) Endeudamiento Neto.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. d) Intereses Deuda.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf",
    },
  ],
  [
    "DAF-S-PCF - II. e) Flujo Fondos.pdf",
    "1er Trimestre",
    "Diana Trigueros",
    "21-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20Fondos.pdf",
    },
  ],
  [
    "DAF-S-PF - A)GASTO POR CATEGORIA PROGRAMATICA.pdf",
    "1er Trimestre",
    "Planeacion Financiera",
    "22-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/A)GASTO%20POR%20CATEGORIA%20PROGRAMATICA.pdf",
    },
  ],
  [
    "DAF-S-PF - B)PROGRAMAS Y PROYECTOS DE INVERSION (2).pdf",
    "1er Trimestre",
    "Planeacion Financiera",
    "22-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/B)PROGRAMAS%20Y%20PROYECTOS%20DE%20INVERSION%20(2).pdf",
    },
  ],
  [
    "DAF-S-PF - C)INDICADORES DE RESULTADOS.pdf",
    "1er Trimestre",
    "Planeacion Financiera",
    "22-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/C)INDICADORES%20DE%20RESULTADOS.pdf",
    },
  ],
  [
    "DAF-S-PF - Gasto por categoria programática Marzo.xlsx",
    "1er Trimestre",
    "Planeacion Financiera Ingresos",
    "23-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programática%20Marzo.xlsx",
    },
  ],
  [
    "DAF-S-PF - Indicadores de resultados Marzo.xlsx",
    "1er Trimestre",
    "Planeacion Financiera Ingresos",
    "23-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados%20Marzo.xlsx",
    },
  ],
  [
    "DAF-S-PF - Programas y proyectos de inversión Marzo.xlsx",
    "1er Trimestre",
    "Planeacion Financiera Ingresos",
    "23-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión%20Marzo.xlsx",
    },
  ],
  [
    "DAF-S-PF - Estado por categoria programatica.pdf",
    "1er Trimestre",
    "Planeacion Financiera Ingresos",
    "23-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Estado%20por%20categoria%20programatica.pdf",
    },
  ],
  [
    "DAF-S-PF - Indicadores de Resultados.pdf",
    "1er Trimestre",
    "Planeacion Financiera Ingresos",
    "23-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Indicadores%20de%20Resultados.pdf",
    },
  ],
  [
    "DAF-S-PF - Programa y proyectos de inversion.pdf",
    "1er Trimestre",
    "Planeacion Financiera Ingresos",
    "23-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PF/Programa%20y%20proyectos%20de%20inversion.pdf",
    },
  ],
  [
    "DAF-S-PCF - EDITABLE EAEPE COG, T GTO, ADMIN Y FUNCIONAL 1er trim.xlsx",
    "1er Trimestre",
    "Departamento de Presupuesto CAASIM",
    "27-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/EDITABLE%20EAEPE%20COG,%20T%20GTO,%20ADMIN%20Y%20FUNCIONAL%201er%20trim.xlsx",
    },
  ],
  [
    "DAF-S-PCF - EDITABLE EAI 1er trim.xlsx",
    "1er Trimestre",
    "Departamento de Presupuesto CAASIM",
    "27-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/EDITABLE%20EAI%201er%20trim.xlsx",
    },
  ],
  [
    "DAF-S-PCF - PDF EAEPE COG, T GTO, ADMIN Y FUNCIONAL 1er trim.pdf",
    "1er Trimestre",
    "Departamento de Presupuesto CAASIM",
    "27-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/PDF%20EAEPE%20COG,%20T%20GTO,%20ADMIN%20Y%20FUNCIONAL%201er%20trim.pdf",
    },
  ],
  [
    "DAF-S-PCF - PDF EAI 1ER TRIM.pdf",
    "1er Trimestre",
    "Departamento de Presupuesto CAASIM",
    "27-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/PDF%20EAI%201ER%20TRIM.pdf",
    },
  ],
  [
    "DAF-S-PCF - Estado Egresos COG, TG, ADMIN Y FUNCIONAL.pdf",
    "1er Trimestre",
    "Departamento de Presupuesto CAASIM",
    "28-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/Estado%20Egresos%20COG,%20TG,%20ADMIN%20Y%20FUNCIONAL.pdf",
    },
  ],
  [
    "DAF-S-PCF - Estado Ingresos.pdf",
    "1er Trimestre",
    "Departamento de Presupuesto CAASIM",
    "28-04-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-PCF/Estado%20Ingresos.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN 20260406006 MANTENIMIENTO VEHICULAR CASA AGRICOLA R-520.pdf",
    "1er Trimestre",
    "EDGAR BAUTISTA",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN%2020260406006%20MANTENIMIENTO%20VEHICULAR%20CASA%20AGRICOLA%20R-520.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260406001 MANTENIMIENTO VEHICULAR CASA AGRICOLA R-523.pdf",
    "1er Trimestre",
    "EDGAR BAUTISTA",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260406001%20MANTENIMIENTO%20VEHICULAR%20CASA%20AGRICOLA%20R-523.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260406002 MANTENIMIENTO VEHICULAR CASA AGRICOLA R-527.pdf",
    "1er Trimestre",
    "EDGAR BAUTISTA",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260406002%20MANTENIMIENTO%20VEHICULAR%20CASA%20AGRICOLA%20R-527.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260406003 MANTENIMIENTO VEHICULAR CASA AGRICOLA R-525.pdf",
    "1er Trimestre",
    "EDGAR BAUTISTA",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260406003%20MANTENIMIENTO%20VEHICULAR%20CASA%20AGRICOLA%20R-525.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260406004 MANTENIMIENTO VEHICULAR CASA AGRICOLA R-522.pdf",
    "1er Trimestre",
    "EDGAR BAUTISTA",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260406004%20MANTENIMIENTO%20VEHICULAR%20CASA%20AGRICOLA%20R-522.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260406005 MANTENIMIENTO VEHICULAR CASA AGRICOLA R-524.pdf",
    "1er Trimestre",
    "EDGAR BAUTISTA",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260406005%20MANTENIMIENTO%20VEHICULAR%20CASA%20AGRICOLA%20R-524.pdf",
    },
  ],
  [
    "DAF-S-RM - PSN20260420001 REPARACION LLANTAS FEDERICO MARTÍNEZ.pdf",
    "1er Trimestre",
    "EDGAR BAUTISTA",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-RM/PSN20260420001%20REPARACION%20LLANTAS%20FEDERICO%20MARTÍNEZ.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-060-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-060-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-061-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-061-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-062-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-062-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-063-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-063-2026.pdf",
    },
  ],
  [
    "DAF-S-RM - DICTAMEN EA-913005999-N6-2026.pdf",
    "2do Trimestre",
    "BEATRIZ   ",
    "06-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/DICTAMEN%20EA-913005999-N6-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-013-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "07-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-013-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-026-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "07-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-026-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-038-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "07-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-038-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-042-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "07-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-042-2026.pdf",
    },
  ],
  [
    "DAJ - Contrato DAJ-043-2026.pdf",
    "1er Trimestre",
    "JORGE DANIEL",
    "07-05-2026",
    {
      text: "PDF",
      link: "/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-043-2026.pdf",
    },
  ],
['DAF-S-I - Contrato OXXO 2026 TESTADO.pdf', '1er Trimestre', 'Maribel Butrón Rosales', '11-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/Contrato%20OXXO%202026%20TESTADO.pdf'}],['DAF-S-I - Monto Mensual 1er. trimestre Oxxo 2026.xlsx', '1er Trimestre', 'Maribel Butrón Rosales', '11-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/Monto%20Mensual%201er.%20trimestre%20Oxxo%202026.xlsx'}],['DAF-S-I - Montos recaudados 1er trim 2026.pdf', '1er Trimestre', 'Maribel Butrón Rosales', '11-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/Montos%20recaudados%201er%20trim%202026.pdf'}]
,
['DAF-S-I - 9 formato para hipervinculo 2026.docx', '1er Trimestre', 'Maribel Butrón Rosales', '13-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/9%20formato%20para%20hipervinculo%202026.docx'}]
,
['DAF-S-I - 9 formato para hipervinculo 2026 1er. trimestre 2026.pdf', '1er Trimestre', 'Maribel Butron Rosales', '15-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF-S-I/9%20formato%20para%20hipervinculo%202026%201er.%20trimestre%202026.pdf'}]
,
['DAJ - Contrato DAJ-044-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '18-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-044-2026.pdf'}],['DAJ - Contrato DAJ-058-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '18-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-058-2026.pdf'}],['DAJ - Convenio DAJ-002-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '18-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-002-2026.pdf'}],['DAJ - Convenio DAJ-014-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '18-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-014-2026.pdf'}],['DAJ - Convenio DAJ-023-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '18-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-023-2026.pdf'}]
,
['DAJ - Contrato DAJ-070-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '27-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-070-2026.pdf'}]
,
['DAJ - Contrato DAJ-071-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '28-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-071-2026.pdf'}]
,
['DAJ - Contrato DAJ-055-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '28-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Contrato%20DAJ-055-2026.pdf'}]
,
['DAJ - Contrato DAJ-064-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '28-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-064-2026.pdf'}]
,
['DAJ - Contrato DAJ-069-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '28-05-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-069-2026.pdf'}]
,
['DAF-S-RM - Orden de Compra Grupo LISSABA SA de CV.pdf', '2do Trimestre', 'Melina Guadalupe Baños Rámirez', '02-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/Orden%20de%20Compra%20Grupo%20LISSABA%20SA%20de%20CV.pdf'}]
,
['DAF - Informe Director General 1er. trim. 2026.pdf', '1er Trimestre', 'Bibiana Limon Perez', '18-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAF/Informe%20Director%20General%201er.%20trim.%202026.pdf'}]
,
['DAJ - Contrato DAJ-072-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '23-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-072-2026.pdf'}]
,
['DAF - DICTAMEN EA-913005999-N8-2026.pdf', '2do Trimestre', 'Beatriz Martínez Aguilar', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/DICTAMEN%20EA-913005999-N8-2026.pdf'}]
,
['DAF-S-RH - F03_Dir. Abasto.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Abasto.pdf'}],['DAF-S-RH - F03_Dir. Admon.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Admon.pdf'}],['DAF-S-RH - F03_Dir. Atencion .pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Atencion%20.pdf'}],['DAF-S-RH - F03_Dir. Comercial.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Comercial.pdf'}],['DAF-S-RH - F03_Dir. General.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20General.pdf'}],['DAF-S-RH - F03_Dir. Gestión.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Gestión.pdf'}],['DAF-S-RH - F03_Dir. Infraestructura.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Infraestructura.pdf'}],['DAF-S-RH - F03_Dir. Juridico.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Juridico.pdf'}],['DAF-S-RH - F03_Dir. para Llevar.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20para%20Llevar.pdf'}],['DAF-S-RH - F03_Dir. Tics.pdf', '2do Trimestre', 'Nancy Templos Hernández ', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Dir.%20Tics.pdf'}]
,
['DAF-S-I - Contrato OXXO 2026 TESTADO.pdf', '2do Trimestre', 'Maribel Butrón Rosales', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/Contrato%20OXXO%202026%20TESTADO.pdf'}],['DAF-S-I - DIRECCIONES Y HORARIOS DE MÓDULOS DE COBRO.pdf', '2do Trimestre', 'Maribel Butrón Rosales', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/DIRECCIONES%20Y%20HORARIOS%20DE%20MÓDULOS%20DE%20COBRO.pdf'}],['DAF-S-I - MESES SIN INTERESES.pdf', '2do Trimestre', 'Maribel Butrón Rosales', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/MESES%20SIN%20INTERESES.pdf'}]
,
['DG - doc00482820260625115119.pdf', '2do Trimestre', 'Arid García Herrera', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DG/doc00482820260625115119.pdf'}],['DG - doc00482920260625115127.pdf', '2do Trimestre', 'Arid García Herrera', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DG/doc00482920260625115127.pdf'}],['DG - doc00483020260625115134.pdf', '2do Trimestre', 'Arid García Herrera', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DG/doc00483020260625115134.pdf'}],['DG - doc00483120260625115157.pdf', '2do Trimestre', 'Arid García Herrera', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DG/doc00483120260625115157.pdf'}],['DG - doc00483220260625115207.pdf', '2do Trimestre', 'Arid García Herrera', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DG/doc00483220260625115207.pdf'}],['DG - doc00483320260625115216.pdf', '2do Trimestre', 'Arid García Herrera', '25-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DG/doc00483320260625115216.pdf'}]
,
['DAF-S-RM - arcodem almacen ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/arcodem%20almacen%20ene%20jun.pdf'}],['DAF-S-RM - arcodem archivo ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/arcodem%20archivo%20ene%20jun.pdf'}],['DAF-S-RM - aurora ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/aurora%20ene%20jun.pdf'}],['DAF-S-RM - carlos ibarra ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/carlos%20ibarra%20ene%20jun.pdf'}],['DAF-S-RM - eduardo javier arrend ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/eduardo%20javier%20arrend%20ene%20jun.pdf'}],['DAF-S-RM - eduardo javier mant ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/eduardo%20javier%20mant%20ene%20jun.pdf'}],['DAF-S-RM - fabian morales ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/fabian%20morales%20ene%20jun.pdf'}],['DAF-S-RM - graciela perez ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/graciela%20perez%20ene%20jun.pdf'}],['DAF-S-RM - julieta cabrera ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/julieta%20cabrera%20ene%20jun.pdf'}],['DAF-S-RM - ma del carmen cortez ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/ma%20del%20carmen%20cortez%20ene%20jun.pdf'}],['DAF-S-RM - mara rebeca ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/mara%20rebeca%20ene%20jun.pdf'}],['DAF-S-RM - maria del carmen parra ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/maria%20del%20carmen%20parra%20ene%20jun.pdf'}],['DAF-S-RM - norberto ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/norberto%20ene%20jun.pdf'}],['DAF-S-RM - odilon ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/odilon%20ene%20jun.pdf'}],['DAF-S-RM - oliver ene jun.pdf', '2do Trimestre', 'Sandra Hernandez Bautista', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/oliver%20ene%20jun.pdf'}]
,
['DAF-S-RM - CUSTODIOS 2026 (1).pdf', '2do Trimestre', 'Alejandra Zimbron Ramirez', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/CUSTODIOS%202026%20(1).pdf'}],['DAF-S-RM - PATRULLAJE 2026 (1).pdf', '2do Trimestre', 'Alejandra Zimbron Ramirez', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/PATRULLAJE%202026%20(1).pdf'}]
,
['DAF-S-RM - AUTORIZACION PRESUPUESTO MEDICAMENTOS.pdf', '2do Trimestre', 'Juana Ines Flores Perez', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/AUTORIZACION%20PRESUPUESTO%20MEDICAMENTOS.pdf'}],['DAF-S-RM - AUTORIZACION PRESUPUESTO REFACCIONES.PDF', '2do Trimestre', 'Juana Ines Flores Perez', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/AUTORIZACION%20PRESUPUESTO%20REFACCIONES.PDF'}],['DAF-S-RM - FACTURA MEDICAMENTOS.pdf', '2do Trimestre', 'Juana Ines Flores Perez', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20MEDICAMENTOS.pdf'}],['DAF-S-RM - FACTURA REFACCIONES.pdf', '2do Trimestre', 'Juana Ines Flores Perez', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20REFACCIONES.pdf'}]
,
['DGVF - CONTRATACIÓN  COMERCIAL 2026.pdf', '2do Trimestre', 'Lidia Guadalupe Hernandez ', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DGVF/CONTRATACIÓN%20%20COMERCIAL%202026.pdf'}],['DGVF - CONTRATACIÓN  COMERCIAL 2026.pdf.docx', '2do Trimestre', 'Lidia Guadalupe Hernandez ', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DGVF/CONTRATACIÓN%20%20COMERCIAL%202026.pdf.docx'}]
,
['DAF-S-RM - SPF-30-2026.pdf', '2do Trimestre', 'Sandra Bautista Hernandez', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/SPF-30-2026.pdf'}]
,
['DPLAP - solicitud de análisis de laboratorio de agua residual.xlsx', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/solicitud%20de%20analisis%20de%20laboratorio%20de%20agua%20residual.xlsx'}],['DPLAP - solicitud de análisis de laboratorio de agua residual.pdf', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/solicitud%20de%20análisis%20de%20laboratorio%20de%20agua%20residual.pdf'}],['DPLAP - solicitud de permiso de desacarga de agua residual.pdf', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/solicitud%20de%20permiso%20de%20desacarga%20de%20agua%20residual.pdf'}],['DPLAP - Solicitud de Permiso de descarga de agua residual.xlsx', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/Solicitud%20de%20Permiso%20de%20descarga%20de%20agua%20residual.xlsx'}],['DPLAP - solicitud de renovación de permiso.pdf', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/solicitud%20de%20renovación%20de%20permiso.pdf'}],['DPLAP - solicitud de renovación de permiso.xlsx', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/solicitud%20de%20renovación%20de%20permiso.xlsx'}]
,
['DPLAP - SOLICITUD DESCARGA DOM.docx', '2do Trimestre', 'Blanca E R M', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/SOLICITUD%20DESCARGA%20DOM.docx'}],['DPLAP - SOLICITUD DESCARGA DOM.pdf', '2do Trimestre', 'Blanca E R M', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/SOLICITUD%20DESCARGA%20DOM.pdf'}],['DPLAP - SOLICITUD ELABORACION DE PRESUPUESTOS.docx', '2do Trimestre', 'Blanca E R M', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/SOLICITUD%20ELABORACION%20DE%20PRESUPUESTOS.docx'}],['DPLAP - SOLICITUD ELABORACION DE PRESUPUESTOS.pdf', '2do Trimestre', 'Blanca E R M', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/SOLICITUD%20ELABORACION%20DE%20PRESUPUESTOS.pdf'}]
,
['DGVF - Contratación y Derivación.pdf', '2do Trimestre', 'Lidia Gudalupe Mendoza', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DGVF/Contratación%20y%20Derivación.pdf'}]
,
['DPLAP - 9 formato para hipervinculo CONSTRUCCION DESCARGAS.pdf', '2do Trimestre', 'Blanca E R M', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/9%20formato%20para%20hipervinculo%20CONSTRUCCION%20DESCARGAS.pdf'}],['DPLAP - 9 formato para hipervinculo PRESUPUESTOS.pdf', '2do Trimestre', 'Blanca E R M', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/9%20formato%20para%20hipervinculo%20PRESUPUESTOS.pdf'}]
,
['DPLAP - Renovacion de Permiso de descarga de agua residual.docx', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/Renovacion%20de%20Permiso%20de%20descarga%20de%20agua%20residual.docx'}],['DPLAP - Solictud de analisis fisicoquimicos para agua residual.docx', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/Solictud%20de%20analisis%20fisicoquimicos%20para%20agua%20residual.docx'}],['DPLAP - Solictud de Permiso de descarga de agua residual.docx', '2do Trimestre', 'Micaela Copca', '26-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/Solictud%20de%20Permiso%20de%20descarga%20de%20agua%20residual.docx'}]
,
['DAF - Dictamen N7-Material de Limpieza.pdf', '2do Trimestre', 'Licitaciones CAASIM', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/Dictamen%20N7-Material%20de%20Limpieza.pdf'}]
,
['DAJ - Contrato DAJ-079-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguin', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-079-2026.pdf'}]
,
['DPLAP - Solictud de analisis fisicoquimicos para agua residual.docx', '2do Trimestre', 'Micaela Copca', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/Solictud%20de%20analisis%20fisicoquimicos%20para%20agua%20residual.docx'}]
,
['DAF - DICTAMEN CEMENTO Y PRODUCTOS DE CONCRETO.pdf', '2do Trimestre', 'Licitaciones CAASIM', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/DICTAMEN%20CEMENTO%20Y%20PRODUCTOS%20DE%20CONCRETO.pdf'}],['DAF - DICTAMEN DE SERVICIO DE MANTENIMIENTO DE BIENES INFORMATICOS.pdf', '2do Trimestre', 'Licitaciones CAASIM', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/DICTAMEN%20DE%20SERVICIO%20DE%20MANTENIMIENTO%20DE%20BIENES%20INFORMATICOS.pdf'}],['DAF - DICTAMEN FLETES Y MANIOBRAS (1).pdf', '2do Trimestre', 'Licitaciones CAASIM', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/DICTAMEN%20FLETES%20Y%20MANIOBRAS%20(1).pdf'}],['DAF - DICTAMEN N9 CEMENTO Y PRODUCTOS DE CONCRETO.pdf', '2do Trimestre', 'Licitaciones CAASIM', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/DICTAMEN%20N9%20CEMENTO%20Y%20PRODUCTOS%20DE%20CONCRETO.pdf'}]
,
['DAF - DICTAMÉN EA-913005999-N13-2026.pdf', '2do Trimestre', 'Licitaciones CAASIM', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/DICTAMÉN%20EA-913005999-N13-2026.pdf'}],['DAF - FACTURA GAEARQ MEDIDORES.pdf', '2do Trimestre', 'Licitaciones CAASIM', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20GAEARQ%20MEDIDORES.pdf'}]
,
['DAF - OFICIO AUTORIZACIÓN RECURSOS ARGAB VERIFICACIÓN 54 VEHÍCULOS SEGUNDO BLOQUE.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20ARGAB%20VERIFICACIÓN%2054%20VEHÍCULOS%20SEGUNDO%20BLOQUE.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS ARGAB VERIFICACIÓN 54 VEHÍCULOS.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20ARGAB%20VERIFICACIÓN%2054%20VEHÍCULOS.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS ARGAB VERIFICACIÓN R-168, 289, 362, 498.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20ARGAB%20VERIFICACIÓN%20R-168,%20289,%20362,%20498.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS ARGAB VERIFICACIÓN R-491, 495, 496, 500.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20ARGAB%20VERIFICACIÓN%20R-491,%20495,%20496,%20500.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS ARGAB VERIFICACIÓN R-492, 501.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20ARGAB%20VERIFICACIÓN%20R-492,%20501.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS ARGAB VERIFICACIÓN R-553, 554, 557.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20ARGAB%20VERIFICACIÓN%20R-553,%20554,%20557.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS GOBIERNO OPINION CUMPLIMIENTO.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20GOBIERNO%20OPINION%20CUMPLIMIENTO.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS MANTTO VEHICULAR AUTONATION R-490.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20MANTTO%20VEHICULAR%20AUTONATION%20R-490.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS TALACHAS FEDERICO.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20TALACHAS%20FEDERICO.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS WEICHAI MANTTO R-520.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20WEICHAI%20MANTTO%20R-520.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS WEICHAI MANTTO R-522.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20WEICHAI%20MANTTO%20R-522.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS WEICHAI MANTTO R-523.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20WEICHAI%20MANTTO%20R-523.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS WEICHAI MANTTO R-524.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20WEICHAI%20MANTTO%20R-524.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS WEICHAI MANTTO R-525.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20WEICHAI%20MANTTO%20R-525.pdf'}],['DAF - OFICIO AUTORIZACIÓN RECURSOS WEICHAI MANTTO R-527.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/OFICIO%20AUTORIZACIÓN%20RECURSOS%20WEICHAI%20MANTTO%20R-527.pdf'}]
,
['DAF - PSN20260615001 AUTONATION MANTTO VEHICULAR R-490.pdf', '2do Trimestre', 'Edgar Bautista', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/PSN20260615001%20AUTONATION%20MANTTO%20VEHICULAR%20R-490.pdf'}]
,
['DAJ - Contrato DAJ-075-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-075-2026.pdf'}]
,
['DIU - AER CAASIM-DAJ-126-2024 Bacheo Z-4.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-126-2024%20Bacheo%20Z-4.pdf'}],['DIU - AER CAASIM-DAJ-127-2024 Bacheo Z-3.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-127-2024%20Bacheo%20Z-3.pdf'}],['DIU - AER CAASIM-DAJ-128-2024 Bacheo Z-2..pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-128-2024%20Bacheo%20Z-2..pdf'}],['DIU - AER CAASIM-DAJ-129-2024 Bacheo Z1.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-129-2024%20Bacheo%20Z1.pdf'}],['DIU - AER CAASIM-DAJ-132-2024 Alc Z-4.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-132-2024%20Alc%20Z-4.pdf'}],['DIU - AER CAASIM-DAJ-135-2025 Agua Z-1.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-135-2025%20Agua%20Z-1.pdf'}],['DIU - AER CAASIM-DAJ-141-2024  Redes Z-5.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-141-2024%20%20Redes%20Z-5.pdf'}],['DIU - AER CAASIM-DAJ-143-2024 Redes Z-3.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-143-2024%20Redes%20Z-3.pdf'}],['DIU - AER CAASIM-DAJ-144-2024 Redes Z-4.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-144-2024%20Redes%20Z-4.pdf'}],['DIU - AER CAASIM-DAJ-145-2024 Redes Z-1.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-145-2024%20Redes%20Z-1.pdf'}],['DIU - AER CAASIM-DAJ-147-2025 Agua Z-3.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-147-2025%20Agua%20Z-3.pdf'}],['DIU - AER CAASIM-DAJ-155-2024 Agua Z-2.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-155-2024%20Agua%20Z-2.pdf'}],['DIU - AER CAASIM-DAJ-46-2024 Descargas.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/AER%20CAASIM-DAJ-46-2024%20Descargas.pdf'}],['DIU - CAASIM-DAJ-094-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-094-2024.pdf'}],['DIU - CAASIM-DAJ-097-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-097-2024.pdf'}],['DIU - CAASIM-DAJ-109-2025.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-109-2025.pdf'}],['DIU - CAASIM-DAJ-120-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-120-2024.pdf'}],['DIU - CAASIM-DAJ-149-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-149-2024.pdf'}],['DIU - CAASIM-DAJ-175-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-175-2024.pdf'}],['DIU - CAASIM-DAJ-177-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-177-2024.pdf'}],['DIU - CAASIM-DAJ-197-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-197-2024.pdf'}],['DIU - CAASIM-DAJ-95-2024.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-95-2024.pdf'}],['DIU - FACTURAS 2025 FLETES Y MANIOBRAS.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACTURAS%202025%20FLETES%20Y%20MANIOBRAS.pdf'}],['DIU - FISICO FINANCIERO.pdf', '2do Trimestre', 'Blanca Estela Martinez', '29-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FISICO%20FINANCIERO.pdf'}]
,
['DCOME - Solitud agua potable.docx', '2do Trimestre', 'Miguel Vivar', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DCOME/Solitud%20agua%20potable.docx'}],['DCOME - Solitud agua potable.pdf', '2do Trimestre', 'Miguel Vivar', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DCOME/Solitud%20agua%20potable.pdf'}]
,
['DCOME - 9 formato para hipervinculo COMERCIAL contrato.docx', '2do Trimestre', 'Miguel Vivar', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DCOME/9%20formato%20para%20hipervinculo%20COMERCIAL%20contrato.docx'}],['DCOME - 9 formato para hipervinculo COMERCIAL.docx', '2do Trimestre', 'Miguel Vivar', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DCOME/9%20formato%20para%20hipervinculo%20COMERCIAL.docx'}]
,
['DIU - ACTA E-R CAASIM-DAJ-093-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20E-R%20CAASIM-DAJ-093-2025.pdf'}],['DIU - ACTA E-R CAASIM-DAJ-112- 2025.pdf', '2do Trimestre', 'Blanca Ramirez', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20E-R%20CAASIM-DAJ-112-%202025.pdf'}],['DIU - ACTA E-R CAASIM-DAJ-125-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20E-R%20CAASIM-DAJ-125-2025.pdf'}],['DIU - ACTA E-R CAASIM-DAJ-167-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20E-R%20CAASIM-DAJ-167-2025.pdf'}],['DIU - FACTURAS DAJ-135-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACTURAS%20DAJ-135-2025.pdf'}],['DIU - FINIQUITO DAJ-135-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FINIQUITO%20DAJ-135-2025.pdf'}]
,
['DIU - ACTA E-R CAASIM-DAJ-196-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20E-R%20CAASIM-DAJ-196-2025.pdf'}]
,
['DAB - Grafica 2do.Trimes_Desazolve.xlsx', '2do Trimestre', 'Dirección de Abasto ', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Grafica%202do.Trimes_Desazolve.xlsx'}],['DAB - Grafica 2do.Trimes_Pipas y Ptar.xlsx', '2do Trimestre', 'Dirección de Abasto ', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Grafica%202do.Trimes_Pipas%20y%20Ptar.xlsx'}],['DAB - Mir_Desazolve 2do_trimestre Dir_Abasto y Ptar excel.xls', '2do Trimestre', 'Dirección de Abasto ', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Mir_Desazolve%202do_trimestre%20Dir_Abasto%20y%20Ptar%20excel.xls'}],['DAB - Mir_Pipas y Plantas 3er_trimestre Dir_Abasto y Ptar.xls', '2do Trimestre', 'Dirección de Abasto ', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Mir_Pipas%20y%20Plantas%203er_trimestre%20Dir_Abasto%20y%20Ptar.xls'}],['DAB - Poa_Desazolve 2do_trimestre Dir_Abasto y Ptar excel.xls', '2do Trimestre', 'Dirección de Abasto ', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Poa_Desazolve%202do_trimestre%20Dir_Abasto%20y%20Ptar%20excel.xls'}],['DAB - Poa_Pipas y Plantas 3er_trimestre Dir_Abasto y Ptar.xls', '2do Trimestre', 'Dirección de Abasto ', '30-06-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Poa_Pipas%20y%20Plantas%203er_trimestre%20Dir_Abasto%20y%20Ptar.xls'}]
,
['DIU - CAASIM-DAJ-196-2024.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/CAASIM-DAJ-196-2024.pdf'}]
,
['DAF-S-RH - F02a_Catálogo Institucional de la CAASIM.pdf', '2do Trimestre', 'Nancy Templos', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F02a_Catálogo%20Institucional%20de%20la%20CAASIM.pdf'}],['DAF-S-RH - F02b_Estructura 2025 CAASIM.pdf', '2do Trimestre', 'Nancy Templos', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F02b_Estructura%202025%20CAASIM.pdf'}],['DAF-S-RH - F03_Estatuto organico.pdf', '2do Trimestre', 'Nancy Templos', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F03_Estatuto%20organico.pdf'}],['DAF-S-RH - F08_Tabulador.pdf', '2do Trimestre', 'Nancy Templos', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F08_Tabulador.pdf'}],['DAF-S-RH - F16a_Condiciones Generales de Trabajo 2024-2025.pdf', '2do Trimestre', 'Nancy Templos', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F16a_Condiciones%20Generales%20de%20Trabajo%202024-2025.pdf'}],['DAF-S-RH - F16a_Manual de Recursos Humano.pdf', '2do Trimestre', 'Nancy Templos', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/F16a_Manual%20de%20Recursos%20Humano.pdf'}]
,
['DIU - caasim-daj-1352025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/caasim-daj-1352025.pdf'}]
,
['DPLAP - Renovación de Permiso de descarga de agua residual.pdf', '2do Trimestre', 'Micaela Copca', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/Renovación%20de%20Permiso%20de%20descarga%20de%20agua%20residual.pdf'}],['DPLAP - Solictud de análisis fisicoquímicos para agua residual (3).pdf', '2do Trimestre', 'Micaela Copca', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DPLAP/Solictud%20de%20análisis%20fisicoquímicos%20para%20agua%20residual%20(3).pdf'}]
,
['DIU - avances fisco-financiero 2°.pdf', '2do Trimestre', 'Blanca Martinez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/avances%20fisco-financiero%202°.pdf'}]
,
['DCOME - formato contrato.pdf', '2do Trimestre', 'Miguel Vivar', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DCOME/formato%20contrato.pdf'}],['DCOME - formato derivacion.pdf', '2do Trimestre', 'Miguel Vivar', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DCOME/formato%20derivacion.pdf'}]
,
['DG-S-COMU - segundotrimestre26.pdf', '2do Trimestre', 'Josue Parra Flores', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DG-S-COMU/segundotrimestre26.pdf'}]
,
['DAF-S-RM - Dictamen ADL-01.pdf', '2do Trimestre', 'Yair Arturo Perez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/Dictamen%20ADL-01.pdf'}],['DAF-S-RM - Dictamen N10.pdf', '2do Trimestre', 'Yair Arturo Perez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/Dictamen%20N10.pdf'}],['DAF-S-RM - Dictamen N14.pdf', '2do Trimestre', 'Yair Arturo Perez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/Dictamen%20N14.pdf'}]
,
['DIU - FACT-CONTRATO 201-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACT-CONTRATO%20201-2025.pdf'}],['DIU - FACT-CONTRATO-168-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACT-CONTRATO-168-2025.pdf'}],['DIU - FACT-CONTRATO-193-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACT-CONTRATO-193-2025.pdf'}],['DIU - FACT-CONTRATO-197-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACT-CONTRATO-197-2025.pdf'}],['DIU - FACT-CONTRATO-198-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACT-CONTRATO-198-2025.pdf'}],['DIU - FACT-CONTRATO-199-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACT-CONTRATO-199-2025.pdf'}],['DIU - FACT-CONTRATO-200-2025.pdf', '2do Trimestre', 'Blanca Ramirez', '01-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/FACT-CONTRATO-200-2025.pdf'}]
,
['DAB - Grafica 2do.Trimes_Desazolve ocr.pdf', '2do Trimestre', 'JKPC', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Grafica%202do.Trimes_Desazolve%20ocr.pdf'}],['DAB - Grafica 2do.Trimes_Pipas y Ptar ocr.pdf', '2do Trimestre', 'JKPC', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Grafica%202do.Trimes_Pipas%20y%20Ptar%20ocr.pdf'}],['DAB - Mir desazolve 2do_Trimestre ocr.pdf', '2do Trimestre', 'JKPC', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Mir%20desazolve%202do_Trimestre%20ocr.pdf'}],['DAB - Mir_Pipas y plantas 2do_Trimestre ocr.pdf', '2do Trimestre', 'JKPC', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Mir_Pipas%20y%20plantas%202do_Trimestre%20ocr.pdf'}],['DAB - Poa desazolve 2do_Trimestre ocr.pdf', '2do Trimestre', 'JKPC', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Poa%20desazolve%202do_Trimestre%20ocr.pdf'}],['DAB - Poa Pipas y Plantas 2do_Trimestre ocr.pdf', '2do Trimestre', 'JKPC', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/Poa%20Pipas%20y%20Plantas%202do_Trimestre%20ocr.pdf'}]
,
['DAB - 2do. Trimestre_Mir Desazolve.pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trimestre_Mir%20Desazolve.pdf'}],['DAB - 2do. Trimestre_Poa Desazolve.pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trimestre_Poa%20Desazolve.pdf'}]
,
['DAB - 2do. Trimestre_Mir Pipas y Plantas.pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trimestre_Mir%20Pipas%20y%20Plantas.pdf'}],['DAB - 2do. Trimestre_Poa Pipas y Plantas.pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trimestre_Poa%20Pipas%20y%20Plantas.pdf'}]
,
['DAJ - Convenio DAJ-004-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguin', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Convenio%20DAJ-004-2026.pdf'}],['DAJ - Convenio DAJ-005-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguin', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Convenio%20DAJ-005-2026.pdf'}]
,
['DAB - 2do. Trimestre_ Mir Desazolve y Equipos .pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trimestre_%20Mir%20Desazolve%20y%20Equipos%20.pdf'}],['DAB - 2do. Trim_Mir Pipas y Plantas .pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trim_Mir%20Pipas%20y%20Plantas%20.pdf'}],['DAB - 2do. Trim_Poa Desazolve y Equipos.pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trim_Poa%20Desazolve%20y%20Equipos.pdf'}],['DAB - 2do. Trim_Poa Pipas y Plantas .pdf', '2do Trimestre', 'Joanna Karina Paz Carrasco', '02-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAB/2do.%20Trim_Poa%20Pipas%20y%20Plantas%20.pdf'}]
,
['DAF-S-RH - 1008.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1008.docx'}],['DAF-S-RH - 1008.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1008.pdf'}],['DAF-S-RH - 1022.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1022.docx'}],['DAF-S-RH - 1022.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1022.pdf'}],['DAF-S-RH - 1816.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1816.docx'}],['DAF-S-RH - 1816.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1816.pdf'}],['DAF-S-RH - 1850.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1850.docx'}],['DAF-S-RH - 1850.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1850.pdf'}],['DAF-S-RH - 1853.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1853.docx'}],['DAF-S-RH - 1853.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1853.pdf'}],['DAF-S-RH - 1979.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1979.docx'}],['DAF-S-RH - 1979.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1979.pdf'}],['DAF-S-RH - 1992.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1992.docx'}],['DAF-S-RH - 1992.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/1992.pdf'}],['DAF-S-RH - 2093.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2093.docx'}],['DAF-S-RH - 2093.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2093.pdf'}],['DAF-S-RH - 2239.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2239.docx'}],['DAF-S-RH - 2239.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2239.pdf'}],['DAF-S-RH - 2261.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2261.docx'}],['DAF-S-RH - 2261.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2261.pdf'}],['DAF-S-RH - 228.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/228.docx'}],['DAF-S-RH - 228.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/228.pdf'}],['DAF-S-RH - 2420.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2420.docx'}],['DAF-S-RH - 2420.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2420.pdf'}],['DAF-S-RH - 2456.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2456.docx'}],['DAF-S-RH - 2456.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2456.pdf'}],['DAF-S-RH - 2457.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2457.docx'}],['DAF-S-RH - 2457.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2457.pdf'}],['DAF-S-RH - 2465.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2465.docx'}],['DAF-S-RH - 2465.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2465.pdf'}],['DAF-S-RH - 2483.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2483.docx'}],['DAF-S-RH - 2483.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2483.pdf'}],['DAF-S-RH - 2489.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2489.docx'}],['DAF-S-RH - 2489.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2489.pdf'}],['DAF-S-RH - 2492.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2492.docx'}],['DAF-S-RH - 2492.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2492.pdf'}],['DAF-S-RH - 2538.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2538.docx'}],['DAF-S-RH - 2538.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2538.pdf'}],['DAF-S-RH - 2547.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2547.docx'}],['DAF-S-RH - 2547.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2547.pdf'}],['DAF-S-RH - 2556.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2556.docx'}],['DAF-S-RH - 2556.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2556.pdf'}],['DAF-S-RH - 2560.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2560.docx'}],['DAF-S-RH - 2560.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2560.pdf'}],['DAF-S-RH - 2566.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2566.docx'}],['DAF-S-RH - 2566.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2566.pdf'}],['DAF-S-RH - 2567.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2567.docx'}],['DAF-S-RH - 2567.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2567.pdf'}],['DAF-S-RH - 2579.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2579.docx'}],['DAF-S-RH - 2579.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2579.pdf'}],['DAF-S-RH - 2581.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2581.docx'}],['DAF-S-RH - 2581.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2581.pdf'}],['DAF-S-RH - 2603.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2603.docx'}],['DAF-S-RH - 2603.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2603.pdf'}],['DAF-S-RH - 2631.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2631.docx'}],['DAF-S-RH - 2631.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2631.pdf'}],['DAF-S-RH - 2647.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2647.docx'}],['DAF-S-RH - 2647.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2647.pdf'}],['DAF-S-RH - 2655.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2655.docx'}],['DAF-S-RH - 2655.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2655.pdf'}],['DAF-S-RH - 2677.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2677.docx'}],['DAF-S-RH - 2677.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2677.pdf'}],['DAF-S-RH - 2734.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2734.docx'}],['DAF-S-RH - 2734.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2734.pdf'}],['DAF-S-RH - 2769.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2769.docx'}],['DAF-S-RH - 2769.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2769.pdf'}],['DAF-S-RH - 2771.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2771.docx'}],['DAF-S-RH - 2771.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2771.pdf'}],['DAF-S-RH - 2855.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2855.docx'}],['DAF-S-RH - 2855.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2855.pdf'}],['DAF-S-RH - 2863.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2863.docx'}],['DAF-S-RH - 2863.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2863.pdf'}],['DAF-S-RH - 2885.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2885.docx'}],['DAF-S-RH - 2885.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2885.pdf'}],['DAF-S-RH - 2886.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2886.docx'}],['DAF-S-RH - 2886.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2886.pdf'}],['DAF-S-RH - 2914.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2914.docx'}],['DAF-S-RH - 2914.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2914.pdf'}],['DAF-S-RH - 2919.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2919.docx'}],['DAF-S-RH - 2919.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2919.pdf'}],['DAF-S-RH - 2957.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2957.docx'}],['DAF-S-RH - 2957.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2957.pdf'}],['DAF-S-RH - 2971.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2971.docx'}],['DAF-S-RH - 2971.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2971.pdf'}],['DAF-S-RH - 2980.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2980.docx'}],['DAF-S-RH - 2980.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2980.pdf'}],['DAF-S-RH - 2989.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2989.docx'}],['DAF-S-RH - 2989.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/2989.pdf'}],['DAF-S-RH - 3000.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3000.docx'}],['DAF-S-RH - 3000.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3000.pdf'}],['DAF-S-RH - 3001.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3001.docx'}],['DAF-S-RH - 3001.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3001.pdf'}],['DAF-S-RH - 3008.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3008.docx'}],['DAF-S-RH - 3008.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3008.pdf'}],['DAF-S-RH - 3011.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3011.docx'}],['DAF-S-RH - 3011.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3011.pdf'}],['DAF-S-RH - 3012.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3012.docx'}],['DAF-S-RH - 3012.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3012.pdf'}],['DAF-S-RH - 3026.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3026.docx'}],['DAF-S-RH - 3026.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3026.pdf'}],['DAF-S-RH - 3027.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3027.docx'}],['DAF-S-RH - 3027.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3027.pdf'}],['DAF-S-RH - 3032.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3032.docx'}],['DAF-S-RH - 3032.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3032.pdf'}],['DAF-S-RH - 3080.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3080.docx'}],['DAF-S-RH - 3080.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3080.pdf'}],['DAF-S-RH - 3087.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3087.docx'}],['DAF-S-RH - 3087.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3087.pdf'}],['DAF-S-RH - 3088.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3088.docx'}],['DAF-S-RH - 3088.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3088.pdf'}],['DAF-S-RH - 3104.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3104.docx'}],['DAF-S-RH - 3104.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3104.pdf'}],['DAF-S-RH - 3105.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3105.docx'}],['DAF-S-RH - 3105.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3105.pdf'}],['DAF-S-RH - 3106.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3106.docx'}],['DAF-S-RH - 3106.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3106.pdf'}],['DAF-S-RH - 3138.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3138.docx'}],['DAF-S-RH - 3138.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3138.pdf'}],['DAF-S-RH - 3166.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3166.docx'}],['DAF-S-RH - 3166.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3166.pdf'}],['DAF-S-RH - 3188.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3188.docx'}],['DAF-S-RH - 3188.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3188.pdf'}],['DAF-S-RH - 3197.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3197.docx'}],['DAF-S-RH - 3197.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3197.pdf'}],['DAF-S-RH - 3211.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3211.docx'}],['DAF-S-RH - 3211.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3211.pdf'}],['DAF-S-RH - 3213.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3213.docx'}],['DAF-S-RH - 3213.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3213.pdf'}],['DAF-S-RH - 3316.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3316.docx'}],['DAF-S-RH - 3316.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3316.pdf'}],['DAF-S-RH - 3321.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3321.docx'}],['DAF-S-RH - 3321.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3321.pdf'}],['DAF-S-RH - 3334.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3334.docx'}],['DAF-S-RH - 3334.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3334.pdf'}],['DAF-S-RH - 3338.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3338.docx'}],['DAF-S-RH - 3338.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3338.pdf'}],['DAF-S-RH - 3358.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3358.docx'}],['DAF-S-RH - 3358.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3358.pdf'}],['DAF-S-RH - 3366.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3366.docx'}],['DAF-S-RH - 3366.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3366.pdf'}],['DAF-S-RH - 3375.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3375.docx'}],['DAF-S-RH - 3375.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3375.pdf'}],['DAF-S-RH - 3389.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3389.docx'}],['DAF-S-RH - 3389.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3389.pdf'}],['DAF-S-RH - 339.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/339.docx'}],['DAF-S-RH - 339.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/339.pdf'}],['DAF-S-RH - 3390.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3390.docx'}],['DAF-S-RH - 3390.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3390.pdf'}],['DAF-S-RH - 3398.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3398.docx'}],['DAF-S-RH - 3398.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3398.pdf'}],['DAF-S-RH - 3406.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3406.docx'}],['DAF-S-RH - 3406.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3406.pdf'}],['DAF-S-RH - 3415.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3415.docx'}],['DAF-S-RH - 3415.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3415.pdf'}],['DAF-S-RH - 3449.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3449.docx'}],['DAF-S-RH - 3449.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3449.pdf'}],['DAF-S-RH - 3455.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3455.docx'}],['DAF-S-RH - 3455.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3455.pdf'}],['DAF-S-RH - 3475.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3475.docx'}],['DAF-S-RH - 3475.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3475.pdf'}],['DAF-S-RH - 3476.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3476.docx'}],['DAF-S-RH - 3476.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3476.pdf'}],['DAF-S-RH - 3511.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3511.docx'}],['DAF-S-RH - 3511.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3511.pdf'}],['DAF-S-RH - 3521.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3521.docx'}],['DAF-S-RH - 3521.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3521.pdf'}],['DAF-S-RH - 3526.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3526.docx'}],['DAF-S-RH - 3526.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3526.pdf'}],['DAF-S-RH - 3583.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3583.docx'}],['DAF-S-RH - 3583.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3583.pdf'}],['DAF-S-RH - 3598.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3598.docx'}],['DAF-S-RH - 3598.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3598.pdf'}],['DAF-S-RH - 3609.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3609.docx'}],['DAF-S-RH - 3609.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3609.pdf'}],['DAF-S-RH - 3610.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3610.docx'}],['DAF-S-RH - 3610.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3610.pdf'}],['DAF-S-RH - 3628.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3628.docx'}],['DAF-S-RH - 3628.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3628.pdf'}],['DAF-S-RH - 3699.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3699.docx'}],['DAF-S-RH - 3699.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3699.pdf'}],['DAF-S-RH - 3725.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3725.docx'}],['DAF-S-RH - 3725.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3725.pdf'}],['DAF-S-RH - 3726.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3726.docx'}],['DAF-S-RH - 3726.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3726.pdf'}],['DAF-S-RH - 3727.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3727.docx'}],['DAF-S-RH - 3727.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3727.pdf'}],['DAF-S-RH - 3750.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3750.docx'}],['DAF-S-RH - 3750.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3750.pdf'}],['DAF-S-RH - 376.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/376.docx'}],['DAF-S-RH - 376.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/376.pdf'}],['DAF-S-RH - 3769.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3769.docx'}],['DAF-S-RH - 3769.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3769.pdf'}],['DAF-S-RH - 3772.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3772.docx'}],['DAF-S-RH - 3772.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3772.pdf'}],['DAF-S-RH - 3778.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3778.docx'}],['DAF-S-RH - 3778.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3778.pdf'}],['DAF-S-RH - 3816.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3816.docx'}],['DAF-S-RH - 3816.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3816.pdf'}],['DAF-S-RH - 3828.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3828.docx'}],['DAF-S-RH - 3828.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3828.pdf'}],['DAF-S-RH - 3835.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3835.docx'}],['DAF-S-RH - 3835.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3835.pdf'}],['DAF-S-RH - 3878.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3878.docx'}],['DAF-S-RH - 3878.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3878.pdf'}],['DAF-S-RH - 3890.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3890.docx'}],['DAF-S-RH - 3890.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3890.pdf'}],['DAF-S-RH - 3893.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3893.docx'}],['DAF-S-RH - 3893.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3893.pdf'}],['DAF-S-RH - 3918.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3918.docx'}],['DAF-S-RH - 3918.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3918.pdf'}],['DAF-S-RH - 3931.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3931.docx'}],['DAF-S-RH - 3931.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3931.pdf'}],['DAF-S-RH - 3952.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3952.docx'}],['DAF-S-RH - 3952.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3952.pdf'}],['DAF-S-RH - 3953.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3953.docx'}],['DAF-S-RH - 3953.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3953.pdf'}],['DAF-S-RH - 3960.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3960.docx'}],['DAF-S-RH - 3960.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3960.pdf'}],['DAF-S-RH - 3961.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3961.docx'}],['DAF-S-RH - 3961.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3961.pdf'}],['DAF-S-RH - 3962.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3962.docx'}],['DAF-S-RH - 3962.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3962.pdf'}],['DAF-S-RH - 3967.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3967.docx'}],['DAF-S-RH - 3967.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3967.pdf'}],['DAF-S-RH - 3970.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3970.docx'}],['DAF-S-RH - 3970.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3970.pdf'}],['DAF-S-RH - 3978.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3978.docx'}],['DAF-S-RH - 3978.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3978.pdf'}],['DAF-S-RH - 3979.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3979.docx'}],['DAF-S-RH - 3979.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3979.pdf'}],['DAF-S-RH - 3983.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3983.docx'}],['DAF-S-RH - 3983.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3983.pdf'}],['DAF-S-RH - 3984.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3984.docx'}],['DAF-S-RH - 3984.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3984.pdf'}],['DAF-S-RH - 3988.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3988.docx'}],['DAF-S-RH - 3988.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/3988.pdf'}],['DAF-S-RH - 4010.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4010.docx'}],['DAF-S-RH - 4010.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4010.pdf'}],['DAF-S-RH - 4017.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4017.docx'}],['DAF-S-RH - 4017.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4017.pdf'}],['DAF-S-RH - 4019.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4019.docx'}],['DAF-S-RH - 4019.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4019.pdf'}],['DAF-S-RH - 4022.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4022.docx'}],['DAF-S-RH - 4022.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4022.pdf'}],['DAF-S-RH - 4026.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4026.docx'}],['DAF-S-RH - 4026.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4026.pdf'}],['DAF-S-RH - 4033.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4033.docx'}],['DAF-S-RH - 4033.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4033.pdf'}],['DAF-S-RH - 4036.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4036.docx'}],['DAF-S-RH - 4036.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4036.pdf'}],['DAF-S-RH - 4039.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4039.docx'}],['DAF-S-RH - 4039.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4039.pdf'}],['DAF-S-RH - 4043.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4043.docx'}],['DAF-S-RH - 4043.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4043.pdf'}],['DAF-S-RH - 4050.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4050.docx'}],['DAF-S-RH - 4050.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4050.pdf'}],['DAF-S-RH - 4086.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4086.docx'}],['DAF-S-RH - 4086.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4086.pdf'}],['DAF-S-RH - 4087.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4087.docx'}],['DAF-S-RH - 4087.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4087.pdf'}],['DAF-S-RH - 4095.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4095.docx'}],['DAF-S-RH - 4095.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4095.pdf'}],['DAF-S-RH - 4149.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4149.docx'}],['DAF-S-RH - 4149.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4149.pdf'}],['DAF-S-RH - 4154.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4154.docx'}],['DAF-S-RH - 4154.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4154.pdf'}],['DAF-S-RH - 4155.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4155.docx'}],['DAF-S-RH - 4155.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4155.pdf'}],['DAF-S-RH - 4156.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4156.docx'}],['DAF-S-RH - 4156.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4156.pdf'}],['DAF-S-RH - 4157.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4157.docx'}],['DAF-S-RH - 4157.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4157.pdf'}],['DAF-S-RH - 4159.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4159.docx'}],['DAF-S-RH - 4159.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4159.pdf'}],['DAF-S-RH - 4160.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4160.docx'}],['DAF-S-RH - 4160.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4160.pdf'}],['DAF-S-RH - 4161.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4161.docx'}],['DAF-S-RH - 4161.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4161.pdf'}],['DAF-S-RH - 4162.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4162.docx'}],['DAF-S-RH - 4162.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4162.pdf'}],['DAF-S-RH - 4167.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4167.docx'}],['DAF-S-RH - 4167.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4167.pdf'}],['DAF-S-RH - 4168.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4168.docx'}],['DAF-S-RH - 4168.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4168.pdf'}],['DAF-S-RH - 4170.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4170.docx'}],['DAF-S-RH - 4170.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4170.pdf'}],['DAF-S-RH - 4175.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4175.docx'}],['DAF-S-RH - 4175.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4175.pdf'}],['DAF-S-RH - 4177.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4177.docx'}],['DAF-S-RH - 4177.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4177.pdf'}],['DAF-S-RH - 4178.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4178.docx'}],['DAF-S-RH - 4178.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4178.pdf'}],['DAF-S-RH - 4181.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4181.docx'}],['DAF-S-RH - 4181.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4181.pdf'}],['DAF-S-RH - 4182.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4182.docx'}],['DAF-S-RH - 4182.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4182.pdf'}],['DAF-S-RH - 4183.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4183.docx'}],['DAF-S-RH - 4183.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4183.pdf'}],['DAF-S-RH - 4184.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4184.docx'}],['DAF-S-RH - 4184.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4184.pdf'}],['DAF-S-RH - 4185.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4185.docx'}],['DAF-S-RH - 4185.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4185.pdf'}],['DAF-S-RH - 4186.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4186.docx'}],['DAF-S-RH - 4186.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4186.pdf'}],['DAF-S-RH - 4187.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4187.docx'}],['DAF-S-RH - 4187.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4187.pdf'}],['DAF-S-RH - 4189.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4189.docx'}],['DAF-S-RH - 4189.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4189.pdf'}],['DAF-S-RH - 4193.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4193.docx'}],['DAF-S-RH - 4193.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4193.pdf'}],['DAF-S-RH - 4198.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4198.docx'}],['DAF-S-RH - 4198.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4198.pdf'}],['DAF-S-RH - 4206.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4206.docx'}],['DAF-S-RH - 4206.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4206.pdf'}],['DAF-S-RH - 4214.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4214.docx'}],['DAF-S-RH - 4214.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4214.pdf'}],['DAF-S-RH - 4215.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4215.docx'}],['DAF-S-RH - 4215.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4215.pdf'}],['DAF-S-RH - 4219.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4219.docx'}],['DAF-S-RH - 4219.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4219.pdf'}],['DAF-S-RH - 4221.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4221.docx'}],['DAF-S-RH - 4221.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4221.pdf'}],['DAF-S-RH - 4225.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4225.docx'}],['DAF-S-RH - 4225.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4225.pdf'}],['DAF-S-RH - 4228.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4228.docx'}],['DAF-S-RH - 4228.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4228.pdf'}],['DAF-S-RH - 4230.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4230.docx'}],['DAF-S-RH - 4230.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4230.pdf'}],['DAF-S-RH - 4235.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4235.docx'}],['DAF-S-RH - 4235.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4235.pdf'}],['DAF-S-RH - 4238.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4238.docx'}],['DAF-S-RH - 4238.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4238.pdf'}],['DAF-S-RH - 4242.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4242.docx'}],['DAF-S-RH - 4242.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4242.pdf'}],['DAF-S-RH - 4248.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4248.docx'}],['DAF-S-RH - 4248.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4248.pdf'}],['DAF-S-RH - 4249.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4249.docx'}],['DAF-S-RH - 4249.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4249.pdf'}],['DAF-S-RH - 4253.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4253.docx'}],['DAF-S-RH - 4253.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4253.pdf'}],['DAF-S-RH - 4260.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4260.docx'}],['DAF-S-RH - 4260.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4260.pdf'}],['DAF-S-RH - 4261.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4261.docx'}],['DAF-S-RH - 4261.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4261.pdf'}],['DAF-S-RH - 4263.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4263.docx'}],['DAF-S-RH - 4263.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4263.pdf'}],['DAF-S-RH - 4265.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4265.docx'}],['DAF-S-RH - 4265.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4265.pdf'}],['DAF-S-RH - 4271.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4271.docx'}],['DAF-S-RH - 4271.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4271.pdf'}],['DAF-S-RH - 4275.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4275.docx'}],['DAF-S-RH - 4275.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4275.pdf'}],['DAF-S-RH - 4281.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4281.docx'}],['DAF-S-RH - 4281.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4281.pdf'}],['DAF-S-RH - 4282.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4282.docx'}],['DAF-S-RH - 4282.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4282.pdf'}],['DAF-S-RH - 4289.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4289.docx'}],['DAF-S-RH - 4289.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4289.pdf'}],['DAF-S-RH - 4291.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4291.docx'}],['DAF-S-RH - 4291.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4291.pdf'}],['DAF-S-RH - 4293.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4293.docx'}],['DAF-S-RH - 4293.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4293.pdf'}],['DAF-S-RH - 4294.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4294.docx'}],['DAF-S-RH - 4294.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4294.pdf'}],['DAF-S-RH - 4296.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4296.docx'}],['DAF-S-RH - 4296.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4296.pdf'}],['DAF-S-RH - 4298.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4298.docx'}],['DAF-S-RH - 4298.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4298.pdf'}],['DAF-S-RH - 4299.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4299.docx'}],['DAF-S-RH - 4299.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4299.pdf'}],['DAF-S-RH - 4325.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4325.docx'}],['DAF-S-RH - 4325.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4325.pdf'}],['DAF-S-RH - 4326.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4326.docx'}],['DAF-S-RH - 4326.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4326.pdf'}],['DAF-S-RH - 4332.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4332.docx'}],['DAF-S-RH - 4332.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4332.pdf'}],['DAF-S-RH - 4357.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4357.docx'}],['DAF-S-RH - 4357.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4357.pdf'}],['DAF-S-RH - 4360.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4360.docx'}],['DAF-S-RH - 4360.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4360.pdf'}],['DAF-S-RH - 4362.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4362.docx'}],['DAF-S-RH - 4362.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4362.pdf'}],['DAF-S-RH - 4372.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4372.docx'}],['DAF-S-RH - 4372.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4372.pdf'}],['DAF-S-RH - 4375.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4375.docx'}],['DAF-S-RH - 4375.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4375.pdf'}],['DAF-S-RH - 4376.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4376.docx'}],['DAF-S-RH - 4376.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4376.pdf'}],['DAF-S-RH - 4379.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4379.docx'}],['DAF-S-RH - 4379.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4379.pdf'}],['DAF-S-RH - 4388.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4388.docx'}],['DAF-S-RH - 4388.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4388.pdf'}],['DAF-S-RH - 4393.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4393.docx'}],['DAF-S-RH - 4393.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4393.pdf'}],['DAF-S-RH - 4399.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4399.docx'}],['DAF-S-RH - 4399.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4399.pdf'}],['DAF-S-RH - 4404.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4404.docx'}],['DAF-S-RH - 4404.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4404.pdf'}],['DAF-S-RH - 4408.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4408.docx'}],['DAF-S-RH - 4408.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4408.pdf'}],['DAF-S-RH - 4413.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4413.docx'}],['DAF-S-RH - 4413.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4413.pdf'}],['DAF-S-RH - 4414.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4414.docx'}],['DAF-S-RH - 4414.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4414.pdf'}],['DAF-S-RH - 4415.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4415.docx'}],['DAF-S-RH - 4415.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4415.pdf'}],['DAF-S-RH - 4416.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4416.docx'}],['DAF-S-RH - 4416.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4416.pdf'}],['DAF-S-RH - 4417.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4417.docx'}],['DAF-S-RH - 4417.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4417.pdf'}],['DAF-S-RH - 4418.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4418.docx'}],['DAF-S-RH - 4418.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4418.pdf'}],['DAF-S-RH - 4419.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4419.docx'}],['DAF-S-RH - 4419.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4419.pdf'}],['DAF-S-RH - 4439.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4439.docx'}],['DAF-S-RH - 4439.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4439.pdf'}],['DAF-S-RH - 4462.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4462.docx'}],['DAF-S-RH - 4462.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4462.pdf'}],['DAF-S-RH - 4478.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4478.docx'}],['DAF-S-RH - 4478.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4478.pdf'}],['DAF-S-RH - 4481.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4481.docx'}],['DAF-S-RH - 4481.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4481.pdf'}],['DAF-S-RH - 4491.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4491.docx'}],['DAF-S-RH - 4491.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4491.pdf'}],['DAF-S-RH - 4492.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4492.docx'}],['DAF-S-RH - 4492.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4492.pdf'}],['DAF-S-RH - 4504.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4504.docx'}],['DAF-S-RH - 4504.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4504.pdf'}],['DAF-S-RH - 4511.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4511.docx'}],['DAF-S-RH - 4511.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4511.pdf'}],['DAF-S-RH - 4556.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4556.docx'}],['DAF-S-RH - 4556.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4556.pdf'}],['DAF-S-RH - 4559.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4559.docx'}],['DAF-S-RH - 4559.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4559.pdf'}],['DAF-S-RH - 4563.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4563.docx'}],['DAF-S-RH - 4563.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4563.pdf'}],['DAF-S-RH - 4564.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4564.docx'}],['DAF-S-RH - 4564.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4564.pdf'}],['DAF-S-RH - 4577.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4577.docx'}],['DAF-S-RH - 4577.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4577.pdf'}],['DAF-S-RH - 4586.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4586.docx'}],['DAF-S-RH - 4586.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4586.pdf'}],['DAF-S-RH - 4588.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4588.docx'}],['DAF-S-RH - 4588.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4588.pdf'}],['DAF-S-RH - 4603.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4603.docx'}],['DAF-S-RH - 4603.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/4603.pdf'}],['DAF-S-RH - 794.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/794.docx'}],['DAF-S-RH - 794.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/794.pdf'}],['DAF-S-RH - 846.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/846.docx'}],['DAF-S-RH - 846.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/846.pdf'}],['DAF-S-RH - 967.docx', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/967.docx'}],['DAF-S-RH - 967.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/967.pdf'}]
,
['DAF-S-RH - completo final-p├íginas-1.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-1.pdf'}],['DAF-S-RH - completo final-p├íginas-10.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-10.pdf'}],['DAF-S-RH - completo final-p├íginas-100.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-100.pdf'}],['DAF-S-RH - completo final-p├íginas-101.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-101.pdf'}],['DAF-S-RH - completo final-p├íginas-102.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-102.pdf'}],['DAF-S-RH - completo final-p├íginas-103.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-103.pdf'}],['DAF-S-RH - completo final-p├íginas-104.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-104.pdf'}],['DAF-S-RH - completo final-p├íginas-105.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-105.pdf'}],['DAF-S-RH - completo final-p├íginas-106.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-106.pdf'}],['DAF-S-RH - completo final-p├íginas-107.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-107.pdf'}],['DAF-S-RH - completo final-p├íginas-108.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-108.pdf'}],['DAF-S-RH - completo final-p├íginas-109.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-109.pdf'}],['DAF-S-RH - completo final-p├íginas-11.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-11.pdf'}],['DAF-S-RH - completo final-p├íginas-110.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-110.pdf'}],['DAF-S-RH - completo final-p├íginas-111.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-111.pdf'}],['DAF-S-RH - completo final-p├íginas-112.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-112.pdf'}],['DAF-S-RH - completo final-p├íginas-113.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-113.pdf'}],['DAF-S-RH - completo final-p├íginas-114.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-114.pdf'}],['DAF-S-RH - completo final-p├íginas-115.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-115.pdf'}],['DAF-S-RH - completo final-p├íginas-116.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-116.pdf'}],['DAF-S-RH - completo final-p├íginas-117.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-117.pdf'}],['DAF-S-RH - completo final-p├íginas-118.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-118.pdf'}],['DAF-S-RH - completo final-p├íginas-119.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-119.pdf'}],['DAF-S-RH - completo final-p├íginas-12.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-12.pdf'}],['DAF-S-RH - completo final-p├íginas-120.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-120.pdf'}],['DAF-S-RH - completo final-p├íginas-121.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-121.pdf'}],['DAF-S-RH - completo final-p├íginas-122.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-122.pdf'}],['DAF-S-RH - completo final-p├íginas-123.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-123.pdf'}],['DAF-S-RH - completo final-p├íginas-124.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-124.pdf'}],['DAF-S-RH - completo final-p├íginas-125.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-125.pdf'}],['DAF-S-RH - completo final-p├íginas-126.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-126.pdf'}],['DAF-S-RH - completo final-p├íginas-127.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-127.pdf'}],['DAF-S-RH - completo final-p├íginas-128.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-128.pdf'}],['DAF-S-RH - completo final-p├íginas-129.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-129.pdf'}],['DAF-S-RH - completo final-p├íginas-13.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-13.pdf'}],['DAF-S-RH - completo final-p├íginas-130.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-130.pdf'}],['DAF-S-RH - completo final-p├íginas-131.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-131.pdf'}],['DAF-S-RH - completo final-p├íginas-132.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-132.pdf'}],['DAF-S-RH - completo final-p├íginas-133.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-133.pdf'}],['DAF-S-RH - completo final-p├íginas-134.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-134.pdf'}],['DAF-S-RH - completo final-p├íginas-135.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-135.pdf'}],['DAF-S-RH - completo final-p├íginas-136.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-136.pdf'}],['DAF-S-RH - completo final-p├íginas-137.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-137.pdf'}],['DAF-S-RH - completo final-p├íginas-138.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-138.pdf'}],['DAF-S-RH - completo final-p├íginas-139.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-139.pdf'}],['DAF-S-RH - completo final-p├íginas-14.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-14.pdf'}],['DAF-S-RH - completo final-p├íginas-140.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-140.pdf'}],['DAF-S-RH - completo final-p├íginas-141.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-141.pdf'}],['DAF-S-RH - completo final-p├íginas-142.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-142.pdf'}],['DAF-S-RH - completo final-p├íginas-143.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-143.pdf'}],['DAF-S-RH - completo final-p├íginas-144.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-144.pdf'}],['DAF-S-RH - completo final-p├íginas-145.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-145.pdf'}],['DAF-S-RH - completo final-p├íginas-146.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-146.pdf'}],['DAF-S-RH - completo final-p├íginas-147.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-147.pdf'}],['DAF-S-RH - completo final-p├íginas-148.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-148.pdf'}],['DAF-S-RH - completo final-p├íginas-149.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-149.pdf'}],['DAF-S-RH - completo final-p├íginas-15.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-15.pdf'}],['DAF-S-RH - completo final-p├íginas-150.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-150.pdf'}],['DAF-S-RH - completo final-p├íginas-151.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-151.pdf'}],['DAF-S-RH - completo final-p├íginas-152.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-152.pdf'}],['DAF-S-RH - completo final-p├íginas-153.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-153.pdf'}],['DAF-S-RH - completo final-p├íginas-154.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-154.pdf'}],['DAF-S-RH - completo final-p├íginas-155.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-155.pdf'}],['DAF-S-RH - completo final-p├íginas-156.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-156.pdf'}],['DAF-S-RH - completo final-p├íginas-157.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-157.pdf'}],['DAF-S-RH - completo final-p├íginas-158.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-158.pdf'}],['DAF-S-RH - completo final-p├íginas-159.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-159.pdf'}],['DAF-S-RH - completo final-p├íginas-16.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-16.pdf'}],['DAF-S-RH - completo final-p├íginas-160.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-160.pdf'}],['DAF-S-RH - completo final-p├íginas-161.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-161.pdf'}],['DAF-S-RH - completo final-p├íginas-162.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-162.pdf'}],['DAF-S-RH - completo final-p├íginas-163.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-163.pdf'}],['DAF-S-RH - completo final-p├íginas-164.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-164.pdf'}],['DAF-S-RH - completo final-p├íginas-165.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-165.pdf'}],['DAF-S-RH - completo final-p├íginas-166.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-166.pdf'}],['DAF-S-RH - completo final-p├íginas-167.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-167.pdf'}],['DAF-S-RH - completo final-p├íginas-168.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-168.pdf'}],['DAF-S-RH - completo final-p├íginas-169.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-169.pdf'}],['DAF-S-RH - completo final-p├íginas-17.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-17.pdf'}],['DAF-S-RH - completo final-p├íginas-170.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-170.pdf'}],['DAF-S-RH - completo final-p├íginas-171.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-171.pdf'}],['DAF-S-RH - completo final-p├íginas-172.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-172.pdf'}],['DAF-S-RH - completo final-p├íginas-173.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-173.pdf'}],['DAF-S-RH - completo final-p├íginas-174.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-174.pdf'}],['DAF-S-RH - completo final-p├íginas-175.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-175.pdf'}],['DAF-S-RH - completo final-p├íginas-176.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-176.pdf'}],['DAF-S-RH - completo final-p├íginas-177.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-177.pdf'}],['DAF-S-RH - completo final-p├íginas-178.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-178.pdf'}],['DAF-S-RH - completo final-p├íginas-179.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-179.pdf'}],['DAF-S-RH - completo final-p├íginas-18.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-18.pdf'}],['DAF-S-RH - completo final-p├íginas-180.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-180.pdf'}],['DAF-S-RH - completo final-p├íginas-181.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-181.pdf'}],['DAF-S-RH - completo final-p├íginas-182.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-182.pdf'}],['DAF-S-RH - completo final-p├íginas-183.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-183.pdf'}],['DAF-S-RH - completo final-p├íginas-184.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-184.pdf'}],['DAF-S-RH - completo final-p├íginas-185.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-185.pdf'}],['DAF-S-RH - completo final-p├íginas-186.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-186.pdf'}],['DAF-S-RH - completo final-p├íginas-187.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-187.pdf'}],['DAF-S-RH - completo final-p├íginas-188.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-188.pdf'}],['DAF-S-RH - completo final-p├íginas-189.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-189.pdf'}],['DAF-S-RH - completo final-p├íginas-19.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-19.pdf'}],['DAF-S-RH - completo final-p├íginas-190.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-190.pdf'}],['DAF-S-RH - completo final-p├íginas-191.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-191.pdf'}],['DAF-S-RH - completo final-p├íginas-192.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-192.pdf'}],['DAF-S-RH - completo final-p├íginas-193.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-193.pdf'}],['DAF-S-RH - completo final-p├íginas-194.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-194.pdf'}],['DAF-S-RH - completo final-p├íginas-195.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-195.pdf'}],['DAF-S-RH - completo final-p├íginas-196.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-196.pdf'}],['DAF-S-RH - completo final-p├íginas-197.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-197.pdf'}],['DAF-S-RH - completo final-p├íginas-198.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-198.pdf'}],['DAF-S-RH - completo final-p├íginas-199.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-199.pdf'}],['DAF-S-RH - completo final-p├íginas-2.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-2.pdf'}],['DAF-S-RH - completo final-p├íginas-20.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-20.pdf'}],['DAF-S-RH - completo final-p├íginas-200.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-200.pdf'}],['DAF-S-RH - completo final-p├íginas-201.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-201.pdf'}],['DAF-S-RH - completo final-p├íginas-202.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-202.pdf'}],['DAF-S-RH - completo final-p├íginas-203.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-203.pdf'}],['DAF-S-RH - completo final-p├íginas-204.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-204.pdf'}],['DAF-S-RH - completo final-p├íginas-205.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-205.pdf'}],['DAF-S-RH - completo final-p├íginas-206.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-206.pdf'}],['DAF-S-RH - completo final-p├íginas-207.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-207.pdf'}],['DAF-S-RH - completo final-p├íginas-208.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-208.pdf'}],['DAF-S-RH - completo final-p├íginas-209.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-209.pdf'}],['DAF-S-RH - completo final-p├íginas-21.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-21.pdf'}],['DAF-S-RH - completo final-p├íginas-210.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-210.pdf'}],['DAF-S-RH - completo final-p├íginas-211.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-211.pdf'}],['DAF-S-RH - completo final-p├íginas-212.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-212.pdf'}],['DAF-S-RH - completo final-p├íginas-213.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-213.pdf'}],['DAF-S-RH - completo final-p├íginas-214.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-214.pdf'}],['DAF-S-RH - completo final-p├íginas-215.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-215.pdf'}],['DAF-S-RH - completo final-p├íginas-216.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-216.pdf'}],['DAF-S-RH - completo final-p├íginas-217.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-217.pdf'}],['DAF-S-RH - completo final-p├íginas-218.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-218.pdf'}],['DAF-S-RH - completo final-p├íginas-219.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-219.pdf'}],['DAF-S-RH - completo final-p├íginas-22.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-22.pdf'}],['DAF-S-RH - completo final-p├íginas-220.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-220.pdf'}],['DAF-S-RH - completo final-p├íginas-221.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-221.pdf'}],['DAF-S-RH - completo final-p├íginas-222.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-222.pdf'}],['DAF-S-RH - completo final-p├íginas-223.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-223.pdf'}],['DAF-S-RH - completo final-p├íginas-224.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-224.pdf'}],['DAF-S-RH - completo final-p├íginas-225.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-225.pdf'}],['DAF-S-RH - completo final-p├íginas-226.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-226.pdf'}],['DAF-S-RH - completo final-p├íginas-23.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-23.pdf'}],['DAF-S-RH - completo final-p├íginas-24.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-24.pdf'}],['DAF-S-RH - completo final-p├íginas-25.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-25.pdf'}],['DAF-S-RH - completo final-p├íginas-26.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-26.pdf'}],['DAF-S-RH - completo final-p├íginas-27.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-27.pdf'}],['DAF-S-RH - completo final-p├íginas-28.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-28.pdf'}],['DAF-S-RH - completo final-p├íginas-29.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-29.pdf'}],['DAF-S-RH - completo final-p├íginas-3.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-3.pdf'}],['DAF-S-RH - completo final-p├íginas-30.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-30.pdf'}],['DAF-S-RH - completo final-p├íginas-31.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-31.pdf'}],['DAF-S-RH - completo final-p├íginas-32.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-32.pdf'}],['DAF-S-RH - completo final-p├íginas-33.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-33.pdf'}],['DAF-S-RH - completo final-p├íginas-34.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-34.pdf'}],['DAF-S-RH - completo final-p├íginas-35.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-35.pdf'}],['DAF-S-RH - completo final-p├íginas-36.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-36.pdf'}],['DAF-S-RH - completo final-p├íginas-37.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-37.pdf'}],['DAF-S-RH - completo final-p├íginas-38.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-38.pdf'}],['DAF-S-RH - completo final-p├íginas-39.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-39.pdf'}],['DAF-S-RH - completo final-p├íginas-4.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-4.pdf'}],['DAF-S-RH - completo final-p├íginas-40.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-40.pdf'}],['DAF-S-RH - completo final-p├íginas-41.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-41.pdf'}],['DAF-S-RH - completo final-p├íginas-42.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-42.pdf'}],['DAF-S-RH - completo final-p├íginas-43.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-43.pdf'}],['DAF-S-RH - completo final-p├íginas-44.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-44.pdf'}],['DAF-S-RH - completo final-p├íginas-45.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-45.pdf'}],['DAF-S-RH - completo final-p├íginas-46.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-46.pdf'}],['DAF-S-RH - completo final-p├íginas-47.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-47.pdf'}],['DAF-S-RH - completo final-p├íginas-48.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-48.pdf'}],['DAF-S-RH - completo final-p├íginas-49.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-49.pdf'}],['DAF-S-RH - completo final-p├íginas-5.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-5.pdf'}],['DAF-S-RH - completo final-p├íginas-50.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-50.pdf'}],['DAF-S-RH - completo final-p├íginas-51.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-51.pdf'}],['DAF-S-RH - completo final-p├íginas-52.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-52.pdf'}],['DAF-S-RH - completo final-p├íginas-53.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-53.pdf'}],['DAF-S-RH - completo final-p├íginas-54.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-54.pdf'}],['DAF-S-RH - completo final-p├íginas-55.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-55.pdf'}],['DAF-S-RH - completo final-p├íginas-56.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-56.pdf'}],['DAF-S-RH - completo final-p├íginas-57.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-57.pdf'}],['DAF-S-RH - completo final-p├íginas-58.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-58.pdf'}],['DAF-S-RH - completo final-p├íginas-59.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-59.pdf'}],['DAF-S-RH - completo final-p├íginas-6.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-6.pdf'}],['DAF-S-RH - completo final-p├íginas-60.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-60.pdf'}],['DAF-S-RH - completo final-p├íginas-61.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-61.pdf'}],['DAF-S-RH - completo final-p├íginas-62.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-62.pdf'}],['DAF-S-RH - completo final-p├íginas-63.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-63.pdf'}],['DAF-S-RH - completo final-p├íginas-64.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-64.pdf'}],['DAF-S-RH - completo final-p├íginas-65.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-65.pdf'}],['DAF-S-RH - completo final-p├íginas-66.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-66.pdf'}],['DAF-S-RH - completo final-p├íginas-67.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-67.pdf'}],['DAF-S-RH - completo final-p├íginas-68.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-68.pdf'}],['DAF-S-RH - completo final-p├íginas-69.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-69.pdf'}],['DAF-S-RH - completo final-p├íginas-7.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-7.pdf'}],['DAF-S-RH - completo final-p├íginas-70.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-70.pdf'}],['DAF-S-RH - completo final-p├íginas-71.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-71.pdf'}],['DAF-S-RH - completo final-p├íginas-72.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-72.pdf'}],['DAF-S-RH - completo final-p├íginas-73.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-73.pdf'}],['DAF-S-RH - completo final-p├íginas-74.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-74.pdf'}],['DAF-S-RH - completo final-p├íginas-75.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-75.pdf'}],['DAF-S-RH - completo final-p├íginas-76.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-76.pdf'}],['DAF-S-RH - completo final-p├íginas-77.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-77.pdf'}],['DAF-S-RH - completo final-p├íginas-78.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-78.pdf'}],['DAF-S-RH - completo final-p├íginas-79.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-79.pdf'}],['DAF-S-RH - completo final-p├íginas-8.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-8.pdf'}],['DAF-S-RH - completo final-p├íginas-80.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-80.pdf'}],['DAF-S-RH - completo final-p├íginas-81.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-81.pdf'}],['DAF-S-RH - completo final-p├íginas-82.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-82.pdf'}],['DAF-S-RH - completo final-p├íginas-83.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-83.pdf'}],['DAF-S-RH - completo final-p├íginas-84.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-84.pdf'}],['DAF-S-RH - completo final-p├íginas-85.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-85.pdf'}],['DAF-S-RH - completo final-p├íginas-86.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-86.pdf'}],['DAF-S-RH - completo final-p├íginas-87.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-87.pdf'}],['DAF-S-RH - completo final-p├íginas-88.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-88.pdf'}],['DAF-S-RH - completo final-p├íginas-89.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-89.pdf'}],['DAF-S-RH - completo final-p├íginas-9.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-9.pdf'}],['DAF-S-RH - completo final-p├íginas-90.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-90.pdf'}],['DAF-S-RH - completo final-p├íginas-91.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-91.pdf'}],['DAF-S-RH - completo final-p├íginas-92.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-92.pdf'}],['DAF-S-RH - completo final-p├íginas-93.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-93.pdf'}],['DAF-S-RH - completo final-p├íginas-94.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-94.pdf'}],['DAF-S-RH - completo final-p├íginas-95.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-95.pdf'}],['DAF-S-RH - completo final-p├íginas-96.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-96.pdf'}],['DAF-S-RH - completo final-p├íginas-97.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-97.pdf'}],['DAF-S-RH - completo final-p├íginas-98.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-98.pdf'}],['DAF-S-RH - completo final-p├íginas-99.pdf', '2do Trimestre', 'Yezmin Hernandez', '03-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RH/completo%20final-p├íginas-99.pdf'}]
,
['DAJ - Subsidios 2 Trimestre 2026.pdf', '2do Trimestre', 'Jorge Olguin', '09-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Subsidios%202%20Trimestre%202026.pdf'}]
,
['DIU - avances de obra.pdf', '2do Trimestre', 'Blanca Ramirez', '10-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/avances%20de%20obra.pdf'}]
,
['DAF-S-PCF - I. a) Estado Actividades.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.xlsx'}],['DAF-S-PCF - I. b) Estado Situacion Financiera.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.xlsx'}],['DAF-S-PCF - I. c) Estado Variacion Hacienda.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda.xlsx'}],['DAF-S-PCF - I. d) Estado Cambios Situacion.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion.xlsx'}],['DAF-S-PCF - I. e) Estado Flujos Efectivo.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.xlsx'}],['DAF-S-PCF - I. f) Estado Analitico Activo.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.xlsx'}],['DAF-S-PCF - I. g) Estado Analitico Deuda.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda.xlsx'}],['DAF-S-PCF - I. h) Pasivos Contingentes.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20h)%20Pasivos%20Contingentes.xlsx'}],['DAF-S-PCF - I. i) Notas Edos Financieros.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Edos%20Financieros.xlsx'}],['DAF-S-PCF - II. a) EAI con excedentes.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20a)%20EAI%20con%20excedentes.xlsx'}],['DAF-S-PCF - II. b) 1.1 EAEPE Clasificacion Administrativa.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.1%20EAEPE%20Clasificacion%20Administrativa.xlsx'}],['DAF-S-PCF - II. b) 1.2 EAEPE Identificado por Ramo.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20EAEPE%20Identificado%20por%20Ramo.xlsx'}],['DAF-S-PCF - II. b) 2. EAEPE Clasificacion Economica Tipo de Gasto.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%202.%20EAEPE%20Clasificacion%20Economica%20Tipo%20de%20Gasto.xlsx'}],['DAF-S-PCF - II. b) 3. EAEPE COG Capitulo y Concepto.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%203.%20EAEPE%20COG%20Capitulo%20y%20Concepto.xlsx'}],['DAF-S-PCF - II. b) 4. EAEPE Clasificacion Funcional.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%204.%20EAEPE%20Clasificacion%20Funcional.xlsx'}],['DAF-S-PCF - II. c) Endeudamiento Neto.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.xlsx'}],['DAF-S-PCF - II. d) Intereses de la Deuda.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20de%20la%20Deuda.xlsx'}],['DAF-S-PCF - II. e) Flujo de Fondos.xlsx', '2do Trimestre', 'Blanca Trigeros', '15-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20de%20Fondos.xlsx'}]
,
['DIU - ACTA FINIQUITO CAASIM-DAJ-067-2025 LUMINARIAS.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-067-2025%20LUMINARIAS.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-094-2025 AV. 2.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-094-2025%20AV.%202.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-101-2025 AV. INSURGENTES.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-101-2025%20AV.%20INSURGENTES.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-107-2025 CERRO GORDO.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-107-2025%20CERRO%20GORDO.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-113-2025 SUSTITUCION DE LINEAS ZONA 3.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-113-2025%20SUSTITUCION%20DE%20LINEAS%20ZONA%203.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-114-2025 SUSTITUCION DE LINEAS ZONA 4.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-114-2025%20SUSTITUCION%20DE%20LINEAS%20ZONA%204.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-120-2025 REDES ZONA 3.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-120-2025%20REDES%20ZONA%203.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-123-2025 CAJAS DE VALVULAS.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-123-2025%20CAJAS%20DE%20VALVULAS.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-126-2025 ALCANTARILLADO ZONA 4.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-126-2025%20ALCANTARILLADO%20ZONA%204.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-127-2025 ALCANTARILLADO ZONA 3.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-127-2025%20ALCANTARILLADO%20ZONA%203.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-128-2025 REDES ZONA 1.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-128-2025%20REDES%20ZONA%201.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-131-2025 ALCANTARILLADO ZONA 5.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-131-2025%20ALCANTARILLADO%20ZONA%205.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-150-2025 CERCADO NO PROPIEDAD.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-150-2025%20CERCADO%20NO%20PROPIEDAD.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-170-2025 CERCADO PROPIEDAD.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-170-2025%20CERCADO%20PROPIEDAD.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-197-2025 VILLA DEL ALAMO.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-197-2025%20VILLA%20DEL%20ALAMO.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-198-2025 POZO LA PAZ 1.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-198-2025%20POZO%20LA%20PAZ%201.pdf'}],['DIU - ACTA FINIQUITO CAASIM-DAJ-200-2025 TRES POZOS.pdf', '2do Trimestre', 'Blanca Martinez', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DIU/ACTA%20FINIQUITO%20CAASIM-DAJ-200-2025%20TRES%20POZOS.pdf'}]
,
['DAF-S-PCF - I. a) Estado Actividades.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20a)%20Estado%20Actividades.pdf'}],['DAF-S-PCF - I. b) Estado Situacion Financiera.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20b)%20Estado%20Situacion%20Financiera.pdf'}],['DAF-S-PCF - I. c) Estado Variacion Hacienda Publica.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20c)%20Estado%20Variacion%20Hacienda%20Publica.pdf'}],['DAF-S-PCF - I. d) Estado Cambios Situacion Financiera.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20d)%20Estado%20Cambios%20Situacion%20Financiera.pdf'}],['DAF-S-PCF - I. e) Estado Flujos Efectivo.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20e)%20Estado%20Flujos%20Efectivo.pdf'}],['DAF-S-PCF - I. f) Estado Analitico Activo.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20f)%20Estado%20Analitico%20Activo.pdf'}],['DAF-S-PCF - I. g) Estado Analitico Deuda Otros Pasivos.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20g)%20Estado%20Analitico%20Deuda%20Otros%20Pasivos.pdf'}],['DAF-S-PCF - I. h) Informe Pasivos Contingentes.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20h)%20Informe%20Pasivos%20Contingentes.pdf'}],['DAF-S-PCF - I. i) Notas Estados Financieros.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/I.%20i)%20Notas%20Estados%20Financieros.pdf'}],['DAF-S-PCF - II. a) Estado Ingresos Excedentes.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20a)%20Estado%20Ingresos%20Excedentes.pdf'}],['DAF-S-PCF - II. b) 1.1. Estado Egresos Clasificacion Administrativa.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.1.%20Estado%20Egresos%20Clasificacion%20Administrativa.pdf'}],['DAF-S-PCF - II. b) 1.2 Estado Egresos Identificado Ramo.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%201.2%20Estado%20Egresos%20Identificado%20Ramo.pdf'}],['DAF-S-PCF - II. b) 2. Estado Egresos Clasificacion Economica.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%202.%20Estado%20Egresos%20Clasificacion%20Economica.pdf'}],['DAF-S-PCF - II. b) 3. Estado Egresos COG.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%203.%20Estado%20Egresos%20COG.pdf'}],['DAF-S-PCF - II. b) 4. Estado Egresos Clasificacion Funcional.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20b)%204.%20Estado%20Egresos%20Clasificacion%20Funcional.pdf'}],['DAF-S-PCF - II. c) Endeudamiento Neto.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20c)%20Endeudamiento%20Neto.pdf'}],['DAF-S-PCF - II. d) Intereses Deuda.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20d)%20Intereses%20Deuda.pdf'}],['DAF-S-PCF - II. e) Flujo Fondos.pdf', '2do Trimestre', 'Blanca Trigueros', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/II.%20e)%20Flujo%20Fondos.pdf'}]
,
['DAJ - Contrato DAJ-076-2026.pdf', '2do Trimestre', 'Jorge Olguin', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-076-2026.pdf'}],['DAJ - Contrato DAJ-077-2026.pdf', '2do Trimestre', 'Jorge Olguin', '16-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-077-2026.pdf'}]
,
['DAF-S-PF - Gasto por categoria programática Junio.xlsx', '2do Trimestre', 'Planeacion Financiera', '20-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PF/Gasto%20por%20categoria%20programática%20Junio.xlsx'}],['DAF-S-PF - Indicadores de resultados junio 26.xlsx', '2do Trimestre', 'Planeacion Financiera', '20-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PF/Indicadores%20de%20resultados%20junio%2026.xlsx'}],['DAF-S-PF - Programas y proyectos de inversión Junio.xlsx', '2do Trimestre', 'Planeacion Financiera', '20-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PF/Programas%20y%20proyectos%20de%20inversión%20Junio.xlsx'}]
,
['DAF-S-I - A) GASTO POR CATEGORIA PROGRAMATICA JUNIO.pdf', '2do Trimestre', 'Planeacion Financiera', '20-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/A)%20GASTO%20POR%20CATEGORIA%20PROGRAMATICA%20JUNIO.pdf'}],['DAF-S-I - B) PROGRAMAS Y PROYECTOS DE INVERSION JUNIO.pdf', '2do Trimestre', 'Planeacion Financiera', '20-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/B)%20PROGRAMAS%20Y%20PROYECTOS%20DE%20INVERSION%20JUNIO.pdf'}],['DAF-S-I - C) INDICADORES DE RESULTADOS JUNIO.pdf', '2do Trimestre', 'Planeacion Financiera', '20-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/C)%20INDICADORES%20DE%20RESULTADOS%20JUNIO.pdf'}]
,
['DAF-S-PCF - EDITABLES EAEPE 2o TRIM 2026.xlsx', '2do Trimestre', 'Departamento de Presupuesto', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/EDITABLES%20EAEPE%202o%20TRIM%202026.xlsx'}],['DAF-S-PCF - EDITABLES EAI 2o TRIM 2026.xlsx', '2do Trimestre', 'Departamento de Presupuesto', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/EDITABLES%20EAI%202o%20TRIM%202026.xlsx'}],['DAF-S-PCF - PDF EAEPE 2o TRIM 2026.pdf', '2do Trimestre', 'Departamento de Presupuesto', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/PDF%20EAEPE%202o%20TRIM%202026.pdf'}],['DAF-S-PCF - PDF EAI 2o TRIM 2026.pdf', '2do Trimestre', 'Departamento de Presupuesto', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/PDF%20EAI%202o%20TRIM%202026.pdf'}]
,
['DAF-S-I - Monto Mensual 2DO. trimestre Oxxo 2026.xlsx', '2do Trimestre', 'Maribel Butrón Rosales', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/Monto%20Mensual%202DO.%20trimestre%20Oxxo%202026.xlsx'}]
,
['DAF-S-I - Estado por categoria programatica.pdf', '2do Trimestre', 'Planeacion Financiera Ingresos', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/Estado%20por%20categoria%20programatica.pdf'}],['DAF-S-I - Indicadores de Resultados.pdf', '2do Trimestre', 'Planeacion Financiera Ingresos', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/Indicadores%20de%20Resultados.pdf'}],['DAF-S-I - Programa y proyectos de inversion.pdf', '2do Trimestre', 'Planeacion Financiera Ingresos', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/Programa%20y%20proyectos%20de%20inversion.pdf'}]
,
['DAF-S-PCF - Estado Egresos COG, TG, ADMIN Y FUNCIONAL.pdf', '2do Trimestre', 'Departamento de Presupuesto', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/Estado%20Egresos%20COG,%20TG,%20ADMIN%20Y%20FUNCIONAL.pdf'}],['DAF-S-PCF - Estado Ingresos.pdf', '2do Trimestre', 'Departamento de Presupuesto', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-PCF/Estado%20Ingresos.pdf'}]
,
['DAF-S-I - Oxxo 2do. Trim. 2026.pdf', '2do Trimestre', 'Maribel Butrón Rosales', '21-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/Oxxo%202do.%20Trim.%202026.pdf'}]
,
['DAF-S-I - 9 formato para hipervinculo 2026 2do. trimestre 2026.pdf', '2do Trimestre', 'Maribel Butron', '22-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-I/9%20formato%20para%20hipervinculo%202026%202do.%20trimestre%202026.pdf'}]
,
['DAJ - Contrato DAJ-066-2026.pdf', '2do Trimestre', 'Jorge Olguin', '22-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-066-2026.pdf'}],['DAJ - Contrato DAJ-074-2026.pdf', '2do Trimestre', 'Jorge Olguin', '22-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-074-2026.pdf'}]
,
['DAF - doc01862220260722164529 (1).pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862220260722164529%20(1).pdf'}],['DAF - doc01862320260722164541.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862320260722164541.pdf'}],['DAF - doc01862420260722164552.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862420260722164552.pdf'}],['DAF - doc01862520260722164602.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862520260722164602.pdf'}],['DAF - doc01862620260722164613.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862620260722164613.pdf'}],['DAF - doc01862720260722164623.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862720260722164623.pdf'}],['DAF - doc01862820260722164639.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862820260722164639.pdf'}],['DAF - doc01862920260722164650.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01862920260722164650.pdf'}],['DAF - doc01863020260722164703.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01863020260722164703.pdf'}],['DAF - doc01863120260722164713.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01863120260722164713.pdf'}],['DAF - doc01863220260722164725.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01863220260722164725.pdf'}],['DAF - doc01863320260722164738.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01863320260722164738.pdf'}],['DAF - doc01863420260722164749.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01863420260722164749.pdf'}],['DAF - doc01863520260722164800.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/doc01863520260722164800.pdf'}],['DAF - FACTURA 3616-3616 ARGAB SERV VERIFICACIÓN 4 VEH ABRIL.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%203616-3616%20ARGAB%20SERV%20VERIFICACIÓN%204%20VEH%20ABRIL.pdf'}],['DAF - FACTURA 3737-3737 ARGAB SERV VERIFICACIÓN 3 VEH ABRIL.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%203737-3737%20ARGAB%20SERV%20VERIFICACIÓN%203%20VEH%20ABRIL.pdf'}],['DAF - FACTURA 3903-3901 ARGAB SERV VERIFICACIÓN 54 VEH BLOQUE-1.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%203903-3901%20ARGAB%20SERV%20VERIFICACIÓN%2054%20VEH%20BLOQUE-1.pdf'}],['DAF - FACTURA 4010-4008 ARGAB SERV VERIFICACIÓN 2 VEH MAYO.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%204010-4008%20ARGAB%20SERV%20VERIFICACIÓN%202%20VEH%20MAYO.pdf'}],['DAF - FACTURA 4081-4083 SER VERIFICACIÓN 54 VEH BLOQUE-2.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%204081-4083%20SER%20VERIFICACIÓN%2054%20VEH%20BLOQUE-2.pdf'}],['DAF - FACTURA AUTONATION SAPI MANTTO PREV R-490.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20AUTONATION%20SAPI%20MANTTO%20PREV%20R-490.pdf'}],['DAF - FACTURA FEDERICO MTZ REP LLANTAS TALACHAS.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20FEDERICO%20MTZ%20REP%20LLANTAS%20TALACHAS.pdf'}],['DAF - FACTURA GOB EDO EXPEDICIÓN OPINIÓN CUMPLIMIENTO ABRIL.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20GOB%20EDO%20EXPEDICIÓN%20OPINIÓN%20CUMPLIMIENTO%20ABRIL.pdf'}],['DAF - FACTURA WEICHAI MANTTO PREV R-520.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20WEICHAI%20MANTTO%20PREV%20R-520.pdf'}],['DAF - FACTURA WEICHAI MANTTO PREV R-522.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20WEICHAI%20MANTTO%20PREV%20R-522.pdf'}],['DAF - FACTURA WEICHAI MANTTO PREV R-523.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20WEICHAI%20MANTTO%20PREV%20R-523.pdf'}],['DAF - FACTURA WEICHAI MANTTO PREV R-5234.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20WEICHAI%20MANTTO%20PREV%20R-5234.pdf'}],['DAF - FACTURA WEICHAI MANTTO PREV R-525.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20WEICHAI%20MANTTO%20PREV%20R-525.pdf'}],['DAF - FACTURA WEICHAI MANTTO PREV R-527.pdf', '2do Trimestre', 'Edgar Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF/FACTURA%20WEICHAI%20MANTTO%20PREV%20R-527.pdf'}]
,
['DAF-S-RM - FACTURA CAASIM-DAJ-051-2026.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-051-2026.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-132-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-132-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-212-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-212-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-226-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-226-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-229-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-229-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-231-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-231-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-013-2026.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-013-2026.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-046-2026.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-046-2026.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-047-2026.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-047-2026.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-048-2026.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-048-2026.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-049-2026.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-049-2026.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-052-2026.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-052-2026.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-138-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-138-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-165-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-165-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-192-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-192-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-214-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-214-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-215-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-215-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-224-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-224-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-228-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-228-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-230-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-230-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-232-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-232-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-233-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '23-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-233-2025.pdf'}]
,
['DAF-S-RM - FACTURA CAASIM-DAJ-097-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-097-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-108-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-108-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-142-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-142-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-153-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-153-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-162-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-162-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-164-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-164-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-176-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-176-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-179-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-179-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-180-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-180-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-183-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-183-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-186-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-186-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-187-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-187-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-189-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-189-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-212-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-212-2025.pdf'}],['DAF-S-RM - FACTURA CAASIM-DAJ-226-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURA%20CAASIM-DAJ-226-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-061-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-061-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-062-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-062-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-063-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-063-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-064-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-064-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-083-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-083-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-087-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-087-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-091-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-091-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-095-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-095-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-099-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-099-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-100-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-100-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-122-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-122-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-134-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-134-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-135-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-135-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-136-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-136-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-141-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-141-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-152-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-152-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-158-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-158-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-159-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-159-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-160-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-160-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-161-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-161-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-172-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-172-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-178-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-178-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-182-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-182-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-190-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-190-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-192-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-192-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-192-2025_1.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-192-2025_1.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-193-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-193-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-193-2025_1.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-193-2025_1.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-194-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-194-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-194-2025_1.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-194-2025_1.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-195-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-195-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-195-2025_1.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-195-2025_1.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-197-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-197-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-200-2025.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-200-2025.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-219-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-219-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-221-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-221-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-224-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-224-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-226-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-226-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-227-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-227-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-231-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-231-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-233-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-233-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-242-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-242-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-244-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-244-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-245-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-245-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-251-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-251-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-253-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-253-2024.pdf'}],['DAF-S-RM - FACTURAS CAASIM-DAJ-254-2024.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20CAASIM-DAJ-254-2024.pdf'}],['DAF-S-RM - FACTURAS PC20251031001.pdf', '2do Trimestre', 'Beatriz Martinez', '24-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAF-S-RM/FACTURAS%20PC20251031001.pdf'}]
,
['DAJ - Contrato DAJ-068-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-068-2026.pdf'}],['DAJ - Contrato DAJ-078-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-078-2026.pdf'}],['DAJ - Contrato DAJ-080-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-080-2026.pdf'}],['DAJ - Convenio DAJ-045-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguín', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Convenio%20DAJ-045-2026.pdf'}]
,
['DAJ - Contrato DAJ-081-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-081-2026.pdf'}],['DAJ - Contrato DAJ-082-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-082-2026.pdf'}],['DAJ - Contrato DAJ-083-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-083-2026.pdf'}],['DAJ - Contrato DAJ-085-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-085-2026.pdf'}]
,
['DAJ - Contrato DAJ-088-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-088-2026.pdf'}],['DAJ - Contrato DAJ-090-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Contrato%20DAJ-090-2026.pdf'}],['DAJ - Convenio DAJ-049-2026.pdf', '2do Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Convenio%20DAJ-049-2026.pdf'}]
,
['DAJ - Contrato DAJ-086-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '30-07-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-086-2026.pdf'}]
,
['DAJ - Contrato DAJ-084-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '19-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-084-2026.pdf'}],['DAJ - Contrato DAJ-089-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '19-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-089-2026.pdf'}],['DAJ - Contrato DAJ-091-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '19-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-091-2026.pdf'}],['DAJ - Convenio DAJ-044-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '19-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Convenio%20DAJ-044-2026.pdf'}],['DAJ - Convenio DAJ-046-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '19-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Convenio%20DAJ-046-2026.pdf'}],['DAJ - Convenio DAJ-047-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '19-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Convenio%20DAJ-047-2026.pdf'}]
,
['DAJ - Contrato DAJ-092-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '21-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-092-2026.pdf'}],['DAJ - Contrato DAJ-093-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '21-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-093-2026.pdf'}],['DAJ - Contrato DAJ-096-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguín', '21-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-096-2026.pdf'}]
,
['DAJ - Convenio DAJ-048-2026.pdf', '2do Trimestre', 'Jorge Olguin', '21-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/2do%20Trimestre/DAJ/Convenio%20DAJ-048-2026.pdf'}]
,
['DAJ - Convenio DAJ-007-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-007-2026.pdf'}],['DAJ - Convenio DAJ-025-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-025-2026.pdf'}],['DAJ - Convenio DAJ-026-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-026-2026.pdf'}],['DAJ - Convenio DAJ-027-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-027-2026.pdf'}],['DAJ - Convenio DAJ-028-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-028-2026.pdf'}],['DAJ - Convenio DAJ-029-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-029-2026.pdf'}],['DAJ - Convenio DAJ-030-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-030-2026.pdf'}],['DAJ - Convenio DAJ-034-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-034-2026.pdf'}],['DAJ - Convenio DAJ-038-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-038-2026.pdf'}],['DAJ - Convenio DAJ-039-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-039-2026.pdf'}],['DAJ - Convenio DAJ-040-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-040-2026.pdf'}],['DAJ - Convenio DAJ-041-2026.pdf', '1er Trimestre', 'Jorge Daniel Olguín', '24-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-041-2026.pdf'}]
,
['DAJ - Contrato DAJ-097-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '26-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-097-2026.pdf'}],['DAJ - Contrato DAJ-098-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '26-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-098-2026.pdf'}],['DAJ - Contrato DAJ-099-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '26-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-099-2026.pdf'}],['DAJ - Contrato DAJ-106-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '26-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-106-2026.pdf'}]
,
['DAJ - Contrato DAJ-101-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '27-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-101-2026.pdf'}],['DAJ - Contrato DAJ-104-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '27-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-104-2026.pdf'}],['DAJ - Contrato DAJ-105-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '27-08-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-105-2026.pdf'}]
,
['DAF-S-RM - FACTURA AUTOCOM RIDERS MANTENIMIENTO PREVENTIVO CUATRIMOTO R-535.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/FACTURA%20AUTOCOM%20RIDERS%20MANTENIMIENTO%20PREVENTIVO%20CUATRIMOTO%20R-535.pdf'}],['DAF-S-RM - FACTURA AUTOCOM RIDERS MANTENIMIENTO PREVENTIVO CUATRIMOTO R-537.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/FACTURA%20AUTOCOM%20RIDERS%20MANTENIMIENTO%20PREVENTIVO%20CUATRIMOTO%20R-537.pdf'}],['DAF-S-RM - FACTURA AUTOCOM RIDERS MANTENIMIENTO PREVENTIVO CUATRIMOTO R-538.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/FACTURA%20AUTOCOM%20RIDERS%20MANTENIMIENTO%20PREVENTIVO%20CUATRIMOTO%20R-538.pdf'}],['DAF-S-RM - FACTURA MANTENIMIENTO PREVENTIVO NISSAN NP300 R-500.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/FACTURA%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20R-500.pdf'}],['DAF-S-RM - FACTURA MANTENIMIENTO PREVENTIVO NISSAN NP300 R-501.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/FACTURA%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20R-501.pdf'}],['DAF-S-RM - FACTURA MANTENIMIENTO PREVENTIVO NISSAN NP300 R-559.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/FACTURA%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20R-559.pdf'}],['DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS MANTENIMIENTO CUATRIMOTOS CAN-AM R-535, R-537, R-538.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20MANTENIMIENTO%20CUATRIMOTOS%20CAN-AM%20R-535,%20R-537,%20R-538.pdf'}],['DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS MANTENIMIENTO PREVENTIVO NISSAN NP300  R-559.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20%20R-559.pdf'}],['DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS MANTENIMIENTO PREVENTIVO NISSAN NP300 R-501.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20R-501.pdf'}],['DAF-S-RM - OFICIO AUTORIZACIÓN RECURSOS NISSAN NP300 R-500.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/OFICIO%20AUTORIZACIÓN%20RECURSOS%20NISSAN%20NP300%20R-500.pdf'}],['DAF-S-RM - PSN20260825001 MANTENIMIENTO PREVENTIVO NISSAN NP300 R-501.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/PSN20260825001%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20R-501.pdf'}],['DAF-S-RM - PSN20260825002 MANTENIMIENTO PREVENTIVO CUATRIMOTOS CAN-AM R-535, R-537, R-538.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/PSN20260825002%20MANTENIMIENTO%20PREVENTIVO%20CUATRIMOTOS%20CAN-AM%20R-535,%20R-537,%20R-538.pdf'}],['DAF-S-RM - PSN20260826004 MANTENIMIENTO PREVENTIVO NISSAN NP300 R-500.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/PSN20260826004%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20R-500.pdf'}],['DAF-S-RM - PSN20260826005 MANTENIMIENTO PREVENTIVO NISSAN NP300 R-559.pdf', '3er Trimestre', 'Edgar Martinez', '01-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAF-S-RM/PSN20260826005%20MANTENIMIENTO%20PREVENTIVO%20NISSAN%20NP300%20R-559.pdf'}]
,
['DAJ - Contrato DAJ-100-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-100-2026.pdf'}],['DAJ - Contrato DAJ-103-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-103-2026.pdf'}],['DAJ - Contrato DAJ-107-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-107-2026.pdf'}],['DAJ - Contrato DAJ-108-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-108-2026.pdf'}],['DAJ - Contrato DAJ-109-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-109-2026.pdf'}],['DAJ - Contrato DAJ-110-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-110-2026.pdf'}],['DAJ - Contrato DAJ-111-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-111-2026.pdf'}],['DAJ - Contrato DAJ-112-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Contrato%20DAJ-112-2026.pdf'}],['DAJ - Convenio DAJ-050-2026.pdf', '3er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DAJ/Convenio%20DAJ-050-2026.pdf'}]
,
['DAJ - Convenio DAJ-032-2025.pdf', '1er Trimestre', 'Jorge Daniel Olguin', '09-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/1er%20Trimestre/DAJ/Convenio%20DAJ-032-2025.pdf'}]
,
['DIU - SOLICITUD DESCARGA DOM (1).pdf', '3er Trimestre', 'Blanca Ramirez', '22-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DIU/SOLICITUD%20DESCARGA%20DOM%20(1).pdf'}],['DIU - SOLICITUD DESCARGA DOM.docx', '3er Trimestre', 'Blanca Ramirez', '22-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DIU/SOLICITUD%20DESCARGA%20DOM.docx'}],['DIU - SOLICITUD ELABORACION DE PRESUPUESTOS (1).pdf', '3er Trimestre', 'Blanca Ramirez', '22-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DIU/SOLICITUD%20ELABORACION%20DE%20PRESUPUESTOS%20(1).pdf'}],['DIU - SOLICITUD ELABORACION DE PRESUPUESTOS.docx', '3er Trimestre', 'Blanca Ramirez', '22-09-2026', {'text': 'PDF', 'link': '/CAASIM/transparencia/2026/3er%20Trimestre/DIU/SOLICITUD%20ELABORACION%20DE%20PRESUPUESTOS.docx'}]
,
];
